import * as Et from "react";
import I, { useState as Ce, useRef as ie, useEffect as Ee, useCallback as Pe, useContext as We, useMemo as me, createContext as Fe, forwardRef as ct, cloneElement as Z4, useLayoutEffect as Y4 } from "react";
import Ru, { flushSync as X4, createPortal as J4 } from "react-dom";
var xi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Bf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var su = { exports: {} }, wi = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fd;
function Q4() {
  if (Fd)
    return wi;
  Fd = 1;
  var e = I, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(d, f, h) {
    var v, m = {}, y = null, $ = null;
    h !== void 0 && (y = "" + h), f.key !== void 0 && (y = "" + f.key), f.ref !== void 0 && ($ = f.ref);
    for (v in f)
      o.call(f, v) && !u.hasOwnProperty(v) && (m[v] = f[v]);
    if (d && d.defaultProps)
      for (v in f = d.defaultProps, f)
        m[v] === void 0 && (m[v] = f[v]);
    return { $$typeof: t, type: d, key: y, ref: $, props: m, _owner: a.current };
  }
  return wi.Fragment = r, wi.jsx = s, wi.jsxs = s, wi;
}
var Ci = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ld;
function e3() {
  return Ld || (Ld = 1, process.env.NODE_ENV !== "production" && function() {
    var e = I, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), d = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), $ = Symbol.for("react.offscreen"), A = Symbol.iterator, _ = "@@iterator";
    function F(C) {
      if (C === null || typeof C != "object")
        return null;
      var Z = A && C[A] || C[_];
      return typeof Z == "function" ? Z : null;
    }
    var W = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(C) {
      {
        for (var Z = arguments.length, ee = new Array(Z > 1 ? Z - 1 : 0), ce = 1; ce < Z; ce++)
          ee[ce - 1] = arguments[ce];
        B("error", C, ee);
      }
    }
    function B(C, Z, ee) {
      {
        var ce = W.ReactDebugCurrentFrame, Re = ce.getStackAddendum();
        Re !== "" && (Z += "%s", ee = ee.concat([Re]));
        var ke = ee.map(function(Ae) {
          return String(Ae);
        });
        ke.unshift("Warning: " + Z), Function.prototype.apply.call(console[C], console, ke);
      }
    }
    var V = !1, j = !1, G = !1, J = !1, w = !1, Y;
    Y = Symbol.for("react.module.reference");
    function O(C) {
      return !!(typeof C == "string" || typeof C == "function" || C === o || C === u || w || C === a || C === h || C === v || J || C === $ || V || j || G || typeof C == "object" && C !== null && (C.$$typeof === y || C.$$typeof === m || C.$$typeof === s || C.$$typeof === d || C.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      C.$$typeof === Y || C.getModuleId !== void 0));
    }
    function K(C, Z, ee) {
      var ce = C.displayName;
      if (ce)
        return ce;
      var Re = Z.displayName || Z.name || "";
      return Re !== "" ? ee + "(" + Re + ")" : ee;
    }
    function k(C) {
      return C.displayName || "Context";
    }
    function T(C) {
      if (C == null)
        return null;
      if (typeof C.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof C == "function")
        return C.displayName || C.name || null;
      if (typeof C == "string")
        return C;
      switch (C) {
        case o:
          return "Fragment";
        case r:
          return "Portal";
        case u:
          return "Profiler";
        case a:
          return "StrictMode";
        case h:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof C == "object")
        switch (C.$$typeof) {
          case d:
            var Z = C;
            return k(Z) + ".Consumer";
          case s:
            var ee = C;
            return k(ee._context) + ".Provider";
          case f:
            return K(C, C.render, "ForwardRef");
          case m:
            var ce = C.displayName || null;
            return ce !== null ? ce : T(C.type) || "Memo";
          case y: {
            var Re = C, ke = Re._payload, Ae = Re._init;
            try {
              return T(Ae(ke));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var D = Object.assign, X = 0, Q, H, le, de, ne, pe, Ie;
    function Be() {
    }
    Be.__reactDisabledLog = !0;
    function Tt() {
      {
        if (X === 0) {
          Q = console.log, H = console.info, le = console.warn, de = console.error, ne = console.group, pe = console.groupCollapsed, Ie = console.groupEnd;
          var C = {
            configurable: !0,
            enumerable: !0,
            value: Be,
            writable: !0
          };
          Object.defineProperties(console, {
            info: C,
            log: C,
            warn: C,
            error: C,
            group: C,
            groupCollapsed: C,
            groupEnd: C
          });
        }
        X++;
      }
    }
    function ut() {
      {
        if (X--, X === 0) {
          var C = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: D({}, C, {
              value: Q
            }),
            info: D({}, C, {
              value: H
            }),
            warn: D({}, C, {
              value: le
            }),
            error: D({}, C, {
              value: de
            }),
            group: D({}, C, {
              value: ne
            }),
            groupCollapsed: D({}, C, {
              value: pe
            }),
            groupEnd: D({}, C, {
              value: Ie
            })
          });
        }
        X < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var dt = W.ReactCurrentDispatcher, he;
    function ge(C, Z, ee) {
      {
        if (he === void 0)
          try {
            throw Error();
          } catch (Re) {
            var ce = Re.stack.trim().match(/\n( *(at )?)/);
            he = ce && ce[1] || "";
          }
        return `
` + he + C;
      }
    }
    var ft = !1, Bt;
    {
      var cn = typeof WeakMap == "function" ? WeakMap : Map;
      Bt = new cn();
    }
    function dn(C, Z) {
      if (!C || ft)
        return "";
      {
        var ee = Bt.get(C);
        if (ee !== void 0)
          return ee;
      }
      var ce;
      ft = !0;
      var Re = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ke;
      ke = dt.current, dt.current = null, Tt();
      try {
        if (Z) {
          var Ae = function() {
            throw Error();
          };
          if (Object.defineProperty(Ae.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ae, []);
            } catch (Dt) {
              ce = Dt;
            }
            Reflect.construct(C, [], Ae);
          } else {
            try {
              Ae.call();
            } catch (Dt) {
              ce = Dt;
            }
            C.call(Ae.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Dt) {
            ce = Dt;
          }
          C();
        }
      } catch (Dt) {
        if (Dt && ce && typeof Dt.stack == "string") {
          for (var we = Dt.stack.split(`
`), ht = ce.stack.split(`
`), Ye = we.length - 1, Je = ht.length - 1; Ye >= 1 && Je >= 0 && we[Ye] !== ht[Je]; )
            Je--;
          for (; Ye >= 1 && Je >= 0; Ye--, Je--)
            if (we[Ye] !== ht[Je]) {
              if (Ye !== 1 || Je !== 1)
                do
                  if (Ye--, Je--, Je < 0 || we[Ye] !== ht[Je]) {
                    var _t = `
` + we[Ye].replace(" at new ", " at ");
                    return C.displayName && _t.includes("<anonymous>") && (_t = _t.replace("<anonymous>", C.displayName)), typeof C == "function" && Bt.set(C, _t), _t;
                  }
                while (Ye >= 1 && Je >= 0);
              break;
            }
        }
      } finally {
        ft = !1, dt.current = ke, ut(), Error.prepareStackTrace = Re;
      }
      var nn = C ? C.displayName || C.name : "", Xi = nn ? ge(nn) : "";
      return typeof C == "function" && Bt.set(C, Xi), Xi;
    }
    function bn(C, Z, ee) {
      return dn(C, !1);
    }
    function pt(C) {
      var Z = C.prototype;
      return !!(Z && Z.isReactComponent);
    }
    function Ht(C, Z, ee) {
      if (C == null)
        return "";
      if (typeof C == "function")
        return dn(C, pt(C));
      if (typeof C == "string")
        return ge(C);
      switch (C) {
        case h:
          return ge("Suspense");
        case v:
          return ge("SuspenseList");
      }
      if (typeof C == "object")
        switch (C.$$typeof) {
          case f:
            return bn(C.render);
          case m:
            return Ht(C.type, Z, ee);
          case y: {
            var ce = C, Re = ce._payload, ke = ce._init;
            try {
              return Ht(ke(Re), Z, ee);
            } catch {
            }
          }
        }
      return "";
    }
    var mn = Object.prototype.hasOwnProperty, At = {}, Xn = W.ReactDebugCurrentFrame;
    function ye(C) {
      if (C) {
        var Z = C._owner, ee = Ht(C.type, C._source, Z ? Z.type : null);
        Xn.setExtraStackFrame(ee);
      } else
        Xn.setExtraStackFrame(null);
    }
    function Me(C, Z, ee, ce, Re) {
      {
        var ke = Function.call.bind(mn);
        for (var Ae in C)
          if (ke(C, Ae)) {
            var we = void 0;
            try {
              if (typeof C[Ae] != "function") {
                var ht = Error((ce || "React class") + ": " + ee + " type `" + Ae + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof C[Ae] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ht.name = "Invariant Violation", ht;
              }
              we = C[Ae](Z, Ae, ce, ee, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ye) {
              we = Ye;
            }
            we && !(we instanceof Error) && (ye(Re), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ce || "React class", ee, Ae, typeof we), ye(null)), we instanceof Error && !(we.message in At) && (At[we.message] = !0, ye(Re), R("Failed %s type: %s", ee, we.message), ye(null));
          }
      }
    }
    var Ke = Array.isArray;
    function $n(C) {
      return Ke(C);
    }
    function $r(C) {
      {
        var Z = typeof Symbol == "function" && Symbol.toStringTag, ee = Z && C[Symbol.toStringTag] || C.constructor.name || "Object";
        return ee;
      }
    }
    function Pl(C) {
      try {
        return Bn(C), !1;
      } catch {
        return !0;
      }
    }
    function Bn(C) {
      return "" + C;
    }
    function Vi(C) {
      if (Pl(C))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $r(C)), Bn(C);
    }
    var tn = W.ReactCurrentOwner, Mn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, yr, xr, Jn;
    Jn = {};
    function Yr(C) {
      if (mn.call(C, "ref")) {
        var Z = Object.getOwnPropertyDescriptor(C, "ref").get;
        if (Z && Z.isReactWarning)
          return !1;
      }
      return C.ref !== void 0;
    }
    function Xr(C) {
      if (mn.call(C, "key")) {
        var Z = Object.getOwnPropertyDescriptor(C, "key").get;
        if (Z && Z.isReactWarning)
          return !1;
      }
      return C.key !== void 0;
    }
    function Jr(C, Z) {
      if (typeof C.ref == "string" && tn.current && Z && tn.current.stateNode !== Z) {
        var ee = T(tn.current.type);
        Jn[ee] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', T(tn.current.type), C.ref), Jn[ee] = !0);
      }
    }
    function Qr(C, Z) {
      {
        var ee = function() {
          yr || (yr = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Z));
        };
        ee.isReactWarning = !0, Object.defineProperty(C, "key", {
          get: ee,
          configurable: !0
        });
      }
    }
    function ei(C, Z) {
      {
        var ee = function() {
          xr || (xr = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Z));
        };
        ee.isReactWarning = !0, Object.defineProperty(C, "ref", {
          get: ee,
          configurable: !0
        });
      }
    }
    var ti = function(C, Z, ee, ce, Re, ke, Ae) {
      var we = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: C,
        key: Z,
        ref: ee,
        props: Ae,
        // Record the component responsible for creating this element.
        _owner: ke
      };
      return we._store = {}, Object.defineProperty(we._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(we, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.defineProperty(we, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Re
      }), Object.freeze && (Object.freeze(we.props), Object.freeze(we)), we;
    };
    function Tl(C, Z, ee, ce, Re) {
      {
        var ke, Ae = {}, we = null, ht = null;
        ee !== void 0 && (Vi(ee), we = "" + ee), Xr(Z) && (Vi(Z.key), we = "" + Z.key), Yr(Z) && (ht = Z.ref, Jr(Z, Re));
        for (ke in Z)
          mn.call(Z, ke) && !Mn.hasOwnProperty(ke) && (Ae[ke] = Z[ke]);
        if (C && C.defaultProps) {
          var Ye = C.defaultProps;
          for (ke in Ye)
            Ae[ke] === void 0 && (Ae[ke] = Ye[ke]);
        }
        if (we || ht) {
          var Je = typeof C == "function" ? C.displayName || C.name || "Unknown" : C;
          we && Qr(Ae, Je), ht && ei(Ae, Je);
        }
        return ti(C, we, ht, Re, ce, tn.current, Ae);
      }
    }
    var ni = W.ReactCurrentOwner, Hi = W.ReactDebugCurrentFrame;
    function yn(C) {
      if (C) {
        var Z = C._owner, ee = Ht(C.type, C._source, Z ? Z.type : null);
        Hi.setExtraStackFrame(ee);
      } else
        Hi.setExtraStackFrame(null);
    }
    var wr;
    wr = !1;
    function ri(C) {
      return typeof C == "object" && C !== null && C.$$typeof === t;
    }
    function Ui() {
      {
        if (ni.current) {
          var C = T(ni.current.type);
          if (C)
            return `

Check the render method of \`` + C + "`.";
        }
        return "";
      }
    }
    function Al(C) {
      {
        if (C !== void 0) {
          var Z = C.fileName.replace(/^.*[\\\/]/, ""), ee = C.lineNumber;
          return `

Check your code at ` + Z + ":" + ee + ".";
        }
        return "";
      }
    }
    var ji = {};
    function Gi(C) {
      {
        var Z = Ui();
        if (!Z) {
          var ee = typeof C == "string" ? C : C.displayName || C.name;
          ee && (Z = `

Check the top-level render call using <` + ee + ">.");
        }
        return Z;
      }
    }
    function qi(C, Z) {
      {
        if (!C._store || C._store.validated || C.key != null)
          return;
        C._store.validated = !0;
        var ee = Gi(Z);
        if (ji[ee])
          return;
        ji[ee] = !0;
        var ce = "";
        C && C._owner && C._owner !== ni.current && (ce = " It was passed a child from " + T(C._owner.type) + "."), yn(C), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ee, ce), yn(null);
      }
    }
    function Zi(C, Z) {
      {
        if (typeof C != "object")
          return;
        if ($n(C))
          for (var ee = 0; ee < C.length; ee++) {
            var ce = C[ee];
            ri(ce) && qi(ce, Z);
          }
        else if (ri(C))
          C._store && (C._store.validated = !0);
        else if (C) {
          var Re = F(C);
          if (typeof Re == "function" && Re !== C.entries)
            for (var ke = Re.call(C), Ae; !(Ae = ke.next()).done; )
              ri(Ae.value) && qi(Ae.value, Z);
        }
      }
    }
    function _l(C) {
      {
        var Z = C.type;
        if (Z == null || typeof Z == "string")
          return;
        var ee;
        if (typeof Z == "function")
          ee = Z.propTypes;
        else if (typeof Z == "object" && (Z.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Z.$$typeof === m))
          ee = Z.propTypes;
        else
          return;
        if (ee) {
          var ce = T(Z);
          Me(ee, C.props, "prop", ce, C);
        } else if (Z.PropTypes !== void 0 && !wr) {
          wr = !0;
          var Re = T(Z);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Re || "Unknown");
        }
        typeof Z.getDefaultProps == "function" && !Z.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ii(C) {
      {
        for (var Z = Object.keys(C.props), ee = 0; ee < Z.length; ee++) {
          var ce = Z[ee];
          if (ce !== "children" && ce !== "key") {
            yn(C), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ce), yn(null);
            break;
          }
        }
        C.ref !== null && (yn(C), R("Invalid attribute `ref` supplied to `React.Fragment`."), yn(null));
      }
    }
    function Yi(C, Z, ee, ce, Re, ke) {
      {
        var Ae = O(C);
        if (!Ae) {
          var we = "";
          (C === void 0 || typeof C == "object" && C !== null && Object.keys(C).length === 0) && (we += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ht = Al(Re);
          ht ? we += ht : we += Ui();
          var Ye;
          C === null ? Ye = "null" : $n(C) ? Ye = "array" : C !== void 0 && C.$$typeof === t ? (Ye = "<" + (T(C.type) || "Unknown") + " />", we = " Did you accidentally export a JSX literal instead of a component?") : Ye = typeof C, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ye, we);
        }
        var Je = Tl(C, Z, ee, Re, ke);
        if (Je == null)
          return Je;
        if (Ae) {
          var _t = Z.children;
          if (_t !== void 0)
            if (ce)
              if ($n(_t)) {
                for (var nn = 0; nn < _t.length; nn++)
                  Zi(_t[nn], C);
                Object.freeze && Object.freeze(_t);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Zi(_t, C);
        }
        return C === o ? ii(Je) : _l(Je), Je;
      }
    }
    function oi(C, Z, ee) {
      return Yi(C, Z, ee, !0);
    }
    function Dl(C, Z, ee) {
      return Yi(C, Z, ee, !1);
    }
    var Fl = Dl, Ll = oi;
    Ci.Fragment = o, Ci.jsx = Fl, Ci.jsxs = Ll;
  }()), Ci;
}
process.env.NODE_ENV === "production" ? su.exports = Q4() : su.exports = e3();
var U = su.exports, Mf = {};
Mf = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "حدد عنصرًا",
  tableResizer: "أداة تغيير الحجم"
};
var Kf = {};
Kf = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Изберете предмет",
  tableResizer: "Преоразмерител"
};
var Of = {};
Of = {
  dropzoneLabel: "Místo pro přetažení",
  selectPlaceholder: "Vyberte položku",
  tableResizer: "Změna velikosti"
};
var kf = {};
kf = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Vælg et element",
  tableResizer: "Størrelsesændring"
};
var Nf = {};
Nf = {
  dropzoneLabel: "Ablegebereich",
  selectPlaceholder: "Element wählen",
  tableResizer: "Größenanpassung"
};
var zf = {};
zf = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Επιλέξτε ένα αντικείμενο",
  tableResizer: "Αλλαγή μεγέθους"
};
var Wf = {};
Wf = {
  selectPlaceholder: "Select an item",
  tableResizer: "Resizer",
  dropzoneLabel: "DropZone"
};
var Vf = {};
Vf = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Seleccionar un artículo",
  tableResizer: "Cambiador de tamaño"
};
var Hf = {};
Hf = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Valige üksus",
  tableResizer: "Suuruse muutja"
};
var Uf = {};
Uf = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Valitse kohde",
  tableResizer: "Koon muuttaja"
};
var jf = {};
jf = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Sélectionner un élément",
  tableResizer: "Redimensionneur"
};
var Gf = {};
Gf = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "בחר פריט",
  tableResizer: "שינוי גודל"
};
var qf = {};
qf = {
  dropzoneLabel: "Zona spuštanja",
  selectPlaceholder: "Odaberite stavku",
  tableResizer: "Promjena veličine"
};
var Zf = {};
Zf = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Válasszon ki egy elemet",
  tableResizer: "Átméretező"
};
var Yf = {};
Yf = {
  dropzoneLabel: "Zona di rilascio",
  selectPlaceholder: "Seleziona un elemento",
  tableResizer: "Ridimensionamento"
};
var Xf = {};
Xf = {
  dropzoneLabel: "ドロップゾーン",
  selectPlaceholder: "項目を選択",
  tableResizer: "サイズ変更ツール"
};
var Jf = {};
Jf = {
  dropzoneLabel: "드롭 영역",
  selectPlaceholder: "항목 선택",
  tableResizer: "크기 조정기"
};
var Qf = {};
Qf = {
  dropzoneLabel: "„DropZone“",
  selectPlaceholder: "Pasirinkite elementą",
  tableResizer: "Dydžio keitiklis"
};
var ep = {};
ep = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izvēlēties vienumu",
  tableResizer: "Izmēra mainītājs"
};
var tp = {};
tp = {
  dropzoneLabel: "Droppsone",
  selectPlaceholder: "Velg et element",
  tableResizer: "Størrelsesendrer"
};
var np = {};
np = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecteer een item",
  tableResizer: "Resizer"
};
var rp = {};
rp = {
  dropzoneLabel: "Strefa upuszczania",
  selectPlaceholder: "Wybierz element",
  tableResizer: "Zmiana rozmiaru"
};
var ip = {};
ip = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecione um item",
  tableResizer: "Redimensionador"
};
var op = {};
op = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecione um item",
  tableResizer: "Redimensionador"
};
var lp = {};
lp = {
  dropzoneLabel: "Zonă de plasare",
  selectPlaceholder: "Selectați un element",
  tableResizer: "Instrument de redimensionare"
};
var ap = {};
ap = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Выберите элемент",
  tableResizer: "Средство изменения размера"
};
var up = {};
up = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Vyberte položku",
  tableResizer: "Nástroj na zmenu veľkosti"
};
var sp = {};
sp = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izberite element",
  tableResizer: "Spreminjanje velikosti"
};
var cp = {};
cp = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izaberite stavku",
  tableResizer: "Promena veličine"
};
var dp = {};
dp = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Välj en artikel",
  tableResizer: "Storleksändrare"
};
var fp = {};
fp = {
  dropzoneLabel: "Bırakma Bölgesi",
  selectPlaceholder: "Bir öğe seçin",
  tableResizer: "Yeniden boyutlandırıcı"
};
var pp = {};
pp = {
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Виберіть елемент",
  tableResizer: "Засіб змінення розміру"
};
var hp = {};
hp = {
  dropzoneLabel: "放置区域",
  selectPlaceholder: "选择一个项目",
  tableResizer: "尺寸调整器"
};
var vp = {};
vp = {
  dropzoneLabel: "放置區",
  selectPlaceholder: "選取項目",
  tableResizer: "大小調整器"
};
function pr(e, t, r) {
  let [o, a] = Ce(e || t), u = ie(e !== void 0), s = e !== void 0;
  Ee(() => {
    let h = u.current;
    h !== s && console.warn(`WARN: A component changed from ${h ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}.`), u.current = s;
  }, [
    s
  ]);
  let d = s ? e : o, f = Pe((h, ...v) => {
    let m = (y, ...$) => {
      r && (Object.is(d, y) || r(y, ...$)), s || (d = y);
    };
    typeof h == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), a(($, ...A) => {
      let _ = h(s ? d : $, ...A);
      return m(_, ...v), s ? $ : _;
    })) : (s || a(h), m(h, ...v));
  }, [
    s,
    d,
    r
  ]);
  return [
    d,
    f
  ];
}
function Yo(e, t = -1 / 0, r = 1 / 0) {
  return Math.min(Math.max(e, t), r);
}
const Xo = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, gp = /* @__PURE__ */ I.createContext(Xo), t3 = /* @__PURE__ */ I.createContext(!1);
let n3 = !!(typeof window < "u" && window.document && window.document.createElement), Va = /* @__PURE__ */ new WeakMap();
function r3(e = !1) {
  let t = We(gp), r = ie(null);
  if (r.current === null && !e) {
    var o, a;
    let u = (a = I.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || a === void 0 || (o = a.ReactCurrentOwner) === null || o === void 0 ? void 0 : o.current;
    if (u) {
      let s = Va.get(u);
      s == null ? Va.set(u, {
        id: t.current,
        state: u.memoizedState
      }) : u.memoizedState !== s.state && (t.current = s.id, Va.delete(u));
    }
    r.current = ++t.current;
  }
  return r.current;
}
function i3(e) {
  let t = We(gp);
  t === Xo && !n3 && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let r = r3(!!e), o = t === Xo && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${o}-${r}`;
}
function o3(e) {
  let t = I.useId(), [r] = Ce(hr()), o = r || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${Xo.prefix}`;
  return e || `${o}-${t}`;
}
const l3 = typeof I.useId == "function" ? o3 : i3;
function a3() {
  return !1;
}
function u3() {
  return !0;
}
function s3(e) {
  return () => {
  };
}
function hr() {
  return typeof I.useSyncExternalStore == "function" ? I.useSyncExternalStore(s3, a3, u3) : We(t3);
}
function bp(e) {
  var t, r, o = "";
  if (typeof e == "string" || typeof e == "number")
    o += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var a = e.length;
      for (t = 0; t < a; t++)
        e[t] && (r = bp(e[t])) && (o && (o += " "), o += r);
    } else
      for (r in e)
        e[r] && (o && (o += " "), o += r);
  return o;
}
function c3() {
  for (var e, t, r = 0, o = "", a = arguments.length; r < a; r++)
    (e = arguments[r]) && (t = bp(e)) && (o && (o += " "), o += t);
  return o;
}
const qe = typeof document < "u" ? I.useLayoutEffect : () => {
};
function St(e) {
  const t = ie(null);
  return qe(() => {
    t.current = e;
  }, [
    e
  ]), Pe((...r) => {
    const o = t.current;
    return o(...r);
  }, []);
}
function d3(e) {
  let [t, r] = Ce(e), o = ie(null), a = St(() => {
    let s = o.current.next();
    if (s.done) {
      o.current = null;
      return;
    }
    t === s.value ? a() : r(s.value);
  });
  qe(() => {
    o.current && a();
  });
  let u = St((s) => {
    o.current = s(t), a();
  });
  return [
    t,
    u
  ];
}
let f3 = !!(typeof window < "u" && window.document && window.document.createElement), Jo = /* @__PURE__ */ new Map();
function gn(e) {
  let [t, r] = Ce(e), o = ie(null), a = l3(t), u = Pe((s) => {
    o.current = s;
  }, []);
  return f3 && Jo.set(a, u), qe(() => {
    let s = a;
    return () => {
      Jo.delete(s);
    };
  }, [
    a
  ]), Ee(() => {
    let s = o.current;
    s && (o.current = null, r(s));
  }), a;
}
function p3(e, t) {
  if (e === t)
    return e;
  let r = Jo.get(e);
  if (r)
    return r(t), t;
  let o = Jo.get(t);
  return o ? (o(e), e) : t;
}
function Qo(e = []) {
  let t = gn(), [r, o] = d3(t), a = Pe(() => {
    o(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    o
  ]);
  return qe(a, [
    t,
    a,
    ...e
  ]), r;
}
function cr(...e) {
  return (...t) => {
    for (let r of e)
      typeof r == "function" && r(...t);
  };
}
const rt = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, Ii = (e) => e && "window" in e && e.window === e ? e : rt(e).defaultView || window;
function Se(...e) {
  let t = {
    ...e[0]
  };
  for (let r = 1; r < e.length; r++) {
    let o = e[r];
    for (let a in o) {
      let u = t[a], s = o[a];
      typeof u == "function" && typeof s == "function" && // This is a lot faster than a regex.
      a[0] === "o" && a[1] === "n" && a.charCodeAt(2) >= /* 'A' */
      65 && a.charCodeAt(2) <= /* 'Z' */
      90 ? t[a] = cr(u, s) : (a === "className" || a === "UNSAFE_className") && typeof u == "string" && typeof s == "string" ? t[a] = c3(u, s) : a === "id" && u && s ? t.id = p3(u, s) : t[a] = s !== void 0 ? s : u;
    }
  }
  return t;
}
function mp(...e) {
  return e.length === 1 ? e[0] : (t) => {
    for (let r of e)
      typeof r == "function" ? r(t) : r != null && (r.current = t);
  };
}
const h3 = /* @__PURE__ */ new Set([
  "id"
]), v3 = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), g3 = /* @__PURE__ */ new Set([
  "href",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), b3 = /^(data-.*)$/;
function at(e, t = {}) {
  let { labelable: r, isLink: o, propNames: a } = t, u = {};
  for (const s in e)
    Object.prototype.hasOwnProperty.call(e, s) && (h3.has(s) || r && v3.has(s) || o && g3.has(s) || a != null && a.has(s) || b3.test(s)) && (u[s] = e[s]);
  return u;
}
function Ln(e) {
  if (m3())
    e.focus({
      preventScroll: !0
    });
  else {
    let t = $3(e);
    e.focus(), y3(t);
  }
}
let ko = null;
function m3() {
  if (ko == null) {
    ko = !1;
    try {
      var e = document.createElement("div");
      e.focus({
        get preventScroll() {
          return ko = !0, !0;
        }
      });
    } catch {
    }
  }
  return ko;
}
function $3(e) {
  for (var t = e.parentNode, r = [], o = document.scrollingElement || document.documentElement; t instanceof HTMLElement && t !== o; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && r.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return o instanceof HTMLElement && r.push({
    element: o,
    scrollTop: o.scrollTop,
    scrollLeft: o.scrollLeft
  }), r;
}
function y3(e) {
  for (let { element: t, scrollTop: r, scrollLeft: o } of e)
    t.scrollTop = r, t.scrollLeft = o;
}
function pl(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((r) => e.test(r.brand))) || e.test(window.navigator.userAgent);
}
function Iu(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function Gn() {
  return Iu(/^Mac/i);
}
function x3() {
  return Iu(/^iPhone/i);
}
function $p() {
  return Iu(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Gn() && navigator.maxTouchPoints > 1;
}
function hl() {
  return x3() || $p();
}
function Go() {
  return Gn() || hl();
}
function yp() {
  return pl(/AppleWebKit/i) && !w3();
}
function w3() {
  return pl(/Chrome/i);
}
function xp() {
  return pl(/Android/i);
}
function C3() {
  return pl(/Firefox/i);
}
const E3 = /* @__PURE__ */ Fe({
  isNative: !0,
  open: P3
});
function Bu() {
  return We(E3);
}
function dr(e, t, r = !0) {
  var o, a;
  let { metaKey: u, ctrlKey: s, altKey: d, shiftKey: f } = t;
  C3() && (!((a = window.event) === null || a === void 0 || (o = a.type) === null || o === void 0) && o.startsWith("key")) && e.target === "_blank" && (Gn() ? u = !0 : s = !0);
  let h = yp() && Gn() && !$p() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: u,
    ctrlKey: s,
    altKey: d,
    shiftKey: f
  }) : new MouseEvent("click", {
    metaKey: u,
    ctrlKey: s,
    altKey: d,
    shiftKey: f,
    bubbles: !0,
    cancelable: !0
  });
  dr.isOpening = r, Ln(e), e.dispatchEvent(h), dr.isOpening = !1;
}
dr.isOpening = !1;
function S3(e, t) {
  if (e instanceof HTMLAnchorElement)
    t(e);
  else if (e.hasAttribute("data-href")) {
    let r = document.createElement("a");
    r.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (r.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (r.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (r.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (r.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (r.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(r), t(r), e.removeChild(r);
  }
}
function P3(e, t) {
  S3(e, (r) => dr(r, t));
}
let zr = /* @__PURE__ */ new Map(), cu = /* @__PURE__ */ new Set();
function Rd() {
  if (typeof window > "u")
    return;
  let e = (r) => {
    let o = zr.get(r.target);
    o || (o = /* @__PURE__ */ new Set(), zr.set(r.target, o), r.target.addEventListener("transitioncancel", t)), o.add(r.propertyName);
  }, t = (r) => {
    let o = zr.get(r.target);
    if (o && (o.delete(r.propertyName), o.size === 0 && (r.target.removeEventListener("transitioncancel", t), zr.delete(r.target)), zr.size === 0)) {
      for (let a of cu)
        a();
      cu.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", t);
}
typeof document < "u" && (document.readyState !== "loading" ? Rd() : document.addEventListener("DOMContentLoaded", Rd));
function wp(e) {
  requestAnimationFrame(() => {
    zr.size === 0 ? e() : cu.add(e);
  });
}
function Cp() {
  let e = ie(/* @__PURE__ */ new Map()), t = Pe((a, u, s, d) => {
    let f = d != null && d.once ? (...h) => {
      e.current.delete(s), s(...h);
    } : s;
    e.current.set(s, {
      type: u,
      eventTarget: a,
      fn: f,
      options: d
    }), a.addEventListener(u, s, d);
  }, []), r = Pe((a, u, s, d) => {
    var f;
    let h = ((f = e.current.get(s)) === null || f === void 0 ? void 0 : f.fn) || s;
    a.removeEventListener(u, h, d), e.current.delete(s);
  }, []), o = Pe(() => {
    e.current.forEach((a, u) => {
      r(a.eventTarget, a.type, u, a.options);
    });
  }, [
    r
  ]);
  return Ee(() => o, [
    o
  ]), {
    addGlobalListener: t,
    removeGlobalListener: r,
    removeAllGlobalListeners: o
  };
}
function el(e, t) {
  let { id: r, "aria-label": o, "aria-labelledby": a } = e;
  return r = gn(r), a && o ? a = [
    .../* @__PURE__ */ new Set([
      r,
      ...a.trim().split(/\s+/)
    ])
  ].join(" ") : a && (a = a.trim().split(/\s+/).join(" ")), !o && !a && t && (o = t), {
    id: r,
    "aria-label": o,
    "aria-labelledby": a
  };
}
function Mu(e) {
  const t = ie();
  return me(() => ({
    get current() {
      return t.current;
    },
    set current(r) {
      t.current = r, typeof e == "function" ? e(r) : e && (e.current = r);
    }
  }), [
    e
  ]);
}
function T3() {
  return typeof window.ResizeObserver < "u";
}
function Ku(e) {
  const { ref: t, onResize: r } = e;
  Ee(() => {
    let o = t == null ? void 0 : t.current;
    if (o)
      if (T3()) {
        const a = new window.ResizeObserver((u) => {
          u.length && r();
        });
        return a.observe(o), () => {
          o && a.unobserve(o);
        };
      } else
        return window.addEventListener("resize", r, !1), () => {
          window.removeEventListener("resize", r, !1);
        };
  }, [
    r,
    t
  ]);
}
function Ep(e, t) {
  qe(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref.current = null;
      };
  });
}
function tl(e, t) {
  for (nl(e, t) && (e = e.parentElement); e && !nl(e, t); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
function nl(e, t) {
  let r = window.getComputedStyle(e), o = /(auto|scroll)/.test(r.overflow + r.overflowX + r.overflowY);
  return o && t && (o = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), o;
}
let A3 = 0;
const Ha = /* @__PURE__ */ new Map();
function _3(e) {
  let [t, r] = Ce(void 0);
  return qe(() => {
    if (!e)
      return;
    let o = Ha.get(e);
    if (o)
      r(o.element.id);
    else {
      let a = `react-aria-description-${A3++}`;
      r(a);
      let u = document.createElement("div");
      u.id = a, u.style.display = "none", u.textContent = e, document.body.appendChild(u), o = {
        refCount: 0,
        element: u
      }, Ha.set(e, o);
    }
    return o.refCount++, () => {
      --o.refCount === 0 && (o.element.remove(), Ha.delete(e));
    };
  }, [
    e
  ]), {
    "aria-describedby": e ? t : void 0
  };
}
function D3(e, t, r, o) {
  let a = St(r), u = r == null;
  Ee(() => {
    if (u)
      return;
    let s = e.current;
    return s.addEventListener(t, a, o), () => {
      s.removeEventListener(t, a, o);
    };
  }, [
    e,
    t,
    o,
    u,
    a
  ]);
}
function Sp(e, t) {
  let r = Id(e, t, "left"), o = Id(e, t, "top"), a = t.offsetWidth, u = t.offsetHeight, s = e.scrollLeft, d = e.scrollTop, { borderTopWidth: f, borderLeftWidth: h } = getComputedStyle(e), v = e.scrollLeft + parseInt(h, 10), m = e.scrollTop + parseInt(f, 10), y = v + e.clientWidth, $ = m + e.clientHeight;
  r <= s ? s = r - parseInt(h, 10) : r + a > y && (s += r + a - y), o <= m ? d = o - parseInt(f, 10) : o + u > $ && (d += o + u - $), e.scrollLeft = s, e.scrollTop = d;
}
function Id(e, t, r) {
  const o = r === "left" ? "offsetLeft" : "offsetTop";
  let a = 0;
  for (; t.offsetParent && (a += t[o], t.offsetParent !== e); ) {
    if (t.offsetParent.contains(e)) {
      a -= e[o];
      break;
    }
    t = t.offsetParent;
  }
  return a;
}
function Bd(e, t) {
  if (document.contains(e)) {
    let s = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(s).overflow === "hidden") {
      let f = tl(e);
      for (; e && f && e !== s && f !== s; )
        Sp(f, e), e = f, f = tl(e);
    } else {
      var r;
      let { left: f, top: h } = e.getBoundingClientRect();
      e == null || (r = e.scrollIntoView) === null || r === void 0 || r.call(e, {
        block: "nearest"
      });
      let { left: v, top: m } = e.getBoundingClientRect();
      if (Math.abs(f - v) > 1 || Math.abs(h - m) > 1) {
        var o, a, u;
        t == null || (a = t.containingElement) === null || a === void 0 || (o = a.scrollIntoView) === null || o === void 0 || o.call(a, {
          block: "center",
          inline: "center"
        }), (u = e.scrollIntoView) === null || u === void 0 || u.call(e, {
          block: "nearest"
        });
      }
    }
  }
}
function du(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : xp() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function F3(e) {
  return !xp() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function Ou(e, t, r) {
  let o = ie(t), a = St(() => {
    r && r(o.current);
  });
  Ee(() => {
    var u;
    let s = e == null || (u = e.current) === null || u === void 0 ? void 0 : u.form;
    return s == null || s.addEventListener("reset", a), () => {
      s == null || s.removeEventListener("reset", a);
    };
  }, [
    e,
    a
  ]);
}
function L3(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function Pp(e, t, r) {
  if (!t.has(e))
    throw new TypeError("attempted to " + r + " private field on non-instance");
  return t.get(e);
}
function R3(e, t) {
  var r = Pp(e, t, "get");
  return L3(e, r);
}
function I3(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function B3(e, t, r) {
  I3(e, t), t.set(e, r);
}
function M3(e, t, r) {
  if (t.set)
    t.set.call(e, r);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = r;
  }
}
function Md(e, t, r) {
  var o = Pp(e, t, "set");
  return M3(e, o, r), r;
}
let Vr = "default", fu = "", qo = /* @__PURE__ */ new WeakMap();
function Kd(e) {
  if (hl()) {
    if (Vr === "default") {
      const t = rt(e);
      fu = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    Vr = "disabled";
  } else
    (e instanceof HTMLElement || e instanceof SVGElement) && (qo.set(e, e.style.userSelect), e.style.userSelect = "none");
}
function No(e) {
  if (hl()) {
    if (Vr !== "disabled")
      return;
    Vr = "restoring", setTimeout(() => {
      wp(() => {
        if (Vr === "restoring") {
          const t = rt(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = fu || ""), fu = "", Vr = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && qo.has(e)) {
    let t = qo.get(e);
    e.style.userSelect === "none" && (e.style.userSelect = t), e.getAttribute("style") === "" && e.removeAttribute("style"), qo.delete(e);
  }
}
const ku = I.createContext({
  register: () => {
  }
});
ku.displayName = "PressResponderContext";
function K3(e) {
  let t = We(ku);
  if (t) {
    let { register: r, ...o } = t;
    e = Se(o, e), r();
  }
  return Ep(t, e.ref), e;
}
var zo = /* @__PURE__ */ new WeakMap();
class Wo {
  continuePropagation() {
    Md(this, zo, !1);
  }
  get shouldStopPropagation() {
    return R3(this, zo);
  }
  constructor(t, r, o) {
    B3(this, zo, {
      writable: !0,
      value: void 0
    }), Md(this, zo, !0), this.type = t, this.pointerType = r, this.target = o.currentTarget, this.shiftKey = o.shiftKey, this.metaKey = o.metaKey, this.ctrlKey = o.ctrlKey, this.altKey = o.altKey;
  }
}
const Od = Symbol("linkClicked");
function Bi(e) {
  let {
    onPress: t,
    onPressChange: r,
    onPressStart: o,
    onPressEnd: a,
    onPressUp: u,
    isDisabled: s,
    isPressed: d,
    preventFocusOnPress: f,
    shouldCancelOnPointerExit: h,
    allowTextSelectionOnPress: v,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: m,
    ...y
  } = K3(e), [$, A] = Ce(!1), _ = ie({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: F, removeAllGlobalListeners: W } = Cp(), R = St((w, Y) => {
    let O = _.current;
    if (s || O.didFirePressStart)
      return !1;
    let K = !0;
    if (O.isTriggeringEvent = !0, o) {
      let k = new Wo("pressstart", Y, w);
      o(k), K = k.shouldStopPropagation;
    }
    return r && r(!0), O.isTriggeringEvent = !1, O.didFirePressStart = !0, A(!0), K;
  }), B = St((w, Y, O = !0) => {
    let K = _.current;
    if (!K.didFirePressStart)
      return !1;
    K.ignoreClickAfterPress = !0, K.didFirePressStart = !1, K.isTriggeringEvent = !0;
    let k = !0;
    if (a) {
      let T = new Wo("pressend", Y, w);
      a(T), k = T.shouldStopPropagation;
    }
    if (r && r(!1), A(!1), t && O && !s) {
      let T = new Wo("press", Y, w);
      t(T), k && (k = T.shouldStopPropagation);
    }
    return K.isTriggeringEvent = !1, k;
  }), V = St((w, Y) => {
    let O = _.current;
    if (s)
      return !1;
    if (u) {
      O.isTriggeringEvent = !0;
      let K = new Wo("pressup", Y, w);
      return u(K), O.isTriggeringEvent = !1, K.shouldStopPropagation;
    }
    return !0;
  }), j = St((w) => {
    let Y = _.current;
    Y.isPressed && Y.target && (Y.isOverTarget && Y.pointerType != null && B(Dn(Y.target, w), Y.pointerType, !1), Y.isPressed = !1, Y.isOverTarget = !1, Y.activePointerId = null, Y.pointerType = null, W(), v || No(Y.target));
  }), G = St((w) => {
    h && j(w);
  }), J = me(() => {
    let w = _.current, Y = {
      onKeyDown(K) {
        if (Ua(K.nativeEvent, K.currentTarget) && K.currentTarget.contains(K.target)) {
          var k;
          Nd(K.target, K.key) && K.preventDefault();
          let T = !0;
          !w.isPressed && !K.repeat && (w.target = K.currentTarget, w.isPressed = !0, T = R(K, "keyboard"), F(rt(K.currentTarget), "keyup", O, !1)), T && K.stopPropagation(), K.metaKey && Gn() && ((k = w.metaKeyEvents) === null || k === void 0 || k.set(K.key, K.nativeEvent));
        } else
          K.key === "Meta" && (w.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onKeyUp(K) {
        Ua(K.nativeEvent, K.currentTarget) && !K.repeat && K.currentTarget.contains(K.target) && w.target && V(Dn(w.target, K), "keyboard");
      },
      onClick(K) {
        if (!(K && !K.currentTarget.contains(K.target)) && K && K.button === 0 && !w.isTriggeringEvent && !dr.isOpening) {
          let k = !0;
          if (s && K.preventDefault(), !w.ignoreClickAfterPress && !w.ignoreEmulatedMouseEvents && !w.isPressed && (w.pointerType === "virtual" || du(K.nativeEvent))) {
            !s && !f && Ln(K.currentTarget);
            let T = R(K, "virtual"), D = V(K, "virtual"), X = B(K, "virtual");
            k = T && D && X;
          }
          w.ignoreEmulatedMouseEvents = !1, w.ignoreClickAfterPress = !1, k && K.stopPropagation();
        }
      }
    }, O = (K) => {
      var k;
      if (w.isPressed && w.target && Ua(K, w.target)) {
        var T;
        Nd(K.target, K.key) && K.preventDefault();
        let X = K.target, Q = B(Dn(w.target, K), "keyboard", w.target.contains(X));
        W(), Q && K.stopPropagation(), K.key !== "Enter" && Nu(w.target) && w.target.contains(X) && !K[Od] && (K[Od] = !0, dr(w.target, K, !1)), w.isPressed = !1, (T = w.metaKeyEvents) === null || T === void 0 || T.delete(K.key);
      } else if (K.key === "Meta" && (!((k = w.metaKeyEvents) === null || k === void 0) && k.size)) {
        var D;
        let X = w.metaKeyEvents;
        w.metaKeyEvents = void 0;
        for (let Q of X.values())
          (D = w.target) === null || D === void 0 || D.dispatchEvent(new KeyboardEvent("keyup", Q));
      }
    };
    if (typeof PointerEvent < "u") {
      Y.onPointerDown = (D) => {
        if (D.button !== 0 || !D.currentTarget.contains(D.target))
          return;
        if (F3(D.nativeEvent)) {
          w.pointerType = "virtual";
          return;
        }
        ja(D.currentTarget) && D.preventDefault(), w.pointerType = D.pointerType;
        let X = !0;
        w.isPressed || (w.isPressed = !0, w.isOverTarget = !0, w.activePointerId = D.pointerId, w.target = D.currentTarget, !s && !f && Ln(D.currentTarget), v || Kd(w.target), X = R(D, w.pointerType), F(rt(D.currentTarget), "pointermove", K, !1), F(rt(D.currentTarget), "pointerup", k, !1), F(rt(D.currentTarget), "pointercancel", T, !1)), X && D.stopPropagation();
      }, Y.onMouseDown = (D) => {
        D.currentTarget.contains(D.target) && D.button === 0 && (ja(D.currentTarget) && D.preventDefault(), D.stopPropagation());
      }, Y.onPointerUp = (D) => {
        !D.currentTarget.contains(D.target) || w.pointerType === "virtual" || D.button === 0 && Kr(D, D.currentTarget) && V(D, w.pointerType || D.pointerType);
      };
      let K = (D) => {
        D.pointerId === w.activePointerId && (w.target && Kr(D, w.target) ? !w.isOverTarget && w.pointerType != null && (w.isOverTarget = !0, R(Dn(w.target, D), w.pointerType)) : w.target && w.isOverTarget && w.pointerType != null && (w.isOverTarget = !1, B(Dn(w.target, D), w.pointerType, !1), G(D)));
      }, k = (D) => {
        D.pointerId === w.activePointerId && w.isPressed && D.button === 0 && w.target && (Kr(D, w.target) && w.pointerType != null ? B(Dn(w.target, D), w.pointerType) : w.isOverTarget && w.pointerType != null && B(Dn(w.target, D), w.pointerType, !1), w.isPressed = !1, w.isOverTarget = !1, w.activePointerId = null, w.pointerType = null, W(), v || No(w.target));
      }, T = (D) => {
        j(D);
      };
      Y.onDragStart = (D) => {
        D.currentTarget.contains(D.target) && j(D);
      };
    } else {
      Y.onMouseDown = (T) => {
        if (T.button !== 0 || !T.currentTarget.contains(T.target))
          return;
        if (ja(T.currentTarget) && T.preventDefault(), w.ignoreEmulatedMouseEvents) {
          T.stopPropagation();
          return;
        }
        w.isPressed = !0, w.isOverTarget = !0, w.target = T.currentTarget, w.pointerType = du(T.nativeEvent) ? "virtual" : "mouse", !s && !f && Ln(T.currentTarget), R(T, w.pointerType) && T.stopPropagation(), F(rt(T.currentTarget), "mouseup", K, !1);
      }, Y.onMouseEnter = (T) => {
        if (!T.currentTarget.contains(T.target))
          return;
        let D = !0;
        w.isPressed && !w.ignoreEmulatedMouseEvents && w.pointerType != null && (w.isOverTarget = !0, D = R(T, w.pointerType)), D && T.stopPropagation();
      }, Y.onMouseLeave = (T) => {
        if (!T.currentTarget.contains(T.target))
          return;
        let D = !0;
        w.isPressed && !w.ignoreEmulatedMouseEvents && w.pointerType != null && (w.isOverTarget = !1, D = B(T, w.pointerType, !1), G(T)), D && T.stopPropagation();
      }, Y.onMouseUp = (T) => {
        T.currentTarget.contains(T.target) && !w.ignoreEmulatedMouseEvents && T.button === 0 && V(T, w.pointerType || "mouse");
      };
      let K = (T) => {
        if (T.button === 0) {
          if (w.isPressed = !1, W(), w.ignoreEmulatedMouseEvents) {
            w.ignoreEmulatedMouseEvents = !1;
            return;
          }
          w.target && Kr(T, w.target) && w.pointerType != null ? B(Dn(w.target, T), w.pointerType) : w.target && w.isOverTarget && w.pointerType != null && B(Dn(w.target, T), w.pointerType, !1), w.isOverTarget = !1;
        }
      };
      Y.onTouchStart = (T) => {
        if (!T.currentTarget.contains(T.target))
          return;
        let D = O3(T.nativeEvent);
        if (!D)
          return;
        w.activePointerId = D.identifier, w.ignoreEmulatedMouseEvents = !0, w.isOverTarget = !0, w.isPressed = !0, w.target = T.currentTarget, w.pointerType = "touch", !s && !f && Ln(T.currentTarget), v || Kd(w.target), R(T, w.pointerType) && T.stopPropagation(), F(Ii(T.currentTarget), "scroll", k, !0);
      }, Y.onTouchMove = (T) => {
        if (!T.currentTarget.contains(T.target))
          return;
        if (!w.isPressed) {
          T.stopPropagation();
          return;
        }
        let D = kd(T.nativeEvent, w.activePointerId), X = !0;
        D && Kr(D, T.currentTarget) ? !w.isOverTarget && w.pointerType != null && (w.isOverTarget = !0, X = R(T, w.pointerType)) : w.isOverTarget && w.pointerType != null && (w.isOverTarget = !1, X = B(T, w.pointerType, !1), G(T)), X && T.stopPropagation();
      }, Y.onTouchEnd = (T) => {
        if (!T.currentTarget.contains(T.target))
          return;
        if (!w.isPressed) {
          T.stopPropagation();
          return;
        }
        let D = kd(T.nativeEvent, w.activePointerId), X = !0;
        D && Kr(D, T.currentTarget) && w.pointerType != null ? (V(T, w.pointerType), X = B(T, w.pointerType)) : w.isOverTarget && w.pointerType != null && (X = B(T, w.pointerType, !1)), X && T.stopPropagation(), w.isPressed = !1, w.activePointerId = null, w.isOverTarget = !1, w.ignoreEmulatedMouseEvents = !0, w.target && !v && No(w.target), W();
      }, Y.onTouchCancel = (T) => {
        T.currentTarget.contains(T.target) && (T.stopPropagation(), w.isPressed && j(T));
      };
      let k = (T) => {
        w.isPressed && T.target.contains(w.target) && j({
          currentTarget: w.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      Y.onDragStart = (T) => {
        T.currentTarget.contains(T.target) && j(T);
      };
    }
    return Y;
  }, [
    F,
    s,
    f,
    W,
    v,
    j,
    G,
    B,
    R,
    V
  ]);
  return Ee(() => () => {
    var w;
    v || No((w = _.current.target) !== null && w !== void 0 ? w : void 0);
  }, [
    v
  ]), {
    isPressed: d || $,
    pressProps: Se(y, J)
  };
}
function Nu(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function Ua(e, t) {
  const { key: r, code: o } = e, a = t, u = a.getAttribute("role");
  return (r === "Enter" || r === " " || r === "Spacebar" || o === "Space") && !(a instanceof Ii(a).HTMLInputElement && !Tp(a, r) || a instanceof Ii(a).HTMLTextAreaElement || a.isContentEditable) && // Links should only trigger with Enter key
  !((u === "link" || !u && Nu(a)) && r !== "Enter");
}
function O3(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function kd(e, t) {
  const r = e.changedTouches;
  for (let o = 0; o < r.length; o++) {
    const a = r[o];
    if (a.identifier === t)
      return a;
  }
  return null;
}
function Dn(e, t) {
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey
  };
}
function k3(e) {
  let t = 0, r = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? r = e.height / 2 : e.radiusY !== void 0 && (r = e.radiusY), {
    top: e.clientY - r,
    right: e.clientX + t,
    bottom: e.clientY + r,
    left: e.clientX - t
  };
}
function N3(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function Kr(e, t) {
  let r = t.getBoundingClientRect(), o = k3(e);
  return N3(r, o);
}
function ja(e) {
  return !(e instanceof HTMLElement) || !e.hasAttribute("draggable");
}
function Nd(e, t) {
  return e instanceof HTMLInputElement ? !Tp(e, t) : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Nu(e);
}
const z3 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Tp(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : z3.has(e.type);
}
function W3({ children: e }) {
  let t = me(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ I.createElement(ku.Provider, {
    value: t
  }, e);
}
class V3 {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, r) {
    this.nativeEvent = r, this.target = r.target, this.currentTarget = r.currentTarget, this.relatedTarget = r.relatedTarget, this.bubbles = r.bubbles, this.cancelable = r.cancelable, this.defaultPrevented = r.defaultPrevented, this.eventPhase = r.eventPhase, this.isTrusted = r.isTrusted, this.timeStamp = r.timeStamp, this.type = t;
  }
}
function Ap(e) {
  let t = ie({
    isFocused: !1,
    observer: null
  });
  qe(() => {
    const o = t.current;
    return () => {
      o.observer && (o.observer.disconnect(), o.observer = null);
    };
  }, []);
  let r = St((o) => {
    e == null || e(o);
  });
  return Pe((o) => {
    if (o.target instanceof HTMLButtonElement || o.target instanceof HTMLInputElement || o.target instanceof HTMLTextAreaElement || o.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = o.target, u = (s) => {
        t.current.isFocused = !1, a.disabled && r(new V3("blur", s)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", u, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          var s;
          (s = t.current.observer) === null || s === void 0 || s.disconnect();
          let d = a === document.activeElement ? null : document.activeElement;
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: d
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: d
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    r
  ]);
}
function _p(e) {
  let { isDisabled: t, onFocus: r, onBlur: o, onFocusChange: a } = e;
  const u = Pe((f) => {
    if (f.target === f.currentTarget)
      return o && o(f), a && a(!1), !0;
  }, [
    o,
    a
  ]), s = Ap(u), d = Pe((f) => {
    f.target === f.currentTarget && document.activeElement === f.target && (r && r(f), a && a(!0), s(f));
  }, [
    a,
    r,
    s
  ]);
  return {
    focusProps: {
      onFocus: !t && (r || a || o) ? d : void 0,
      onBlur: !t && (o || a) ? u : void 0
    }
  };
}
let In = null, Mi = /* @__PURE__ */ new Set(), zd = !1, fr = !1, pu = !1;
const H3 = {
  Tab: !0,
  Escape: !0
};
function vl(e, t) {
  for (let r of Mi)
    r(e, t);
}
function U3(e) {
  return !(e.metaKey || !Gn() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Wd(e) {
  fr = !0, U3(e) && (In = "keyboard", vl("keyboard", e));
}
function Or(e) {
  In = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (fr = !0, vl("pointer", e));
}
function j3(e) {
  du(e) && (fr = !0, In = "virtual");
}
function G3(e) {
  e.target === window || e.target === document || (!fr && !pu && (In = "virtual", vl("virtual", e)), fr = !1, pu = !1);
}
function q3() {
  fr = !1, pu = !0;
}
function rl() {
  if (typeof window > "u" || zd)
    return;
  let e = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function() {
    fr = !0, e.apply(this, arguments);
  }, document.addEventListener("keydown", Wd, !0), document.addEventListener("keyup", Wd, !0), document.addEventListener("click", j3, !0), window.addEventListener("focus", G3, !0), window.addEventListener("blur", q3, !1), typeof PointerEvent < "u" ? (document.addEventListener("pointerdown", Or, !0), document.addEventListener("pointermove", Or, !0), document.addEventListener("pointerup", Or, !0)) : (document.addEventListener("mousedown", Or, !0), document.addEventListener("mousemove", Or, !0), document.addEventListener("mouseup", Or, !0)), zd = !0;
}
typeof document < "u" && (document.readyState !== "loading" ? rl() : document.addEventListener("DOMContentLoaded", rl));
function il() {
  return In !== "pointer";
}
function hu() {
  return In;
}
function Dp(e) {
  In = e, vl(e, null);
}
function Z3() {
  rl();
  let [e, t] = Ce(In);
  return Ee(() => {
    let r = () => {
      t(In);
    };
    return Mi.add(r), () => {
      Mi.delete(r);
    };
  }, []), hr() ? null : e;
}
const Y3 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function X3(e, t, r) {
  var o;
  return e = e || (r == null ? void 0 : r.target) instanceof HTMLInputElement && !Y3.has(r == null || (o = r.target) === null || o === void 0 ? void 0 : o.type) || (r == null ? void 0 : r.target) instanceof HTMLTextAreaElement || (r == null ? void 0 : r.target) instanceof HTMLElement && (r == null ? void 0 : r.target.isContentEditable), !(e && t === "keyboard" && r instanceof KeyboardEvent && !H3[r.key]);
}
function J3(e, t, r) {
  rl(), Ee(() => {
    let o = (a, u) => {
      X3(!!(r != null && r.isTextInput), a, u) && e(il());
    };
    return Mi.add(o), () => {
      Mi.delete(o);
    };
  }, t);
}
function Wi(e) {
  let { isDisabled: t, onBlurWithin: r, onFocusWithin: o, onFocusWithinChange: a } = e, u = ie({
    isFocusWithin: !1
  }), s = Pe((h) => {
    u.current.isFocusWithin && !h.currentTarget.contains(h.relatedTarget) && (u.current.isFocusWithin = !1, r && r(h), a && a(!1));
  }, [
    r,
    a,
    u
  ]), d = Ap(s), f = Pe((h) => {
    !u.current.isFocusWithin && document.activeElement === h.target && (o && o(h), a && a(!0), u.current.isFocusWithin = !0, d(h));
  }, [
    o,
    a,
    d
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: f,
      onBlur: s
    }
  };
}
let ol = !1, Ga = 0;
function vu() {
  ol = !0, setTimeout(() => {
    ol = !1;
  }, 50);
}
function Vd(e) {
  e.pointerType === "touch" && vu();
}
function Q3() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", Vd) : document.addEventListener("touchend", vu), Ga++, () => {
      Ga--, !(Ga > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", Vd) : document.removeEventListener("touchend", vu));
    };
}
function vr(e) {
  let { onHoverStart: t, onHoverChange: r, onHoverEnd: o, isDisabled: a } = e, [u, s] = Ce(!1), d = ie({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  Ee(Q3, []);
  let { hoverProps: f, triggerHoverEnd: h } = me(() => {
    let v = ($, A) => {
      if (d.pointerType = A, a || A === "touch" || d.isHovered || !$.currentTarget.contains($.target))
        return;
      d.isHovered = !0;
      let _ = $.currentTarget;
      d.target = _, t && t({
        type: "hoverstart",
        target: _,
        pointerType: A
      }), r && r(!0), s(!0);
    }, m = ($, A) => {
      if (d.pointerType = "", d.target = null, A === "touch" || !d.isHovered)
        return;
      d.isHovered = !1;
      let _ = $.currentTarget;
      o && o({
        type: "hoverend",
        target: _,
        pointerType: A
      }), r && r(!1), s(!1);
    }, y = {};
    return typeof PointerEvent < "u" ? (y.onPointerEnter = ($) => {
      ol && $.pointerType === "mouse" || v($, $.pointerType);
    }, y.onPointerLeave = ($) => {
      !a && $.currentTarget.contains($.target) && m($, $.pointerType);
    }) : (y.onTouchStart = () => {
      d.ignoreEmulatedMouseEvents = !0;
    }, y.onMouseEnter = ($) => {
      !d.ignoreEmulatedMouseEvents && !ol && v($, "mouse"), d.ignoreEmulatedMouseEvents = !1;
    }, y.onMouseLeave = ($) => {
      !a && $.currentTarget.contains($.target) && m($, "mouse");
    }), {
      hoverProps: y,
      triggerHoverEnd: m
    };
  }, [
    t,
    r,
    o,
    a,
    d
  ]);
  return Ee(() => {
    a && h({
      currentTarget: d.target
    }, d.pointerType);
  }, [
    a
  ]), {
    hoverProps: f,
    isHovered: u
  };
}
function ex(e) {
  let { ref: t, onInteractOutside: r, isDisabled: o, onInteractOutsideStart: a } = e, u = ie({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), s = St((f) => {
    r && Vo(f, t) && (a && a(f), u.current.isPointerDown = !0);
  }), d = St((f) => {
    r && r(f);
  });
  Ee(() => {
    let f = u.current;
    if (o)
      return;
    const h = t.current, v = rt(h);
    if (typeof PointerEvent < "u") {
      let m = (y) => {
        f.isPointerDown && Vo(y, t) && d(y), f.isPointerDown = !1;
      };
      return v.addEventListener("pointerdown", s, !0), v.addEventListener("pointerup", m, !0), () => {
        v.removeEventListener("pointerdown", s, !0), v.removeEventListener("pointerup", m, !0);
      };
    } else {
      let m = ($) => {
        f.ignoreEmulatedMouseEvents ? f.ignoreEmulatedMouseEvents = !1 : f.isPointerDown && Vo($, t) && d($), f.isPointerDown = !1;
      }, y = ($) => {
        f.ignoreEmulatedMouseEvents = !0, f.isPointerDown && Vo($, t) && d($), f.isPointerDown = !1;
      };
      return v.addEventListener("mousedown", s, !0), v.addEventListener("mouseup", m, !0), v.addEventListener("touchstart", s, !0), v.addEventListener("touchend", y, !0), () => {
        v.removeEventListener("mousedown", s, !0), v.removeEventListener("mouseup", m, !0), v.removeEventListener("touchstart", s, !0), v.removeEventListener("touchend", y, !0);
      };
    }
  }, [
    t,
    o,
    s,
    d
  ]);
}
function Vo(e, t) {
  if (e.button > 0)
    return !1;
  if (e.target) {
    const r = e.target.ownerDocument;
    if (!r || !r.documentElement.contains(e.target) || e.target.closest("[data-react-aria-top-layer]"))
      return !1;
  }
  return t.current && !t.current.contains(e.target);
}
function Hd(e) {
  if (!e)
    return;
  let t = !0;
  return (r) => {
    let o = {
      ...r,
      preventDefault() {
        r.preventDefault();
      },
      isDefaultPrevented() {
        return r.isDefaultPrevented();
      },
      stopPropagation() {
        console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
      },
      continuePropagation() {
        t = !1;
      }
    };
    e(o), t && r.stopPropagation();
  };
}
function tx(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: Hd(e.onKeyDown),
      onKeyUp: Hd(e.onKeyUp)
    }
  };
}
const nx = 500;
function Fp(e) {
  let { isDisabled: t, onLongPressStart: r, onLongPressEnd: o, onLongPress: a, threshold: u = nx, accessibilityDescription: s } = e;
  const d = ie();
  let { addGlobalListener: f, removeGlobalListener: h } = Cp(), { pressProps: v } = Bi({
    isDisabled: t,
    onPressStart(y) {
      if (y.continuePropagation(), (y.pointerType === "mouse" || y.pointerType === "touch") && (r && r({
        ...y,
        type: "longpressstart"
      }), d.current = setTimeout(() => {
        y.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), a && a({
          ...y,
          type: "longpress"
        }), d.current = void 0;
      }, u), y.pointerType === "touch")) {
        let $ = (A) => {
          A.preventDefault();
        };
        f(y.target, "contextmenu", $, {
          once: !0
        }), f(window, "pointerup", () => {
          setTimeout(() => {
            h(y.target, "contextmenu", $);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(y) {
      d.current && clearTimeout(d.current), o && (y.pointerType === "mouse" || y.pointerType === "touch") && o({
        ...y,
        type: "longpressend"
      });
    }
  }), m = _3(a && !t ? s : void 0);
  return {
    longPressProps: Se(v, m)
  };
}
function Ki(e) {
  const t = rt(e);
  if (hu() === "virtual") {
    let r = t.activeElement;
    wp(() => {
      t.activeElement === r && e.isConnected && Ln(e);
    });
  } else
    Ln(e);
}
function rx(e) {
  const t = Ii(e);
  if (!(e instanceof t.HTMLElement) && !(e instanceof t.SVGElement))
    return !1;
  let { display: r, visibility: o } = e.style, a = r !== "none" && o !== "hidden" && o !== "collapse";
  if (a) {
    const { getComputedStyle: u } = e.ownerDocument.defaultView;
    let { display: s, visibility: d } = u(e);
    a = s !== "none" && d !== "hidden" && d !== "collapse";
  }
  return a;
}
function ix(e, t) {
  return !e.hasAttribute("hidden") && (e.nodeName === "DETAILS" && t && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function Lp(e, t) {
  return e.nodeName !== "#comment" && rx(e) && ix(e, t) && (!e.parentElement || Lp(e.parentElement, e));
}
const Ud = /* @__PURE__ */ I.createContext(null);
let Ue = null;
function Rp(e) {
  let { children: t, contain: r, restoreFocus: o, autoFocus: a } = e, u = ie(null), s = ie(null), d = ie([]), { parentNode: f } = We(Ud) || {}, h = me(() => new gu({
    scopeRef: d
  }), [
    d
  ]);
  qe(() => {
    let y = f || it.root;
    if (it.getTreeNode(y.scopeRef) && Ue && !al(Ue, y.scopeRef)) {
      let $ = it.getTreeNode(Ue);
      $ && (y = $);
    }
    y.addChild(h), it.addNode(h);
  }, [
    h,
    f
  ]), qe(() => {
    let y = it.getTreeNode(d);
    y && (y.contain = !!r);
  }, [
    r
  ]), qe(() => {
    var y;
    let $ = (y = u.current) === null || y === void 0 ? void 0 : y.nextSibling, A = [];
    for (; $ && $ !== s.current; )
      A.push($), $ = $.nextSibling;
    d.current = A;
  }, [
    t
  ]), dx(d, o, r), ux(d, r), px(d, o, r), cx(d, a), Ee(() => {
    const y = rt(d.current ? d.current[0] : void 0).activeElement;
    let $ = null;
    if ($t(y, d.current)) {
      for (let A of it.traverse())
        A.scopeRef && $t(y, A.scopeRef.current) && ($ = A);
      $ === it.getTreeNode(d) && (Ue = $.scopeRef);
    }
  }, [
    d
  ]), qe(() => () => {
    var y, $, A;
    let _ = (A = ($ = it.getTreeNode(d)) === null || $ === void 0 || (y = $.parent) === null || y === void 0 ? void 0 : y.scopeRef) !== null && A !== void 0 ? A : null;
    (d === Ue || al(d, Ue)) && (!_ || it.getTreeNode(_)) && (Ue = _), it.removeTreeNode(d);
  }, [
    d
  ]);
  let v = me(() => ox(d), []), m = me(() => ({
    focusManager: v,
    parentNode: h
  }), [
    h,
    v
  ]);
  return /* @__PURE__ */ I.createElement(Ud.Provider, {
    value: m
  }, /* @__PURE__ */ I.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: u
  }), t, /* @__PURE__ */ I.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: s
  }));
}
function ox(e) {
  return {
    focusNext(t = {}) {
      let r = e.current, { from: o, tabbable: a, wrap: u, accept: s } = t, d = o || rt(r[0]).activeElement, f = r[0].previousElementSibling, h = ur(r), v = vn(h, {
        tabbable: a,
        accept: s
      }, r);
      v.currentNode = $t(d, r) ? d : f;
      let m = v.nextNode();
      return !m && u && (v.currentNode = f, m = v.nextNode()), m && Rn(m, !0), m;
    },
    focusPrevious(t = {}) {
      let r = e.current, { from: o, tabbable: a, wrap: u, accept: s } = t, d = o || rt(r[0]).activeElement, f = r[r.length - 1].nextElementSibling, h = ur(r), v = vn(h, {
        tabbable: a,
        accept: s
      }, r);
      v.currentNode = $t(d, r) ? d : f;
      let m = v.previousNode();
      return !m && u && (v.currentNode = f, m = v.previousNode()), m && Rn(m, !0), m;
    },
    focusFirst(t = {}) {
      let r = e.current, { tabbable: o, accept: a } = t, u = ur(r), s = vn(u, {
        tabbable: o,
        accept: a
      }, r);
      s.currentNode = r[0].previousElementSibling;
      let d = s.nextNode();
      return d && Rn(d, !0), d;
    },
    focusLast(t = {}) {
      let r = e.current, { tabbable: o, accept: a } = t, u = ur(r), s = vn(u, {
        tabbable: o,
        accept: a
      }, r);
      s.currentNode = r[r.length - 1].nextElementSibling;
      let d = s.previousNode();
      return d && Rn(d, !0), d;
    }
  };
}
const zu = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]"
], lx = zu.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
zu.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const ax = zu.join(':not([hidden]):not([tabindex="-1"]),');
function ur(e) {
  return e[0].parentElement;
}
function Li(e) {
  let t = it.getTreeNode(Ue);
  for (; t && t.scopeRef !== e; ) {
    if (t.contain)
      return !1;
    t = t.parent;
  }
  return !0;
}
function ux(e, t) {
  let r = ie(), o = ie();
  qe(() => {
    let a = e.current;
    if (!t) {
      o.current && (cancelAnimationFrame(o.current), o.current = void 0);
      return;
    }
    const u = rt(a ? a[0] : void 0);
    let s = (h) => {
      if (h.key !== "Tab" || h.altKey || h.ctrlKey || h.metaKey || !Li(e))
        return;
      let v = u.activeElement, m = e.current;
      if (!m || !$t(v, m))
        return;
      let y = ur(m), $ = vn(y, {
        tabbable: !0
      }, m);
      if (!v)
        return;
      $.currentNode = v;
      let A = h.shiftKey ? $.previousNode() : $.nextNode();
      A || ($.currentNode = h.shiftKey ? m[m.length - 1].nextElementSibling : m[0].previousElementSibling, A = h.shiftKey ? $.previousNode() : $.nextNode()), h.preventDefault(), A && Rn(A, !0);
    }, d = (h) => {
      (!Ue || al(Ue, e)) && $t(h.target, e.current) ? (Ue = e, r.current = h.target) : Li(e) && !ll(h.target, e) ? r.current ? r.current.focus() : Ue && Ue.current && ul(Ue.current) : Li(e) && (r.current = h.target);
    }, f = (h) => {
      o.current && cancelAnimationFrame(o.current), o.current = requestAnimationFrame(() => {
        if (u.activeElement && Li(e) && !ll(u.activeElement, e))
          if (Ue = e, u.body.contains(h.target)) {
            var v;
            r.current = h.target, (v = r.current) === null || v === void 0 || v.focus();
          } else
            Ue.current && ul(Ue.current);
      });
    };
    return u.addEventListener("keydown", s, !1), u.addEventListener("focusin", d, !1), a == null || a.forEach((h) => h.addEventListener("focusin", d, !1)), a == null || a.forEach((h) => h.addEventListener("focusout", f, !1)), () => {
      u.removeEventListener("keydown", s, !1), u.removeEventListener("focusin", d, !1), a == null || a.forEach((h) => h.removeEventListener("focusin", d, !1)), a == null || a.forEach((h) => h.removeEventListener("focusout", f, !1));
    };
  }, [
    e,
    t
  ]), qe(() => () => {
    o.current && cancelAnimationFrame(o.current);
  }, [
    o
  ]);
}
function Ip(e) {
  return ll(e);
}
function $t(e, t) {
  return !e || !t ? !1 : t.some((r) => r.contains(e));
}
function ll(e, t = null) {
  if (e instanceof Element && e.closest("[data-react-aria-top-layer]"))
    return !0;
  for (let { scopeRef: r } of it.traverse(it.getTreeNode(t)))
    if (r && $t(e, r.current))
      return !0;
  return !1;
}
function sx(e) {
  return ll(e, Ue);
}
function al(e, t) {
  var r;
  let o = (r = it.getTreeNode(t)) === null || r === void 0 ? void 0 : r.parent;
  for (; o; ) {
    if (o.scopeRef === e)
      return !0;
    o = o.parent;
  }
  return !1;
}
function Rn(e, t = !1) {
  if (e != null && !t)
    try {
      Ki(e);
    } catch {
    }
  else if (e != null)
    try {
      e.focus();
    } catch {
    }
}
function ul(e, t = !0) {
  let r = e[0].previousElementSibling, o = ur(e), a = vn(o, {
    tabbable: t
  }, e);
  a.currentNode = r;
  let u = a.nextNode();
  t && !u && (o = ur(e), a = vn(o, {
    tabbable: !1
  }, e), a.currentNode = r, u = a.nextNode()), Rn(u);
}
function cx(e, t) {
  const r = I.useRef(t);
  Ee(() => {
    if (r.current) {
      Ue = e;
      const o = rt(e.current ? e.current[0] : void 0);
      !$t(o.activeElement, Ue.current) && e.current && ul(e.current);
    }
    r.current = !1;
  }, [
    e
  ]);
}
function dx(e, t, r) {
  qe(() => {
    if (t || r)
      return;
    let o = e.current;
    const a = rt(o ? o[0] : void 0);
    let u = (s) => {
      let d = s.target;
      $t(d, e.current) ? Ue = e : Ip(d) || (Ue = null);
    };
    return a.addEventListener("focusin", u, !1), o == null || o.forEach((s) => s.addEventListener("focusin", u, !1)), () => {
      a.removeEventListener("focusin", u, !1), o == null || o.forEach((s) => s.removeEventListener("focusin", u, !1));
    };
  }, [
    e,
    t,
    r
  ]);
}
function fx(e) {
  let t = it.getTreeNode(Ue);
  for (; t && t.scopeRef !== e; ) {
    if (t.nodeToRestore)
      return !1;
    t = t.parent;
  }
  return (t == null ? void 0 : t.scopeRef) === e;
}
function px(e, t, r) {
  const o = ie(typeof document < "u" ? rt(e.current ? e.current[0] : void 0).activeElement : null);
  qe(() => {
    let a = e.current;
    const u = rt(a ? a[0] : void 0);
    if (!t || r)
      return;
    let s = () => {
      (!Ue || al(Ue, e)) && $t(u.activeElement, e.current) && (Ue = e);
    };
    return u.addEventListener("focusin", s, !1), a == null || a.forEach((d) => d.addEventListener("focusin", s, !1)), () => {
      u.removeEventListener("focusin", s, !1), a == null || a.forEach((d) => d.removeEventListener("focusin", s, !1));
    };
  }, [
    e,
    r
  ]), qe(() => {
    const a = rt(e.current ? e.current[0] : void 0);
    if (!t)
      return;
    let u = (s) => {
      if (s.key !== "Tab" || s.altKey || s.ctrlKey || s.metaKey || !Li(e))
        return;
      let d = a.activeElement;
      if (!$t(d, e.current))
        return;
      let f = it.getTreeNode(e);
      if (!f)
        return;
      let h = f.nodeToRestore, v = vn(a.body, {
        tabbable: !0
      });
      v.currentNode = d;
      let m = s.shiftKey ? v.previousNode() : v.nextNode();
      if ((!h || !a.body.contains(h) || h === a.body) && (h = void 0, f.nodeToRestore = void 0), (!m || !$t(m, e.current)) && h) {
        v.currentNode = h;
        do
          m = s.shiftKey ? v.previousNode() : v.nextNode();
        while ($t(m, e.current));
        s.preventDefault(), s.stopPropagation(), m ? Rn(m, !0) : Ip(h) ? Rn(h, !0) : d.blur();
      }
    };
    return r || a.addEventListener("keydown", u, !0), () => {
      r || a.removeEventListener("keydown", u, !0);
    };
  }, [
    e,
    t,
    r
  ]), qe(() => {
    const a = rt(e.current ? e.current[0] : void 0);
    if (!t)
      return;
    let u = it.getTreeNode(e);
    if (u) {
      var s;
      return u.nodeToRestore = (s = o.current) !== null && s !== void 0 ? s : void 0, () => {
        let d = it.getTreeNode(e);
        if (!d)
          return;
        let f = d.nodeToRestore;
        if (t && f && // eslint-disable-next-line react-hooks/exhaustive-deps
        ($t(a.activeElement, e.current) || a.activeElement === a.body && fx(e))) {
          let h = it.clone();
          requestAnimationFrame(() => {
            if (a.activeElement === a.body) {
              let v = h.getTreeNode(e);
              for (; v; ) {
                if (v.nodeToRestore && v.nodeToRestore.isConnected) {
                  Rn(v.nodeToRestore);
                  return;
                }
                v = v.parent;
              }
              for (v = h.getTreeNode(e); v; ) {
                if (v.scopeRef && v.scopeRef.current && it.getTreeNode(v.scopeRef)) {
                  ul(v.scopeRef.current, !0);
                  return;
                }
                v = v.parent;
              }
            }
          });
        }
      };
    }
  }, [
    e,
    t
  ]);
}
function vn(e, t, r) {
  let o = t != null && t.tabbable ? ax : lx, a = rt(e).createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode(u) {
      var s;
      return !(t == null || (s = t.from) === null || s === void 0) && s.contains(u) ? NodeFilter.FILTER_REJECT : u.matches(o) && Lp(u) && (!r || $t(u, r)) && (!(t != null && t.accept) || t.accept(u)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return t != null && t.from && (a.currentNode = t.from), a;
}
class Wu {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, r, o) {
    let a = this.fastMap.get(r ?? null);
    if (!a)
      return;
    let u = new gu({
      scopeRef: t
    });
    a.addChild(u), u.parent = a, this.fastMap.set(t, u), o && (u.nodeToRestore = o);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null)
      return;
    let r = this.fastMap.get(t);
    if (!r)
      return;
    let o = r.parent;
    for (let u of this.traverse())
      u !== r && r.nodeToRestore && u.nodeToRestore && r.scopeRef && r.scopeRef.current && $t(u.nodeToRestore, r.scopeRef.current) && (u.nodeToRestore = r.nodeToRestore);
    let a = r.children;
    o && (o.removeChild(r), a.size > 0 && a.forEach((u) => o && o.addChild(u))), this.fastMap.delete(r.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0)
      for (let r of t.children)
        yield* this.traverse(r);
  }
  clone() {
    var t;
    let r = new Wu();
    var o;
    for (let a of this.traverse())
      r.addTreeNode(a.scopeRef, (o = (t = a.parent) === null || t === void 0 ? void 0 : t.scopeRef) !== null && o !== void 0 ? o : null, a.nodeToRestore);
    return r;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new gu({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class gu {
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
}
let it = new Wu();
function gr(e = {}) {
  let { autoFocus: t = !1, isTextInput: r, within: o } = e, a = ie({
    isFocused: !1,
    isFocusVisible: t || il()
  }), [u, s] = Ce(!1), [d, f] = Ce(() => a.current.isFocused && a.current.isFocusVisible), h = Pe(() => f(a.current.isFocused && a.current.isFocusVisible), []), v = Pe(($) => {
    a.current.isFocused = $, s($), h();
  }, [
    h
  ]);
  J3(($) => {
    a.current.isFocusVisible = $, h();
  }, [], {
    isTextInput: r
  });
  let { focusProps: m } = _p({
    isDisabled: o,
    onFocusChange: v
  }), { focusWithinProps: y } = Wi({
    isDisabled: !o,
    onFocusWithinChange: v
  });
  return {
    isFocused: u,
    isFocusVisible: d,
    focusProps: o ? y : m
  };
}
let hx = /* @__PURE__ */ I.createContext(null);
function vx(e) {
  let t = We(hx) || {};
  Ep(t, e);
  let { ref: r, ...o } = t;
  return o;
}
function Vu(e, t) {
  let { focusProps: r } = _p(e), { keyboardProps: o } = tx(e), a = Se(r, o), u = vx(t), s = e.isDisabled ? {} : u, d = ie(e.autoFocus);
  return Ee(() => {
    d.current && t.current && Ki(t.current), d.current = !1;
  }, [
    t
  ]), {
    focusableProps: Se({
      ...a,
      tabIndex: e.excludeFromTabOrder && !e.isDisabled ? -1 : void 0
    }, s)
  };
}
const gx = Symbol.for("react-aria.i18n.locale"), bx = Symbol.for("react-aria.i18n.strings");
let kr;
class gl {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(t, r) {
    let a = this.getStringsForLocale(r)[t];
    if (!a)
      throw new Error(`Could not find intl message ${t} in ${r} locale`);
    return a;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(t) {
    let r = this.strings[t];
    return r || (r = mx(t, this.strings, this.defaultLocale), this.strings[t] = r), r;
  }
  static getGlobalDictionaryForPackage(t) {
    if (typeof window > "u")
      return null;
    let r = window[gx];
    if (kr === void 0) {
      let a = window[bx];
      if (!a)
        return null;
      kr = {};
      for (let u in a)
        kr[u] = new gl({
          [r]: a[u]
        }, r);
    }
    let o = kr == null ? void 0 : kr[t];
    if (!o)
      throw new Error(`Strings for package "${t}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return o;
  }
  constructor(t, r = "en-US") {
    this.strings = {
      ...t
    }, this.defaultLocale = r;
  }
}
function mx(e, t, r = "en-US") {
  if (t[e])
    return t[e];
  let o = $x(e);
  if (t[o])
    return t[o];
  for (let a in t)
    if (a.startsWith(o + "-"))
      return t[a];
  return t[r];
}
function $x(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const jd = /* @__PURE__ */ new Map(), Gd = /* @__PURE__ */ new Map();
class yx {
  /** Formats a localized string for the given key with the provided variables. */
  format(t, r) {
    let o = this.strings.getStringForLocale(t, this.locale);
    return typeof o == "function" ? o(r, this) : o;
  }
  plural(t, r, o = "cardinal") {
    let a = r["=" + t];
    if (a)
      return typeof a == "function" ? a() : a;
    let u = this.locale + ":" + o, s = jd.get(u);
    s || (s = new Intl.PluralRules(this.locale, {
      type: o
    }), jd.set(u, s));
    let d = s.select(t);
    return a = r[d] || r.other, typeof a == "function" ? a() : a;
  }
  number(t) {
    let r = Gd.get(this.locale);
    return r || (r = new Intl.NumberFormat(this.locale), Gd.set(this.locale, r)), r.format(t);
  }
  select(t, r) {
    let o = t[r] || t.other;
    return typeof o == "function" ? o() : o;
  }
  constructor(t, r) {
    this.locale = t, this.strings = r;
  }
}
let qa = /* @__PURE__ */ new Map(), bu = !1;
try {
  bu = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let sl = !1;
try {
  sl = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const Bp = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class xx {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(t) {
    let r = "";
    if (!bu && this.options.signDisplay != null ? r = Cx(this.numberFormatter, this.options.signDisplay, t) : r = this.numberFormatter.format(t), this.options.style === "unit" && !sl) {
      var o;
      let { unit: a, unitDisplay: u = "short", locale: s } = this.resolvedOptions();
      if (!a)
        return r;
      let d = (o = Bp[a]) === null || o === void 0 ? void 0 : o[u];
      r += d[s] || d.default;
    }
    return r;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, r) {
    if (typeof this.numberFormatter.formatRange == "function")
      return this.numberFormatter.formatRange(t, r);
    if (r < t)
      throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(r)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, r) {
    if (typeof this.numberFormatter.formatRangeToParts == "function")
      return this.numberFormatter.formatRangeToParts(t, r);
    if (r < t)
      throw new RangeError("End date must be >= start date");
    let o = this.numberFormatter.formatToParts(t), a = this.numberFormatter.formatToParts(r);
    return [
      ...o.map((u) => ({
        ...u,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...a.map((u) => ({
        ...u,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !bu && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !sl && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
  constructor(t, r = {}) {
    this.numberFormatter = wx(t, r), this.options = r;
  }
}
function wx(e, t = {}) {
  let { numberingSystem: r } = t;
  if (r && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${r}`), t.style === "unit" && !sl) {
    var o;
    let { unit: s, unitDisplay: d = "short" } = t;
    if (!s)
      throw new Error('unit option must be provided with style: "unit"');
    if (!(!((o = Bp[s]) === null || o === void 0) && o[d]))
      throw new Error(`Unsupported unit ${s} with unitDisplay = ${d}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let a = e + (t ? Object.entries(t).sort((s, d) => s[0] < d[0] ? -1 : 1).join() : "");
  if (qa.has(a))
    return qa.get(a);
  let u = new Intl.NumberFormat(e, t);
  return qa.set(a, u), u;
}
function Cx(e, t, r) {
  if (t === "auto")
    return e.format(r);
  if (t === "never")
    return e.format(Math.abs(r));
  {
    let o = !1;
    if (t === "always" ? o = r > 0 || Object.is(r, 0) : t === "exceptZero" && (Object.is(r, -0) || Object.is(r, 0) ? r = Math.abs(r) : o = r > 0), o) {
      let a = e.format(-r), u = e.format(r), s = a.replace(u, "").replace(/\u200e|\u061C/, "");
      return [
        ...s
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), a.replace(u, "!!!").replace(s, "+").replace("!!!", u);
    } else
      return e.format(r);
  }
}
const Ex = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Sx = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Px(e) {
  if (Intl.Locale) {
    let r = new Intl.Locale(e).maximize(), o = typeof r.getTextInfo == "function" ? r.getTextInfo() : r.textInfo;
    if (o)
      return o.direction === "rtl";
    if (r.script)
      return Ex.has(r.script);
  }
  let t = e.split("-")[0];
  return Sx.has(t);
}
const Tx = Symbol.for("react-aria.i18n.locale");
function Mp() {
  let e = typeof window < "u" && window[Tx] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: Px(e) ? "rtl" : "ltr"
  };
}
let mu = Mp(), Ri = /* @__PURE__ */ new Set();
function qd() {
  mu = Mp();
  for (let e of Ri)
    e(mu);
}
function Ax() {
  let e = hr(), [t, r] = Ce(mu);
  return Ee(() => (Ri.size === 0 && window.addEventListener("languagechange", qd), Ri.add(r), () => {
    Ri.delete(r), Ri.size === 0 && window.removeEventListener("languagechange", qd);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : t;
}
const _x = /* @__PURE__ */ I.createContext(null);
function br() {
  let e = Ax();
  return We(_x) || e;
}
const Zd = /* @__PURE__ */ new WeakMap();
function Dx(e) {
  let t = Zd.get(e);
  return t || (t = new gl(e), Zd.set(e, t)), t;
}
function Fx(e, t) {
  return t && gl.getGlobalDictionaryForPackage(t) || Dx(e);
}
function bl(e, t) {
  let { locale: r } = br(), o = Fx(e, t);
  return me(() => new yx(r, o), [
    r,
    o
  ]);
}
function Lx(e = {}) {
  let { locale: t } = br();
  return me(() => new xx(t, e), [
    t,
    e
  ]);
}
let Za = /* @__PURE__ */ new Map();
function ml(e) {
  let { locale: t } = br(), r = t + (e ? Object.entries(e).sort((a, u) => a[0] < u[0] ? -1 : 1).join() : "");
  if (Za.has(r))
    return Za.get(r);
  let o = new Intl.Collator(t, e);
  return Za.set(r, o), o;
}
function Rx(e) {
  let t = ml({
    usage: "search",
    ...e
  }), r = Pe((u, s) => s.length === 0 ? !0 : (u = u.normalize("NFC"), s = s.normalize("NFC"), t.compare(u.slice(0, s.length), s) === 0), [
    t
  ]), o = Pe((u, s) => s.length === 0 ? !0 : (u = u.normalize("NFC"), s = s.normalize("NFC"), t.compare(u.slice(-s.length), s) === 0), [
    t
  ]), a = Pe((u, s) => {
    if (s.length === 0)
      return !0;
    u = u.normalize("NFC"), s = s.normalize("NFC");
    let d = 0, f = s.length;
    for (; d + f <= u.length; d++) {
      let h = u.slice(d, d + f);
      if (t.compare(s, h) === 0)
        return !0;
    }
    return !1;
  }, [
    t
  ]);
  return me(() => ({
    startsWith: r,
    endsWith: o,
    contains: a
  }), [
    r,
    o,
    a
  ]);
}
function Kp(e, t) {
  let {
    elementType: r = "button",
    isDisabled: o,
    onPress: a,
    onPressStart: u,
    onPressEnd: s,
    onPressUp: d,
    onPressChange: f,
    preventFocusOnPress: h,
    allowFocusWhenDisabled: v,
    // @ts-ignore
    onClick: m,
    href: y,
    target: $,
    rel: A,
    type: _ = "button"
  } = e, F;
  r === "button" ? F = {
    type: _,
    disabled: o
  } : F = {
    role: "button",
    tabIndex: o ? void 0 : 0,
    href: r === "a" && o ? void 0 : y,
    target: r === "a" ? $ : void 0,
    type: r === "input" ? _ : void 0,
    disabled: r === "input" ? o : void 0,
    "aria-disabled": !o || r === "input" ? void 0 : o,
    rel: r === "a" ? A : void 0
  };
  let { pressProps: W, isPressed: R } = Bi({
    onPressStart: u,
    onPressEnd: s,
    onPressChange: f,
    onPress: a,
    onPressUp: d,
    isDisabled: o,
    preventFocusOnPress: h,
    ref: t
  }), { focusableProps: B } = Vu(e, t);
  v && (B.tabIndex = o ? -1 : B.tabIndex);
  let V = Se(B, W, at(e, {
    labelable: !0
  }));
  return {
    isPressed: R,
    buttonProps: Se(F, V, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      onClick: (j) => {
        m && (m(j), console.warn("onClick is deprecated, please use onPress"));
      }
    })
  };
}
function Ix(e, t, r) {
  const { isSelected: o } = t, { isPressed: a, buttonProps: u } = Kp({
    ...e,
    onPress: cr(t.toggle, e.onPress)
  }, r);
  return {
    isPressed: a,
    buttonProps: Se(u, {
      "aria-pressed": o
    })
  };
}
const Op = 7e3;
let Ya = null;
function Xa(e, t = "assertive", r = Op) {
  Ya || (Ya = new Bx()), Ya.announce(e, t, r);
}
class Bx {
  createLog(t) {
    let r = document.createElement("div");
    return r.setAttribute("role", "log"), r.setAttribute("aria-live", t), r.setAttribute("aria-relevant", "additions"), r;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, r = "assertive", o = Op) {
    if (!this.node)
      return;
    let a = document.createElement("div");
    a.textContent = t, r === "assertive" ? this.assertiveLog.appendChild(a) : this.politeLog.appendChild(a), t !== "" && setTimeout(() => {
      a.remove();
    }, o);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node);
  }
}
function Hu(e, t, r) {
  let { validationBehavior: o, focus: a } = e;
  qe(() => {
    if (o === "native" && (r != null && r.current)) {
      let f = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      r.current.setCustomValidity(f), r.current.hasAttribute("title") || (r.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(Kx(r.current));
    }
  });
  let u = St(() => {
    t.resetValidation();
  }), s = St((f) => {
    var h;
    t.displayValidation.isInvalid || t.commitValidation();
    let v = r == null || (h = r.current) === null || h === void 0 ? void 0 : h.form;
    if (!f.defaultPrevented && r && v && Ox(v) === r.current) {
      var m;
      a ? a() : (m = r.current) === null || m === void 0 || m.focus(), Dp("keyboard");
    }
    f.preventDefault();
  }), d = St(() => {
    t.commitValidation();
  });
  Ee(() => {
    let f = r == null ? void 0 : r.current;
    if (!f)
      return;
    let h = f.form;
    return f.addEventListener("invalid", s), f.addEventListener("change", d), h == null || h.addEventListener("reset", u), () => {
      f.removeEventListener("invalid", s), f.removeEventListener("change", d), h == null || h.removeEventListener("reset", u);
    };
  }, [
    r,
    s,
    d,
    u,
    o
  ]);
}
function Mx(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function Kx(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: Mx(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function Ox(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let r = e.elements[t];
    if (!r.validity.valid)
      return r;
  }
  return null;
}
const kp = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, Np = {
  ...kp,
  customError: !0,
  valid: !1
}, Ei = {
  isInvalid: !1,
  validationDetails: kp,
  validationErrors: []
}, kx = Fe({}), $u = "__formValidationState" + Date.now();
function $l(e) {
  if (e[$u]) {
    let { realtimeValidation: t, displayValidation: r, updateValidation: o, resetValidation: a, commitValidation: u } = e[$u];
    return {
      realtimeValidation: t,
      displayValidation: r,
      updateValidation: o,
      resetValidation: a,
      commitValidation: u
    };
  }
  return Nx(e);
}
function Nx(e) {
  let { isInvalid: t, validationState: r, name: o, value: a, builtinValidation: u, validate: s, validationBehavior: d = "aria" } = e;
  r && (t || (t = r === "invalid"));
  let f = t ? {
    isInvalid: !0,
    validationErrors: [],
    validationDetails: Np
  } : null, h = me(() => Yd(zx(s, a)), [
    s,
    a
  ]);
  u != null && u.validationDetails.valid && (u = null);
  let v = We(kx), m = me(() => o ? Array.isArray(o) ? o.flatMap((O) => yu(v[O])) : yu(v[o]) : [], [
    v,
    o
  ]), [y, $] = Ce(v), [A, _] = Ce(!1);
  v !== y && ($(v), _(!1));
  let F = me(() => Yd(A ? [] : m), [
    A,
    m
  ]), W = ie(Ei), [R, B] = Ce(Ei), V = ie(Ei), j = () => {
    if (!G)
      return;
    J(!1);
    let O = h || u || W.current;
    Ja(O, V.current) || (V.current = O, B(O));
  }, [G, J] = Ce(!1);
  return Ee(j), {
    realtimeValidation: f || F || h || u || Ei,
    displayValidation: d === "native" ? f || F || R : f || F || h || u || R,
    updateValidation(O) {
      d === "aria" && !Ja(R, O) ? B(O) : W.current = O;
    },
    resetValidation() {
      let O = Ei;
      Ja(O, V.current) || (V.current = O, B(O)), d === "native" && J(!1), _(!0);
    },
    commitValidation() {
      d === "native" && J(!0), _(!0);
    }
  };
}
function yu(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function zx(e, t) {
  if (typeof e == "function") {
    let r = e(t);
    if (r && typeof r != "boolean")
      return yu(r);
  }
  return [];
}
function Yd(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: Np
  } : null;
}
function Ja(e, t) {
  return e === t ? !0 : e && t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((r, o) => r === t.validationErrors[o]) && Object.entries(e.validationDetails).every(([r, o]) => t.validationDetails[r] === o);
}
function Uu(e) {
  let { id: t, label: r, "aria-labelledby": o, "aria-label": a, labelElementType: u = "label" } = e;
  t = gn(t);
  let s = gn(), d = {};
  r ? (o = o ? `${s} ${o}` : s, d = {
    id: s,
    htmlFor: u === "label" ? t : void 0
  }) : !o && !a && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let f = el({
    id: t,
    "aria-label": a,
    "aria-labelledby": o
  });
  return {
    labelProps: d,
    fieldProps: f
  };
}
function ju(e) {
  let { description: t, errorMessage: r, isInvalid: o, validationState: a } = e, { labelProps: u, fieldProps: s } = Uu(e), d = Qo([
    !!t,
    !!r,
    o,
    a
  ]), f = Qo([
    !!t,
    !!r,
    o,
    a
  ]);
  return s = Se(s, {
    "aria-describedby": [
      d,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      f,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: u,
    fieldProps: s,
    descriptionProps: {
      id: d
    },
    errorMessageProps: {
      id: f
    }
  };
}
function Wx(e = {}) {
  let { isReadOnly: t } = e, [r, o] = pr(e.isSelected, e.defaultSelected || !1, e.onChange);
  function a(s) {
    t || o(s);
  }
  function u() {
    t || o(!r);
  }
  return {
    isSelected: r,
    setSelected: a,
    toggle: u
  };
}
var zp = {};
zp = {
  buttonLabel: "عرض المقترحات",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} خيار`,
    other: () => `${t.number(e.optionCount)} خيارات`
  })} متاحة.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `المجموعة المدخلة ${e.groupTitle}, مع ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} خيار`,
      other: () => `${t.number(e.groupCount)} خيارات`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", محدد",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "مقترحات",
  selectedAnnouncement: (e) => `${e.optionText}، محدد`
};
var Wp = {};
Wp = {
  buttonLabel: "Покажи предложения",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} опция`,
    other: () => `${t.number(e.optionCount)} опции`
  })} на разположение.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Въведена група ${e.groupTitle}, с ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} опция`,
      other: () => `${t.number(e.groupCount)} опции`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", избрани",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Предложения",
  selectedAnnouncement: (e) => `${e.optionText}, избрани`
};
var Vp = {};
Vp = {
  buttonLabel: "Zobrazit doporučení",
  countAnnouncement: (e, t) => `K dispozici ${t.plural(e.optionCount, {
    one: () => `je ${t.number(e.optionCount)} možnost`,
    other: () => `jsou/je ${t.number(e.optionCount)} možnosti/-í`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Zadaná skupina „${e.groupTitle}“ ${t.plural(e.groupCount, {
      one: () => `s ${t.number(e.groupCount)} možností`,
      other: () => `se ${t.number(e.groupCount)} možnostmi`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: " (vybráno)",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Návrhy",
  selectedAnnouncement: (e) => `${e.optionText}, vybráno`
};
var Hp = {};
Hp = {
  buttonLabel: "Vis forslag",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} mulighed tilgængelig`,
    other: () => `${t.number(e.optionCount)} muligheder tilgængelige`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Angivet gruppe ${e.groupTitle}, med ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} mulighed`,
      other: () => `${t.number(e.groupCount)} muligheder`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valgt",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Forslag",
  selectedAnnouncement: (e) => `${e.optionText}, valgt`
};
var Up = {};
Up = {
  buttonLabel: "Empfehlungen anzeigen",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} Option`,
    other: () => `${t.number(e.optionCount)} Optionen`
  })} verfügbar.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Eingetretene Gruppe ${e.groupTitle}, mit ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} Option`,
      other: () => `${t.number(e.groupCount)} Optionen`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", ausgewählt",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Empfehlungen",
  selectedAnnouncement: (e) => `${e.optionText}, ausgewählt`
};
var jp = {};
jp = {
  buttonLabel: "Προβολή προτάσεων",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} επιλογή`,
    other: () => `${t.number(e.optionCount)} επιλογές `
  })} διαθέσιμες.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Εισαγμένη ομάδα ${e.groupTitle}, με ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} επιλογή`,
      other: () => `${t.number(e.groupCount)} επιλογές`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", επιλεγμένο",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Προτάσεις",
  selectedAnnouncement: (e) => `${e.optionText}, επιλέχθηκε`
};
var Gp = {};
Gp = {
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Entered group ${e.groupTitle}, with ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} option`,
      other: () => `${t.number(e.groupCount)} options`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selected",
    other: ""
  }, e.isSelected)}`,
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} option`,
    other: () => `${t.number(e.optionCount)} options`
  })} available.`,
  selectedAnnouncement: (e) => `${e.optionText}, selected`,
  buttonLabel: "Show suggestions",
  listboxLabel: "Suggestions"
};
var qp = {};
qp = {
  buttonLabel: "Mostrar sugerencias",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opción`,
    other: () => `${t.number(e.optionCount)} opciones`
  })} disponible(s).`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Se ha unido al grupo ${e.groupTitle}, con ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opción`,
      other: () => `${t.number(e.groupCount)} opciones`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", seleccionado",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugerencias",
  selectedAnnouncement: (e) => `${e.optionText}, seleccionado`
};
var Zp = {};
Zp = {
  buttonLabel: "Kuva soovitused",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} valik`,
    other: () => `${t.number(e.optionCount)} valikud`
  })} saadaval.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Sisestatud rühm ${e.groupTitle}, valikuga ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} valik`,
      other: () => `${t.number(e.groupCount)} valikud`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valitud",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Soovitused",
  selectedAnnouncement: (e) => `${e.optionText}, valitud`
};
var Yp = {};
Yp = {
  buttonLabel: "Näytä ehdotukset",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} vaihtoehto`,
    other: () => `${t.number(e.optionCount)} vaihtoehdot`
  })} saatavilla.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Mentiin ryhmään ${e.groupTitle}, ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} vaihtoehdon`,
      other: () => `${t.number(e.groupCount)} vaihtoehdon`
    })} kanssa.`,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valittu",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Ehdotukset",
  selectedAnnouncement: (e) => `${e.optionText}, valittu`
};
var Xp = {};
Xp = {
  buttonLabel: "Afficher les suggestions",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} option`,
    other: () => `${t.number(e.optionCount)} options`
  })} disponible(s).`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Groupe ${e.groupTitle} saisi, avec ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} option`,
      other: () => `${t.number(e.groupCount)} options`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", sélectionné(s)",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Suggestions",
  selectedAnnouncement: (e) => `${e.optionText}, sélectionné`
};
var Jp = {};
Jp = {
  buttonLabel: "הצג הצעות",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `אפשרות ${t.number(e.optionCount)}`,
    other: () => `${t.number(e.optionCount)} אפשרויות`
  })} במצב זמין.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `נכנס לקבוצה ${e.groupTitle}, עם ${t.plural(e.groupCount, {
      one: () => `אפשרות ${t.number(e.groupCount)}`,
      other: () => `${t.number(e.groupCount)} אפשרויות`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", נבחר",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "הצעות",
  selectedAnnouncement: (e) => `${e.optionText}, נבחר`
};
var Qp = {};
Qp = {
  buttonLabel: "Prikaži prijedloge",
  countAnnouncement: (e, t) => `Dostupno još: ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcija`,
    other: () => `${t.number(e.optionCount)} opcije/a`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Unesena skupina ${e.groupTitle}, s ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opcijom`,
      other: () => `${t.number(e.groupCount)} opcije/a`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", odabranih",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Prijedlozi",
  selectedAnnouncement: (e) => `${e.optionText}, odabrano`
};
var eh = {};
eh = {
  buttonLabel: "Javaslatok megjelenítése",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} lehetőség`,
    other: () => `${t.number(e.optionCount)} lehetőség`
  })} áll rendelkezésre.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Belépett a(z) ${e.groupTitle} csoportba, amely ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} lehetőséget`,
      other: () => `${t.number(e.groupCount)} lehetőséget`
    })} tartalmaz. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", kijelölve",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Javaslatok",
  selectedAnnouncement: (e) => `${e.optionText}, kijelölve`
};
var th = {};
th = {
  buttonLabel: "Mostra suggerimenti",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opzione disponibile`,
    other: () => `${t.number(e.optionCount)} opzioni disponibili`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Ingresso nel gruppo ${e.groupTitle}, con ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opzione`,
      other: () => `${t.number(e.groupCount)} opzioni`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selezionato",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Suggerimenti",
  selectedAnnouncement: (e) => `${e.optionText}, selezionato`
};
var nh = {};
nh = {
  buttonLabel: "候補を表示",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} 個のオプション`,
    other: () => `${t.number(e.optionCount)} 個のオプション`
  })}を利用できます。`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `入力されたグループ ${e.groupTitle}、${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} 個のオプション`,
      other: () => `${t.number(e.groupCount)} 個のオプション`
    })}を含む。`,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: "、選択済み",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "候補",
  selectedAnnouncement: (e) => `${e.optionText}、選択済み`
};
var rh = {};
rh = {
  buttonLabel: "제안 사항 표시",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)}개 옵션`,
    other: () => `${t.number(e.optionCount)}개 옵션`
  })}을 사용할 수 있습니다.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `입력한 그룹 ${e.groupTitle}, ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)}개 옵션`,
      other: () => `${t.number(e.groupCount)}개 옵션`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", 선택됨",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "제안",
  selectedAnnouncement: (e) => `${e.optionText}, 선택됨`
};
var ih = {};
ih = {
  buttonLabel: "Rodyti pasiūlymus",
  countAnnouncement: (e, t) => `Yra ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} parinktis`,
    other: () => `${t.number(e.optionCount)} parinktys (-ių)`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Įvesta grupė ${e.groupTitle}, su ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} parinktimi`,
      other: () => `${t.number(e.groupCount)} parinktimis (-ių)`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", pasirinkta",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Pasiūlymai",
  selectedAnnouncement: (e) => `${e.optionText}, pasirinkta`
};
var oh = {};
oh = {
  buttonLabel: "Rādīt ieteikumus",
  countAnnouncement: (e, t) => `Pieejamo opciju skaits: ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcija`,
    other: () => `${t.number(e.optionCount)} opcijas`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Ievadīta grupa ${e.groupTitle}, ar ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opciju`,
      other: () => `${t.number(e.groupCount)} opcijām`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", atlasīta",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Ieteikumi",
  selectedAnnouncement: (e) => `${e.optionText}, atlasīta`
};
var lh = {};
lh = {
  buttonLabel: "Vis forslag",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} alternativ`,
    other: () => `${t.number(e.optionCount)} alternativer`
  })} finnes.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Angitt gruppe ${e.groupTitle}, med ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} alternativ`,
      other: () => `${t.number(e.groupCount)} alternativer`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valgt",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Forslag",
  selectedAnnouncement: (e) => `${e.optionText}, valgt`
};
var ah = {};
ah = {
  buttonLabel: "Suggesties weergeven",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} optie`,
    other: () => `${t.number(e.optionCount)} opties`
  })} beschikbaar.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Groep ${e.groupTitle} ingevoerd met ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} optie`,
      other: () => `${t.number(e.groupCount)} opties`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", geselecteerd",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Suggesties",
  selectedAnnouncement: (e) => `${e.optionText}, geselecteerd`
};
var uh = {};
uh = {
  buttonLabel: "Wyświetlaj sugestie",
  countAnnouncement: (e, t) => `dostępna/dostępne(-nych) ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcja`,
    other: () => `${t.number(e.optionCount)} opcje(-i)`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Dołączono do grupy ${e.groupTitle}, z ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opcją`,
      other: () => `${t.number(e.groupCount)} opcjami`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", wybrano",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugestie",
  selectedAnnouncement: (e) => `${e.optionText}, wybrano`
};
var sh = {};
sh = {
  buttonLabel: "Mostrar sugestões",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opção`,
    other: () => `${t.number(e.optionCount)} opções`
  })} disponível.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Grupo inserido ${e.groupTitle}, com ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opção`,
      other: () => `${t.number(e.groupCount)} opções`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selecionado",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugestões",
  selectedAnnouncement: (e) => `${e.optionText}, selecionado`
};
var ch = {};
ch = {
  buttonLabel: "Apresentar sugestões",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opção`,
    other: () => `${t.number(e.optionCount)} opções`
  })} disponível.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Grupo introduzido ${e.groupTitle}, com ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opção`,
      other: () => `${t.number(e.groupCount)} opções`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selecionado",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugestões",
  selectedAnnouncement: (e) => `${e.optionText}, selecionado`
};
var dh = {};
dh = {
  buttonLabel: "Afișare sugestii",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opțiune`,
    other: () => `${t.number(e.optionCount)} opțiuni`
  })} disponibile.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Grup ${e.groupTitle} introdus, cu ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opțiune`,
      other: () => `${t.number(e.groupCount)} opțiuni`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selectat",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugestii",
  selectedAnnouncement: (e) => `${e.optionText}, selectat`
};
var fh = {};
fh = {
  buttonLabel: "Показать предложения",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} параметр`,
    other: () => `${t.number(e.optionCount)} параметров`
  })} доступно.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Введенная группа ${e.groupTitle}, с ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} параметром`,
      other: () => `${t.number(e.groupCount)} параметрами`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", выбранными",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Предложения",
  selectedAnnouncement: (e) => `${e.optionText}, выбрано`
};
var ph = {};
ph = {
  buttonLabel: "Zobraziť návrhy",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} možnosť`,
    other: () => `${t.number(e.optionCount)} možnosti/-í`
  })} k dispozícii.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Zadaná skupina ${e.groupTitle}, s ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} možnosťou`,
      other: () => `${t.number(e.groupCount)} možnosťami`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", vybraté",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Návrhy",
  selectedAnnouncement: (e) => `${e.optionText}, vybraté`
};
var hh = {};
hh = {
  buttonLabel: "Prikaži predloge",
  countAnnouncement: (e, t) => `Na voljo je ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcija`,
    other: () => `${t.number(e.optionCount)} opcije`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Vnesena skupina ${e.groupTitle}, z ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opcija`,
      other: () => `${t.number(e.groupCount)} opcije`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", izbrano",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Predlogi",
  selectedAnnouncement: (e) => `${e.optionText}, izbrano`
};
var vh = {};
vh = {
  buttonLabel: "Prikaži predloge",
  countAnnouncement: (e, t) => `Dostupno još: ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcija`,
    other: () => `${t.number(e.optionCount)} opcije/a`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Unesena grupa ${e.groupTitle}, s ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opcijom`,
      other: () => `${t.number(e.groupCount)} optione/a`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", izabranih",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Predlozi",
  selectedAnnouncement: (e) => `${e.optionText}, izabrano`
};
var gh = {};
gh = {
  buttonLabel: "Visa förslag",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} alternativ`,
    other: () => `${t.number(e.optionCount)} alternativ`
  })} tillgängliga.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Ingick i gruppen ${e.groupTitle} med ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} alternativ`,
      other: () => `${t.number(e.groupCount)} alternativ`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valda",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Förslag",
  selectedAnnouncement: (e) => `${e.optionText}, valda`
};
var bh = {};
bh = {
  buttonLabel: "Önerileri göster",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} seçenek`,
    other: () => `${t.number(e.optionCount)} seçenekler`
  })} kullanılabilir.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Girilen grup ${e.groupTitle}, ile ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} seçenek`,
      other: () => `${t.number(e.groupCount)} seçenekler`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", seçildi",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Öneriler",
  selectedAnnouncement: (e) => `${e.optionText}, seçildi`
};
var mh = {};
mh = {
  buttonLabel: "Показати пропозиції",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} параметр`,
    other: () => `${t.number(e.optionCount)} параметри(-ів)`
  })} доступно.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Введена група ${e.groupTitle}, з ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} параметр`,
      other: () => `${t.number(e.groupCount)} параметри(-ів)`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", вибрано",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Пропозиції",
  selectedAnnouncement: (e) => `${e.optionText}, вибрано`
};
var $h = {};
$h = {
  buttonLabel: "显示建议",
  countAnnouncement: (e, t) => `有 ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} 个选项`,
    other: () => `${t.number(e.optionCount)} 个选项`
  })}可用。`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `进入了 ${e.groupTitle} 组，其中有 ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} 个选项`,
      other: () => `${t.number(e.groupCount)} 个选项`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", 已选择",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "建议",
  selectedAnnouncement: (e) => `${e.optionText}, 已选择`
};
var yh = {};
yh = {
  buttonLabel: "顯示建議",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} 選項`,
    other: () => `${t.number(e.optionCount)} 選項`
  })} 可用。`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `輸入的群組 ${e.groupTitle}, 有 ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} 選項`,
      other: () => `${t.number(e.groupCount)} 選項`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", 已選取",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "建議",
  selectedAnnouncement: (e) => `${e.optionText}, 已選取`
};
var xh = {};
xh = {
  dismiss: "تجاهل"
};
var wh = {};
wh = {
  dismiss: "Отхвърляне"
};
var Ch = {};
Ch = {
  dismiss: "Odstranit"
};
var Eh = {};
Eh = {
  dismiss: "Luk"
};
var Sh = {};
Sh = {
  dismiss: "Schließen"
};
var Ph = {};
Ph = {
  dismiss: "Απόρριψη"
};
var Th = {};
Th = {
  dismiss: "Dismiss"
};
var Ah = {};
Ah = {
  dismiss: "Descartar"
};
var _h = {};
_h = {
  dismiss: "Lõpeta"
};
var Dh = {};
Dh = {
  dismiss: "Hylkää"
};
var Fh = {};
Fh = {
  dismiss: "Rejeter"
};
var Lh = {};
Lh = {
  dismiss: "התעלם"
};
var Rh = {};
Rh = {
  dismiss: "Odbaci"
};
var Ih = {};
Ih = {
  dismiss: "Elutasítás"
};
var Bh = {};
Bh = {
  dismiss: "Ignora"
};
var Mh = {};
Mh = {
  dismiss: "閉じる"
};
var Kh = {};
Kh = {
  dismiss: "무시"
};
var Oh = {};
Oh = {
  dismiss: "Atmesti"
};
var kh = {};
kh = {
  dismiss: "Nerādīt"
};
var Nh = {};
Nh = {
  dismiss: "Lukk"
};
var zh = {};
zh = {
  dismiss: "Negeren"
};
var Wh = {};
Wh = {
  dismiss: "Zignoruj"
};
var Vh = {};
Vh = {
  dismiss: "Descartar"
};
var Hh = {};
Hh = {
  dismiss: "Dispensar"
};
var Uh = {};
Uh = {
  dismiss: "Revocare"
};
var jh = {};
jh = {
  dismiss: "Пропустить"
};
var Gh = {};
Gh = {
  dismiss: "Zrušiť"
};
var qh = {};
qh = {
  dismiss: "Opusti"
};
var Zh = {};
Zh = {
  dismiss: "Odbaci"
};
var Yh = {};
Yh = {
  dismiss: "Avvisa"
};
var Xh = {};
Xh = {
  dismiss: "Kapat"
};
var Jh = {};
Jh = {
  dismiss: "Скасувати"
};
var Qh = {};
Qh = {
  dismiss: "取消"
};
var ev = {};
ev = {
  dismiss: "關閉"
};
const Xd = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function tv(e = {}) {
  let { style: t, isFocusable: r } = e, [o, a] = Ce(!1), { focusWithinProps: u } = Wi({
    isDisabled: !r,
    onFocusWithinChange: (d) => a(d)
  }), s = me(() => o ? t : t ? {
    ...Xd,
    ...t
  } : Xd, [
    o
  ]);
  return {
    visuallyHiddenProps: {
      ...u,
      style: s
    }
  };
}
function nv(e) {
  let { children: t, elementType: r = "div", isFocusable: o, style: a, ...u } = e, { visuallyHiddenProps: s } = tv(e);
  return /* @__PURE__ */ I.createElement(r, Se(u, s), t);
}
function Vx(e) {
  return e && e.__esModule ? e.default : e;
}
const Jd = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, cl = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, Hx = {
  top: "left",
  left: "top"
}, xu = {
  top: "height",
  left: "width"
}, Ux = {
  width: "totalWidth",
  height: "totalHeight"
}, Ho = {};
let Nr = typeof document < "u" && window.visualViewport;
function Qd(e) {
  let t = 0, r = 0, o = 0, a = 0, u = 0, s = 0, d = {};
  if (e.tagName === "BODY") {
    let v = document.documentElement;
    o = v.clientWidth, a = v.clientHeight;
    var f;
    t = (f = Nr == null ? void 0 : Nr.width) !== null && f !== void 0 ? f : o;
    var h;
    r = (h = Nr == null ? void 0 : Nr.height) !== null && h !== void 0 ? h : a, d.top = v.scrollTop || e.scrollTop, d.left = v.scrollLeft || e.scrollLeft;
  } else
    ({ width: t, height: r, top: u, left: s } = Ur(e)), d.top = e.scrollTop, d.left = e.scrollLeft, o = t, a = r;
  return {
    width: t,
    height: r,
    totalWidth: o,
    totalHeight: a,
    scroll: d,
    top: u,
    left: s
  };
}
function jx(e) {
  return {
    top: e.scrollTop,
    left: e.scrollLeft,
    width: e.scrollWidth,
    height: e.scrollHeight
  };
}
function ef(e, t, r, o, a, u) {
  let s = a.scroll[e], d = o[xu[e]], f = t - u - s, h = t + u - s + r;
  return f < 0 ? -f : h > d ? Math.max(d - h, -f) : 0;
}
function Gx(e) {
  let t = window.getComputedStyle(e);
  return {
    top: parseInt(t.marginTop, 10) || 0,
    bottom: parseInt(t.marginBottom, 10) || 0,
    left: parseInt(t.marginLeft, 10) || 0,
    right: parseInt(t.marginRight, 10) || 0
  };
}
function tf(e) {
  if (Ho[e])
    return Ho[e];
  let [t, r] = e.split(" "), o = Jd[t] || "right", a = Hx[o];
  Jd[r] || (r = "center");
  let u = xu[o], s = xu[a];
  return Ho[e] = {
    placement: t,
    crossPlacement: r,
    axis: o,
    crossAxis: a,
    size: u,
    crossSize: s
  }, Ho[e];
}
function Qa(e, t, r, o, a, u, s, d, f, h) {
  let { placement: v, crossPlacement: m, axis: y, crossAxis: $, size: A, crossSize: _ } = o, F = {};
  F[$] = e[$], m === "center" ? F[$] += (e[_] - r[_]) / 2 : m !== $ && (F[$] += e[_] - r[_]), F[$] += u;
  const W = e[$] - r[_] + f + h, R = e[$] + e[_] - f - h;
  if (F[$] = Yo(F[$], W, R), v === y) {
    const B = d ? s[A] : t[Ux[A]];
    F[cl[y]] = Math.floor(B - e[y] + a);
  } else
    F[y] = Math.floor(e[y] + e[A] + a);
  return F;
}
function qx(e, t, r, o, a, u) {
  return e.top != null ? Math.max(0, t.height + t.top + t.scroll.top - (r.top + e.top) - (a.top + a.bottom + u)) : Math.max(0, o.top + r.top - (t.top + t.scroll.top) - (a.top + a.bottom + u));
}
function nf(e, t, r, o, a, u) {
  let { placement: s, axis: d, size: f } = u;
  return s === d ? Math.max(0, r[d] - e[d] - e.scroll[d] + t[d] - o[d] - o[cl[d]] - a) : Math.max(0, e[f] + e[d] + e.scroll[d] - t[d] - r[d] - r[f] - o[d] - o[cl[d]] - a);
}
function Zx(e, t, r, o, a, u, s, d, f, h, v, m, y, $, A, _) {
  let F = tf(e), { size: W, crossAxis: R, crossSize: B, placement: V, crossPlacement: j } = F, G = Qa(t, d, r, F, v, m, h, y, A, _), J = v, w = nf(d, h, t, a, u + v, F);
  if (s && o[W] > w) {
    let le = tf(`${cl[V]} ${j}`), de = Qa(t, d, r, le, v, m, h, y, A, _);
    nf(d, h, t, a, u + v, le) > w && (F = le, G = de, J = v);
  }
  let Y = ef(R, G[R], r[B], d, f, u);
  G[R] += Y;
  let O = qx(G, d, h, t, a, u);
  $ && $ < O && (O = $), r.height = Math.min(r.height, O), G = Qa(t, d, r, F, J, m, h, y, A, _), Y = ef(R, G[R], r[B], d, f, u), G[R] += Y;
  let K = {}, k = t[R] + 0.5 * t[B] - r[R];
  const T = A / 2 + _, D = r[B] - A / 2 - _, X = t[R] - r[R] + A / 2, Q = t[R] + t[B] - r[R] - A / 2, H = Yo(k, X, Q);
  return K[R] = Yo(H, T, D), {
    position: G,
    maxHeight: O,
    arrowOffsetLeft: K.left,
    arrowOffsetTop: K.top,
    placement: F.placement
  };
}
function Yx(e) {
  let { placement: t, targetNode: r, overlayNode: o, scrollNode: a, padding: u, shouldFlip: s, boundaryElement: d, offset: f, crossOffset: h, maxHeight: v, arrowSize: m = 0, arrowBoundaryOffset: y = 0 } = e, $ = o instanceof HTMLElement ? Xx(o) : document.documentElement, A = $ === document.documentElement;
  const _ = window.getComputedStyle($).position;
  let F = !!_ && _ !== "static", W = A ? Ur(r) : rf(r, $);
  if (!A) {
    let { marginTop: w, marginLeft: Y } = window.getComputedStyle(r);
    W.top += parseInt(w, 10) || 0, W.left += parseInt(Y, 10) || 0;
  }
  let R = Ur(o), B = Gx(o);
  R.width += B.left + B.right, R.height += B.top + B.bottom;
  let V = jx(a), j = Qd(d), G = Qd($), J = d.tagName === "BODY" ? Ur($) : rf($, d);
  return Zx(t, W, R, V, B, u, s, j, G, J, f, h, F, v, m, y);
}
function Ur(e) {
  let { top: t, left: r, width: o, height: a } = e.getBoundingClientRect(), { scrollTop: u, scrollLeft: s, clientTop: d, clientLeft: f } = document.documentElement;
  return {
    top: t + u - d,
    left: r + s - f,
    width: o,
    height: a
  };
}
function rf(e, t) {
  let r = window.getComputedStyle(e), o;
  if (r.position === "fixed") {
    let { top: a, left: u, width: s, height: d } = e.getBoundingClientRect();
    o = {
      top: a,
      left: u,
      width: s,
      height: d
    };
  } else {
    o = Ur(e);
    let a = Ur(t), u = window.getComputedStyle(t);
    a.top += (parseInt(u.borderTopWidth, 10) || 0) - t.scrollTop, a.left += (parseInt(u.borderLeftWidth, 10) || 0) - t.scrollLeft, o.top -= a.top, o.left -= a.left;
  }
  return o.top -= parseInt(r.marginTop, 10) || 0, o.left -= parseInt(r.marginLeft, 10) || 0, o;
}
function Xx(e) {
  let t = e.offsetParent;
  if (t && t === document.body && window.getComputedStyle(t).position === "static" && !of(t) && (t = document.documentElement), t == null)
    for (t = e.parentElement; t && !of(t); )
      t = t.parentElement;
  return t || document.documentElement;
}
function of(e) {
  let t = window.getComputedStyle(e);
  return t.transform !== "none" || /transform|perspective/.test(t.willChange) || t.filter !== "none" || t.contain === "paint" || // @ts-ignore
  "backdropFilter" in t && t.backdropFilter !== "none" || // @ts-ignore
  "WebkitBackdropFilter" in t && t.WebkitBackdropFilter !== "none";
}
const rv = /* @__PURE__ */ new WeakMap();
function Jx(e) {
  let { triggerRef: t, isOpen: r, onClose: o } = e;
  Ee(() => {
    if (!r || o === null)
      return;
    let a = (u) => {
      let s = u.target;
      if (!t.current || s instanceof Node && !s.contains(t.current))
        return;
      let d = o || rv.get(t.current);
      d && d();
    };
    return window.addEventListener("scroll", a, !0), () => {
      window.removeEventListener("scroll", a, !0);
    };
  }, [
    r,
    o,
    t
  ]);
}
let Qt = typeof document < "u" && window.visualViewport;
function Qx(e) {
  let { direction: t } = br(), { arrowSize: r = 0, targetRef: o, overlayRef: a, scrollRef: u = a, placement: s = "bottom", containerPadding: d = 12, shouldFlip: f = !0, boundaryElement: h = typeof document < "u" ? document.body : null, offset: v = 0, crossOffset: m = 0, shouldUpdatePosition: y = !0, isOpen: $ = !0, onClose: A, maxHeight: _, arrowBoundaryOffset: F = 0 } = e, [W, R] = Ce({
    position: {},
    arrowOffsetLeft: void 0,
    arrowOffsetTop: void 0,
    maxHeight: void 0,
    placement: void 0
  }), B = [
    y,
    s,
    a.current,
    o.current,
    u.current,
    d,
    f,
    h,
    v,
    m,
    $,
    t,
    _,
    F,
    r
  ], V = Pe(() => {
    if (y === !1 || !$ || !a.current || !o.current || !u.current || !h)
      return;
    let J = Yx({
      placement: t5(s, t),
      overlayNode: a.current,
      targetNode: o.current,
      scrollNode: u.current,
      padding: d,
      shouldFlip: f,
      boundaryElement: h,
      offset: v,
      crossOffset: m,
      maxHeight: _,
      arrowSize: r,
      arrowBoundaryOffset: F
    });
    Object.keys(J.position).forEach((w) => a.current.style[w] = J.position[w] + "px"), a.current.style.maxHeight = J.maxHeight != null ? J.maxHeight + "px" : void 0, R(J);
  }, B);
  qe(V, B), e5(V), Ku({
    ref: a,
    onResize: V
  });
  let j = ie(!1);
  qe(() => {
    let J, w = () => {
      j.current = !0, clearTimeout(J), J = setTimeout(() => {
        j.current = !1;
      }, 500), V();
    };
    return Qt == null || Qt.addEventListener("resize", w), Qt == null || Qt.addEventListener("scroll", w), () => {
      Qt == null || Qt.removeEventListener("resize", w), Qt == null || Qt.removeEventListener("scroll", w);
    };
  }, [
    V
  ]);
  let G = Pe(() => {
    j.current || A();
  }, [
    A,
    j
  ]);
  return Jx({
    triggerRef: o,
    isOpen: $,
    onClose: A && G
  }), {
    overlayProps: {
      style: {
        position: "absolute",
        zIndex: 1e5,
        ...W.position,
        maxHeight: W.maxHeight
      }
    },
    placement: W.placement,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: W.arrowOffsetLeft,
        top: W.arrowOffsetTop
      }
    },
    updatePosition: V
  };
}
function e5(e) {
  qe(() => (window.addEventListener("resize", e, !1), () => {
    window.removeEventListener("resize", e, !1);
  }), [
    e
  ]);
}
function t5(e, t) {
  return t === "rtl" ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
}
const Fn = [];
function n5(e, t) {
  let { onClose: r, shouldCloseOnBlur: o, isOpen: a, isDismissable: u = !1, isKeyboardDismissDisabled: s = !1, shouldCloseOnInteractOutside: d } = e;
  Ee(() => (a && Fn.push(t), () => {
    let A = Fn.indexOf(t);
    A >= 0 && Fn.splice(A, 1);
  }), [
    a,
    t
  ]);
  let f = () => {
    Fn[Fn.length - 1] === t && r && r();
  }, h = (A) => {
    (!d || d(A.target)) && Fn[Fn.length - 1] === t && (A.stopPropagation(), A.preventDefault());
  }, v = (A) => {
    (!d || d(A.target)) && (Fn[Fn.length - 1] === t && (A.stopPropagation(), A.preventDefault()), f());
  }, m = (A) => {
    A.key === "Escape" && !s && (A.stopPropagation(), A.preventDefault(), f());
  };
  ex({
    ref: t,
    onInteractOutside: u && a ? v : null,
    onInteractOutsideStart: h
  });
  let { focusWithinProps: y } = Wi({
    isDisabled: !o,
    onBlurWithin: (A) => {
      !A.relatedTarget || sx(A.relatedTarget) || (!d || d(A.relatedTarget)) && r();
    }
  }), $ = (A) => {
    A.target === A.currentTarget && A.preventDefault();
  };
  return {
    overlayProps: {
      onKeyDown: m,
      ...y
    },
    underlayProps: {
      onPointerDown: $
    }
  };
}
function r5(e, t, r) {
  let { type: o } = e, { isOpen: a } = t;
  Ee(() => {
    r && r.current && rv.set(r.current, t.close);
  });
  let u;
  o === "menu" ? u = !0 : o === "listbox" && (u = "listbox");
  let s = gn();
  return {
    triggerProps: {
      "aria-haspopup": u,
      "aria-expanded": a,
      "aria-controls": a ? s : null,
      onPress: t.toggle
    },
    overlayProps: {
      id: s
    }
  };
}
const eu = typeof document < "u" && window.visualViewport, i5 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let Uo = 0, tu;
function o5(e = {}) {
  let { isDisabled: t } = e;
  qe(() => {
    if (!t)
      return Uo++, Uo === 1 && (hl() ? tu = a5() : tu = l5()), () => {
        Uo--, Uo === 0 && tu();
      };
  }, [
    t
  ]);
}
function l5() {
  return cr(Hr(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), Hr(document.documentElement, "overflow", "hidden"));
}
function a5() {
  let e, t, r = (h) => {
    e = tl(h.target, !0), !(e === document.documentElement && e === document.body) && e instanceof HTMLElement && window.getComputedStyle(e).overscrollBehavior === "auto" && (t = Hr(e, "overscrollBehavior", "contain"));
  }, o = (h) => {
    if (!e || e === document.documentElement || e === document.body) {
      h.preventDefault();
      return;
    }
    e.scrollHeight === e.clientHeight && e.scrollWidth === e.clientWidth && h.preventDefault();
  }, a = (h) => {
    let v = h.target;
    af(v) && v !== document.activeElement && (h.preventDefault(), d(), v.style.transform = "translateY(-2000px)", v.focus(), requestAnimationFrame(() => {
      v.style.transform = "";
    })), t && t();
  }, u = (h) => {
    let v = h.target;
    af(v) && (d(), v.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      v.style.transform = "", eu && (eu.height < window.innerHeight ? requestAnimationFrame(() => {
        lf(v);
      }) : eu.addEventListener("resize", () => lf(v), {
        once: !0
      }));
    }));
  }, s = null, d = () => {
    if (s)
      return;
    let h = () => {
      window.scrollTo(0, 0);
    }, v = window.pageXOffset, m = window.pageYOffset;
    s = cr(Si(window, "scroll", h), Hr(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), Hr(document.documentElement, "overflow", "hidden"), Hr(document.body, "marginTop", `-${m}px`), () => {
      window.scrollTo(v, m);
    }), window.scrollTo(0, 0);
  }, f = cr(Si(document, "touchstart", r, {
    passive: !1,
    capture: !0
  }), Si(document, "touchmove", o, {
    passive: !1,
    capture: !0
  }), Si(document, "touchend", a, {
    passive: !1,
    capture: !0
  }), Si(document, "focus", u, !0));
  return () => {
    t == null || t(), s == null || s(), f();
  };
}
function Hr(e, t, r) {
  let o = e.style[t];
  return e.style[t] = r, () => {
    e.style[t] = o;
  };
}
function Si(e, t, r, o) {
  return e.addEventListener(t, r, o), () => {
    e.removeEventListener(t, r, o);
  };
}
function lf(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let r = tl(e);
    if (r !== document.documentElement && r !== document.body && r !== e) {
      let o = r.getBoundingClientRect().top, a = e.getBoundingClientRect().top;
      a > o + e.clientHeight && (r.scrollTop += a - o);
    }
    e = r.parentElement;
  }
}
function af(e) {
  return e instanceof HTMLInputElement && !i5.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
var iv = {};
iv = {
  "ar-AE": xh,
  "bg-BG": wh,
  "cs-CZ": Ch,
  "da-DK": Eh,
  "de-DE": Sh,
  "el-GR": Ph,
  "en-US": Th,
  "es-ES": Ah,
  "et-EE": _h,
  "fi-FI": Dh,
  "fr-FR": Fh,
  "he-IL": Lh,
  "hr-HR": Rh,
  "hu-HU": Ih,
  "it-IT": Bh,
  "ja-JP": Mh,
  "ko-KR": Kh,
  "lt-LT": Oh,
  "lv-LV": kh,
  "nb-NO": Nh,
  "nl-NL": zh,
  "pl-PL": Wh,
  "pt-BR": Vh,
  "pt-PT": Hh,
  "ro-RO": Uh,
  "ru-RU": jh,
  "sk-SK": Gh,
  "sl-SI": qh,
  "sr-SP": Zh,
  "sv-SE": Yh,
  "tr-TR": Xh,
  "uk-UA": Jh,
  "zh-CN": Qh,
  "zh-TW": ev
};
function uf(e) {
  let { onDismiss: t, ...r } = e, o = bl(/* @__PURE__ */ Vx(iv), "@react-aria/overlays"), a = el(r, o.format("dismiss")), u = () => {
    t && t();
  };
  return /* @__PURE__ */ I.createElement(nv, null, /* @__PURE__ */ I.createElement("button", {
    ...a,
    tabIndex: -1,
    onClick: u,
    style: {
      width: 1,
      height: 1
    }
  }));
}
let Pi = /* @__PURE__ */ new WeakMap(), en = [];
function ov(e, t = document.body) {
  let r = new Set(e), o = /* @__PURE__ */ new Set(), a = (f) => {
    for (let y of f.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]"))
      r.add(y);
    let h = (y) => {
      if (r.has(y) || o.has(y.parentElement) && y.parentElement.getAttribute("role") !== "row")
        return NodeFilter.FILTER_REJECT;
      for (let $ of r)
        if (y.contains($))
          return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, v = document.createTreeWalker(f, NodeFilter.SHOW_ELEMENT, {
      acceptNode: h
    }), m = h(f);
    if (m === NodeFilter.FILTER_ACCEPT && u(f), m !== NodeFilter.FILTER_REJECT) {
      let y = v.nextNode();
      for (; y != null; )
        u(y), y = v.nextNode();
    }
  }, u = (f) => {
    var h;
    let v = (h = Pi.get(f)) !== null && h !== void 0 ? h : 0;
    f.getAttribute("aria-hidden") === "true" && v === 0 || (v === 0 && f.setAttribute("aria-hidden", "true"), o.add(f), Pi.set(f, v + 1));
  };
  en.length && en[en.length - 1].disconnect(), a(t);
  let s = new MutationObserver((f) => {
    for (let h of f)
      if (!(h.type !== "childList" || h.addedNodes.length === 0) && ![
        ...r,
        ...o
      ].some((v) => v.contains(h.target))) {
        for (let v of h.removedNodes)
          v instanceof Element && (r.delete(v), o.delete(v));
        for (let v of h.addedNodes)
          (v instanceof HTMLElement || v instanceof SVGElement) && (v.dataset.liveAnnouncer === "true" || v.dataset.reactAriaTopLayer === "true") ? r.add(v) : v instanceof Element && a(v);
      }
  });
  s.observe(t, {
    childList: !0,
    subtree: !0
  });
  let d = {
    observe() {
      s.observe(t, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      s.disconnect();
    }
  };
  return en.push(d), () => {
    s.disconnect();
    for (let f of o) {
      let h = Pi.get(f);
      h === 1 ? (f.removeAttribute("aria-hidden"), Pi.delete(f)) : Pi.set(f, h - 1);
    }
    d === en[en.length - 1] ? (en.pop(), en.length && en[en.length - 1].observe()) : en.splice(en.indexOf(d), 1);
  };
}
function u5(e, t) {
  let { triggerRef: r, popoverRef: o, isNonModal: a, isKeyboardDismissDisabled: u, shouldCloseOnInteractOutside: s, ...d } = e, { overlayProps: f, underlayProps: h } = n5({
    isOpen: t.isOpen,
    onClose: t.close,
    shouldCloseOnBlur: !0,
    isDismissable: !a,
    isKeyboardDismissDisabled: u,
    shouldCloseOnInteractOutside: s
  }, o), { overlayProps: v, arrowProps: m, placement: y } = Qx({
    ...d,
    targetRef: r,
    overlayRef: o,
    isOpen: t.isOpen,
    onClose: a ? t.close : null
  });
  return o5({
    isDisabled: a || !t.isOpen
  }), qe(() => {
    if (t.isOpen && !a && o.current)
      return ov([
        o.current
      ]);
  }, [
    a,
    t.isOpen,
    o
  ]), {
    popoverProps: Se(f, v),
    arrowProps: m,
    underlayProps: h,
    placement: y
  };
}
const s5 = /* @__PURE__ */ I.createContext(null);
function c5(e) {
  let t = hr(), { portalContainer: r = t ? null : document.body, isExiting: o } = e, [a, u] = Ce(!1), s = me(() => ({
    contain: a,
    setContain: u
  }), [
    a,
    u
  ]);
  if (!r)
    return null;
  let d = e.children;
  return e.disableFocusManagement || (d = /* @__PURE__ */ I.createElement(Rp, {
    restoreFocus: !0,
    contain: a && !o
  }, d)), d = /* @__PURE__ */ I.createElement(s5.Provider, {
    value: s
  }, /* @__PURE__ */ I.createElement(W3, null, d)), /* @__PURE__ */ Ru.createPortal(d, r);
}
function wu(e) {
  return Go() ? e.altKey : e.ctrlKey;
}
function Wr(e) {
  return Gn() ? e.metaKey : e.ctrlKey;
}
const d5 = 1e3;
function lv(e) {
  let { keyboardDelegate: t, selectionManager: r, onTypeSelect: o } = e, a = ie({
    search: "",
    timeout: null
  }).current, u = (s) => {
    let d = f5(s.key);
    if (!d || s.ctrlKey || s.metaKey || !s.currentTarget.contains(s.target))
      return;
    d === " " && a.search.trim().length > 0 && (s.preventDefault(), "continuePropagation" in s || s.stopPropagation()), a.search += d;
    let f = t.getKeyForSearch(a.search, r.focusedKey);
    f == null && (f = t.getKeyForSearch(a.search)), f != null && (r.setFocusedKey(f), o && o(f)), clearTimeout(a.timeout), a.timeout = setTimeout(() => {
      a.search = "";
    }, d5);
  };
  return {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: t.getKeyForSearch ? u : null
    }
  };
}
function f5(e) {
  return e.length === 1 || !/^[A-Z]/i.test(e) ? e : "";
}
function av(e) {
  let { selectionManager: t, keyboardDelegate: r, ref: o, autoFocus: a = !1, shouldFocusWrap: u = !1, disallowEmptySelection: s = !1, disallowSelectAll: d = !1, selectOnFocus: f = t.selectionBehavior === "replace", disallowTypeAhead: h = !1, shouldUseVirtualFocus: v, allowsTabNavigation: m = !1, isVirtualized: y, scrollRef: $ = o, linkBehavior: A = "action" } = e, { direction: _ } = br(), F = Bu(), W = (O) => {
    if (O.altKey && O.key === "Tab" && O.preventDefault(), !o.current.contains(O.target))
      return;
    const K = (ne, pe) => {
      if (ne != null) {
        if (t.isLink(ne) && A === "selection" && f && !wu(O)) {
          X4(() => {
            t.setFocusedKey(ne, pe);
          });
          let Ie = $.current.querySelector(`[data-key="${CSS.escape(ne.toString())}"]`);
          F.open(Ie, O);
          return;
        }
        if (t.setFocusedKey(ne, pe), t.isLink(ne) && A === "override")
          return;
        O.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(ne) : f && !wu(O) && t.replaceSelection(ne);
      }
    };
    switch (O.key) {
      case "ArrowDown":
        if (r.getKeyBelow) {
          var k, T;
          O.preventDefault();
          let ne = t.focusedKey != null ? r.getKeyBelow(t.focusedKey) : (k = r.getFirstKey) === null || k === void 0 ? void 0 : k.call(r);
          ne == null && u && (ne = (T = r.getFirstKey) === null || T === void 0 ? void 0 : T.call(r, t.focusedKey)), K(ne);
        }
        break;
      case "ArrowUp":
        if (r.getKeyAbove) {
          var D, X;
          O.preventDefault();
          let ne = t.focusedKey != null ? r.getKeyAbove(t.focusedKey) : (D = r.getLastKey) === null || D === void 0 ? void 0 : D.call(r);
          ne == null && u && (ne = (X = r.getLastKey) === null || X === void 0 ? void 0 : X.call(r, t.focusedKey)), K(ne);
        }
        break;
      case "ArrowLeft":
        if (r.getKeyLeftOf) {
          var Q, H;
          O.preventDefault();
          let ne = r.getKeyLeftOf(t.focusedKey);
          ne == null && u && (ne = _ === "rtl" ? (Q = r.getFirstKey) === null || Q === void 0 ? void 0 : Q.call(r, t.focusedKey) : (H = r.getLastKey) === null || H === void 0 ? void 0 : H.call(r, t.focusedKey)), K(ne, _ === "rtl" ? "first" : "last");
        }
        break;
      case "ArrowRight":
        if (r.getKeyRightOf) {
          var le, de;
          O.preventDefault();
          let ne = r.getKeyRightOf(t.focusedKey);
          ne == null && u && (ne = _ === "rtl" ? (le = r.getLastKey) === null || le === void 0 ? void 0 : le.call(r, t.focusedKey) : (de = r.getFirstKey) === null || de === void 0 ? void 0 : de.call(r, t.focusedKey)), K(ne, _ === "rtl" ? "last" : "first");
        }
        break;
      case "Home":
        if (r.getFirstKey) {
          O.preventDefault();
          let ne = r.getFirstKey(t.focusedKey, Wr(O));
          t.setFocusedKey(ne), Wr(O) && O.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(ne) : f && t.replaceSelection(ne);
        }
        break;
      case "End":
        if (r.getLastKey) {
          O.preventDefault();
          let ne = r.getLastKey(t.focusedKey, Wr(O));
          t.setFocusedKey(ne), Wr(O) && O.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(ne) : f && t.replaceSelection(ne);
        }
        break;
      case "PageDown":
        if (r.getKeyPageBelow) {
          O.preventDefault();
          let ne = r.getKeyPageBelow(t.focusedKey);
          K(ne);
        }
        break;
      case "PageUp":
        if (r.getKeyPageAbove) {
          O.preventDefault();
          let ne = r.getKeyPageAbove(t.focusedKey);
          K(ne);
        }
        break;
      case "a":
        Wr(O) && t.selectionMode === "multiple" && d !== !0 && (O.preventDefault(), t.selectAll());
        break;
      case "Escape":
        O.preventDefault(), s || t.clearSelection();
        break;
      case "Tab":
        if (!m) {
          if (O.shiftKey)
            o.current.focus();
          else {
            let ne = vn(o.current, {
              tabbable: !0
            }), pe, Ie;
            do
              Ie = ne.lastChild(), Ie && (pe = Ie);
            while (Ie);
            pe && !pe.contains(document.activeElement) && Ln(pe);
          }
          break;
        }
    }
  }, R = ie({
    top: 0,
    left: 0
  });
  D3($, "scroll", y ? null : () => {
    R.current = {
      top: $.current.scrollTop,
      left: $.current.scrollLeft
    };
  });
  let B = (O) => {
    if (t.isFocused) {
      O.currentTarget.contains(O.target) || t.setFocused(!1);
      return;
    }
    if (O.currentTarget.contains(O.target)) {
      if (t.setFocused(!0), t.focusedKey == null) {
        let T = (X) => {
          X != null && (t.setFocusedKey(X), f && t.replaceSelection(X));
        }, D = O.relatedTarget;
        var K, k;
        D && O.currentTarget.compareDocumentPosition(D) & Node.DOCUMENT_POSITION_FOLLOWING ? T((K = t.lastSelectedKey) !== null && K !== void 0 ? K : r.getLastKey()) : T((k = t.firstSelectedKey) !== null && k !== void 0 ? k : r.getFirstKey());
      } else
        y || ($.current.scrollTop = R.current.top, $.current.scrollLeft = R.current.left);
      if (!y && t.focusedKey != null) {
        let T = $.current.querySelector(`[data-key="${CSS.escape(t.focusedKey.toString())}"]`);
        T && (T.contains(document.activeElement) || Ln(T), hu() === "keyboard" && Bd(T, {
          containingElement: o.current
        }));
      }
    }
  }, V = (O) => {
    O.currentTarget.contains(O.relatedTarget) || t.setFocused(!1);
  };
  const j = ie(a);
  Ee(() => {
    if (j.current) {
      let O = null;
      a === "first" && (O = r.getFirstKey()), a === "last" && (O = r.getLastKey());
      let K = t.selectedKeys;
      if (K.size) {
        for (let k of K)
          if (t.canSelectItem(k)) {
            O = k;
            break;
          }
      }
      t.setFocused(!0), t.setFocusedKey(O), O == null && !v && Ki(o.current);
    }
  }, []);
  let G = ie(t.focusedKey);
  Ee(() => {
    let O = hu();
    if (t.isFocused && t.focusedKey != null && ($ != null && $.current)) {
      let K = $.current.querySelector(`[data-key="${CSS.escape(t.focusedKey.toString())}"]`);
      K && (O === "keyboard" || j.current) && (y || Sp($.current, K), Bd(K, {
        containingElement: o.current
      }));
    }
    t.isFocused && t.focusedKey == null && G.current != null && Ki(o.current), G.current = t.focusedKey, j.current = !1;
  }, [
    y,
    $,
    t.focusedKey,
    t.isFocused,
    o
  ]);
  let J = {
    onKeyDown: W,
    onFocus: B,
    onBlur: V,
    onMouseDown(O) {
      $.current === O.target && O.preventDefault();
    }
  }, { typeSelectProps: w } = lv({
    keyboardDelegate: r,
    selectionManager: t
  });
  h || (J = Se(w, J));
  let Y;
  return v || (Y = t.focusedKey == null ? 0 : -1), {
    collectionProps: {
      ...J,
      tabIndex: Y
    }
  };
}
function p5(e) {
  let { selectionManager: t, key: r, ref: o, shouldSelectOnPressUp: a, shouldUseVirtualFocus: u, focus: s, isDisabled: d, onAction: f, allowsDifferentPressOrigin: h, linkBehavior: v = "action" } = e, m = Bu(), y = (H) => {
    if (H.pointerType === "keyboard" && wu(H))
      t.toggleSelection(r);
    else {
      if (t.selectionMode === "none")
        return;
      if (t.isLink(r)) {
        if (v === "selection") {
          m.open(o.current, H), t.setSelectedKeys(t.selectedKeys);
          return;
        } else if (v === "override" || v === "none")
          return;
      }
      t.selectionMode === "single" ? t.isSelected(r) && !t.disallowEmptySelection ? t.toggleSelection(r) : t.replaceSelection(r) : H && H.shiftKey ? t.extendSelection(r) : t.selectionBehavior === "toggle" || H && (Wr(H) || H.pointerType === "touch" || H.pointerType === "virtual") ? t.toggleSelection(r) : t.replaceSelection(r);
    }
  };
  Ee(() => {
    r === t.focusedKey && t.isFocused && !u && (s ? s() : document.activeElement !== o.current && Ki(o.current));
  }, [
    o,
    r,
    t.focusedKey,
    t.childFocusStrategy,
    t.isFocused,
    u
  ]), d = d || t.isDisabled(r);
  let $ = {};
  !u && !d ? $ = {
    tabIndex: r === t.focusedKey ? 0 : -1,
    onFocus(H) {
      H.target === o.current && t.setFocusedKey(r);
    }
  } : d && ($.onMouseDown = (H) => {
    H.preventDefault();
  });
  let A = t.isLink(r) && v === "override", _ = t.isLink(r) && v !== "selection" && v !== "none", F = !d && t.canSelectItem(r) && !A, W = (f || _) && !d, R = W && (t.selectionBehavior === "replace" ? !F : !F || t.isEmpty), B = W && F && t.selectionBehavior === "replace", V = R || B, j = ie(null), G = V && F, J = ie(!1), w = ie(!1), Y = (H) => {
    f && f(), _ && m.open(o.current, H);
  }, O = {};
  a ? (O.onPressStart = (H) => {
    j.current = H.pointerType, J.current = G, H.pointerType === "keyboard" && (!V || cf()) && y(H);
  }, h ? (O.onPressUp = R ? null : (H) => {
    H.pointerType !== "keyboard" && F && y(H);
  }, O.onPress = R ? Y : null) : O.onPress = (H) => {
    if (R || B && H.pointerType !== "mouse") {
      if (H.pointerType === "keyboard" && !sf())
        return;
      Y(H);
    } else
      H.pointerType !== "keyboard" && F && y(H);
  }) : (O.onPressStart = (H) => {
    j.current = H.pointerType, J.current = G, w.current = R, F && (H.pointerType === "mouse" && !R || H.pointerType === "keyboard" && (!W || cf())) && y(H);
  }, O.onPress = (H) => {
    (H.pointerType === "touch" || H.pointerType === "pen" || H.pointerType === "virtual" || H.pointerType === "keyboard" && V && sf() || H.pointerType === "mouse" && w.current) && (V ? Y(H) : F && y(H));
  }), $["data-key"] = r, O.preventFocusOnPress = u;
  let { pressProps: K, isPressed: k } = Bi(O), T = B ? (H) => {
    j.current === "mouse" && (H.stopPropagation(), H.preventDefault(), Y(H));
  } : void 0, { longPressProps: D } = Fp({
    isDisabled: !G,
    onLongPress(H) {
      H.pointerType === "touch" && (y(H), t.setSelectionBehavior("toggle"));
    }
  }), X = (H) => {
    j.current === "touch" && J.current && H.preventDefault();
  }, Q = t.isLink(r) ? (H) => {
    dr.isOpening || H.preventDefault();
  } : void 0;
  return {
    itemProps: Se($, F || R ? K : {}, G ? D : {}, {
      onDoubleClick: T,
      onDragStartCapture: X,
      onClick: Q
    }),
    isPressed: k,
    isSelected: t.isSelected(r),
    isFocused: t.isFocused && t.focusedKey === r,
    isDisabled: d,
    allowsSelection: F,
    hasAction: V
  };
}
function sf() {
  let e = window.event;
  return (e == null ? void 0 : e.key) === "Enter";
}
function cf() {
  let e = window.event;
  return (e == null ? void 0 : e.key) === " " || (e == null ? void 0 : e.code) === "Space";
}
class yl {
  getNextKey(t) {
    for (t = this.collection.getKeyAfter(t); t != null; ) {
      if (this.collection.getItem(t).type === "item" && !this.disabledKeys.has(t))
        return t;
      t = this.collection.getKeyAfter(t);
    }
    return null;
  }
  getPreviousKey(t) {
    for (t = this.collection.getKeyBefore(t); t != null; ) {
      if (this.collection.getItem(t).type === "item" && !this.disabledKeys.has(t))
        return t;
      t = this.collection.getKeyBefore(t);
    }
    return null;
  }
  findKey(t, r, o) {
    let a = this.getItem(t);
    if (!a)
      return null;
    let u = a.getBoundingClientRect();
    do
      t = r(t), a = this.getItem(t);
    while (a && o(u, a.getBoundingClientRect()));
    return t;
  }
  isSameRow(t, r) {
    return t.top === r.top || t.left !== r.left;
  }
  isSameColumn(t, r) {
    return t.left === r.left || t.top !== r.top;
  }
  getKeyBelow(t) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (r) => this.getNextKey(r), this.isSameRow) : this.getNextKey(t);
  }
  getKeyAbove(t) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (r) => this.getPreviousKey(r), this.isSameRow) : this.getPreviousKey(t);
  }
  getNextColumn(t, r) {
    return r ? this.getPreviousKey(t) : this.getNextKey(t);
  }
  getKeyRightOf(t) {
    return this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "rtl") : this.findKey(t, (r) => this.getNextColumn(r, this.direction === "rtl"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "rtl") : null;
  }
  getKeyLeftOf(t) {
    return this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "ltr") : this.findKey(t, (r) => this.getNextColumn(r, this.direction === "ltr"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "ltr") : null;
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    for (; t != null; ) {
      if (this.collection.getItem(t).type === "item" && !this.disabledKeys.has(t))
        return t;
      t = this.collection.getKeyAfter(t);
    }
    return null;
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    for (; t != null; ) {
      if (this.collection.getItem(t).type === "item" && !this.disabledKeys.has(t))
        return t;
      t = this.collection.getKeyBefore(t);
    }
    return null;
  }
  getItem(t) {
    return this.ref.current.querySelector(`[data-key="${CSS.escape(t.toString())}"]`);
  }
  getKeyPageAbove(t) {
    let r = this.ref.current, o = this.getItem(t);
    if (!o)
      return null;
    if (!nl(r))
      return this.getFirstKey();
    let a = r.getBoundingClientRect(), u = o.getBoundingClientRect();
    if (this.orientation === "horizontal") {
      let s = a.x - r.scrollLeft, d = Math.max(0, u.x - s + u.width - a.width);
      for (; o && u.x - s > d; )
        t = this.getKeyAbove(t), o = t == null ? null : this.getItem(t), u = o == null ? void 0 : o.getBoundingClientRect();
    } else {
      let s = a.y - r.scrollTop, d = Math.max(0, u.y - s + u.height - a.height);
      for (; o && u.y - s > d; )
        t = this.getKeyAbove(t), o = t == null ? null : this.getItem(t), u = o == null ? void 0 : o.getBoundingClientRect();
    }
    return t ?? this.getFirstKey();
  }
  getKeyPageBelow(t) {
    let r = this.ref.current, o = this.getItem(t);
    if (!o)
      return null;
    if (!nl(r))
      return this.getLastKey();
    let a = r.getBoundingClientRect(), u = o.getBoundingClientRect();
    if (this.orientation === "horizontal") {
      let s = a.x - r.scrollLeft, d = Math.min(r.scrollWidth, u.x - s - u.width + a.width);
      for (; o && u.x - s < d; )
        t = this.getKeyBelow(t), o = t == null ? null : this.getItem(t), u = o == null ? void 0 : o.getBoundingClientRect();
    } else {
      let s = a.y - r.scrollTop, d = Math.min(r.scrollHeight, u.y - s - u.height + a.height);
      for (; o && u.y - s < d; )
        t = this.getKeyBelow(t), o = t == null ? null : this.getItem(t), u = o == null ? void 0 : o.getBoundingClientRect();
    }
    return t ?? this.getLastKey();
  }
  getKeyForSearch(t, r) {
    if (!this.collator)
      return null;
    let o = this.collection, a = r || this.getFirstKey();
    for (; a != null; ) {
      let u = o.getItem(a), s = u.textValue.slice(0, t.length);
      if (u.textValue && this.collator.compare(s, t) === 0)
        return a;
      a = this.getKeyBelow(a);
    }
    return null;
  }
  constructor(...t) {
    if (t.length === 1) {
      let r = t[0];
      this.collection = r.collection, this.ref = r.ref, this.collator = r.collator, this.disabledKeys = r.disabledKeys || /* @__PURE__ */ new Set(), this.orientation = r.orientation, this.direction = r.direction, this.layout = r.layout || "stack";
    } else
      this.collection = t[0], this.disabledKeys = t[1], this.ref = t[2], this.collator = t[3], this.layout = "stack", this.orientation = "vertical";
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
}
function h5(e) {
  let { selectionManager: t, collection: r, disabledKeys: o, ref: a, keyboardDelegate: u } = e, s = ml({
    usage: "search",
    sensitivity: "base"
  }), d = t.disabledBehavior, f = me(() => u || new yl(r, d === "selection" ? /* @__PURE__ */ new Set() : o, a, s), [
    u,
    r,
    o,
    a,
    s,
    d
  ]), { collectionProps: h } = av({
    ...e,
    ref: a,
    selectionManager: t,
    keyboardDelegate: f
  });
  return {
    listProps: h
  };
}
class v5 {
  build(t, r) {
    return this.context = r, df(() => this.iterateCollection(t));
  }
  *iterateCollection(t) {
    let { children: r, items: o } = t;
    if (typeof r == "function") {
      if (!o)
        throw new Error("props.children was a function but props.items is missing");
      for (let a of t.items)
        yield* this.getFullNode({
          value: a
        }, {
          renderer: r
        });
    } else {
      let a = [];
      I.Children.forEach(r, (s) => {
        a.push(s);
      });
      let u = 0;
      for (let s of a) {
        let d = this.getFullNode({
          element: s,
          index: u
        }, {});
        for (let f of d)
          u++, yield f;
      }
    }
  }
  getKey(t, r, o, a) {
    if (t.key != null)
      return t.key;
    if (r.type === "cell" && r.key != null)
      return `${a}${r.key}`;
    let u = r.value;
    if (u != null) {
      var s;
      let d = (s = u.key) !== null && s !== void 0 ? s : u.id;
      if (d == null)
        throw new Error("No key found for item");
      return d;
    }
    return a ? `${a}.${r.index}` : `$.${r.index}`;
  }
  getChildState(t, r) {
    return {
      renderer: r.renderer || t.renderer
    };
  }
  *getFullNode(t, r, o, a) {
    let u = t.element;
    if (!u && t.value && r && r.renderer) {
      let f = this.cache.get(t.value);
      if (f && (!f.shouldInvalidate || !f.shouldInvalidate(this.context))) {
        f.index = t.index, f.parentKey = a ? a.key : null, yield f;
        return;
      }
      u = r.renderer(t.value);
    }
    if (I.isValidElement(u)) {
      let f = u.type;
      if (typeof f != "function" && typeof f.getCollectionNode != "function") {
        let y = typeof u.type == "function" ? u.type.name : u.type;
        throw new Error(`Unknown element <${y}> in collection.`);
      }
      let h = f.getCollectionNode(u.props, this.context), v = t.index, m = h.next();
      for (; !m.done && m.value; ) {
        let y = m.value;
        t.index = v;
        let $ = y.key;
        $ || ($ = y.element ? null : this.getKey(u, t, r, o));
        let _ = [
          ...this.getFullNode({
            ...y,
            key: $,
            index: v,
            wrapper: g5(t.wrapper, y.wrapper)
          }, this.getChildState(r, y), o ? `${o}${u.key}` : u.key, a)
        ];
        for (let F of _) {
          if (F.value = y.value || t.value, F.value && this.cache.set(F.value, F), t.type && F.type !== t.type)
            throw new Error(`Unsupported type <${nu(F.type)}> in <${nu(a.type)}>. Only <${nu(t.type)}> is supported.`);
          v++, yield F;
        }
        m = h.next(_);
      }
      return;
    }
    if (t.key == null)
      return;
    let s = this, d = {
      type: t.type,
      props: t.props,
      key: t.key,
      parentKey: a ? a.key : null,
      value: t.value,
      level: a ? a.level + 1 : 0,
      index: t.index,
      rendered: t.rendered,
      textValue: t.textValue,
      "aria-label": t["aria-label"],
      wrapper: t.wrapper,
      shouldInvalidate: t.shouldInvalidate,
      hasChildNodes: t.hasChildNodes,
      childNodes: df(function* () {
        if (!t.hasChildNodes)
          return;
        let f = 0;
        for (let h of t.childNodes()) {
          h.key != null && (h.key = `${d.key}${h.key}`), h.index = f;
          let v = s.getFullNode(h, s.getChildState(r, h), d.key, d);
          for (let m of v)
            f++, yield m;
        }
      })
    };
    yield d;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function df(e) {
  let t = [], r = null;
  return {
    *[Symbol.iterator]() {
      for (let o of t)
        yield o;
      r || (r = e());
      for (let o of r)
        t.push(o), yield o;
    }
  };
}
function g5(e, t) {
  if (e && t)
    return (r) => e(t(r));
  if (e)
    return e;
  if (t)
    return t;
}
function nu(e) {
  return e[0].toUpperCase() + e.slice(1);
}
function b5(e, t, r) {
  let o = me(() => new v5(), []), { children: a, items: u, collection: s } = e;
  return me(() => {
    if (s)
      return s;
    let f = o.build({
      children: a,
      items: u
    }, r);
    return t(f);
  }, [
    o,
    a,
    u,
    s,
    r,
    t
  ]);
}
function xl(e, t) {
  return typeof t.getChildren == "function" ? t.getChildren(e.key) : e.childNodes;
}
function m5(e) {
  return $5(e, 0);
}
function $5(e, t) {
  if (t < 0)
    return;
  let r = 0;
  for (let o of e) {
    if (r === t)
      return o;
    r++;
  }
}
function ru(e, t, r) {
  if (t.parentKey === r.parentKey)
    return t.index - r.index;
  let o = [
    ...ff(e, t),
    t
  ], a = [
    ...ff(e, r),
    r
  ], u = o.slice(0, a.length).findIndex((s, d) => s !== a[d]);
  return u !== -1 ? (t = o[u], r = a[u], t.index - r.index) : o.findIndex((s) => s === r) >= 0 ? 1 : (a.findIndex((s) => s === t) >= 0, -1);
}
function ff(e, t) {
  let r = [];
  for (; (t == null ? void 0 : t.parentKey) != null; )
    t = e.getItem(t.parentKey), r.unshift(t);
  return r;
}
const pf = /* @__PURE__ */ new WeakMap();
function uv(e) {
  let t = pf.get(e);
  if (t != null)
    return t;
  t = 0;
  let r = (o) => {
    for (let a of o)
      a.type === "section" ? r(xl(a, e)) : t++;
  };
  return r(e), pf.set(e, t), t;
}
const wl = /* @__PURE__ */ new WeakMap();
function y5(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
function sv(e, t) {
  let r = wl.get(e);
  if (!r)
    throw new Error("Unknown list");
  return `${r.id}-option-${y5(t)}`;
}
function x5(e, t, r) {
  let o = at(e, {
    labelable: !0
  }), a = e.selectionBehavior || "toggle", u = e.linkBehavior || (a === "replace" ? "action" : "override");
  a === "toggle" && u === "action" && (u = "override");
  let { listProps: s } = h5({
    ...e,
    ref: r,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    linkBehavior: u
  }), { focusWithinProps: d } = Wi({
    onFocusWithin: e.onFocus,
    onBlurWithin: e.onBlur,
    onFocusWithinChange: e.onFocusChange
  }), f = gn(e.id);
  wl.set(t, {
    id: f,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus,
    shouldSelectOnPressUp: e.shouldSelectOnPressUp,
    shouldFocusOnHover: e.shouldFocusOnHover,
    isVirtualized: e.isVirtualized,
    onAction: e.onAction,
    linkBehavior: u
  });
  let { labelProps: h, fieldProps: v } = Uu({
    ...e,
    id: f,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: h,
    listBoxProps: Se(o, d, t.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      ...Se(v, s)
    })
  };
}
function w5(e, t, r) {
  var o;
  let { key: a } = e, u = wl.get(t);
  var s;
  let d = (s = e.isDisabled) !== null && s !== void 0 ? s : t.disabledKeys.has(a);
  var f;
  let h = (f = e.isSelected) !== null && f !== void 0 ? f : t.selectionManager.isSelected(a);
  var v;
  let m = (v = e.shouldSelectOnPressUp) !== null && v !== void 0 ? v : u == null ? void 0 : u.shouldSelectOnPressUp;
  var y;
  let $ = (y = e.shouldFocusOnHover) !== null && y !== void 0 ? y : u == null ? void 0 : u.shouldFocusOnHover;
  var A;
  let _ = (A = e.shouldUseVirtualFocus) !== null && A !== void 0 ? A : u == null ? void 0 : u.shouldUseVirtualFocus;
  var F;
  let W = (F = e.isVirtualized) !== null && F !== void 0 ? F : u == null ? void 0 : u.isVirtualized, R = Qo(), B = Qo(), V = {
    role: "option",
    "aria-disabled": d || void 0,
    "aria-selected": t.selectionManager.selectionMode !== "none" ? h : void 0
  };
  Gn() && yp() || (V["aria-label"] = e["aria-label"], V["aria-labelledby"] = R, V["aria-describedby"] = B);
  let j = t.collection.getItem(a);
  if (W) {
    let T = Number(j == null ? void 0 : j.index);
    V["aria-posinset"] = Number.isNaN(T) ? void 0 : T + 1, V["aria-setsize"] = uv(t.collection);
  }
  let { itemProps: G, isPressed: J, isFocused: w, hasAction: Y, allowsSelection: O } = p5({
    selectionManager: t.selectionManager,
    key: a,
    ref: r,
    shouldSelectOnPressUp: m,
    allowsDifferentPressOrigin: m && $,
    isVirtualized: W,
    shouldUseVirtualFocus: _,
    isDisabled: d,
    onAction: u != null && u.onAction ? () => {
      var T;
      return u == null || (T = u.onAction) === null || T === void 0 ? void 0 : T.call(u, a);
    } : void 0,
    linkBehavior: u == null ? void 0 : u.linkBehavior
  }), { hoverProps: K } = vr({
    isDisabled: d || !$,
    onHoverStart() {
      il() || (t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(a));
    }
  }), k = at(j == null ? void 0 : j.props, {
    isLink: !!(!(j == null || (o = j.props) === null || o === void 0) && o.href)
  });
  return delete k.id, {
    optionProps: {
      ...V,
      ...Se(k, G, K),
      id: sv(t, a)
    },
    labelProps: {
      id: R
    },
    descriptionProps: {
      id: B
    },
    isFocused: w,
    isFocusVisible: w && il(),
    isSelected: h,
    isDisabled: d,
    isPressed: J,
    allowsSelection: O,
    hasAction: Y
  };
}
function C5(e) {
  let { heading: t, "aria-label": r } = e, o = gn();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Techincally, listbox cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a visual label for the nested group.
      id: o,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": r,
      "aria-labelledby": t ? o : void 0
    }
  };
}
var cv = {};
cv = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var dv = {};
dv = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var fv = {};
fv = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var pv = {};
pv = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var hv = {};
hv = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var vv = {};
vv = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var gv = {};
gv = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var bv = {};
bv = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var mv = {};
mv = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var $v = {};
$v = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var yv = {};
yv = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var xv = {};
xv = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var wv = {};
wv = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var Cv = {};
Cv = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var Ev = {};
Ev = {
  longPressMessage: "Premere a lungo o premere Alt + Freccia giù per aprire il menu"
};
var Sv = {};
Sv = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var Pv = {};
Pv = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var Tv = {};
Tv = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var Av = {};
Av = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var _v = {};
_v = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var Dv = {};
Dv = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var Fv = {};
Fv = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var Lv = {};
Lv = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var Rv = {};
Rv = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var Iv = {};
Iv = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var Bv = {};
Bv = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var Mv = {};
Mv = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var Kv = {};
Kv = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var Ov = {};
Ov = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var kv = {};
kv = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var Nv = {};
Nv = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var zv = {};
zv = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var Wv = {};
Wv = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var Vv = {};
Vv = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
function E5(e) {
  return e && e.__esModule ? e.default : e;
}
var Hv = {};
Hv = {
  "ar-AE": cv,
  "bg-BG": dv,
  "cs-CZ": fv,
  "da-DK": pv,
  "de-DE": hv,
  "el-GR": vv,
  "en-US": gv,
  "es-ES": bv,
  "et-EE": mv,
  "fi-FI": $v,
  "fr-FR": yv,
  "he-IL": xv,
  "hr-HR": wv,
  "hu-HU": Cv,
  "it-IT": Ev,
  "ja-JP": Sv,
  "ko-KR": Pv,
  "lt-LT": Tv,
  "lv-LV": Av,
  "nb-NO": _v,
  "nl-NL": Dv,
  "pl-PL": Fv,
  "pt-BR": Lv,
  "pt-PT": Rv,
  "ro-RO": Iv,
  "ru-RU": Bv,
  "sk-SK": Mv,
  "sl-SI": Kv,
  "sr-SP": Ov,
  "sv-SE": kv,
  "tr-TR": Nv,
  "uk-UA": zv,
  "zh-CN": Wv,
  "zh-TW": Vv
};
function Uv(e, t, r) {
  let { type: o = "menu", isDisabled: a, trigger: u = "press" } = e, s = gn(), { triggerProps: d, overlayProps: f } = r5({
    type: o
  }, t, r), h = ($) => {
    if (!a && !(u === "longPress" && !$.altKey) && r && r.current)
      switch ($.key) {
        case "Enter":
        case " ":
          if (u === "longPress")
            return;
        case "ArrowDown":
          "continuePropagation" in $ || $.stopPropagation(), $.preventDefault(), t.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in $ || $.stopPropagation(), $.preventDefault(), t.toggle("last");
          break;
        default:
          "continuePropagation" in $ && $.continuePropagation();
      }
  }, v = bl(/* @__PURE__ */ E5(Hv), "@react-aria/menu"), { longPressProps: m } = Fp({
    isDisabled: a || u !== "longPress",
    accessibilityDescription: v.format("longPressMessage"),
    onLongPressStart() {
      t.close();
    },
    onLongPress() {
      t.open("first");
    }
  }), y = {
    onPressStart($) {
      $.pointerType !== "touch" && $.pointerType !== "keyboard" && !a && t.toggle($.pointerType === "virtual" ? "first" : null);
    },
    onPress($) {
      $.pointerType === "touch" && !a && t.toggle();
    }
  };
  return delete d.onPress, {
    menuTriggerProps: {
      ...d,
      ...u === "press" ? y : m,
      id: s,
      onKeyDown: h
    },
    menuProps: {
      ...f,
      "aria-labelledby": s,
      autoFocus: t.focusStrategy || !0,
      onClose: t.close
    }
  };
}
function jv(e, t) {
  let { inputElementType: r = "input", isDisabled: o = !1, isRequired: a = !1, isReadOnly: u = !1, type: s = "text", validationBehavior: d = "aria" } = e, [f, h] = pr(e.value, e.defaultValue || "", e.onChange), { focusableProps: v } = Vu(e, t), m = $l({
    ...e,
    value: f
  }), { isInvalid: y, validationErrors: $, validationDetails: A } = m.displayValidation, { labelProps: _, fieldProps: F, descriptionProps: W, errorMessageProps: R } = ju({
    ...e,
    isInvalid: y,
    errorMessage: e.errorMessage || $
  }), B = at(e, {
    labelable: !0
  });
  const V = {
    type: s,
    pattern: e.pattern
  };
  return Ou(t, f, h), Hu(e, m, t), Ee(() => {
    if (t.current instanceof Ii(t.current).HTMLTextAreaElement) {
      let j = t.current;
      Object.defineProperty(j, "defaultValue", {
        get: () => j.value,
        set: () => {
        },
        configurable: !0
      });
    }
  }, [
    t
  ]), {
    labelProps: _,
    inputProps: Se(B, r === "input" && V, {
      disabled: o,
      readOnly: u,
      required: a && d === "native",
      "aria-required": a && d === "aria" || void 0,
      "aria-invalid": y || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-activedescendant": e["aria-activedescendant"],
      "aria-autocomplete": e["aria-autocomplete"],
      "aria-haspopup": e["aria-haspopup"],
      value: f,
      onChange: (j) => h(j.target.value),
      autoComplete: e.autoComplete,
      autoCapitalize: e.autoCapitalize,
      maxLength: e.maxLength,
      minLength: e.minLength,
      name: e.name,
      placeholder: e.placeholder,
      inputMode: e.inputMode,
      // Clipboard events
      onCopy: e.onCopy,
      onCut: e.onCut,
      onPaste: e.onPaste,
      // Composition events
      onCompositionEnd: e.onCompositionEnd,
      onCompositionStart: e.onCompositionStart,
      onCompositionUpdate: e.onCompositionUpdate,
      // Selection events
      onSelect: e.onSelect,
      // Input events
      onBeforeInput: e.onBeforeInput,
      onInput: e.onInput,
      ...v,
      ...F
    }),
    descriptionProps: W,
    errorMessageProps: R,
    isInvalid: y,
    validationErrors: $,
    validationDetails: A
  };
}
function S5(e) {
  return e && e.__esModule ? e.default : e;
}
var Gv = {};
Gv = {
  "ar-AE": zp,
  "bg-BG": Wp,
  "cs-CZ": Vp,
  "da-DK": Hp,
  "de-DE": Up,
  "el-GR": jp,
  "en-US": Gp,
  "es-ES": qp,
  "et-EE": Zp,
  "fi-FI": Yp,
  "fr-FR": Xp,
  "he-IL": Jp,
  "hr-HR": Qp,
  "hu-HU": eh,
  "it-IT": th,
  "ja-JP": nh,
  "ko-KR": rh,
  "lt-LT": ih,
  "lv-LV": oh,
  "nb-NO": lh,
  "nl-NL": ah,
  "pl-PL": uh,
  "pt-BR": sh,
  "pt-PT": ch,
  "ro-RO": dh,
  "ru-RU": fh,
  "sk-SK": ph,
  "sl-SI": hh,
  "sr-SP": vh,
  "sv-SE": gh,
  "tr-TR": bh,
  "uk-UA": mh,
  "zh-CN": $h,
  "zh-TW": yh
};
function P5(e, t) {
  let { buttonRef: r, popoverRef: o, inputRef: a, listBoxRef: u, keyboardDelegate: s, shouldFocusWrap: d, isReadOnly: f, isDisabled: h } = e, v = bl(/* @__PURE__ */ S5(Gv), "@react-aria/combobox"), { menuTriggerProps: m, menuProps: y } = Uv({
    type: "listbox",
    isDisabled: h || f
  }, t, r);
  wl.set(t, {
    id: y.id
  });
  let $ = me(() => s || new yl(t.collection, t.disabledKeys, u), [
    s,
    t.collection,
    t.disabledKeys,
    u
  ]), { collectionProps: A } = av({
    selectionManager: t.selectionManager,
    keyboardDelegate: $,
    disallowTypeAhead: !0,
    disallowEmptySelection: !0,
    shouldFocusWrap: d,
    ref: a,
    // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
    isVirtualized: !0
  }), _ = Bu(), F = (he) => {
    switch (he.key) {
      case "Enter":
      case "Tab":
        if (t.isOpen && he.key === "Enter" && he.preventDefault(), t.isOpen && t.selectionManager.focusedKey != null && t.selectionManager.isLink(t.selectionManager.focusedKey)) {
          if (he.key === "Enter") {
            let ge = u.current.querySelector(`[data-key="${CSS.escape(t.selectionManager.focusedKey.toString())}"]`);
            ge instanceof HTMLAnchorElement && _.open(ge, he);
          }
          t.close();
        } else
          t.commit();
        break;
      case "Escape":
        (t.selectedKey !== null || t.inputValue === "" || e.allowsCustomValue) && he.continuePropagation(), t.revert();
        break;
      case "ArrowDown":
        t.open("first", "manual");
        break;
      case "ArrowUp":
        t.open("last", "manual");
        break;
      case "ArrowLeft":
      case "ArrowRight":
        t.selectionManager.setFocusedKey(null);
        break;
    }
  }, W = (he) => {
    var ge;
    he.relatedTarget === (r == null ? void 0 : r.current) || !((ge = o.current) === null || ge === void 0) && ge.contains(he.relatedTarget) || (e.onBlur && e.onBlur(he), t.setFocused(!1));
  }, R = (he) => {
    t.isFocused || (e.onFocus && e.onFocus(he), t.setFocused(!0));
  }, { isInvalid: B, validationErrors: V, validationDetails: j } = t.displayValidation, { labelProps: G, inputProps: J, descriptionProps: w, errorMessageProps: Y } = jv({
    ...e,
    onChange: t.setInputValue,
    onKeyDown: f ? e.onKeyDown : cr(t.isOpen && A.onKeyDown, F, e.onKeyDown),
    onBlur: W,
    value: t.inputValue,
    onFocus: R,
    autoComplete: "off",
    validate: void 0,
    [$u]: t
  }, a), O = (he) => {
    he.pointerType === "touch" && (a.current.focus(), t.toggle(null, "manual"));
  }, K = (he) => {
    he.pointerType !== "touch" && (a.current.focus(), t.toggle(he.pointerType === "keyboard" || he.pointerType === "virtual" ? "first" : null, "manual"));
  }, k = el({
    id: m.id,
    "aria-label": v.format("buttonLabel"),
    "aria-labelledby": e["aria-labelledby"] || G.id
  }), T = el({
    id: y.id,
    "aria-label": v.format("listboxLabel"),
    "aria-labelledby": e["aria-labelledby"] || G.id
  }), D = ie(0), X = (he) => {
    if (h || f)
      return;
    if (he.timeStamp - D.current < 500) {
      he.preventDefault(), a.current.focus();
      return;
    }
    let ge = he.target.getBoundingClientRect(), ft = he.changedTouches[0], Bt = Math.ceil(ge.left + 0.5 * ge.width), cn = Math.ceil(ge.top + 0.5 * ge.height);
    ft.clientX === Bt && ft.clientY === cn && (he.preventDefault(), a.current.focus(), t.toggle(null, "manual"), D.current = he.timeStamp);
  }, Q = t.selectionManager.focusedKey != null && t.isOpen ? t.collection.getItem(t.selectionManager.focusedKey) : void 0;
  var H;
  let le = (H = Q == null ? void 0 : Q.parentKey) !== null && H !== void 0 ? H : null;
  var de;
  let ne = (de = t.selectionManager.focusedKey) !== null && de !== void 0 ? de : null, pe = ie(le), Ie = ie(ne);
  Ee(() => {
    if (Go() && Q != null && ne !== Ie.current) {
      let he = t.selectionManager.isSelected(ne), ge = le != null ? t.collection.getItem(le) : null, ft = (ge == null ? void 0 : ge["aria-label"]) || (typeof (ge == null ? void 0 : ge.rendered) == "string" ? ge.rendered : "") || "", Bt = v.format("focusAnnouncement", {
        isGroupChange: ge && le !== pe.current,
        groupTitle: ft,
        groupCount: ge ? [
          ...xl(ge, t.collection)
        ].length : 0,
        optionText: Q["aria-label"] || Q.textValue || "",
        isSelected: he
      });
      Xa(Bt);
    }
    pe.current = le, Ie.current = ne;
  });
  let Be = uv(t.collection), Tt = ie(Be), ut = ie(t.isOpen);
  Ee(() => {
    let he = t.isOpen !== ut.current && (t.selectionManager.focusedKey == null || Go());
    if (t.isOpen && (he || Be !== Tt.current)) {
      let ge = v.format("countAnnouncement", {
        optionCount: Be
      });
      Xa(ge);
    }
    Tt.current = Be, ut.current = t.isOpen;
  });
  let dt = ie(t.selectedKey);
  return Ee(() => {
    if (Go() && t.isFocused && t.selectedItem && t.selectedKey !== dt.current) {
      let he = t.selectedItem["aria-label"] || t.selectedItem.textValue || "", ge = v.format("selectedAnnouncement", {
        optionText: he
      });
      Xa(ge);
    }
    dt.current = t.selectedKey;
  }), Ee(() => {
    if (t.isOpen)
      return ov([
        a.current,
        o.current
      ]);
  }, [
    t.isOpen,
    a,
    o
  ]), {
    labelProps: G,
    buttonProps: {
      ...m,
      ...k,
      excludeFromTabOrder: !0,
      onPress: O,
      onPressStart: K,
      isDisabled: h || f
    },
    inputProps: Se(J, {
      role: "combobox",
      "aria-expanded": m["aria-expanded"],
      "aria-controls": t.isOpen ? y.id : void 0,
      // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
      "aria-autocomplete": "list",
      "aria-activedescendant": Q ? sv(t, Q.key) : void 0,
      onTouchEnd: X,
      // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
      autoCorrect: "off",
      // This disable's the macOS Safari spell check auto corrections.
      spellCheck: "false"
    }),
    listBoxProps: Se(y, T, {
      autoFocus: t.focusStrategy,
      shouldUseVirtualFocus: !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      linkBehavior: "selection"
    }),
    descriptionProps: w,
    errorMessageProps: Y,
    isInvalid: B,
    validationErrors: V,
    validationDetails: j
  };
}
function T5(e) {
  let { value: t = 0, minValue: r = 0, maxValue: o = 100, valueLabel: a, isIndeterminate: u, formatOptions: s = {
    style: "percent"
  } } = e, d = at(e, {
    labelable: !0
  }), { labelProps: f, fieldProps: h } = Uu({
    ...e,
    // Progress bar is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  t = Yo(t, r, o);
  let v = (t - r) / (o - r), m = Lx(s);
  if (!u && !a) {
    let y = s.style === "percent" ? v : t;
    a = m.format(y);
  }
  return {
    progressBarProps: Se(d, {
      ...h,
      "aria-valuenow": u ? void 0 : t,
      "aria-valuemin": r,
      "aria-valuemax": o,
      "aria-valuetext": u ? void 0 : a,
      role: "progressbar"
    }),
    labelProps: f
  };
}
const qv = /* @__PURE__ */ new WeakMap();
function A5(e, t, r) {
  let { value: o, children: a, "aria-label": u, "aria-labelledby": s } = e;
  const d = e.isDisabled || t.isDisabled;
  let f = a != null, h = u != null || s != null;
  !f && !h && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let v = t.selectedValue === o, m = (w) => {
    w.stopPropagation(), t.setSelectedValue(o);
  }, { pressProps: y, isPressed: $ } = Bi({
    isDisabled: d
  }), { pressProps: A, isPressed: _ } = Bi({
    isDisabled: d,
    onPress() {
      t.setSelectedValue(o);
    }
  }), { focusableProps: F } = Vu(Se(e, {
    onFocus: () => t.setLastFocusedValue(o)
  }), r), W = Se(y, F), R = at(e, {
    labelable: !0
  }), B = -1;
  t.selectedValue != null ? t.selectedValue === o && (B = 0) : (t.lastFocusedValue === o || t.lastFocusedValue == null) && (B = 0), d && (B = void 0);
  let { name: V, descriptionId: j, errorMessageId: G, validationBehavior: J } = qv.get(t);
  return Ou(r, t.selectedValue, t.setSelectedValue), Hu({
    validationBehavior: J
  }, t, r), {
    labelProps: Se(A, {
      onClick: (w) => w.preventDefault()
    }),
    inputProps: Se(R, {
      ...W,
      type: "radio",
      name: V,
      tabIndex: B,
      disabled: d,
      required: t.isRequired && J === "native",
      checked: v,
      value: o,
      onChange: m,
      "aria-describedby": [
        e["aria-describedby"],
        t.isInvalid ? G : null,
        j
      ].filter(Boolean).join(" ") || void 0
    }),
    isDisabled: d,
    isSelected: v,
    isPressed: $ || _
  };
}
function _5(e, t) {
  let { name: r, isReadOnly: o, isRequired: a, isDisabled: u, orientation: s = "vertical", validationBehavior: d = "aria" } = e, { direction: f } = br(), { isInvalid: h, validationErrors: v, validationDetails: m } = t.displayValidation, { labelProps: y, fieldProps: $, descriptionProps: A, errorMessageProps: _ } = ju({
    ...e,
    // Radio group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid: t.isInvalid,
    errorMessage: e.errorMessage || v
  }), F = at(e, {
    labelable: !0
  }), { focusWithinProps: W } = Wi({
    onBlurWithin(V) {
      var j;
      (j = e.onBlur) === null || j === void 0 || j.call(e, V), t.selectedValue || t.setLastFocusedValue(null);
    },
    onFocusWithin: e.onFocus,
    onFocusWithinChange: e.onFocusChange
  }), R = (V) => {
    let j;
    switch (V.key) {
      case "ArrowRight":
        f === "rtl" && s !== "vertical" ? j = "prev" : j = "next";
        break;
      case "ArrowLeft":
        f === "rtl" && s !== "vertical" ? j = "next" : j = "prev";
        break;
      case "ArrowDown":
        j = "next";
        break;
      case "ArrowUp":
        j = "prev";
        break;
      default:
        return;
    }
    V.preventDefault();
    let G = vn(V.currentTarget, {
      from: V.target
    }), J;
    j === "next" ? (J = G.nextNode(), J || (G.currentNode = V.currentTarget, J = G.firstChild())) : (J = G.previousNode(), J || (G.currentNode = V.currentTarget, J = G.lastChild())), J && (J.focus(), t.setSelectedValue(J.value));
  }, B = gn(r);
  return qv.set(t, {
    name: B,
    descriptionId: A.id,
    errorMessageId: _.id,
    validationBehavior: d
  }), {
    radioGroupProps: Se(F, {
      // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
      role: "radiogroup",
      onKeyDown: R,
      "aria-invalid": t.isInvalid || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-readonly": o || void 0,
      "aria-required": a || void 0,
      "aria-disabled": u || void 0,
      "aria-orientation": s,
      ...$,
      ...W
    }),
    labelProps: y,
    descriptionProps: A,
    errorMessageProps: _,
    isInvalid: h,
    validationErrors: v,
    validationDetails: m
  };
}
const Zv = /* @__PURE__ */ new WeakMap();
function D5(e, t, r) {
  let { keyboardDelegate: o, isDisabled: a, isRequired: u, name: s, validationBehavior: d = "aria" } = e, f = ml({
    usage: "search",
    sensitivity: "base"
  }), h = me(() => o || new yl(t.collection, t.disabledKeys, null, f), [
    o,
    t.collection,
    t.disabledKeys,
    f
  ]), { menuTriggerProps: v, menuProps: m } = Uv({
    isDisabled: a,
    type: "listbox"
  }, t, r), y = (w) => {
    switch (w.key) {
      case "ArrowLeft": {
        w.preventDefault();
        let Y = t.selectedKey != null ? h.getKeyAbove(t.selectedKey) : h.getFirstKey();
        Y && t.setSelectedKey(Y);
        break;
      }
      case "ArrowRight": {
        w.preventDefault();
        let Y = t.selectedKey != null ? h.getKeyBelow(t.selectedKey) : h.getFirstKey();
        Y && t.setSelectedKey(Y);
        break;
      }
    }
  }, { typeSelectProps: $ } = lv({
    keyboardDelegate: h,
    selectionManager: t.selectionManager,
    onTypeSelect(w) {
      t.setSelectedKey(w);
    }
  }), { isInvalid: A, validationErrors: _, validationDetails: F } = t.displayValidation, { labelProps: W, fieldProps: R, descriptionProps: B, errorMessageProps: V } = ju({
    ...e,
    labelElementType: "span",
    isInvalid: A,
    errorMessage: e.errorMessage || _
  });
  $.onKeyDown = $.onKeyDownCapture, delete $.onKeyDownCapture;
  let j = at(e, {
    labelable: !0
  }), G = Se($, v, R), J = gn();
  return Zv.set(t, {
    isDisabled: a,
    isRequired: u,
    name: s,
    validationBehavior: d
  }), {
    labelProps: {
      ...W,
      onClick: () => {
        e.isDisabled || (r.current.focus(), Dp("keyboard"));
      }
    },
    triggerProps: Se(j, {
      ...G,
      isDisabled: a,
      onKeyDown: cr(G.onKeyDown, y, e.onKeyDown),
      onKeyUp: e.onKeyUp,
      "aria-labelledby": [
        J,
        G["aria-labelledby"],
        G["aria-label"] && !G["aria-labelledby"] ? G.id : null
      ].filter(Boolean).join(" "),
      onFocus(w) {
        t.isFocused || (e.onFocus && e.onFocus(w), e.onFocusChange && e.onFocusChange(!0), t.setFocused(!0));
      },
      onBlur(w) {
        t.isOpen || (e.onBlur && e.onBlur(w), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      }
    }),
    valueProps: {
      id: J
    },
    menuProps: {
      ...m,
      autoFocus: t.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      linkBehavior: "selection",
      onBlur: (w) => {
        w.currentTarget.contains(w.relatedTarget) || (e.onBlur && e.onBlur(w), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      },
      "aria-labelledby": [
        R["aria-labelledby"],
        G["aria-label"] && !R["aria-labelledby"] ? G.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: B,
    errorMessageProps: V,
    isInvalid: A,
    validationErrors: _,
    validationDetails: F
  };
}
function F5(e, t, r) {
  let o = Zv.get(t) || {}, { autoComplete: a, name: u = o.name, isDisabled: s = o.isDisabled } = e, { validationBehavior: d, isRequired: f } = o, h = Z3(), { visuallyHiddenProps: v } = tv();
  Ou(e.selectRef, t.selectedKey, t.setSelectedKey), Hu({
    validationBehavior: d,
    focus: () => r.current.focus()
  }, t, e.selectRef);
  var m;
  return {
    containerProps: {
      ...v,
      "aria-hidden": !0,
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      type: "text",
      tabIndex: h == null || t.isFocused || t.isOpen ? -1 : 0,
      style: {
        fontSize: 16
      },
      onFocus: () => r.current.focus(),
      disabled: s
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: a,
      disabled: s,
      required: d === "native" && f,
      name: u,
      value: (m = t.selectedKey) !== null && m !== void 0 ? m : "",
      onChange: (y) => t.setSelectedKey(y.target.value)
    }
  };
}
function L5(e) {
  let { state: t, triggerRef: r, label: o, name: a, isDisabled: u } = e, s = ie(null), { containerProps: d, inputProps: f, selectProps: h } = F5({
    ...e,
    selectRef: s
  }, t, r);
  var v;
  return t.collection.size <= 300 ? /* @__PURE__ */ I.createElement("div", {
    ...d,
    "data-testid": "hidden-select-container"
  }, /* @__PURE__ */ I.createElement("input", f), /* @__PURE__ */ I.createElement("label", null, o, /* @__PURE__ */ I.createElement("select", {
    ...h,
    ref: s
  }, /* @__PURE__ */ I.createElement("option", null), [
    ...t.collection.getKeys()
  ].map((m) => {
    let y = t.collection.getItem(m);
    if (y.type === "item")
      return /* @__PURE__ */ I.createElement("option", {
        key: y.key,
        value: y.key
      }, y.textValue);
  })))) : a ? /* @__PURE__ */ I.createElement("input", {
    type: "hidden",
    autoComplete: h.autoComplete,
    name: a,
    disabled: u,
    value: (v = t.selectedKey) !== null && v !== void 0 ? v : ""
  }) : null;
}
function R5(e) {
  let t = at(e, {
    labelable: !0
  }), r;
  return e.orientation === "vertical" && (r = "vertical"), e.elementType !== "hr" ? {
    separatorProps: {
      ...t,
      role: "separator",
      "aria-orientation": r
    }
  } : {
    separatorProps: t
  };
}
class sn extends Set {
  constructor(t, r, o) {
    super(t), t instanceof sn ? (this.anchorKey = r || t.anchorKey, this.currentKey = o || t.currentKey) : (this.anchorKey = r, this.currentKey = o);
  }
}
function I5(e, t) {
  if (e.size !== t.size)
    return !1;
  for (let r of e)
    if (!t.has(r))
      return !1;
  return !0;
}
function B5(e) {
  let { selectionMode: t = "none", disallowEmptySelection: r, allowDuplicateSelectionEvents: o, selectionBehavior: a = "toggle", disabledBehavior: u = "all" } = e, s = ie(!1), [, d] = Ce(!1), f = ie(null), h = ie(null), [, v] = Ce(null), m = me(() => hf(e.selectedKeys), [
    e.selectedKeys
  ]), y = me(() => hf(e.defaultSelectedKeys, new sn()), [
    e.defaultSelectedKeys
  ]), [$, A] = pr(m, y, e.onSelectionChange), _ = me(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), [F, W] = Ce(a);
  a === "replace" && F === "toggle" && typeof $ == "object" && $.size === 0 && W("replace");
  let R = ie(a);
  return Ee(() => {
    a !== R.current && (W(a), R.current = a);
  }, [
    a
  ]), {
    selectionMode: t,
    disallowEmptySelection: r,
    selectionBehavior: F,
    setSelectionBehavior: W,
    get isFocused() {
      return s.current;
    },
    setFocused(B) {
      s.current = B, d(B);
    },
    get focusedKey() {
      return f.current;
    },
    get childFocusStrategy() {
      return h.current;
    },
    setFocusedKey(B, V = "first") {
      f.current = B, h.current = V, v(B);
    },
    selectedKeys: $,
    setSelectedKeys(B) {
      (o || !I5(B, $)) && A(B);
    },
    disabledKeys: _,
    disabledBehavior: u
  };
}
function hf(e, t) {
  return e ? e === "all" ? "all" : new sn(e) : t;
}
class M5 {
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(t) {
    this.state.setSelectionBehavior(t);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(t) {
    this.state.setFocused(t);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(t, r) {
    (t == null || this.collection.getItem(t)) && this.state.setFocusedKey(t, r);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(t) {
    return this.state.selectionMode === "none" ? !1 : (t = this.getKey(t), this.state.selectedKeys === "all" ? this.canSelectItem(t) : this.state.selectedKeys.has(t));
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty)
      return !1;
    if (this.state.selectedKeys === "all")
      return !0;
    if (this._isSelectAll != null)
      return this._isSelectAll;
    let t = this.getSelectAllKeys(), r = this.state.selectedKeys;
    return this._isSelectAll = t.every((o) => r.has(o)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let t = null;
    for (let r of this.state.selectedKeys) {
      let o = this.collection.getItem(r);
      (!t || o && ru(this.collection, o, t) < 0) && (t = o);
    }
    return t == null ? void 0 : t.key;
  }
  get lastSelectedKey() {
    let t = null;
    for (let r of this.state.selectedKeys) {
      let o = this.collection.getItem(r);
      (!t || o && ru(this.collection, o, t) > 0) && (t = o);
    }
    return t == null ? void 0 : t.key;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(t) {
    if (this.selectionMode === "none")
      return;
    if (this.selectionMode === "single") {
      this.replaceSelection(t);
      return;
    }
    t = this.getKey(t);
    let r;
    if (this.state.selectedKeys === "all")
      r = new sn([
        t
      ], t, t);
    else {
      let o = this.state.selectedKeys, a = o.anchorKey || t;
      r = new sn(o, a, t);
      for (let u of this.getKeyRange(a, o.currentKey || t))
        r.delete(u);
      for (let u of this.getKeyRange(t, a))
        this.canSelectItem(u) && r.add(u);
    }
    this.state.setSelectedKeys(r);
  }
  getKeyRange(t, r) {
    let o = this.collection.getItem(t), a = this.collection.getItem(r);
    return o && a ? ru(this.collection, o, a) <= 0 ? this.getKeyRangeInternal(t, r) : this.getKeyRangeInternal(r, t) : [];
  }
  getKeyRangeInternal(t, r) {
    let o = [], a = t;
    for (; a; ) {
      let u = this.collection.getItem(a);
      if ((u && u.type === "item" || u.type === "cell" && this.allowsCellSelection) && o.push(a), a === r)
        return o;
      a = this.collection.getKeyAfter(a);
    }
    return [];
  }
  getKey(t) {
    let r = this.collection.getItem(t);
    if (!r || r.type === "cell" && this.allowsCellSelection)
      return t;
    for (; r.type !== "item" && r.parentKey != null; )
      r = this.collection.getItem(r.parentKey);
    return !r || r.type !== "item" ? null : r.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(t) {
    if (this.selectionMode === "none")
      return;
    if (this.selectionMode === "single" && !this.isSelected(t)) {
      this.replaceSelection(t);
      return;
    }
    if (t = this.getKey(t), t == null)
      return;
    let r = new sn(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    r.has(t) ? r.delete(t) : this.canSelectItem(t) && (r.add(t), r.anchorKey = t, r.currentKey = t), !(this.disallowEmptySelection && r.size === 0) && this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(t) {
    if (this.selectionMode === "none" || (t = this.getKey(t), t == null))
      return;
    let r = this.canSelectItem(t) ? new sn([
      t
    ], t, t) : new sn();
    this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(t) {
    if (this.selectionMode === "none")
      return;
    let r = new sn();
    for (let o of t)
      if (o = this.getKey(o), o != null && (r.add(o), this.selectionMode === "single"))
        break;
    this.state.setSelectedKeys(r);
  }
  getSelectAllKeys() {
    let t = [], r = (o) => {
      for (; o; ) {
        if (this.canSelectItem(o)) {
          let a = this.collection.getItem(o);
          a.type === "item" && t.push(o), a.hasChildNodes && (this.allowsCellSelection || a.type !== "item") && r(m5(xl(a, this.collection)).key);
        }
        o = this.collection.getKeyAfter(o);
      }
    };
    return r(this.collection.getFirstKey()), t;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new sn());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(t, r) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(t) && !this.disallowEmptySelection ? this.toggleSelection(t) : this.replaceSelection(t) : this.selectionBehavior === "toggle" || r && (r.pointerType === "touch" || r.pointerType === "virtual") ? this.toggleSelection(t) : this.replaceSelection(t));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(t) {
    if (t === this.state.selectedKeys)
      return !0;
    let r = this.selectedKeys;
    if (t.size !== r.size)
      return !1;
    for (let o of t)
      if (!r.has(o))
        return !1;
    for (let o of r)
      if (!t.has(o))
        return !1;
    return !0;
  }
  canSelectItem(t) {
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(t))
      return !1;
    let r = this.collection.getItem(t);
    return !(!r || r.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(t) {
    return this.state.disabledKeys.has(t) && this.state.disabledBehavior === "all";
  }
  isLink(t) {
    var r, o;
    return !!(!((o = this.collection.getItem(t)) === null || o === void 0 || (r = o.props) === null || r === void 0) && r.href);
  }
  constructor(t, r, o) {
    this.collection = t, this.state = r;
    var a;
    this.allowsCellSelection = (a = o == null ? void 0 : o.allowsCellSelection) !== null && a !== void 0 ? a : !1, this._isSelectAll = null;
  }
}
class Cu {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let r = this.keyMap.get(t);
    return r ? r.prevKey : null;
  }
  getKeyAfter(t) {
    let r = this.keyMap.get(t);
    return r ? r.nextKey : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    return this.keyMap.get(t);
  }
  at(t) {
    const r = [
      ...this.getKeys()
    ];
    return this.getItem(r[t]);
  }
  getChildren(t) {
    let r = this.keyMap.get(t);
    return (r == null ? void 0 : r.childNodes) || [];
  }
  constructor(t) {
    this.keyMap = /* @__PURE__ */ new Map(), this.iterable = t;
    let r = (u) => {
      if (this.keyMap.set(u.key, u), u.childNodes && u.type === "section")
        for (let s of u.childNodes)
          r(s);
    };
    for (let u of t)
      r(u);
    let o, a = 0;
    for (let [u, s] of this.keyMap)
      o ? (o.nextKey = u, s.prevKey = o.key) : (this.firstKey = u, s.prevKey = void 0), s.type === "item" && (s.index = a++), o = s, o.nextKey = void 0;
    this.lastKey = o == null ? void 0 : o.key;
  }
}
function Yv(e) {
  let { filter: t } = e, r = B5(e), o = me(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), a = Pe((h) => t ? new Cu(t(h)) : new Cu(h), [
    t
  ]), u = me(() => ({
    suppressTextValueWarning: e.suppressTextValueWarning
  }), [
    e.suppressTextValueWarning
  ]), s = b5(e, a, u), d = me(() => new M5(s, r), [
    s,
    r
  ]);
  const f = ie(null);
  return Ee(() => {
    if (r.focusedKey != null && !s.getItem(r.focusedKey)) {
      const h = f.current.getItem(r.focusedKey), v = [
        ...f.current.getKeys()
      ].map((_) => {
        const F = f.current.getItem(_);
        return F.type === "item" ? F : null;
      }).filter((_) => _ !== null), m = [
        ...s.getKeys()
      ].map((_) => {
        const F = s.getItem(_);
        return F.type === "item" ? F : null;
      }).filter((_) => _ !== null), y = v.length - m.length;
      let $ = Math.min(y > 1 ? Math.max(h.index - y + 1, 0) : h.index, m.length - 1), A;
      for (; $ >= 0; ) {
        if (!d.isDisabled(m[$].key)) {
          A = m[$];
          break;
        }
        $ < m.length - 1 ? $++ : ($ > h.index && ($ = h.index), $--);
      }
      r.setFocusedKey(A ? A.key : null);
    }
    f.current = s;
  }, [
    s,
    d,
    r,
    r.focusedKey
  ]), {
    collection: s,
    disabledKeys: o,
    selectionManager: d
  };
}
function Xv(e) {
  var t;
  let [r, o] = pr(e.selectedKey, (t = e.defaultSelectedKey) !== null && t !== void 0 ? t : null, e.onSelectionChange), a = me(() => r != null ? [
    r
  ] : [], [
    r
  ]), { collection: u, disabledKeys: s, selectionManager: d } = Yv({
    ...e,
    selectionMode: "single",
    disallowEmptySelection: !0,
    allowDuplicateSelectionEvents: !0,
    selectedKeys: a,
    onSelectionChange: (h) => {
      var v;
      let m = (v = h.values().next().value) !== null && v !== void 0 ? v : null;
      m === r && e.onSelectionChange && e.onSelectionChange(m), o(m);
    }
  }), f = r != null ? u.getItem(r) : null;
  return {
    collection: u,
    disabledKeys: s,
    selectionManager: d,
    selectedKey: r,
    setSelectedKey: o,
    selectedItem: f
  };
}
function Gu(e) {
  let [t, r] = pr(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const o = Pe(() => {
    r(!0);
  }, [
    r
  ]), a = Pe(() => {
    r(!1);
  }, [
    r
  ]), u = Pe(() => {
    r(!t);
  }, [
    r,
    t
  ]);
  return {
    isOpen: t,
    setOpen: r,
    open: o,
    close: a,
    toggle: u
  };
}
function K5(e) {
  var t, r;
  let { defaultFilter: o, menuTrigger: a = "input", allowsEmptyCollection: u = !1, allowsCustomValue: s, shouldCloseOnBlur: d = !0 } = e, [f, h] = Ce(!1), [v, m] = Ce(!1), [y, $] = Ce(null), A = (ye) => {
    e.onSelectionChange && e.onSelectionChange(ye), ye === R && (Tt(), pe());
  };
  var _;
  let { collection: F, selectionManager: W, selectedKey: R, setSelectedKey: B, selectedItem: V, disabledKeys: j } = Xv({
    ...e,
    onSelectionChange: A,
    items: (_ = e.items) !== null && _ !== void 0 ? _ : e.defaultItems
  });
  var G, J;
  let [w, Y] = pr(e.inputValue, (J = (G = e.defaultInputValue) !== null && G !== void 0 ? G : (t = F.getItem(R)) === null || t === void 0 ? void 0 : t.textValue) !== null && J !== void 0 ? J : "", e.onInputChange), O = F, K = me(() => (
    // No default filter if items are controlled.
    e.items != null || !o ? F : O5(F, w, o)
  ), [
    F,
    w,
    o,
    e.items
  ]), [k, T] = Ce(K), D = ie("focus"), Q = Gu({
    ...e,
    onOpenChange: (ye) => {
      e.onOpenChange && e.onOpenChange(ye, ye ? D.current : void 0), W.setFocused(ye), ye || W.setFocusedKey(null);
    },
    isOpen: void 0,
    defaultOpen: void 0
  }), H = (ye = null, Me) => {
    let Ke = Me === "manual" || Me === "focus" && a === "focus";
    (u || K.size > 0 || Ke && O.size > 0 || e.items) && (Ke && !Q.isOpen && e.items === void 0 && h(!0), D.current = Me, $(ye), Q.open());
  }, le = (ye = null, Me) => {
    let Ke = Me === "manual" || Me === "focus" && a === "focus";
    !(u || K.size > 0 || Ke && O.size > 0 || e.items) && !Q.isOpen || (Ke && !Q.isOpen && e.items === void 0 && h(!0), Q.isOpen || (D.current = Me), ne(ye));
  }, de = Pe(() => {
    T(f ? O : K);
  }, [
    f,
    O,
    K
  ]), ne = Pe((ye = null) => {
    Q.isOpen && de(), $(ye), Q.toggle();
  }, [
    Q,
    de
  ]), pe = Pe(() => {
    Q.isOpen && (de(), Q.close());
  }, [
    Q,
    de
  ]), [Ie, Be] = Ce(w), Tt = () => {
    var ye, Me;
    let Ke = (Me = (ye = F.getItem(R)) === null || ye === void 0 ? void 0 : ye.textValue) !== null && Me !== void 0 ? Me : "";
    Be(Ke), Y(Ke);
  };
  var ut, dt;
  let he = ie((dt = (ut = e.selectedKey) !== null && ut !== void 0 ? ut : e.defaultSelectedKey) !== null && dt !== void 0 ? dt : null);
  var ge;
  let ft = ie((ge = (r = F.getItem(R)) === null || r === void 0 ? void 0 : r.textValue) !== null && ge !== void 0 ? ge : "");
  Ee(() => {
    var ye;
    v && (K.size > 0 || u) && !Q.isOpen && w !== Ie && a !== "manual" && H(null, "input"), !f && !u && Q.isOpen && K.size === 0 && pe(), R != null && R !== he.current && pe(), w !== Ie && (W.setFocusedKey(null), h(!1), w === "" && (e.inputValue === void 0 || e.selectedKey === void 0) && B(null)), R !== he.current && (e.inputValue === void 0 || e.selectedKey === void 0) ? Tt() : Ie !== w && Be(w);
    var Me;
    let Ke = (Me = (ye = F.getItem(R)) === null || ye === void 0 ? void 0 : ye.textValue) !== null && Me !== void 0 ? Me : "";
    !v && R != null && e.inputValue === void 0 && R === he.current && ft.current !== Ke && (Be(Ke), Y(Ke)), he.current = R, ft.current = Ke;
  });
  let Bt = $l({
    ...e,
    value: me(() => ({
      inputValue: w,
      selectedKey: R
    }), [
      w,
      R
    ])
  }), cn = () => {
    s && R == null ? dn() : bn();
  }, dn = () => {
    he.current = null, B(null), pe();
  }, bn = () => {
    if (e.selectedKey !== void 0 && e.inputValue !== void 0) {
      var ye;
      e.onSelectionChange(R);
      var Me;
      let Ke = (Me = (ye = F.getItem(R)) === null || ye === void 0 ? void 0 : ye.textValue) !== null && Me !== void 0 ? Me : "";
      Be(Ke), pe();
    } else
      Tt(), pe();
  };
  const pt = () => {
    if (s) {
      var ye, Me;
      const Ke = (Me = (ye = F.getItem(R)) === null || ye === void 0 ? void 0 : ye.textValue) !== null && Me !== void 0 ? Me : "";
      w === Ke ? bn() : dn();
    } else
      bn();
  };
  let Ht = () => {
    Q.isOpen && W.focusedKey != null ? R === W.focusedKey ? bn() : B(W.focusedKey) : pt();
  }, mn = ie(w), At = (ye) => {
    ye ? (mn.current = w, a === "focus" && H(null, "focus")) : (d && pt(), w !== mn.current && Bt.commitValidation()), m(ye);
  }, Xn = me(() => Q.isOpen ? f ? O : K : k, [
    Q.isOpen,
    O,
    K,
    f,
    k
  ]);
  return {
    ...Bt,
    ...Q,
    focusStrategy: y,
    toggle: le,
    open: H,
    close: pt,
    selectionManager: W,
    selectedKey: R,
    setSelectedKey: B,
    disabledKeys: j,
    isFocused: v,
    setFocused: At,
    selectedItem: V,
    collection: Xn,
    inputValue: w,
    setInputValue: Y,
    commit: Ht,
    revert: cn
  };
}
function O5(e, t, r) {
  return new Cu(Jv(e, e, t, r));
}
function Jv(e, t, r, o) {
  let a = [];
  for (let u of t)
    if (u.type === "section" && u.hasChildNodes) {
      let s = Jv(e, xl(u, e), r, o);
      [
        ...s
      ].some((d) => d.type === "item") && a.push({
        ...u,
        childNodes: s
      });
    } else
      u.type === "item" && o(u.textValue, r) ? a.push({
        ...u
      }) : u.type !== "item" && a.push({
        ...u
      });
  return a;
}
let k5 = Math.round(Math.random() * 1e10), N5 = 0;
function z5(e) {
  let t = me(() => e.name || `radio-group-${k5}-${++N5}`, [
    e.name
  ]);
  var r;
  let [o, a] = pr(e.value, (r = e.defaultValue) !== null && r !== void 0 ? r : null, e.onChange), [u, s] = Ce(null), d = $l({
    ...e,
    value: o
  }), f = (v) => {
    !e.isReadOnly && !e.isDisabled && (a(v), d.commitValidation());
  }, h = d.displayValidation.isInvalid;
  return {
    ...d,
    name: t,
    selectedValue: o,
    setSelectedValue: f,
    lastFocusedValue: u,
    setLastFocusedValue: s,
    isDisabled: e.isDisabled || !1,
    isReadOnly: e.isReadOnly || !1,
    isRequired: e.isRequired || !1,
    validationState: e.validationState || (h ? "invalid" : null),
    isInvalid: h
  };
}
function W5(e) {
  let t = Gu(e), [r, o] = Ce(null), a = Xv({
    ...e,
    onSelectionChange: (f) => {
      e.onSelectionChange != null && e.onSelectionChange(f), t.close(), u.commitValidation();
    }
  }), u = $l({
    ...e,
    value: a.selectedKey
  }), [s, d] = Ce(!1);
  return {
    ...u,
    ...a,
    ...t,
    focusStrategy: r,
    open(f = null) {
      a.collection.size !== 0 && (o(f), t.open());
    },
    toggle(f = null) {
      a.collection.size !== 0 && (o(f), t.toggle());
    },
    isFocused: s,
    setFocused: d
  };
}
var Eu = { exports: {} }, iu = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vf;
function V5() {
  if (vf)
    return iu;
  vf = 1;
  var e = I;
  function t(m, y) {
    return m === y && (m !== 0 || 1 / m === 1 / y) || m !== m && y !== y;
  }
  var r = typeof Object.is == "function" ? Object.is : t, o = e.useState, a = e.useEffect, u = e.useLayoutEffect, s = e.useDebugValue;
  function d(m, y) {
    var $ = y(), A = o({ inst: { value: $, getSnapshot: y } }), _ = A[0].inst, F = A[1];
    return u(function() {
      _.value = $, _.getSnapshot = y, f(_) && F({ inst: _ });
    }, [m, $, y]), a(function() {
      return f(_) && F({ inst: _ }), m(function() {
        f(_) && F({ inst: _ });
      });
    }, [m]), s($), $;
  }
  function f(m) {
    var y = m.getSnapshot;
    m = m.value;
    try {
      var $ = y();
      return !r(m, $);
    } catch {
      return !0;
    }
  }
  function h(m, y) {
    return y();
  }
  var v = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? h : d;
  return iu.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : v, iu;
}
var ou = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gf;
function H5() {
  return gf || (gf = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = I, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(B) {
      {
        for (var V = arguments.length, j = new Array(V > 1 ? V - 1 : 0), G = 1; G < V; G++)
          j[G - 1] = arguments[G];
        o("error", B, j);
      }
    }
    function o(B, V, j) {
      {
        var G = t.ReactDebugCurrentFrame, J = G.getStackAddendum();
        J !== "" && (V += "%s", j = j.concat([J]));
        var w = j.map(function(Y) {
          return String(Y);
        });
        w.unshift("Warning: " + V), Function.prototype.apply.call(console[B], console, w);
      }
    }
    function a(B, V) {
      return B === V && (B !== 0 || 1 / B === 1 / V) || B !== B && V !== V;
    }
    var u = typeof Object.is == "function" ? Object.is : a, s = e.useState, d = e.useEffect, f = e.useLayoutEffect, h = e.useDebugValue, v = !1, m = !1;
    function y(B, V, j) {
      v || e.startTransition !== void 0 && (v = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var G = V();
      if (!m) {
        var J = V();
        u(G, J) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), m = !0);
      }
      var w = s({
        inst: {
          value: G,
          getSnapshot: V
        }
      }), Y = w[0].inst, O = w[1];
      return f(function() {
        Y.value = G, Y.getSnapshot = V, $(Y) && O({
          inst: Y
        });
      }, [B, G, V]), d(function() {
        $(Y) && O({
          inst: Y
        });
        var K = function() {
          $(Y) && O({
            inst: Y
          });
        };
        return B(K);
      }, [B]), h(G), G;
    }
    function $(B) {
      var V = B.getSnapshot, j = B.value;
      try {
        var G = V();
        return !u(j, G);
      } catch {
        return !0;
      }
    }
    function A(B, V, j) {
      return V();
    }
    var _ = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", F = !_, W = F ? A : y, R = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : W;
    ou.useSyncExternalStore = R, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ou;
}
process.env.NODE_ENV === "production" ? Eu.exports = V5() : Eu.exports = H5();
var U5 = Eu.exports;
function j5(e) {
  return e && e.__esModule ? e.default : e;
}
class qu {
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let t = new qu(this.type, this.key);
    return t.value = this.value, t.level = this.level, t.hasChildNodes = this.hasChildNodes, t.rendered = this.rendered, t.textValue = this.textValue, t["aria-label"] = this["aria-label"], t.index = this.index, t.parentKey = this.parentKey, t.prevKey = this.prevKey, t.nextKey = this.nextKey, t.firstChildKey = this.firstChildKey, t.lastChildKey = this.lastChildKey, t.props = this.props, t;
  }
  constructor(t, r) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.type = t, this.key = r;
  }
}
class Qv {
  *[Symbol.iterator]() {
    let t = this.firstChild;
    for (; t; )
      yield t, t = t.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(t) {
    this._firstChild = t, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(t) {
    this._lastChild = t, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(t) {
    this._previousSibling = t, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(t) {
    this._nextSibling = t, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(t) {
    this._parentNode = t, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    var t;
    return ((t = this.parentNode) === null || t === void 0 ? void 0 : t.isConnected) || !1;
  }
  appendChild(t) {
    this.ownerDocument.startTransaction(), t.parentNode && t.parentNode.removeChild(t), this.firstChild == null && (this.firstChild = t), this.lastChild ? (this.lastChild.nextSibling = t, t.index = this.lastChild.index + 1, t.previousSibling = this.lastChild) : (t.previousSibling = null, t.index = 0), t.parentNode = this, t.nextSibling = null, this.lastChild = t, this.ownerDocument.markDirty(this), t.hasSetProps && this.ownerDocument.addNode(t), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  insertBefore(t, r) {
    if (r == null)
      return this.appendChild(t);
    this.ownerDocument.startTransaction(), t.parentNode && t.parentNode.removeChild(t), t.nextSibling = r, t.previousSibling = r.previousSibling, t.index = r.index, this.firstChild === r ? this.firstChild = t : r.previousSibling && (r.previousSibling.nextSibling = t), r.previousSibling = t, t.parentNode = r.parentNode;
    let o = r;
    for (; o; )
      o.index++, o = o.nextSibling;
    t.hasSetProps && this.ownerDocument.addNode(t), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  removeChild(t) {
    if (t.parentNode !== this)
      return;
    this.ownerDocument.startTransaction();
    let r = t.nextSibling;
    for (; r; )
      r.index--, r = r.nextSibling;
    t.nextSibling && (t.nextSibling.previousSibling = t.previousSibling), t.previousSibling && (t.previousSibling.nextSibling = t.nextSibling), this.firstChild === t && (this.firstChild = t.nextSibling), this.lastChild === t && (this.lastChild = t.previousSibling), t.parentNode = null, t.nextSibling = null, t.previousSibling = null, t.index = 0, this.ownerDocument.removeNode(t), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  constructor(t) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this.ownerDocument = t;
  }
}
class Oi extends Qv {
  get index() {
    return this._index;
  }
  set index(t) {
    this._index = t, this.ownerDocument.markDirty(this);
  }
  get level() {
    return this.parentNode instanceof Oi ? this.parentNode.level + (this.node.type === "item" ? 1 : 0) : 0;
  }
  updateNode() {
    var t, r, o, a;
    let u = this.ownerDocument.getMutableNode(this);
    u.index = this.index, u.level = this.level, u.parentKey = this.parentNode instanceof Oi ? this.parentNode.node.key : null;
    var s;
    u.prevKey = (s = (t = this.previousSibling) === null || t === void 0 ? void 0 : t.node.key) !== null && s !== void 0 ? s : null;
    var d;
    u.nextKey = (d = (r = this.nextSibling) === null || r === void 0 ? void 0 : r.node.key) !== null && d !== void 0 ? d : null, u.hasChildNodes = !!this.firstChild;
    var f;
    u.firstChildKey = (f = (o = this.firstChild) === null || o === void 0 ? void 0 : o.node.key) !== null && f !== void 0 ? f : null;
    var h;
    u.lastChildKey = (h = (a = this.lastChild) === null || a === void 0 ? void 0 : a.node.key) !== null && h !== void 0 ? h : null;
  }
  setProps(t, r, o) {
    let a = this.ownerDocument.getMutableNode(this), { value: u, textValue: s, id: d, ...f } = t;
    if (f.ref = r, a.props = f, a.rendered = o, a.value = u, a.textValue = s || (typeof o == "string" ? o : "") || t["aria-label"] || "", d != null && d !== a.key) {
      if (this.hasSetProps)
        throw new Error("Cannot change the id of an item");
      a.key = d;
    }
    this.hasSetProps || (this.ownerDocument.addNode(this), this.ownerDocument.endTransaction(), this.hasSetProps = !0), this.ownerDocument.queueUpdate();
  }
  get style() {
    return {};
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
  constructor(t, r) {
    super(r), this.nodeType = 8, this._index = 0, this.hasSetProps = !1, this.node = new qu(t, `react-aria-${++r.nodeId}`), this.ownerDocument.startTransaction();
  }
}
class G5 {
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let t = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; t; )
      yield t, t = t.nextKey != null ? this.keyMap.get(t.nextKey) : void 0;
  }
  getChildren(t) {
    let r = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let o = r.get(t), a = (o == null ? void 0 : o.firstChildKey) != null ? r.get(o.firstChildKey) : null;
        for (; a; )
          yield a, a = a.nextKey != null ? r.get(a.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(t) {
    let r = this.keyMap.get(t);
    if (!r)
      return null;
    if (r.prevKey != null) {
      for (r = this.keyMap.get(r.prevKey); r && r.type !== "item" && r.lastChildKey != null; )
        r = this.keyMap.get(r.lastChildKey);
      var o;
      return (o = r == null ? void 0 : r.key) !== null && o !== void 0 ? o : null;
    }
    return r.parentKey;
  }
  getKeyAfter(t) {
    let r = this.keyMap.get(t);
    if (!r)
      return null;
    if (r.type !== "item" && r.firstChildKey != null)
      return r.firstChildKey;
    for (; r; ) {
      if (r.nextKey != null)
        return r.nextKey;
      if (r.parentKey != null)
        r = this.keyMap.get(r.parentKey);
      else
        return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let t = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; (t == null ? void 0 : t.lastChildKey) != null; )
      t = this.keyMap.get(t.lastChildKey);
    var r;
    return (r = t == null ? void 0 : t.key) !== null && r !== void 0 ? r : null;
  }
  getItem(t) {
    var r;
    return (r = this.keyMap.get(t)) !== null && r !== void 0 ? r : null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let t = this.constructor, r = new t();
    return r.keyMap = new Map(this.keyMap), r.firstKey = this.firstKey, r.lastKey = this.lastKey, r;
  }
  addNode(t) {
    if (this.frozen)
      throw new Error("Cannot add a node to a frozen collection");
    this.keyMap.set(t.key, t);
  }
  removeNode(t) {
    if (this.frozen)
      throw new Error("Cannot remove a node to a frozen collection");
    this.keyMap.delete(t);
  }
  commit(t, r, o = !1) {
    if (this.frozen)
      throw new Error("Cannot commit a frozen collection");
    this.firstKey = t, this.lastKey = r, this.frozen = !o;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1;
  }
}
class q5 extends Qv {
  get isConnected() {
    return !0;
  }
  createElement(t) {
    return new Oi(t, this);
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode(t) {
    let r = t.node;
    return this.mutatedNodes.has(t) || (r = t.node.clone(), this.mutatedNodes.add(t), t.node = r), this.markDirty(t), r;
  }
  getMutableCollection() {
    return !this.isSSR && !this.collectionMutated && (this.collection = this.collection.clone(), this.collectionMutated = !0), this.collection;
  }
  markDirty(t) {
    this.dirtyNodes.add(t);
  }
  startTransaction() {
    this.transactionCount++;
  }
  endTransaction() {
    this.transactionCount--;
  }
  addNode(t) {
    let r = this.getMutableCollection();
    if (!r.getItem(t.node.key)) {
      r.addNode(t.node);
      for (let o of t)
        this.addNode(o);
    }
    this.markDirty(t);
  }
  removeNode(t) {
    for (let o of t)
      this.removeNode(o);
    this.getMutableCollection().removeNode(t.node.key), this.markDirty(t);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.transactionCount > 0 ? this.collection : (this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let u of this.dirtyNodes)
      u instanceof Oi && u.isConnected && u.updateNode();
    if (this.dirtyNodes.clear(), this.mutatedNodes.size) {
      var t, r;
      let u = this.getMutableCollection();
      for (let s of this.mutatedNodes)
        s.isConnected && u.addNode(s.node);
      var o, a;
      u.commit((o = (t = this.firstChild) === null || t === void 0 ? void 0 : t.node.key) !== null && o !== void 0 ? o : null, (a = (r = this.lastChild) === null || r === void 0 ? void 0 : r.node.key) !== null && a !== void 0 ? a : null, this.isSSR), this.mutatedNodes.clear();
    }
    this.collectionMutated = !1;
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.transactionCount > 0))
      for (let t of this.subscriptions)
        t();
  }
  subscribe(t) {
    return this.subscriptions.add(t), () => this.subscriptions.delete(t);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
  constructor(t) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.mutatedNodes = /* @__PURE__ */ new Set(), this.subscriptions = /* @__PURE__ */ new Set(), this.transactionCount = 0, this.collection = t, this.collectionMutated = !0;
  }
}
function Zu(e) {
  let { children: t, items: r, idScope: o, addIdAndValue: a, dependencies: u = [] } = e, s = me(() => /* @__PURE__ */ new WeakMap(), u);
  return me(() => {
    if (r && typeof t == "function") {
      let h = [];
      for (let v of r) {
        let m = s.get(v);
        if (!m) {
          m = t(v);
          var d, f;
          let y = (f = (d = m.props.id) !== null && d !== void 0 ? d : v.key) !== null && f !== void 0 ? f : v.id;
          if (y == null)
            throw new Error("Could not determine key for item");
          o && (y = o + ":" + y), m = /* @__PURE__ */ Z4(m, a ? {
            key: y,
            id: y,
            value: v
          } : {
            key: y
          }), s.set(v, m);
        }
        h.push(m);
      }
      return h;
    } else if (typeof t != "function")
      return t;
  }, [
    t,
    r,
    s,
    o,
    a
  ]);
}
function Yu(e) {
  return Zu({
    ...e,
    addIdAndValue: !0
  });
}
const eg = /* @__PURE__ */ Fe(!1);
function Z5(e, t) {
  let { collection: r, document: o } = Xu(t);
  return {
    portal: tg(e, o),
    collection: r
  };
}
function Y5(e, t, r) {
  let o = hr(), a = ie(o);
  a.current = o;
  let u = Pe(() => a.current ? r() : t(), [
    t,
    r
  ]);
  return U5.useSyncExternalStore(e, u);
}
const X5 = typeof I.useSyncExternalStore == "function" ? I.useSyncExternalStore : Y5;
function Xu(e) {
  let t = me(() => new q5(e || new G5()), [
    e
  ]), r = Pe((s) => t.subscribe(s), [
    t
  ]), o = Pe(() => {
    let s = t.getCollection();
    return t.isSSR && t.resetAfterSSR(), s;
  }, [
    t
  ]), a = Pe(() => (t.isSSR = !0, t.getCollection()), [
    t
  ]);
  return {
    collection: X5(r, o, a),
    document: t
  };
}
const Su = /* @__PURE__ */ Fe(null), Cl = /* @__PURE__ */ Fe(null);
function tg(e, t) {
  let r = We(Cl), o = t ?? r, a = Yu(e), u = me(() => /* @__PURE__ */ I.createElement(eg.Provider, {
    value: !0
  }, a), [
    a
  ]);
  return hr() ? /* @__PURE__ */ I.createElement(Su.Provider, {
    value: o
  }, u) : /* @__PURE__ */ J4(u, o);
}
function J5(e) {
  return /* @__PURE__ */ I.createElement(I.Fragment, null, tg(e));
}
function ng(e, t, r) {
  let o = We(eg);
  var a;
  return o ? (a = Ju(e, t, r, "children" in t ? t.children : null)) !== null && a !== void 0 ? a : /* @__PURE__ */ I.createElement(I.Fragment, null) : null;
}
function Q5(e, t, r) {
  return Pe((o) => {
    o == null || o.setProps(e, t, r);
  }, [
    e,
    t,
    r
  ]);
}
function Ju(e, t, r, o, a) {
  let u = Q5(t, r, o), s = We(Su);
  if (s) {
    let d = s.ownerDocument.nodesByProps.get(t);
    return d || (d = s.ownerDocument.createElement(e), d.setProps(t, r, o), s.appendChild(d), s.ownerDocument.updateCollection(), s.ownerDocument.nodesByProps.set(t, d)), a ? /* @__PURE__ */ I.createElement(Su.Provider, {
      value: d
    }, a) : null;
  }
  return /* @__PURE__ */ I.createElement(e, {
    ref: u
  }, a);
}
function ew(e, t) {
  let r = Yu(e);
  return Ju("section", e, t, null, r);
}
const tw = /* @__PURE__ */ ct(ew), nw = /* @__PURE__ */ Fe(null), rw = /* @__PURE__ */ Fe(null);
function iw(e) {
  let t = We(nw);
  e = Se(t, e), e.dependencies = ((t == null ? void 0 : t.dependencies) || []).concat(e.dependencies);
  let r = typeof e.children == "function" ? e.children : null;
  return /* @__PURE__ */ I.createElement(rw.Provider, {
    value: r
  }, Yu(e));
}
const ow = Symbol("callback"), bf = Symbol("default");
function qn({ values: e, children: t }) {
  for (let [r, o] of e)
    t = /* @__PURE__ */ I.createElement(r.Provider, {
      value: o
    }, t);
  return t;
}
function Pt(e) {
  let { className: t, style: r, children: o, defaultClassName: a, defaultChildren: u, values: s } = e;
  return me(() => {
    let d, f, h;
    return typeof t == "function" ? d = t(s) : d = t, typeof r == "function" ? f = r(s) : f = r, typeof o == "function" ? h = o(s) : o == null ? h = u : h = o, {
      className: d ?? a,
      style: f,
      children: h,
      "data-rac": ""
    };
  }, [
    t,
    r,
    o,
    a,
    u,
    s
  ]);
}
function rg(e, t) {
  return (r) => t(typeof e == "function" ? e(r) : e, r);
}
function ig(e, t) {
  let r = We(e);
  if (t === null)
    return null;
  if (r && typeof r == "object" && "slots" in r && r.slots) {
    let o = new Intl.ListFormat().format(Object.keys(r.slots).map((u) => `"${u}"`));
    if (!t && !r.slots[bf])
      throw new Error(`A slot prop is required. Valid slot names are ${o}.`);
    let a = t || bf;
    if (!r.slots[a])
      throw new Error(`Invalid slot "${t}". Valid slot names are ${o}.`);
    return r.slots[a];
  }
  return r;
}
function et(e, t, r) {
  let o = ig(r, e.slot) || {}, { ref: a, [ow]: u, ...s } = o, d = Mu(me(() => mp(t, a), [
    t,
    a
  ])), f = Se(s, e);
  return "style" in s && s.style && typeof s.style == "object" && "style" in e && e.style && typeof e.style == "object" && (f.style = {
    ...s.style,
    ...e.style
  }), Ee(() => {
    u && u(e);
  }, [
    u,
    e
  ]), [
    f,
    d
  ];
}
function jr() {
  let [e, t] = Ce(!0), r = ie(!1), o = Pe((a) => {
    r.current = !0, t(!!a);
  }, []);
  return qe(() => {
    r.current || t(!1);
  }, []), [
    o,
    e
  ];
}
function lw(e, t = !0) {
  let [r, o] = Ce(!0);
  return og(e, r && t, Pe(() => o(!1), [])), r && t;
}
function aw(e, t) {
  let [r, o] = Ce(!1), [a, u] = Ce("idle");
  return !t && e.current && a === "idle" && (r = !0, o(!0), u("exiting")), !e.current && a === "exited" && u("idle"), og(e, r, Pe(() => {
    u("exited"), o(!1);
  }, [])), r;
}
function og(e, t, r) {
  let o = ie(null);
  t && e.current && (o.current = window.getComputedStyle(e.current).animation), qe(() => {
    if (t && e.current) {
      let a = window.getComputedStyle(e.current);
      if (a.animationName && a.animationName !== "none" && a.animation !== o.current) {
        let u = (d) => {
          d.target === e.current && (s.removeEventListener("animationend", u), Ru.flushSync(() => {
            r();
          }));
        }, s = e.current;
        return s.addEventListener("animationend", u), () => {
          s.removeEventListener("animationend", u);
        };
      } else
        r();
    }
  }, [
    e,
    t,
    r
  ]);
}
if (typeof HTMLTemplateElement < "u") {
  const e = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : e.call(this);
    }
  });
}
const ki = /* @__PURE__ */ Fe(!1), uw = typeof DocumentFragment < "u" ? new DocumentFragment() : null;
function lg(e) {
  let t = We(ki), r = hr();
  if (t)
    return /* @__PURE__ */ I.createElement(I.Fragment, null, e.children);
  let o = /* @__PURE__ */ I.createElement(ki.Provider, {
    value: !0
  }, e.children);
  return r ? /* @__PURE__ */ I.createElement("template", {
    "data-react-aria-hidden": !0
  }, o) : /* @__PURE__ */ Ru.createPortal(o, uw);
}
function ag(e) {
  let t = (r, o) => We(ki) ? null : e(r, o);
  return t.displayName = e.displayName || e.name, I.forwardRef(t);
}
function El(e) {
  const t = /^(data-.*)$/;
  let r = {};
  for (const o in e)
    t.test(o) || (r[o] = e[o]);
  return r;
}
const sw = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]), Qu = /* @__PURE__ */ Fe({});
function cw(e, t) {
  [e, t] = et(e, t, Qu);
  let r = e, { buttonProps: o, isPressed: a } = Kp(e, t), { focusProps: u, isFocused: s, isFocusVisible: d } = gr(e), { hoverProps: f, isHovered: h } = vr(e), v = Pt({
    ...e,
    values: {
      isHovered: h,
      isPressed: a,
      isFocused: s,
      isFocusVisible: d,
      isDisabled: e.isDisabled || !1
    },
    defaultClassName: "react-aria-Button"
  });
  return /* @__PURE__ */ I.createElement("button", {
    ...at(e, {
      propNames: sw
    }),
    ...Se(o, u, f),
    ...v,
    ref: t,
    slot: e.slot || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-pressed": r.isPressed || a || void 0,
    "data-hovered": h || void 0,
    "data-focused": s || void 0,
    "data-focus-visible": d || void 0
  });
}
const dw = /* @__PURE__ */ ag(cw), Yn = /* @__PURE__ */ Fe({});
function fw(e, t) {
  [e, t] = et(e, t, Yn);
  let { elementType: r = "span", ...o } = e;
  return /* @__PURE__ */ I.createElement(r, {
    className: "react-aria-Text",
    ...o,
    ref: t
  });
}
const pw = /* @__PURE__ */ ct(fw), Sl = /* @__PURE__ */ Fe(null), Gr = /* @__PURE__ */ Fe({}), ug = /* @__PURE__ */ Fe({});
function hw(e, t) {
  [e, t] = et(e, t, ug);
  let { isDisabled: r, isInvalid: o, onHoverStart: a, onHoverChange: u, onHoverEnd: s, ...d } = e, { hoverProps: f, isHovered: h } = vr({
    onHoverStart: a,
    onHoverChange: u,
    onHoverEnd: s,
    isDisabled: r
  }), { isFocused: v, isFocusVisible: m, focusProps: y } = gr({
    within: !0
  });
  r ?? (r = !!e["aria-disabled"] && e["aria-disabled"] !== "false"), o ?? (o = !!e["aria-invalid"] && e["aria-invalid"] !== "false");
  let $ = Pt({
    ...e,
    values: {
      isHovered: h,
      isFocusWithin: v,
      isFocusVisible: m,
      isDisabled: r,
      isInvalid: o
    },
    defaultClassName: "react-aria-Group"
  });
  var A, _;
  return /* @__PURE__ */ I.createElement("div", {
    ...Se(d, y, f),
    ...$,
    ref: t,
    role: (A = e.role) !== null && A !== void 0 ? A : "group",
    slot: (_ = e.slot) !== null && _ !== void 0 ? _ : void 0,
    "data-focus-within": v || void 0,
    "data-hovered": h || void 0,
    "data-focus-visible": m || void 0,
    "data-disabled": r || void 0,
    "data-invalid": o || void 0
  }, $.children);
}
const vw = /* @__PURE__ */ ct(hw), es = /* @__PURE__ */ Fe({});
let gw = (e) => {
  let { onHoverStart: t, onHoverChange: r, onHoverEnd: o, ...a } = e;
  return a;
};
function bw(e, t) {
  [e, t] = et(e, t, es);
  let { hoverProps: r, isHovered: o } = vr(e), { isFocused: a, isFocusVisible: u, focusProps: s } = gr({
    isTextInput: !0,
    autoFocus: e.autoFocus
  }), d = !!e["aria-invalid"] && e["aria-invalid"] !== "false", f = Pt({
    ...e,
    values: {
      isHovered: o,
      isFocused: a,
      isFocusVisible: u,
      isDisabled: e.disabled || !1,
      isInvalid: d
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ I.createElement("input", {
    ...Se(gw(e), s, r),
    ...f,
    ref: t,
    "data-focused": a || void 0,
    "data-disabled": e.disabled || void 0,
    "data-hovered": o || void 0,
    "data-focus-visible": u || void 0,
    "data-invalid": d || void 0
  });
}
const mw = /* @__PURE__ */ ag(bw), sg = /* @__PURE__ */ Fe(null);
function $w(e, t) {
  let { render: r } = We(sg);
  return /* @__PURE__ */ I.createElement(I.Fragment, null, r(e, t));
}
const yw = /* @__PURE__ */ ct($w), ts = /* @__PURE__ */ Fe({}), xw = /* @__PURE__ */ Fe({});
function ww(e, t) {
  let [r, o] = et(e, t, xw), a = ng("header", e, t);
  return a || /* @__PURE__ */ I.createElement("header", {
    className: "react-aria-Header",
    ...r,
    ref: o
  }, r.children);
}
const cg = /* @__PURE__ */ ct(ww), dg = /* @__PURE__ */ Fe({});
function Cw(e, t) {
  let [r, o] = et(e, t, dg), { elementType: a, orientation: u, style: s, className: d } = r, f = a || "hr";
  f === "hr" && u === "vertical" && (f = "div");
  let { separatorProps: h } = R5({
    elementType: a,
    orientation: u
  }), v = ng("separator", e, t);
  return v || /* @__PURE__ */ I.createElement(f, {
    ...at(r),
    ...h,
    style: s,
    className: d ?? "react-aria-Separator",
    ref: o,
    slot: r.slot || void 0
  });
}
const Ew = /* @__PURE__ */ ct(Cw), qr = /* @__PURE__ */ Fe(null), Zr = /* @__PURE__ */ Fe(null);
function Sw(e, t) {
  [e, t] = et(e, t, qr);
  let r = We(ki), o = We(Zr);
  return We(Cl) ? /* @__PURE__ */ I.createElement(J5, e) : o ? r ? null : /* @__PURE__ */ I.createElement(fg, {
    state: o,
    props: e,
    listBoxRef: t
  }) : /* @__PURE__ */ I.createElement(Pw, {
    props: e,
    listBoxRef: t
  });
}
function Pw({ props: e, listBoxRef: t }) {
  let { portal: r, collection: o } = Z5(e);
  e = {
    ...e,
    collection: o,
    children: null,
    items: null
  };
  let a = Yv(e);
  return /* @__PURE__ */ I.createElement(I.Fragment, null, r, /* @__PURE__ */ I.createElement(fg, {
    state: a,
    props: e,
    listBoxRef: t
  }));
}
const Tw = /* @__PURE__ */ ct(Sw);
function fg({ state: e, props: t, listBoxRef: r }) {
  let { dragAndDropHooks: o, layout: a = "stack", orientation: u = "vertical" } = t, { collection: s, selectionManager: d } = e, f = !!(o != null && o.useDraggableCollectionState), h = !!(o != null && o.useDroppableCollectionState), { direction: v } = br(), { disabledBehavior: m, disabledKeys: y } = d, $ = ml({
    usage: "search",
    sensitivity: "base"
  }), A = me(() => t.keyboardDelegate || new yl({
    collection: s,
    collator: $,
    ref: r,
    disabledKeys: m === "selection" ? /* @__PURE__ */ new Set() : y,
    layout: a,
    orientation: u,
    direction: v
  }), [
    s,
    $,
    r,
    m,
    y,
    u,
    v,
    t.keyboardDelegate,
    a
  ]), { listBoxProps: _ } = x5({
    ...t,
    shouldSelectOnPressUp: f || t.shouldSelectOnPressUp,
    keyboardDelegate: A
  }, e, r), F = Zu({
    items: s,
    children: (X) => {
      switch (X.type) {
        case "section":
          return /* @__PURE__ */ I.createElement(Aw, {
            section: X
          });
        case "separator":
          return /* @__PURE__ */ I.createElement(Ew, X.props);
        case "item":
          return /* @__PURE__ */ I.createElement(pg, {
            item: X
          });
        default:
          throw new Error("Unsupported node type in Menu: " + X.type);
      }
    }
  }), W = ie(f), R = ie(h);
  Ee(() => {
    W.current !== f && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), R.current !== h && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
  }, [
    f,
    h
  ]);
  let B, V, j, G = !1, J = null, w = ie(null);
  if (f && o) {
    B = o.useDraggableCollectionState({
      collection: s,
      selectionManager: d,
      preview: o.renderDragPreview ? w : void 0
    }), o.useDraggableCollection({}, B, r);
    let X = o.DragPreview;
    J = o.renderDragPreview ? /* @__PURE__ */ I.createElement(X, {
      ref: w
    }, o.renderDragPreview) : null;
  }
  if (h && o) {
    V = o.useDroppableCollectionState({
      collection: s,
      selectionManager: d
    });
    let X = o.dropTargetDelegate || new o.ListDropTargetDelegate(s, r, {
      orientation: u,
      layout: a,
      direction: v
    });
    j = o.useDroppableCollection({
      keyboardDelegate: A,
      dropTargetDelegate: X
    }, V, r), G = V.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: Y, isFocused: O, isFocusVisible: K } = gr(), k = {
    isDropTarget: G,
    isEmpty: e.collection.size === 0,
    isFocused: O,
    isFocusVisible: K,
    layout: t.layout || "stack",
    state: e
  }, T = Pt({
    className: t.className,
    style: t.style,
    defaultClassName: "react-aria-ListBox",
    values: k
  }), D = null;
  return e.collection.size === 0 && t.renderEmptyState && (D = /* @__PURE__ */ I.createElement("div", {
    // eslint-disable-next-line
    role: "option",
    style: {
      display: "contents"
    }
  }, t.renderEmptyState(k))), /* @__PURE__ */ I.createElement(Rp, null, /* @__PURE__ */ I.createElement("div", {
    ...at(t),
    ...Se(_, Y, j == null ? void 0 : j.collectionProps),
    ...T,
    ref: r,
    slot: t.slot || void 0,
    onScroll: t.onScroll,
    "data-drop-target": G || void 0,
    "data-empty": e.collection.size === 0 || void 0,
    "data-focused": O || void 0,
    "data-focus-visible": K || void 0,
    "data-layout": t.layout || "stack",
    "data-orientation": t.orientation || "vertical"
  }, /* @__PURE__ */ I.createElement(qn, {
    values: [
      [
        qr,
        t
      ],
      [
        Zr,
        e
      ],
      [
        ts,
        {
          dragAndDropHooks: o,
          dragState: B,
          dropState: V
        }
      ],
      [
        dg,
        {
          elementType: "div"
        }
      ],
      [
        sg,
        {
          render: Lw
        }
      ]
    ]
  }, F), D, J));
}
function Aw({ section: e, className: t, style: r }) {
  var o, a;
  let u = We(Zr), [s, d] = jr();
  var f;
  let { headingProps: h, groupProps: v } = C5({
    heading: d,
    "aria-label": (f = e.props["aria-label"]) !== null && f !== void 0 ? f : void 0
  }), m = Zu({
    items: u.collection.getChildren(e.key),
    children: (y) => {
      switch (y.type) {
        case "header":
          return /* @__PURE__ */ I.createElement(_w, {
            item: y,
            headingProps: h,
            headingRef: s
          });
        case "item":
          return /* @__PURE__ */ I.createElement(pg, {
            item: y
          });
        default:
          throw new Error("Unsupported element type in Section: " + y.type);
      }
    }
  });
  return /* @__PURE__ */ I.createElement("section", {
    ...at(e.props),
    ...v,
    className: t || ((o = e.props) === null || o === void 0 ? void 0 : o.className) || "react-aria-Section",
    style: r || ((a = e.props) === null || a === void 0 ? void 0 : a.style),
    ref: e.props.ref
  }, m);
}
function _w({ item: e, headingProps: t, headingRef: r }) {
  let { ref: o, ...a } = e.props;
  return /* @__PURE__ */ I.createElement(cg, {
    ...t,
    ...a,
    ref: mp(r, o)
  }, e.rendered);
}
function Dw(e, t) {
  return Ju("item", e, t, e.children);
}
const Fw = /* @__PURE__ */ ct(Dw);
function pg({ item: e }) {
  let t = Mu(e.props.ref), r = We(Zr), { dragAndDropHooks: o, dragState: a, dropState: u } = We(ts), { optionProps: s, labelProps: d, descriptionProps: f, ...h } = w5({
    key: e.key
  }, r, t), { hoverProps: v, isHovered: m } = vr({
    isDisabled: !h.allowsSelection && !h.hasAction
  }), y = null;
  a && o && (y = o.useDraggableItem({
    key: e.key
  }, a));
  let $ = null;
  u && o && ($ = o.useDroppableItem({
    target: {
      type: "item",
      key: e.key,
      dropPosition: "on"
    }
  }, u, t));
  let A = e.props, _ = a && a.isDragging(e.key), F = Pt({
    ...A,
    id: void 0,
    children: e.rendered,
    defaultClassName: "react-aria-ListBoxItem",
    values: {
      ...h,
      isHovered: m,
      selectionMode: r.selectionManager.selectionMode,
      selectionBehavior: r.selectionManager.selectionBehavior,
      allowsDragging: !!a,
      isDragging: _,
      isDropTarget: $ == null ? void 0 : $.isDropTarget
    }
  }), W = (o == null ? void 0 : o.renderDropIndicator) || ((B) => /* @__PURE__ */ I.createElement(yw, {
    target: B
  }));
  Ee(() => {
    e.textValue || console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    e.textValue
  ]);
  let R = A.href ? "a" : "div";
  return /* @__PURE__ */ I.createElement(I.Fragment, null, (o == null ? void 0 : o.useDropIndicator) && W({
    type: "item",
    key: e.key,
    dropPosition: "before"
  }), /* @__PURE__ */ I.createElement(R, {
    ...Se(s, v, y == null ? void 0 : y.dragProps, $ == null ? void 0 : $.dropProps),
    ...F,
    ref: t,
    "data-allows-dragging": !!a || void 0,
    "data-selected": h.isSelected || void 0,
    "data-disabled": h.isDisabled || void 0,
    "data-hovered": m || void 0,
    "data-focused": h.isFocused || void 0,
    "data-focus-visible": h.isFocusVisible || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-dragging": _ || void 0,
    "data-drop-target": ($ == null ? void 0 : $.isDropTarget) || void 0,
    "data-selection-mode": r.selectionManager.selectionMode === "none" ? void 0 : r.selectionManager.selectionMode
  }, /* @__PURE__ */ I.createElement(qn, {
    values: [
      [
        Yn,
        {
          slots: {
            label: d,
            description: f
          }
        }
      ]
    ]
  }, F.children)), (o == null ? void 0 : o.useDropIndicator) && r.collection.getKeyAfter(e.key) == null && W({
    type: "item",
    key: e.key,
    dropPosition: "after"
  }));
}
function Lw(e, t) {
  t = Mu(t);
  let { dragAndDropHooks: r, dropState: o } = We(ts), { dropIndicatorProps: a, isHidden: u, isDropTarget: s } = r.useDropIndicator(e, o, t);
  return u ? null : /* @__PURE__ */ I.createElement(Iw, {
    ...e,
    dropIndicatorProps: a,
    isDropTarget: s,
    ref: t
  });
}
function Rw(e, t) {
  let { dropIndicatorProps: r, isDropTarget: o, ...a } = e, u = Pt({
    ...a,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: o
    }
  });
  return /* @__PURE__ */ I.createElement("div", {
    ...r,
    ...u,
    // eslint-disable-next-line
    role: "option",
    ref: t,
    "data-drop-target": o || void 0
  });
}
const Iw = /* @__PURE__ */ ct(Rw), Bw = /* @__PURE__ */ Fe({
  placement: "bottom"
}), ns = /* @__PURE__ */ Fe(null);
function Mw(e, t) {
  [e, t] = et(e, t, ns);
  let r = We(rs), o = Gu(e), a = e.isOpen != null || e.defaultOpen != null || !r ? o : r, u = aw(t, a.isOpen) || e.isExiting || !1;
  if (We(ki)) {
    let d = e.children;
    return typeof d == "function" && (d = d({
      trigger: e.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1
    })), /* @__PURE__ */ I.createElement(I.Fragment, null, d);
  }
  return a && !a.isOpen && !u ? null : /* @__PURE__ */ I.createElement(Ow, {
    ...e,
    triggerRef: e.triggerRef,
    state: a,
    popoverRef: t,
    isExiting: u
  });
}
const Kw = /* @__PURE__ */ ct(Mw);
function Ow({ state: e, isExiting: t, UNSTABLE_portalContainer: r, ...o }) {
  var a;
  let { popoverProps: u, underlayProps: s, arrowProps: d, placement: f } = u5({
    ...o,
    offset: (a = o.offset) !== null && a !== void 0 ? a : 8
  }, e), h = o.popoverRef, v = lw(h, !!f) || o.isEntering || !1, m = Pt({
    ...o,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: o.trigger || null,
      placement: f,
      isEntering: v,
      isExiting: t
    }
  }), y = {
    ...u.style,
    ...m.style
  };
  return /* @__PURE__ */ I.createElement(c5, {
    isExiting: t,
    portalContainer: r
  }, !o.isNonModal && e.isOpen && /* @__PURE__ */ I.createElement("div", {
    ...s,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ I.createElement("div", {
    ...Se(at(o), u),
    ...m,
    ref: h,
    slot: o.slot || void 0,
    style: y,
    "data-trigger": o.trigger,
    "data-placement": f,
    "data-entering": v || void 0,
    "data-exiting": t || void 0
  }, !o.isNonModal && /* @__PURE__ */ I.createElement(uf, {
    onDismiss: e.close
  }), /* @__PURE__ */ I.createElement(Bw.Provider, {
    value: {
      ...d,
      placement: f
    }
  }, m.children), /* @__PURE__ */ I.createElement(uf, {
    onDismiss: e.close
  })));
}
const rs = /* @__PURE__ */ Fe(null), kw = /* @__PURE__ */ Fe(null), Nw = /* @__PURE__ */ Fe(null);
function zw(e, t) {
  [e, t] = et(e, t, kw);
  let { collection: r, document: o } = Xu(), { children: a, isDisabled: u = !1, isInvalid: s = !1, isRequired: d = !1 } = e;
  a = me(() => typeof a == "function" ? a({
    isOpen: !1,
    isDisabled: u,
    isInvalid: s,
    isRequired: d
  }) : a, [
    a,
    u,
    s,
    d
  ]);
  var f;
  return /* @__PURE__ */ I.createElement(I.Fragment, null, /* @__PURE__ */ I.createElement(lg, null, /* @__PURE__ */ I.createElement(qn, {
    values: [
      [
        Cl,
        o
      ],
      [
        qr,
        {
          items: (f = e.items) !== null && f !== void 0 ? f : e.defaultItems
        }
      ]
    ]
  }, a)), /* @__PURE__ */ I.createElement(Ww, {
    props: e,
    collection: r,
    comboBoxRef: t
  }));
}
function Ww({ props: e, collection: t, comboBoxRef: r }) {
  let { name: o, formValue: a = "key", allowsCustomValue: u } = e;
  u && (a = "text");
  let { contains: s } = Rx({
    sensitivity: "base"
  });
  var d;
  let f = K5({
    defaultFilter: e.defaultFilter || s,
    ...e,
    // If props.items isn't provided, rely on collection filtering (aka listbox.items is provided or defaultItems provided to Combobox)
    items: e.items,
    children: void 0,
    collection: t,
    validationBehavior: (d = e.validationBehavior) !== null && d !== void 0 ? d : "native"
  }), h = ie(null), v = ie(null), m = ie(null), y = ie(null), [$, A] = jr();
  var _;
  let { buttonProps: F, inputProps: W, listBoxProps: R, labelProps: B, descriptionProps: V, errorMessageProps: j, ...G } = P5({
    ...El(e),
    label: A,
    inputRef: v,
    buttonRef: h,
    listBoxRef: m,
    popoverRef: y,
    name: a === "text" ? o : void 0,
    validationBehavior: (_ = e.validationBehavior) !== null && _ !== void 0 ? _ : "native"
  }, f), [J, w] = Ce(null), Y = Pe(() => {
    if (v.current) {
      var T;
      let D = (T = h.current) === null || T === void 0 ? void 0 : T.getBoundingClientRect(), X = v.current.getBoundingClientRect(), Q = D ? Math.min(D.left, X.left) : X.left, H = D ? Math.max(D.right, X.right) : X.right;
      w(H - Q + "px");
    }
  }, [
    h,
    v,
    w
  ]);
  Ku({
    ref: v,
    onResize: Y
  });
  let O = me(() => ({
    isOpen: f.isOpen,
    isDisabled: e.isDisabled || !1,
    isInvalid: G.isInvalid || !1,
    isRequired: e.isRequired || !1
  }), [
    f.isOpen,
    e.isDisabled,
    G.isInvalid,
    e.isRequired
  ]), K = Pt({
    ...e,
    values: O,
    defaultClassName: "react-aria-ComboBox"
  }), k = at(e);
  return delete k.id, /* @__PURE__ */ I.createElement(qn, {
    values: [
      [
        Nw,
        f
      ],
      [
        Gr,
        {
          ...B,
          ref: $
        }
      ],
      [
        Qu,
        {
          ...F,
          ref: h,
          isPressed: f.isOpen
        }
      ],
      [
        es,
        {
          ...W,
          ref: v
        }
      ],
      [
        rs,
        f
      ],
      [
        ns,
        {
          ref: y,
          triggerRef: v,
          placement: "bottom start",
          isNonModal: !0,
          trigger: "ComboBox",
          style: {
            "--trigger-width": J
          }
        }
      ],
      [
        qr,
        {
          ...R,
          ref: m
        }
      ],
      [
        Zr,
        f
      ],
      [
        Yn,
        {
          slots: {
            description: V,
            errorMessage: j
          }
        }
      ],
      [
        ug,
        {
          isInvalid: G.isInvalid,
          isDisabled: e.isDisabled || !1
        }
      ],
      [
        Sl,
        G
      ]
    ]
  }, /* @__PURE__ */ I.createElement("div", {
    ...k,
    ...K,
    ref: r,
    slot: e.slot || void 0,
    "data-focused": f.isFocused || void 0,
    "data-open": f.isOpen || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": G.isInvalid || void 0,
    "data-required": e.isRequired || void 0
  }), o && a === "key" && /* @__PURE__ */ I.createElement("input", {
    type: "hidden",
    name: o,
    value: f.selectedKey
  }));
}
const Vw = /* @__PURE__ */ ct(zw);
var hg = {};
hg = {
  "ar-AE": Mf,
  "bg-BG": Kf,
  "cs-CZ": Of,
  "da-DK": kf,
  "de-DE": Nf,
  "el-GR": zf,
  "en-US": Wf,
  "es-ES": Vf,
  "et-EE": Hf,
  "fi-FI": Uf,
  "fr-FR": jf,
  "he-IL": Gf,
  "hr-HR": qf,
  "hu-HU": Zf,
  "it-IT": Yf,
  "ja-JP": Xf,
  "ko-KR": Jf,
  "lt-LT": Qf,
  "lv-LV": ep,
  "nb-NO": tp,
  "nl-NL": np,
  "pl-PL": rp,
  "pt-BR": ip,
  "pt-PT": op,
  "ro-RO": lp,
  "ru-RU": ap,
  "sk-SK": up,
  "sl-SI": sp,
  "sr-SP": cp,
  "sv-SE": dp,
  "tr-TR": fp,
  "uk-UA": pp,
  "zh-CN": hp,
  "zh-TW": vp
};
const Hw = /* @__PURE__ */ Fe(null);
function Uw(e, t) {
  [e, t] = et(e, t, Hw);
  let { value: r = 0, minValue: o = 0, maxValue: a = 100, isIndeterminate: u = !1 } = e, [s, d] = jr(), { progressBarProps: f, labelProps: h } = T5({
    ...e,
    label: d
  }), v = u ? void 0 : (r - o) / (a - o) * 100, m = Pt({
    ...e,
    defaultClassName: "react-aria-ProgressBar",
    values: {
      percentage: v,
      valueText: f["aria-valuetext"],
      isIndeterminate: u
    }
  });
  return /* @__PURE__ */ I.createElement("div", {
    ...f,
    ...m,
    ref: t,
    slot: e.slot || void 0
  }, /* @__PURE__ */ I.createElement(Gr.Provider, {
    value: {
      ...h,
      ref: s,
      elementType: "span"
    }
  }, m.children));
}
const jw = /* @__PURE__ */ ct(Uw), Gw = /* @__PURE__ */ Fe(null), vg = /* @__PURE__ */ Fe(null), gg = /* @__PURE__ */ Fe(null);
function qw(e, t) {
  [e, t] = et(e, t, Gw);
  var r;
  let o = z5({
    ...e,
    validationBehavior: (r = e.validationBehavior) !== null && r !== void 0 ? r : "native"
  }), [a, u] = jr();
  var s;
  let { radioGroupProps: d, labelProps: f, descriptionProps: h, errorMessageProps: v, ...m } = _5({
    ...e,
    label: u,
    validationBehavior: (s = e.validationBehavior) !== null && s !== void 0 ? s : "native"
  }, o), y = Pt({
    ...e,
    values: {
      orientation: e.orientation || "vertical",
      isDisabled: o.isDisabled,
      isReadOnly: o.isReadOnly,
      isRequired: o.isRequired,
      isInvalid: o.isInvalid,
      state: o
    },
    defaultClassName: "react-aria-RadioGroup"
  });
  return /* @__PURE__ */ I.createElement("div", {
    ...d,
    ...y,
    ref: t,
    slot: e.slot || void 0,
    "data-orientation": e.orientation || "vertical",
    "data-invalid": o.isInvalid || void 0,
    "data-disabled": o.isDisabled || void 0,
    "data-readonly": o.isReadOnly || void 0,
    "data-required": o.isRequired || void 0
  }, /* @__PURE__ */ I.createElement(qn, {
    values: [
      [
        gg,
        o
      ],
      [
        Gr,
        {
          ...f,
          ref: a,
          elementType: "span"
        }
      ],
      [
        Yn,
        {
          slots: {
            description: h,
            errorMessage: v
          }
        }
      ],
      [
        Sl,
        m
      ]
    ]
  }, y.children));
}
function Zw(e, t) {
  [e, t] = et(e, t, vg);
  let r = I.useContext(gg), o = ie(null), { labelProps: a, inputProps: u, isSelected: s, isDisabled: d, isPressed: f } = A5({
    ...El(e),
    // ReactNode type doesn't allow function children.
    children: typeof e.children == "function" ? !0 : e.children
  }, r, o), { isFocused: h, isFocusVisible: v, focusProps: m } = gr(), y = d || r.isReadOnly, { hoverProps: $, isHovered: A } = vr({
    ...e,
    isDisabled: y
  }), _ = Pt({
    ...e,
    defaultClassName: "react-aria-Radio",
    values: {
      isSelected: s,
      isPressed: f,
      isHovered: A,
      isFocused: h,
      isFocusVisible: v,
      isDisabled: d,
      isReadOnly: r.isReadOnly,
      isInvalid: r.isInvalid,
      isRequired: r.isRequired
    }
  }), F = at(e);
  return delete F.id, /* @__PURE__ */ I.createElement("label", {
    ...Se(F, a, $, _),
    ref: t,
    "data-selected": s || void 0,
    "data-pressed": f || void 0,
    "data-hovered": A || void 0,
    "data-focused": h || void 0,
    "data-focus-visible": v || void 0,
    "data-disabled": d || void 0,
    "data-readonly": r.isReadOnly || void 0,
    "data-invalid": r.isInvalid || void 0,
    "data-required": r.isRequired || void 0
  }, /* @__PURE__ */ I.createElement(nv, {
    elementType: "span"
  }, /* @__PURE__ */ I.createElement("input", {
    ...Se(u, m),
    ref: o
  })), _.children);
}
const Yw = /* @__PURE__ */ ct(qw), Xw = /* @__PURE__ */ ct(Zw), Zo = /* @__PURE__ */ Fe(null), Pu = /* @__PURE__ */ Fe(null);
function Jw(e, t) {
  [e, t] = et(e, t, Zo);
  let { collection: r, document: o } = Xu();
  var a;
  let u = W5({
    ...e,
    collection: r,
    children: void 0,
    validationBehavior: (a = e.validationBehavior) !== null && a !== void 0 ? a : "native"
  }), { isFocusVisible: s, focusProps: d } = gr({
    within: !0
  }), f = ie(null), [h, v] = jr();
  var m;
  let { labelProps: y, triggerProps: $, valueProps: A, menuProps: _, descriptionProps: F, errorMessageProps: W, ...R } = D5({
    ...El(e),
    label: v,
    validationBehavior: (m = e.validationBehavior) !== null && m !== void 0 ? m : "native"
  }, u, f), [B, V] = Ce(null), j = Pe(() => {
    f.current && V(f.current.offsetWidth + "px");
  }, [
    f
  ]);
  Ku({
    ref: f,
    onResize: j
  });
  let G = me(() => ({
    isOpen: u.isOpen,
    isFocused: u.isFocused,
    isFocusVisible: s,
    isDisabled: e.isDisabled || !1,
    isInvalid: R.isInvalid || !1,
    isRequired: e.isRequired || !1
  }), [
    u.isOpen,
    u.isFocused,
    s,
    e.isDisabled,
    R.isInvalid,
    e.isRequired
  ]), J = Pt({
    ...e,
    values: G,
    defaultClassName: "react-aria-Select"
  }), w = at(e);
  return delete w.id, /* @__PURE__ */ I.createElement(I.Fragment, null, /* @__PURE__ */ I.createElement(lg, null, /* @__PURE__ */ I.createElement(qn, {
    values: [
      [
        Zo,
        e
      ],
      [
        Pu,
        u
      ],
      [
        Cl,
        o
      ]
    ]
  }, J.children)), /* @__PURE__ */ I.createElement(qn, {
    values: [
      [
        Zo,
        e
      ],
      [
        Pu,
        u
      ],
      [
        bg,
        A
      ],
      [
        Gr,
        {
          ...y,
          ref: h,
          elementType: "span"
        }
      ],
      [
        Qu,
        {
          ...$,
          ref: f,
          isPressed: u.isOpen
        }
      ],
      [
        rs,
        u
      ],
      [
        ns,
        {
          trigger: "Select",
          triggerRef: f,
          placement: "bottom start",
          style: {
            "--trigger-width": B
          }
        }
      ],
      [
        qr,
        _
      ],
      [
        Zr,
        u
      ],
      [
        Yn,
        {
          slots: {
            description: F,
            errorMessage: W
          }
        }
      ],
      [
        Sl,
        R
      ]
    ]
  }, /* @__PURE__ */ I.createElement("div", {
    ...w,
    ...J,
    ...d,
    ref: t,
    slot: e.slot || void 0,
    "data-focused": u.isFocused || void 0,
    "data-focus-visible": s || void 0,
    "data-open": u.isOpen || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": R.isInvalid || void 0,
    "data-required": e.isRequired || void 0
  }), /* @__PURE__ */ I.createElement(L5, {
    state: u,
    triggerRef: f,
    label: v,
    name: e.name,
    isDisabled: e.isDisabled
  })));
}
const Qw = /* @__PURE__ */ ct(Jw), bg = /* @__PURE__ */ Fe(null);
function e6(e, t) {
  var r, o;
  [e, t] = et(e, t, bg);
  let a = We(Pu), { placeholder: u } = ig(Zo), s = a.selectedKey != null ? a.collection.getItem(a.selectedKey) : null, d = s == null ? void 0 : s.rendered;
  typeof d == "function" && (d = d({
    isHovered: !1,
    isPressed: !1,
    isSelected: !1,
    isFocused: !1,
    isFocusVisible: !1,
    isDisabled: !1,
    selectionMode: "single",
    selectionBehavior: "toggle"
  }));
  let f = bl(/* @__PURE__ */ j5(hg), "react-aria-components");
  var h, v;
  let m = Pt({
    ...e,
    defaultChildren: d || u || f.format("selectPlaceholder"),
    defaultClassName: "react-aria-SelectValue",
    values: {
      selectedItem: (h = (r = a.selectedItem) === null || r === void 0 ? void 0 : r.value) !== null && h !== void 0 ? h : null,
      selectedText: (v = (o = a.selectedItem) === null || o === void 0 ? void 0 : o.textValue) !== null && v !== void 0 ? v : null,
      isPlaceholder: !s
    }
  }), y = at(e);
  return /* @__PURE__ */ I.createElement("span", {
    ref: t,
    ...y,
    ...m,
    "data-placeholder": !s || void 0
  }, /* @__PURE__ */ I.createElement(Yn.Provider, {
    value: void 0
  }, m.children));
}
const t6 = /* @__PURE__ */ ct(e6), mg = /* @__PURE__ */ Fe({}), n6 = /* @__PURE__ */ Fe(null);
function r6(e, t) {
  [e, t] = et(e, t, n6);
  let r = ie(null), [o, a] = jr(), [u, s] = Ce("input");
  var d;
  let { labelProps: f, inputProps: h, descriptionProps: v, errorMessageProps: m, ...y } = jv({
    ...El(e),
    inputElementType: u,
    label: a,
    validationBehavior: (d = e.validationBehavior) !== null && d !== void 0 ? d : "native"
  }, r), $ = Pe((_) => {
    r.current = _, _ && s(_ instanceof HTMLTextAreaElement ? "textarea" : "input");
  }, []), A = Pt({
    ...e,
    values: {
      isDisabled: e.isDisabled || !1,
      isInvalid: y.isInvalid
    },
    defaultClassName: "react-aria-TextField"
  });
  return /* @__PURE__ */ I.createElement("div", {
    ...at(e),
    ...A,
    ref: t,
    slot: e.slot || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": y.isInvalid || void 0
  }, /* @__PURE__ */ I.createElement(qn, {
    values: [
      [
        Gr,
        {
          ...f,
          ref: o
        }
      ],
      [
        es,
        {
          ...h,
          ref: $
        }
      ],
      [
        mg,
        {
          ...h,
          ref: $
        }
      ],
      [
        Yn,
        {
          slots: {
            description: v,
            errorMessage: m
          }
        }
      ],
      [
        Sl,
        y
      ]
    ]
  }, A.children));
}
ct(r6);
const $g = /* @__PURE__ */ Fe({});
function i6(e, t) {
  [e, t] = et(e, t, $g);
  let r = Wx(e), { buttonProps: o, isPressed: a } = Ix(e, r, t), { focusProps: u, isFocused: s, isFocusVisible: d } = gr(e), { hoverProps: f, isHovered: h } = vr(e), v = Pt({
    ...e,
    values: {
      isHovered: h,
      isPressed: a,
      isFocused: s,
      isSelected: r.isSelected,
      isFocusVisible: d,
      isDisabled: e.isDisabled || !1,
      state: r
    },
    defaultClassName: "react-aria-ToggleButton"
  });
  return /* @__PURE__ */ I.createElement("button", {
    ...Se(o, u, f),
    ...v,
    ref: t,
    slot: e.slot || void 0,
    "data-focused": s || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-pressed": a || void 0,
    "data-selected": r.isSelected || void 0,
    "data-hovered": h || void 0,
    "data-focus-visible": d || void 0
  });
}
const o6 = /* @__PURE__ */ ct(i6);
var mf = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Wt = (e) => !e || typeof e != "object" || Object.keys(e).length === 0, l6 = (e, t) => JSON.stringify(e) === JSON.stringify(t);
function yg(e, t) {
  e.forEach(function(r) {
    Array.isArray(r) ? yg(r, t) : t.push(r);
  });
}
function xg(e) {
  let t = [];
  return yg(e, t), t;
}
var wg = (...e) => xg(e).filter(Boolean), Cg = (e, t) => {
  let r = {}, o = Object.keys(e), a = Object.keys(t);
  for (let u of o)
    if (a.includes(u)) {
      let s = e[u], d = t[u];
      typeof s == "object" && typeof d == "object" ? r[u] = Cg(s, d) : Array.isArray(s) || Array.isArray(d) ? r[u] = wg(d, s) : r[u] = d + " " + s;
    } else
      r[u] = e[u];
  for (let u of a)
    o.includes(u) || (r[u] = t[u]);
  return r;
}, $f = (e) => !e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim();
function a6() {
  for (var e = 0, t, r, o = ""; e < arguments.length; )
    (t = arguments[e++]) && (r = Eg(t)) && (o && (o += " "), o += r);
  return o;
}
function Eg(e) {
  if (typeof e == "string")
    return e;
  for (var t, r = "", o = 0; o < e.length; o++)
    e[o] && (t = Eg(e[o])) && (r && (r += " "), r += t);
  return r;
}
var is = "-";
function u6(e) {
  var t = c6(e), r = e.conflictingClassGroups, o = e.conflictingClassGroupModifiers, a = o === void 0 ? {} : o;
  function u(d) {
    var f = d.split(is);
    return f[0] === "" && f.length !== 1 && f.shift(), Sg(f, t) || s6(d);
  }
  function s(d, f) {
    var h = r[d] || [];
    return f && a[d] ? [].concat(h, a[d]) : h;
  }
  return {
    getClassGroupId: u,
    getConflictingClassGroupIds: s
  };
}
function Sg(e, t) {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  var r = e[0], o = t.nextPart.get(r), a = o ? Sg(e.slice(1), o) : void 0;
  if (a)
    return a;
  if (t.validators.length !== 0) {
    var u = e.join(is);
    return (s = t.validators.find(function(d) {
      var f = d.validator;
      return f(u);
    })) == null ? void 0 : s.classGroupId;
  }
}
var yf = /^\[(.+)\]$/;
function s6(e) {
  if (yf.test(e)) {
    var t = yf.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}
function c6(e) {
  var t = e.theme, r = e.prefix, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, a = f6(Object.entries(e.classGroups), r);
  return a.forEach(function(u) {
    var s = u[0], d = u[1];
    Tu(d, o, s, t);
  }), o;
}
function Tu(e, t, r, o) {
  e.forEach(function(a) {
    if (typeof a == "string") {
      var u = a === "" ? t : xf(t, a);
      u.classGroupId = r;
      return;
    }
    if (typeof a == "function") {
      if (d6(a)) {
        Tu(a(o), t, r, o);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: r
      });
      return;
    }
    Object.entries(a).forEach(function(s) {
      var d = s[0], f = s[1];
      Tu(f, xf(t, d), r, o);
    });
  });
}
function xf(e, t) {
  var r = e;
  return t.split(is).forEach(function(o) {
    r.nextPart.has(o) || r.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(o);
  }), r;
}
function d6(e) {
  return e.isThemeGetter;
}
function f6(e, t) {
  return t ? e.map(function(r) {
    var o = r[0], a = r[1], u = a.map(function(s) {
      return typeof s == "string" ? t + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(function(d) {
        var f = d[0], h = d[1];
        return [t + f, h];
      })) : s;
    });
    return [o, u];
  }) : e;
}
function p6(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, r = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  function a(u, s) {
    r.set(u, s), t++, t > e && (t = 0, o = r, r = /* @__PURE__ */ new Map());
  }
  return {
    get: function(s) {
      var d = r.get(s);
      if (d !== void 0)
        return d;
      if ((d = o.get(s)) !== void 0)
        return a(s, d), d;
    },
    set: function(s, d) {
      r.has(s) ? r.set(s, d) : a(s, d);
    }
  };
}
var Pg = "!";
function h6(e) {
  var t = e.separator || ":", r = t.length === 1, o = t[0], a = t.length;
  return function(s) {
    for (var d = [], f = 0, h = 0, v, m = 0; m < s.length; m++) {
      var y = s[m];
      if (f === 0) {
        if (y === o && (r || s.slice(m, m + a) === t)) {
          d.push(s.slice(h, m)), h = m + a;
          continue;
        }
        if (y === "/") {
          v = m;
          continue;
        }
      }
      y === "[" ? f++ : y === "]" && f--;
    }
    var $ = d.length === 0 ? s : s.substring(h), A = $.startsWith(Pg), _ = A ? $.substring(1) : $, F = v && v > h ? v - h : void 0;
    return {
      modifiers: d,
      hasImportantModifier: A,
      baseClassName: _,
      maybePostfixModifierPosition: F
    };
  };
}
function v6(e) {
  if (e.length <= 1)
    return e;
  var t = [], r = [];
  return e.forEach(function(o) {
    var a = o[0] === "[";
    a ? (t.push.apply(t, r.sort().concat([o])), r = []) : r.push(o);
  }), t.push.apply(t, r.sort()), t;
}
function g6(e) {
  return {
    cache: p6(e.cacheSize),
    splitModifiers: h6(e),
    ...u6(e)
  };
}
var b6 = /\s+/;
function m6(e, t) {
  var r = t.splitModifiers, o = t.getClassGroupId, a = t.getConflictingClassGroupIds, u = /* @__PURE__ */ new Set();
  return e.trim().split(b6).map(function(s) {
    var d = r(s), f = d.modifiers, h = d.hasImportantModifier, v = d.baseClassName, m = d.maybePostfixModifierPosition, y = o(m ? v.substring(0, m) : v), $ = !!m;
    if (!y) {
      if (!m)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      if (y = o(v), !y)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      $ = !1;
    }
    var A = v6(f).join(":"), _ = h ? A + Pg : A;
    return {
      isTailwindClass: !0,
      modifierId: _,
      classGroupId: y,
      originalClassName: s,
      hasPostfixModifier: $
    };
  }).reverse().filter(function(s) {
    if (!s.isTailwindClass)
      return !0;
    var d = s.modifierId, f = s.classGroupId, h = s.hasPostfixModifier, v = d + f;
    return u.has(v) ? !1 : (u.add(v), a(f, h).forEach(function(m) {
      return u.add(d + m);
    }), !0);
  }).reverse().map(function(s) {
    return s.originalClassName;
  }).join(" ");
}
function Au() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var o, a, u, s = d;
  function d(h) {
    var v = t[0], m = t.slice(1), y = m.reduce(function($, A) {
      return A($);
    }, v());
    return o = g6(y), a = o.cache.get, u = o.cache.set, s = f, f(h);
  }
  function f(h) {
    var v = a(h);
    if (v)
      return v;
    var m = m6(h, o);
    return u(h, m), m;
  }
  return function() {
    return s(a6.apply(null, arguments));
  };
}
function Ge(e) {
  var t = function(o) {
    return o[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var Tg = /^\[(?:([a-z-]+):)?(.+)\]$/i, $6 = /^\d+\/\d+$/, y6 = /* @__PURE__ */ new Set(["px", "full", "screen"]), x6 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, w6 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, C6 = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function un(e) {
  return sr(e) || y6.has(e) || $6.test(e) || _u(e);
}
function _u(e) {
  return mr(e, "length", _6);
}
function E6(e) {
  return mr(e, "size", Ag);
}
function S6(e) {
  return mr(e, "position", Ag);
}
function P6(e) {
  return mr(e, "url", D6);
}
function jo(e) {
  return mr(e, "number", sr);
}
function sr(e) {
  return !Number.isNaN(Number(e));
}
function T6(e) {
  return e.endsWith("%") && sr(e.slice(0, -1));
}
function Ti(e) {
  return wf(e) || mr(e, "number", wf);
}
function De(e) {
  return Tg.test(e);
}
function Ai() {
  return !0;
}
function jn(e) {
  return x6.test(e);
}
function A6(e) {
  return mr(e, "", F6);
}
function mr(e, t, r) {
  var o = Tg.exec(e);
  return o ? o[1] ? o[1] === t : r(o[2]) : !1;
}
function _6(e) {
  return w6.test(e);
}
function Ag() {
  return !1;
}
function D6(e) {
  return e.startsWith("url(");
}
function wf(e) {
  return Number.isInteger(Number(e));
}
function F6(e) {
  return C6.test(e);
}
function Du() {
  var e = Ge("colors"), t = Ge("spacing"), r = Ge("blur"), o = Ge("brightness"), a = Ge("borderColor"), u = Ge("borderRadius"), s = Ge("borderSpacing"), d = Ge("borderWidth"), f = Ge("contrast"), h = Ge("grayscale"), v = Ge("hueRotate"), m = Ge("invert"), y = Ge("gap"), $ = Ge("gradientColorStops"), A = Ge("gradientColorStopPositions"), _ = Ge("inset"), F = Ge("margin"), W = Ge("opacity"), R = Ge("padding"), B = Ge("saturate"), V = Ge("scale"), j = Ge("sepia"), G = Ge("skew"), J = Ge("space"), w = Ge("translate"), Y = function() {
    return ["auto", "contain", "none"];
  }, O = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, K = function() {
    return ["auto", De, t];
  }, k = function() {
    return [De, t];
  }, T = function() {
    return ["", un];
  }, D = function() {
    return ["auto", sr, De];
  }, X = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, Q = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, H = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, le = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, de = function() {
    return ["", "0", De];
  }, ne = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, pe = function() {
    return [sr, jo];
  }, Ie = function() {
    return [sr, De];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [Ai],
      spacing: [un],
      blur: ["none", "", jn, De],
      brightness: pe(),
      borderColor: [e],
      borderRadius: ["none", "", "full", jn, De],
      borderSpacing: k(),
      borderWidth: T(),
      contrast: pe(),
      grayscale: de(),
      hueRotate: Ie(),
      invert: de(),
      gap: k(),
      gradientColorStops: [e],
      gradientColorStopPositions: [T6, _u],
      inset: K(),
      margin: K(),
      opacity: pe(),
      padding: k(),
      saturate: pe(),
      scale: pe(),
      sepia: de(),
      skew: Ie(),
      space: k(),
      translate: k()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", De]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [jn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": ne()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": ne()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(X(), [De])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: O()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": O()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": O()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: Y()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": Y()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": Y()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [_]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [_]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [_]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [_]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [_]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [_]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [_]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [_]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [_]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Ti]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: K()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", De]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: de()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: de()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Ti]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Ai]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Ti]
        }, De]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": D()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": D()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Ai]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Ti]
        }, De]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": D()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": D()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", De]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", De]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [y]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [y]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [y]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(le())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(le(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(le(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [R]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [R]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [R]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [R]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [R]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [R]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [R]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [R]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [R]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [F]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [F]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [F]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [F]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [F]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [F]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [F]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [F]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [F]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [J]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [J]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", De, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", De, un]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [jn]
        }, jn, De]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [De, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", De, un]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [De, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", jn, _u]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", jo]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ai]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", De]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", sr, jo]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", De, un]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", De]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", De]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [W]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [W]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(Q(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", un]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", De, un]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: k()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", De]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", De]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [W]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(X(), [S6])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", E6]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, P6]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [A]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [A]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [A]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [$]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [$]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [$]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [u]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [u]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [u]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [u]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [u]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [u]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [u]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [u]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [u]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [u]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [u]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [u]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [u]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [u]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [u]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [d]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [d]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [d]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [d]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [d]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [d]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [d]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [d]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [d]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [W]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(Q(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [d]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [d]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [W]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Q()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(Q())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [De, un]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [un]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: T()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [W]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [un]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", jn, A6]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Ai]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [W]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": H()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": H()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [f]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", jn, De]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [h]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [v]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [m]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [B]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [j]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [f]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [h]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [v]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [m]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [W]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [B]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [j]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", De]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Ie()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", De]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Ie()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", De]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [V]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [V]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [V]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Ti, De]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [w]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [w]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [G]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [G]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", De]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", De]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": k()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": k()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": k()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": k()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": k()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": k()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": k()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": k()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": k()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": k()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": k()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": k()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": k()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": k()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": k()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": k()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": k()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": k()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", De]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [un, jo]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
function L6(e, t) {
  for (var r in t)
    _g(e, r, t[r]);
  return e;
}
var R6 = Object.prototype.hasOwnProperty, I6 = /* @__PURE__ */ new Set(["string", "number", "boolean"]);
function _g(e, t, r) {
  if (!R6.call(e, t) || I6.has(typeof r) || r === null) {
    e[t] = r;
    return;
  }
  if (Array.isArray(r) && Array.isArray(e[t])) {
    e[t] = e[t].concat(r);
    return;
  }
  if (typeof r == "object" && typeof e[t] == "object") {
    if (e[t] === null) {
      e[t] = r;
      return;
    }
    for (var o in r)
      _g(e[t], o, r[o]);
  }
}
function B6(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)
    r[o - 1] = arguments[o];
  return typeof e == "function" ? Au.apply(void 0, [Du, e].concat(r)) : Au.apply(void 0, [function() {
    return L6(Du(), e);
  }].concat(r));
}
var M6 = /* @__PURE__ */ Au(Du), K6 = { twMerge: !0, twMergeConfig: {}, responsiveVariants: !1 }, Dg = (e) => e || void 0, Ni = (...e) => Dg(xg(e).filter(Boolean).join(" ")), lu = null, dl = {}, Fu = !1, _i = (...e) => (t) => t.twMerge ? ((!lu || Fu) && (Fu = !1, lu = Wt(dl) ? M6 : B6(dl)), Dg(lu(Ni(e)))) : Ni(e), Cf = (e, t) => {
  for (let r in t)
    e.hasOwnProperty(r) ? e[r] = Ni(e[r], t[r]) : e[r] = t[r];
  return e;
}, Fg = (e, t) => {
  let { extend: r = null, slots: o = {}, variants: a = {}, compoundVariants: u = [], compoundSlots: s = [], defaultVariants: d = {} } = e, f = { ...K6, ...t }, h = r != null && r.base ? Ni(r.base, e == null ? void 0 : e.base) : e == null ? void 0 : e.base, v = r != null && r.variants && !Wt(r.variants) ? Cg(a, r.variants) : a, m = r != null && r.defaultVariants && !Wt(r.defaultVariants) ? { ...r.defaultVariants, ...d } : d;
  !Wt(f.twMergeConfig) && !l6(f.twMergeConfig, dl) && (Fu = !0, dl = f.twMergeConfig);
  let y = Wt(r == null ? void 0 : r.slots), $ = Wt(o) ? {} : { base: Ni(e == null ? void 0 : e.base, y && (r == null ? void 0 : r.base)), ...o }, A = y ? $ : Cf({ ...r == null ? void 0 : r.slots }, Wt($) ? { base: e == null ? void 0 : e.base } : $), _ = (W) => {
    if (Wt(v) && Wt(o) && y)
      return _i(h, W == null ? void 0 : W.class, W == null ? void 0 : W.className)(f);
    if (u && !Array.isArray(u))
      throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof u}`);
    if (s && !Array.isArray(s))
      throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof s}`);
    let R = (k, T, D = [], X) => {
      let Q = D;
      if (typeof T == "string")
        Q = Q.concat($f(T).split(" ").map((H) => `${k}:${H}`));
      else if (Array.isArray(T))
        Q = Q.concat(T.reduce((H, le) => H.concat(`${k}:${le}`), []));
      else if (typeof T == "object" && typeof X == "string") {
        for (let H in T)
          if (T.hasOwnProperty(H) && H === X) {
            let le = T[H];
            if (le && typeof le == "string") {
              let de = $f(le);
              Q[X] ? Q[X] = Q[X].concat(de.split(" ").map((ne) => `${k}:${ne}`)) : Q[X] = de.split(" ").map((ne) => `${k}:${ne}`);
            } else
              Array.isArray(le) && le.length > 0 && (Q[X] = le.reduce((de, ne) => de.concat(`${k}:${ne}`), []));
          }
      }
      return Q;
    }, B = (k, T = v, D = null, X = null) => {
      var Q;
      let H = T[k];
      if (!H || Wt(H))
        return null;
      let le = (Q = X == null ? void 0 : X[k]) != null ? Q : W == null ? void 0 : W[k];
      if (le === null)
        return null;
      let de = mf(le), ne = Array.isArray(f.responsiveVariants) && f.responsiveVariants.length > 0 || f.responsiveVariants === !0, pe = m == null ? void 0 : m[k], Ie = [];
      if (typeof de == "object" && ne)
        for (let [Tt, ut] of Object.entries(de)) {
          let dt = H[ut];
          if (Tt === "initial") {
            pe = ut;
            continue;
          }
          Array.isArray(f.responsiveVariants) && !f.responsiveVariants.includes(Tt) || (Ie = R(Tt, dt, Ie, D));
        }
      let Be = H[de] || H[mf(pe)];
      return typeof Ie == "object" && typeof D == "string" && Ie[D] ? Cf(Ie, Be) : Ie.length > 0 ? (Ie.push(Be), Ie) : Be;
    }, V = () => v ? Object.keys(v).map((k) => B(k, v)) : null, j = (k, T) => {
      if (!v || typeof v != "object")
        return null;
      let D = new Array();
      for (let X in v) {
        let Q = B(X, v, k, T), H = k === "base" && typeof Q == "string" ? Q : Q && Q[k];
        H && (D[D.length] = H);
      }
      return D;
    }, G = {};
    for (let k in W)
      W[k] !== void 0 && (G[k] = W[k]);
    let J = (k, T) => {
      var D;
      let X = typeof (W == null ? void 0 : W[k]) == "object" ? { [k]: (D = W[k]) == null ? void 0 : D.initial } : {};
      return { ...m, ...G, ...X, ...T };
    }, w = (k = [], T) => {
      let D = [];
      for (let { class: X, className: Q, ...H } of k) {
        let le = !0;
        for (let [de, ne] of Object.entries(H)) {
          let pe = J(de, T);
          if (Array.isArray(ne)) {
            if (!ne.includes(pe[de])) {
              le = !1;
              break;
            }
          } else if (pe[de] !== ne) {
            le = !1;
            break;
          }
        }
        le && (X && D.push(X), Q && D.push(Q));
      }
      return D;
    }, Y = (k) => {
      let T = w(u, k), D = w(r == null ? void 0 : r.compoundVariants, k);
      return wg(D, T);
    }, O = (k) => {
      let T = Y(k);
      if (!Array.isArray(T))
        return T;
      let D = {};
      for (let X of T)
        if (typeof X == "string" && (D.base = _i(D.base, X)(f)), typeof X == "object")
          for (let [Q, H] of Object.entries(X))
            D[Q] = _i(D[Q], H)(f);
      return D;
    }, K = (k) => {
      if (s.length < 1)
        return null;
      let T = {};
      for (let { slots: D = [], class: X, className: Q, ...H } of s) {
        if (!Wt(H)) {
          let le = !0;
          for (let de of Object.keys(H)) {
            let ne = J(de, k)[de];
            if (ne === void 0 || (Array.isArray(H[de]) ? !H[de].includes(ne) : H[de] !== ne)) {
              le = !1;
              break;
            }
          }
          if (!le)
            continue;
        }
        for (let le of D)
          T[le] = T[le] || [], T[le].push([X, Q]);
      }
      return T;
    };
    if (!Wt(o) || !y) {
      let k = {};
      if (typeof A == "object" && !Wt(A))
        for (let T of Object.keys(A))
          k[T] = (D) => {
            var X, Q;
            return _i(A[T], j(T, D), ((X = O(D)) != null ? X : [])[T], ((Q = K(D)) != null ? Q : [])[T], D == null ? void 0 : D.class, D == null ? void 0 : D.className)(f);
          };
      return k;
    }
    return _i(h, V(), Y(), W == null ? void 0 : W.class, W == null ? void 0 : W.className)(f);
  }, F = () => {
    if (!(!v || typeof v != "object"))
      return Object.keys(v);
  };
  return _.variantKeys = F(), _.extend = r, _.base = h, _.slots = A, _.variants = v, _.defaultVariants = m, _.compoundSlots = s, _.compoundVariants = u, _;
};
const O6 = {
  twMergeConfig: {
    classGroups: {
      fontSizes: [
        {
          text: [
            "title-large",
            "page-title",
            "heading",
            "subtitle-1",
            "subtitle-2",
            "body",
            "body-small",
            "body-xs",
            "button",
            "caption",
            "overline"
          ]
        }
      ]
    }
  }
}, k6 = (e) => e ? {
  full: {
    [e]: "h-full"
  },
  0: {
    [e]: "h-0"
  },
  0.5: {
    [e]: "h-0.5"
  },
  1: {
    [e]: "h-1"
  },
  1.5: {
    [e]: "h-1.5"
  },
  2: {
    [e]: "h-2"
  },
  2.5: {
    [e]: "h-2.5"
  },
  3: {
    [e]: "h-3"
  },
  4: {
    [e]: "h-4"
  },
  5: {
    [e]: "h-5"
  },
  6: {
    [e]: "h-6"
  },
  7: {
    [e]: "h-7"
  },
  8: {
    [e]: "h-8"
  },
  9: {
    [e]: "h-9"
  }
} : {
  full: "h-full",
  0: "h-0",
  0.5: "h-0.5",
  1: "h-1",
  1.5: "h-1.5",
  2: "h-2",
  2.5: "h-2.5",
  3: "h-3",
  4: "h-4",
  5: "h-5",
  6: "h-6",
  7: "h-7",
  8: "h-8",
  9: "h-9"
}, N6 = (e) => e ? {
  full: {
    [e]: "w-full"
  },
  0: {
    [e]: "w-0"
  },
  0.5: {
    [e]: "w-0.5"
  },
  1: {
    [e]: "w-1"
  },
  1.5: {
    [e]: "w-1.5"
  },
  2: {
    [e]: "w-2"
  },
  2.5: {
    [e]: "w-2.5"
  },
  3: {
    [e]: "w-3"
  },
  4: {
    [e]: "w-4"
  },
  5: {
    [e]: "w-5"
  },
  6: {
    [e]: "w-6"
  },
  7: {
    [e]: "w-7"
  },
  8: {
    [e]: "w-8"
  },
  9: {
    [e]: "w-9"
  }
} : {
  full: "w-full",
  0: "w-0",
  0.5: "w-0.5",
  1: "w-1",
  1.5: "w-1.5",
  2: "w-2",
  2.5: "w-2.5",
  3: "w-3",
  4: "w-4",
  5: "w-5",
  6: "w-6",
  7: "w-7",
  8: "w-8",
  9: "w-9"
}, z6 = (e) => e ? {
  0: {
    [e]: "p-0"
  },
  0.5: {
    [e]: "p-0.5"
  },
  1: {
    [e]: "p-1"
  },
  1.5: {
    [e]: "p-1.5"
  },
  2: {
    [e]: "p-2"
  },
  2.5: {
    [e]: "p-2.5"
  },
  3: {
    [e]: "p-3"
  },
  4: {
    [e]: "p-4"
  },
  5: {
    [e]: "p-5"
  },
  6: {
    [e]: "p-6"
  },
  7: {
    [e]: "p-7"
  },
  8: {
    [e]: "p-8"
  },
  9: {
    [e]: "p-9"
  }
} : {
  0: "p-0",
  0.5: "p-0.5",
  1: "p-1",
  1.5: "p-1.5",
  2: "p-2",
  2.5: "p-2.5",
  3: "p-3",
  4: "p-4",
  5: "p-5",
  6: "p-6",
  7: "p-7",
  8: "p-8",
  9: "p-9"
}, Vt = (e) => Fg(e, O6), W6 = Vt({
  base: "shrink-0",
  variants: {
    color: {
      transparent: "fill-transparent",
      current: "fill-current",
      "primary-light": "fill-primary-light",
      "primary-base": "fill-primary-base",
      "primary-dark": "fill-primary-dark",
      "primary-hover": "fill-primary-hover",
      "secondary-light": "fill-secondary-light",
      "secondary-base": "fill-secondary-base",
      brand: "fill-brand",
      link: "fill-link",
      linkLight: "fill-linkLight",
      subTitle: "fill-subTitle",
      "sucess-light": "fill-sucess-light",
      "succuess-base": "fill-succuess-base",
      "success-dark": "fill-success-dark",
      "warning-light": "fill-warning-light",
      "warning-base": "fill-warning-base",
      "warning-dark": "fill-warning-dark",
      "critical-light": "fill-critical-light",
      "critical-base": "fill-critical-base",
      "critical-dark": "fill-critical-dark",
      "critical-hover": "fill-critical-hover",
      "informational-light": "fill-informational-light",
      "informational-base": "fill-informational-base",
      "informational-dark": "fill-informational-dark",
      "informational-hover": "fill-informational-hover",
      black: "fill-black",
      white: "fill-white",
      "gray-700": "fill-gray-700",
      "gray-600": "fill-gray-600",
      "gray-500": "fill-gray-500",
      "gray-400": "fill-gray-400",
      "gray-300": "fill-gray-300",
      "gray-200": "fill-gray-200",
      "gray-100": "fill-gray-100",
      "gray-50": "fill-gray-50",
      "decorative-mintGreen": "fill-decorative-mintGreen",
      "decorative-highlightBlue": "fill-decorative-highlightBlue",
      "channel-inbound": "fill-channel-inbound",
      "channel-outbound": "fill-channel-outbound",
      "channel-referrals": "fill-channel-referrals"
    }
  }
}), Zn = ({ Icon: e, color: t = "gray-600", size: r = 16 }) => e ? /* @__PURE__ */ U.jsx(e, { className: W6({ color: t }), height: r, width: r }) : null, V6 = Vt({
  slots: {
    wrapper: "relative flex w-min cursor-pointer justify-center rounded px-1 py-1.5 outline-none disabled:cursor-default disabled:bg-gray-200 disabled:text-gray-500",
    label: "flex h-full w-full flex-row items-center justify-center gap-0.5",
    text: "w-full overflow-hidden text-ellipsis whitespace-nowrap text-button"
  },
  variants: {
    variant: {
      primaryFilled: {
        wrapper: "bg-primary-base text-white hover:bg-primary-dark"
      },
      criticalFilled: {
        wrapper: "bg-critical-base text-white hover:bg-critical-dark"
      },
      primaryOutlined: {
        wrapper: "rounded border border-gray-200 bg-white text-primary-base hover:bg-gray-100"
      },
      criticalOutlined: {
        wrapper: "rounded border border-gray-200 bg-white text-critical-base hover:bg-gray-100"
      },
      primaryGhost: { wrapper: "text-primary-base hover:bg-gray-200" },
      criticalGhost: { wrapper: "text-critical-base hover:bg-gray-200" },
      outlined: {
        wrapper: "rounded border border-gray-200 bg-white text-gray-600 hover:bg-gray-100"
      },
      ghost: { wrapper: "text-gray-600 hover:bg-gray-200" },
      inline: { wrapper: "inline p-0 text-link" }
    },
    h: k6("wrapper"),
    w: N6("wrapper"),
    p: z6("wrapper"),
    isLoading: {
      true: {
        label: "opacity-0",
        wrapper: "pointer-events-none bg-gray-100 text-gray-500"
      }
    }
  }
}), os = I.forwardRef(
  ({ children: e, className: t, variant: r, h: o, w: a, p: u, isLoading: s, icon: d, ...f }, h) => {
    const { wrapper: v, label: m, text: y } = V6({
      variant: r,
      h: o,
      w: a,
      p: u,
      isLoading: s
    }), $ = r === "primaryFilled" || r === "criticalFilled" ? "white" : d == null ? void 0 : d.color, A = d && r !== "inline", _ = A && (d.side === "left" || d.side === void 0), F = A && d.side === "right";
    return /* @__PURE__ */ U.jsxs(
      dw,
      {
        ...f,
        ref: h,
        className: rg(
          t,
          (W, R) => v({ ...R, className: W })
        ),
        children: [
          s && /* @__PURE__ */ U.jsx("div", { className: "absolute", children: /* @__PURE__ */ U.jsx(Z6, { size: "small" }) }),
          /* @__PURE__ */ U.jsxs("div", { className: m(), children: [
            _ && /* @__PURE__ */ U.jsx(Zn, { ...d, color: $ }),
            e && /* @__PURE__ */ U.jsx("div", { className: y(), children: /* @__PURE__ */ U.jsx(U.Fragment, { children: e }) }),
            F && /* @__PURE__ */ U.jsx(Zn, { ...d, color: $ })
          ] })
        ]
      }
    );
  }
), Lg = I.forwardRef(
  (e, t) => ([e, t] = et(e, t, Gr), /* @__PURE__ */ U.jsx("label", { ...e, className: "text-subtitle-2 text-black", ref: t }))
), H6 = (e) => /* @__PURE__ */ Et.createElement("svg", { width: 12, height: 10, viewBox: "0 0 12 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Et.createElement("path", { d: "M3.86337 7.58331L1.55004 5.26998C1.42548 5.14514 1.25638 5.07499 1.08004 5.07499C0.903694 5.07499 0.734593 5.14514 0.610039 5.26998C0.350039 5.52998 0.350039 5.94998 0.610039 6.20998L3.39671 8.99664C3.65671 9.25664 4.07671 9.25664 4.33671 8.99664L11.39 1.94331C11.65 1.68331 11.65 1.26331 11.39 1.00331C11.2655 0.878474 11.0964 0.808319 10.92 0.808319C10.7437 0.808319 10.5746 0.878474 10.45 1.00331L3.86337 7.58331Z", fill: "currentFill" })), Rg = ({ children: e, ...t }) => {
  const r = t.textValue || (typeof e == "string" ? e : void 0);
  return /* @__PURE__ */ U.jsx(
    Fw,
    {
      ...t,
      textValue: r,
      className: "selected:bg-informational-light flex min-h-0 cursor-pointer flex-row items-center justify-between gap-2 rounded px-1 py-0.5 outline-none hover:bg-gray-100 focus-visible:outline-informational-base",
      children: ({ isSelected: o }) => /* @__PURE__ */ U.jsxs(U.Fragment, { children: [
        /* @__PURE__ */ U.jsx("div", { className: "overflow-hidden text-ellipsis whitespace-nowrap text-body-small", children: /* @__PURE__ */ U.jsx(U.Fragment, { children: e }) }),
        o && /* @__PURE__ */ U.jsx(Zn, { Icon: H6, size: 12, color: "informational-base" })
      ] })
    }
  );
}, U6 = ({
  children: e,
  ...t
}) => /* @__PURE__ */ U.jsx(tw, { ...t, children: e }), G2 = ({
  children: e,
  title: t,
  id: r,
  ...o
}) => /* @__PURE__ */ U.jsxs(U6, { className: "pb-1", ...o, children: [
  /* @__PURE__ */ U.jsx(j6, { children: t ?? r }),
  /* @__PURE__ */ U.jsx(iw, { items: o.items, children: (a) => /* @__PURE__ */ U.jsx(Rg, { children: a.name }) })
] }), j6 = ({ children: e }) => /* @__PURE__ */ U.jsx(cg, { className: "text-overline uppercase text-gray-500", children: e }), G6 = ({ children: e, ...t }, r) => ([t, r] = et(t, r, qr), /* @__PURE__ */ U.jsx(
  Tw,
  {
    ...t,
    className: "box-border max-h-[inherit] overflow-auto p-1 outline-none",
    children: e || ((o) => /* @__PURE__ */ U.jsx(Rg, { children: o.name }))
  }
)), Ig = I.forwardRef(G6), q6 = Fg({
  base: "h-4 w-4 animate-spin fill-brand text-gray-100",
  variants: {
    size: {
      small: "h-3 w-3",
      large: "h-6 w-6"
    }
  }
}), Z6 = ({ size: e, text: t }) => {
  const r = q6({ size: e });
  return /* @__PURE__ */ U.jsx(jw, { isIndeterminate: !0, children: () => /* @__PURE__ */ U.jsxs("div", { className: "col items-center gap-1", children: [
    /* @__PURE__ */ U.jsxs(
      "svg",
      {
        className: r,
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ U.jsx(
            "path",
            {
              d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ U.jsx(
            "path",
            {
              d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
              fill: "currentFill"
            }
          )
        ]
      }
    ),
    t && /* @__PURE__ */ U.jsx(zi, { slot: "label", children: t })
  ] }) });
}, Bg = (e) => /* @__PURE__ */ Et.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Et.createElement("g", { id: "chevron-down" }, /* @__PURE__ */ Et.createElement("path", { id: "Icon", fillRule: "evenodd", clipRule: "evenodd", d: "M3.52864 5.52859C3.78899 5.26824 4.2111 5.26824 4.47145 5.52859L8.00004 9.05719L11.5286 5.52859C11.789 5.26824 12.2111 5.26824 12.4714 5.52859C12.7318 5.78894 12.7318 6.21105 12.4714 6.4714L8.47145 10.4714C8.2111 10.7317 7.78899 10.7317 7.52864 10.4714L3.52864 6.4714C3.26829 6.21105 3.26829 5.78894 3.52864 5.52859Z", fill: "currentFill" }))), Y6 = (e) => /* @__PURE__ */ U.jsx(
  t6,
  {
    className: ({ isPlaceholder: t }) => t ? "text-gray-400" : "text-black",
    ...e
  }
), q2 = ({
  children: e,
  variant: t = "outlined",
  label: r,
  description: o,
  errorMessage: a,
  items: u,
  ...s
}) => /* @__PURE__ */ U.jsxs(Qw, { ...s, isInvalid: s.isInvalid || !!a, children: [
  /* @__PURE__ */ U.jsxs("div", { className: "flex flex-col gap-0.5", children: [
    r && /* @__PURE__ */ U.jsx(Lg, { children: r }),
    /* @__PURE__ */ U.jsx(
      os,
      {
        variant: t,
        p: 0.5,
        h: 4,
        w: "full",
        icon: { Icon: Bg, side: "right", color: "gray-700" },
        children: /* @__PURE__ */ U.jsx(Y6, {})
      }
    ),
    !a && o && /* @__PURE__ */ U.jsx(zi, { slot: "description", children: o }),
    a && /* @__PURE__ */ U.jsx(zi, { slot: "errorMessage", children: a })
  ] }),
  /* @__PURE__ */ U.jsx(Og, { className: "w-[--trigger-width]", children: /* @__PURE__ */ U.jsx(Ig, { items: u, children: e }) })
] }), X6 = Vt({
  variants: {
    slot: {
      label: "text-caption text-gray-600",
      description: "text-caption text-gray-500",
      errorMessage: "text-caption text-critical-base"
    }
  }
}), zi = I.forwardRef(
  (e, t) => ([e, t] = et(e, t, Yn), /* @__PURE__ */ U.jsx(
    pw,
    {
      ...e,
      ref: t,
      className: X6({ slot: e.slot })
    }
  ))
), J6 = (e) => /* @__PURE__ */ Et.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Et.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.1517 0.875747C15.1473 0.871037 15.1428 0.866383 15.1382 0.861785C15.0209 0.744566 14.8709 0.680124 14.7176 0.668458C14.676 0.66526 14.6339 0.66597 14.5919 0.670714C14.5378 0.676795 14.4842 0.689495 14.4326 0.708815L1.11318 5.37062C0.855184 5.46092 0.678448 5.69956 0.667306 5.97268C0.656163 6.2458 0.812872 6.49805 1.06266 6.60906L6.82835 9.17159L9.39088 14.9373C9.50189 15.1871 9.75414 15.3438 10.0273 15.3326C10.3004 15.3215 10.539 15.1448 10.6293 14.8868L15.2912 1.5672C15.3101 1.51665 15.3226 1.46427 15.3289 1.41128C15.3517 1.21751 15.2885 1.02072 15.1517 0.875747ZM12.1296 2.9275L3.1408 6.07359L7.18577 7.87136L12.1296 2.9275ZM8.12858 8.81417L13.0724 3.87031L9.92635 12.8591L8.12858 8.81417Z", fill: "currentFill" }));
function Lu() {
  return Lu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, Lu.apply(this, arguments);
}
function Q6(e, t) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), a, u;
  for (u = 0; u < o.length; u++)
    a = o[u], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var e2 = Y4, t2 = function(t) {
  var r = Et.useRef(t);
  return e2(function() {
    r.current = t;
  }), r;
}, Ef = function(t, r) {
  if (typeof t == "function") {
    t(r);
    return;
  }
  t.current = r;
}, n2 = function(t, r) {
  var o = ie();
  return Pe(function(a) {
    t.current = a, o.current && Ef(o.current, null), o.current = r, r && Ef(r, a);
  }, [r]);
}, Sf = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0"
}, r2 = function(t) {
  Object.keys(Sf).forEach(function(r) {
    t.style.setProperty(r, Sf[r], "important");
  });
}, Pf = r2, Ct = null, Tf = function(t, r) {
  var o = t.scrollHeight;
  return r.sizingStyle.boxSizing === "border-box" ? o + r.borderSize : o - r.paddingSize;
};
function i2(e, t, r, o) {
  r === void 0 && (r = 1), o === void 0 && (o = 1 / 0), Ct || (Ct = document.createElement("textarea"), Ct.setAttribute("tabindex", "-1"), Ct.setAttribute("aria-hidden", "true"), Pf(Ct)), Ct.parentNode === null && document.body.appendChild(Ct);
  var a = e.paddingSize, u = e.borderSize, s = e.sizingStyle, d = s.boxSizing;
  Object.keys(s).forEach(function(y) {
    var $ = y;
    Ct.style[$] = s[$];
  }), Pf(Ct), Ct.value = t;
  var f = Tf(Ct, e);
  Ct.value = t, f = Tf(Ct, e), Ct.value = "x";
  var h = Ct.scrollHeight - a, v = h * r;
  d === "border-box" && (v = v + a + u), f = Math.max(v, f);
  var m = h * o;
  return d === "border-box" && (m = m + a + u), f = Math.min(m, f), [f, h];
}
var Af = function() {
}, o2 = function(t, r) {
  return t.reduce(function(o, a) {
    return o[a] = r[a], o;
  }, {});
}, l2 = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak"
], a2 = !!document.documentElement.currentStyle, u2 = function(t) {
  var r = window.getComputedStyle(t);
  if (r === null)
    return null;
  var o = o2(l2, r), a = o.boxSizing;
  if (a === "")
    return null;
  a2 && a === "border-box" && (o.width = parseFloat(o.width) + parseFloat(o.borderRightWidth) + parseFloat(o.borderLeftWidth) + parseFloat(o.paddingRight) + parseFloat(o.paddingLeft) + "px");
  var u = parseFloat(o.paddingBottom) + parseFloat(o.paddingTop), s = parseFloat(o.borderBottomWidth) + parseFloat(o.borderTopWidth);
  return {
    sizingStyle: o,
    paddingSize: u,
    borderSize: s
  };
}, s2 = u2;
function Mg(e, t, r) {
  var o = t2(r);
  Et.useLayoutEffect(function() {
    var a = function(s) {
      return o.current(s);
    };
    if (e)
      return e.addEventListener(t, a), function() {
        return e.removeEventListener(t, a);
      };
  }, []);
}
var c2 = function(t) {
  Mg(window, "resize", t);
}, d2 = function(t) {
  Mg(document.fonts, "loadingdone", t);
}, f2 = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], p2 = function(t, r) {
  var o = t.cacheMeasurements, a = t.maxRows, u = t.minRows, s = t.onChange, d = s === void 0 ? Af : s, f = t.onHeightChange, h = f === void 0 ? Af : f, v = Q6(t, f2), m = v.value !== void 0, y = Et.useRef(null), $ = n2(y, r), A = Et.useRef(0), _ = Et.useRef(), F = function() {
    var B = y.current, V = o && _.current ? _.current : s2(B);
    if (V) {
      _.current = V;
      var j = i2(V, B.value || B.placeholder || "x", u, a), G = j[0], J = j[1];
      A.current !== G && (A.current = G, B.style.setProperty("height", G + "px", "important"), h(G, {
        rowHeight: J
      }));
    }
  }, W = function(B) {
    m || F(), d(B);
  };
  return Et.useLayoutEffect(F), c2(F), d2(F), /* @__PURE__ */ Et.createElement("textarea", Lu({}, v, {
    onChange: W,
    ref: $
  }));
}, h2 = /* @__PURE__ */ Et.forwardRef(p2);
const v2 = I.forwardRef(
  (e, t) => ([e, t] = et(e, t, mg), /* @__PURE__ */ U.jsx(h2, { className: e.className, ref: t, ...e }))
), g2 = (e) => /^https?:\/\/\S+\.[a-zA-Z]{1,}|\.([a-zA-Z]{1,}\S+)/.test(e), b2 = (e) => {
  const t = /(https?:\/\/\S+\.\S+|\S+)/g;
  return e.split(t);
}, m2 = (e) => (e.startsWith("https://") || (e = "https://" + e), e), _f = ({
  message: e,
  className: t
}) => /* @__PURE__ */ U.jsx(
  "a",
  {
    href: m2(e),
    target: "_blank",
    rel: "noopener noreferrer",
    className: t,
    children: e
  }
), $2 = ({
  message: e,
  className: t
}) => {
  const r = /[.,;:!?]/.test(e.slice(-1));
  if (r) {
    const o = r ? e.slice(0, -1) : e, a = r ? e.slice(-1) : "";
    return /* @__PURE__ */ U.jsxs(U.Fragment, { children: [
      /* @__PURE__ */ U.jsx(_f, { message: o, className: t }),
      /* @__PURE__ */ U.jsx("span", { children: a })
    ] });
  }
  return /* @__PURE__ */ U.jsx(_f, { message: e, className: t });
}, y2 = ({
  message: e,
  className: t
}) => {
  const r = b2(e);
  return /* @__PURE__ */ U.jsx(U.Fragment, { children: r.map((o, a) => /* @__PURE__ */ U.jsx("span", { children: g2(o) ? /* @__PURE__ */ U.jsx($2, { message: o, className: t }) : o }, a)) });
}, x2 = Vt({
  base: "min-w-min max-w-[100%] whitespace-pre-line p-1 text-body shadow",
  variants: {
    isPrimaryUser: {
      true: "ml-auto rounded-[8px] rounded-br-[4px] bg-informational-hover text-white",
      false: "mr-auto rounded-[8px] rounded-bl-[4px] bg-gray-200 text-gray-700"
    }
  }
}), w2 = Vt({
  base: "flex flex-col px-0.5 py-1 text-caption text-gray-600",
  variants: {
    isPrimaryUser: {
      true: "items-end",
      false: "items-start"
    }
  }
}), Df = I.forwardRef(
  ({ message: e, isPrimaryUser: t, isPartOfGroup: r }, o) => /* @__PURE__ */ U.jsxs("div", { className: "flex flex-col", ref: o, children: [
    e.user && !r && /* @__PURE__ */ U.jsx("div", { className: w2({ isPrimaryUser: t }), children: e.user.name }),
    /* @__PURE__ */ U.jsx("div", { className: x2({ isPrimaryUser: t }), children: /* @__PURE__ */ U.jsx(
      y2,
      {
        message: e.message,
        className: "text-white"
      }
    ) })
  ] })
), C2 = ({
  id: e,
  children: t
}) => /* @__PURE__ */ U.jsx("div", { id: e, className: "flex h-full min-h-0 flex-col bg-gray-100", children: t }), E2 = ({ children: e }) => /* @__PURE__ */ U.jsx("div", { className: "flex h-full min-h-0 flex-col gap-1 overflow-y-auto scroll-smooth p-1", children: e }), S2 = ({ title: e }) => /* @__PURE__ */ U.jsx("div", { className: "flex flex-row justify-center border-b p-1 text-subtitle-1 shadow", children: e }), P2 = ({ onSend: e, user: t }) => {
  const [r, o] = Ce(""), a = I.useRef(null), u = !r.length, s = () => o(""), d = () => {
    var m;
    return (m = a.current) == null ? void 0 : m.focus();
  }, f = () => {
    u || (s(), e({ message: r, user: t }), d());
  }, h = (m) => o(m.target.value), v = (m) => {
    m.key === "Enter" && !m.shiftKey && (m.preventDefault(), f());
  };
  return /* @__PURE__ */ U.jsxs("div", { className: "mx-auto flex w-[95%] flex-row items-end justify-start gap-1 p-0.5", children: [
    /* @__PURE__ */ U.jsx(
      v2,
      {
        value: r,
        onChange: h,
        onKeyDown: v,
        placeholder: "Type here...",
        className: "w-[90%] resize-none rounded border border-gray-200 text-body leading-[30px] outline-none",
        maxRows: 3,
        autoFocus: !0,
        ref: a
      }
    ),
    /* @__PURE__ */ U.jsx("div", { className: "h-[44px] w-[50px]", children: /* @__PURE__ */ U.jsx(
      os,
      {
        variant: "primaryFilled",
        h: "full",
        w: "full",
        p: 0,
        icon: { Icon: J6, color: u ? "gray-600" : "white" },
        onPress: f,
        isDisabled: u
      }
    ) })
  ] });
}, Z2 = ({
  id: e,
  title: t,
  messages: r,
  primaryUser: o,
  onSend: a,
  isTyping: u
}) => {
  const s = ie(null), d = (f, h) => {
    f && h && (s.current = f);
  };
  return Ee(() => {
    s.current && s.current.scrollIntoView({ behavior: "smooth" });
  }, [s.current]), /* @__PURE__ */ U.jsxs(C2, { id: e, children: [
    t && /* @__PURE__ */ U.jsx(S2, { title: t }),
    /* @__PURE__ */ U.jsxs(E2, { children: [
      r.map((f, h) => {
        var y, $, A;
        const v = o.id === ((y = f.user) == null ? void 0 : y.id), m = h > 0 && (($ = r[h - 1].user) == null ? void 0 : $.id) === ((A = f.user) == null ? void 0 : A.id);
        return /* @__PURE__ */ U.jsx(
          Df,
          {
            message: f,
            isPrimaryUser: v,
            isPartOfGroup: m,
            ref: (_) => d(_, h === r.length - 1)
          },
          h.toString() + f
        );
      }),
      u && /* @__PURE__ */ U.jsx(
        Df,
        {
          message: {
            message: "..."
          },
          isPrimaryUser: !1,
          isPartOfGroup: !0
        }
      )
    ] }),
    /* @__PURE__ */ U.jsx(P2, { onSend: a, user: o })
  ] });
}, T2 = Vt({
  base: "min-h-[90px] cursor-pointer whitespace-nowrap rounded border border-gray-500 bg-white px-2 py-1 text-gray-600 shadow outline-none transition-colors duration-150 ease-in-out hover:bg-gray-100 focus:bg-gray-100",
  variants: {
    isSelected: {
      true: "border-primary-base bg-primary-light text-primary-base",
      false: ""
    },
    fullWidth: {
      true: "w-full"
    },
    isDisabled: {
      true: "cursor-default bg-gray-100 text-gray-500"
    }
  }
}), A2 = Vt({
  base: "flex h-2.5 w-2.5 items-center justify-center rounded-full border border-gray-400",
  variants: {
    isSelected: {
      true: "border-primary-base"
    }
  }
}), _2 = Vt({
  base: "h-[12px] w-[12px] rounded-full bg-white",
  variants: {
    isSelected: {
      true: "bg-primary-base"
    }
  }
}), Kg = Fe({
  fullWidth: !1
}), Y2 = I.forwardRef(
  ({ icon: e, title: t, description: r, ...o }, a) => {
    [o, a] = et(o, a, vg);
    const { fullWidth: u } = We(Kg), s = e && (e.side === "left" || e.side === void 0), d = e && e.side === "right";
    return /* @__PURE__ */ U.jsx(
      Xw,
      {
        className: ({ isSelected: f, isDisabled: h }) => T2({ isSelected: f, fullWidth: u, isDisabled: h }),
        ...o,
        children: ({ isSelected: f }) => {
          const h = f ? "primary-base" : "gray-600";
          return /* @__PURE__ */ U.jsxs("div", { className: "flex h-full w-full flex-row items-center justify-center gap-0.5", children: [
            /* @__PURE__ */ U.jsx("div", { className: A2({ isSelected: f }), children: /* @__PURE__ */ U.jsx("div", { className: _2({ isSelected: f }) }) }),
            s && /* @__PURE__ */ U.jsx(Zn, { ...e, color: h }),
            /* @__PURE__ */ U.jsxs("div", { className: "flex-grow", children: [
              /* @__PURE__ */ U.jsx("div", { className: "text-body font-medium", children: t }),
              r && /* @__PURE__ */ U.jsx("div", { className: "text-body text-gray-600", children: r })
            ] }),
            d && /* @__PURE__ */ U.jsx(Zn, { ...e, color: h })
          ] });
        }
      }
    );
  }
), D2 = Vt({
  base: "flex flex-col gap-0.5 rounded p-0.5",
  variants: {
    fullWidth: {
      true: "w-full",
      false: "w-fit",
      undefined: "w-fit"
    }
  }
}), X2 = ({ fullWidth: e, children: t, ...r }) => /* @__PURE__ */ U.jsx(Yw, { className: D2({ fullWidth: e }), ...r, children: /* @__PURE__ */ U.jsx(Kg.Provider, { value: { fullWidth: e }, children: /* @__PURE__ */ U.jsx(U.Fragment, { children: t }) }) }), F2 = Vt({
  base: "cursor-pointer whitespace-nowrap rounded p-1 outline-none hover:bg-gray-200",
  variants: {
    isSelected: {
      true: "bg-gray-100 text-primary-base",
      false: "bg-white text-gray-600"
    }
  }
}), J2 = I.forwardRef(
  ({ children: e, icon: t, ...r }, o) => {
    [r, o] = et(r, o, $g);
    const a = t && (t.side === "left" || t.side === void 0), u = t && t.side === "right";
    return /* @__PURE__ */ U.jsx(
      o6,
      {
        ref: o,
        className: ({ isSelected: s }) => F2({ isSelected: s }),
        ...r,
        children: ({ isSelected: s }) => {
          const d = s ? "primary-base" : "gray-600";
          return /* @__PURE__ */ U.jsxs("div", { className: "flex h-full w-full flex-row items-center justify-center gap-0.5", children: [
            a && /* @__PURE__ */ U.jsx(Zn, { ...t, color: d }),
            /* @__PURE__ */ U.jsx(U.Fragment, { children: e }),
            u && /* @__PURE__ */ U.jsx(Zn, { ...t, color: d })
          ] });
        }
      }
    );
  }
);
var fl = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
fl.exports;
(function(e, t) {
  (function() {
    var r, o = "4.17.21", a = 200, u = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", d = "Invalid `variable` option passed into `_.template`", f = "__lodash_hash_undefined__", h = 500, v = "__lodash_placeholder__", m = 1, y = 2, $ = 4, A = 1, _ = 2, F = 1, W = 2, R = 4, B = 8, V = 16, j = 32, G = 64, J = 128, w = 256, Y = 512, O = 30, K = "...", k = 800, T = 16, D = 1, X = 2, Q = 3, H = 1 / 0, le = 9007199254740991, de = 17976931348623157e292, ne = 0 / 0, pe = 4294967295, Ie = pe - 1, Be = pe >>> 1, Tt = [
      ["ary", J],
      ["bind", F],
      ["bindKey", W],
      ["curry", B],
      ["curryRight", V],
      ["flip", Y],
      ["partial", j],
      ["partialRight", G],
      ["rearg", w]
    ], ut = "[object Arguments]", dt = "[object Array]", he = "[object AsyncFunction]", ge = "[object Boolean]", ft = "[object Date]", Bt = "[object DOMException]", cn = "[object Error]", dn = "[object Function]", bn = "[object GeneratorFunction]", pt = "[object Map]", Ht = "[object Number]", mn = "[object Null]", At = "[object Object]", Xn = "[object Promise]", ye = "[object Proxy]", Me = "[object RegExp]", Ke = "[object Set]", $n = "[object String]", $r = "[object Symbol]", Pl = "[object Undefined]", Bn = "[object WeakMap]", Vi = "[object WeakSet]", tn = "[object ArrayBuffer]", Mn = "[object DataView]", yr = "[object Float32Array]", xr = "[object Float64Array]", Jn = "[object Int8Array]", Yr = "[object Int16Array]", Xr = "[object Int32Array]", Jr = "[object Uint8Array]", Qr = "[object Uint8ClampedArray]", ei = "[object Uint16Array]", ti = "[object Uint32Array]", Tl = /\b__p \+= '';/g, ni = /\b(__p \+=) '' \+/g, Hi = /(__e\(.*?\)|\b__t\)) \+\n'';/g, yn = /&(?:amp|lt|gt|quot|#39);/g, wr = /[&<>"']/g, ri = RegExp(yn.source), Ui = RegExp(wr.source), Al = /<%-([\s\S]+?)%>/g, ji = /<%([\s\S]+?)%>/g, Gi = /<%=([\s\S]+?)%>/g, qi = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Zi = /^\w*$/, _l = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ii = /[\\^$.*+?()[\]{}|]/g, Yi = RegExp(ii.source), oi = /^\s+/, Dl = /\s/, Fl = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ll = /\{\n\/\* \[wrapped with (.+)\] \*/, C = /,? & /, Z = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ee = /[()=,{}\[\]\/\s]/, ce = /\\(\\)?/g, Re = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ke = /\w*$/, Ae = /^[-+]0x[0-9a-f]+$/i, we = /^0b[01]+$/i, ht = /^\[object .+?Constructor\]$/, Ye = /^0o[0-7]+$/i, Je = /^(?:0|[1-9]\d*)$/, _t = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, nn = /($^)/, Xi = /['\n\r\u2028\u2029\\]/g, Dt = "\\ud800-\\udfff", Wg = "\\u0300-\\u036f", Vg = "\\ufe20-\\ufe2f", Hg = "\\u20d0-\\u20ff", ls = Wg + Vg + Hg, as = "\\u2700-\\u27bf", us = "a-z\\xdf-\\xf6\\xf8-\\xff", Ug = "\\xac\\xb1\\xd7\\xf7", jg = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Gg = "\\u2000-\\u206f", qg = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ss = "A-Z\\xc0-\\xd6\\xd8-\\xde", cs = "\\ufe0e\\ufe0f", ds = Ug + jg + Gg + qg, Rl = "['’]", Zg = "[" + Dt + "]", fs = "[" + ds + "]", Ji = "[" + ls + "]", ps = "\\d+", Yg = "[" + as + "]", hs = "[" + us + "]", vs = "[^" + Dt + ds + ps + as + us + ss + "]", Il = "\\ud83c[\\udffb-\\udfff]", Xg = "(?:" + Ji + "|" + Il + ")", gs = "[^" + Dt + "]", Bl = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ml = "[\\ud800-\\udbff][\\udc00-\\udfff]", Cr = "[" + ss + "]", bs = "\\u200d", ms = "(?:" + hs + "|" + vs + ")", Jg = "(?:" + Cr + "|" + vs + ")", $s = "(?:" + Rl + "(?:d|ll|m|re|s|t|ve))?", ys = "(?:" + Rl + "(?:D|LL|M|RE|S|T|VE))?", xs = Xg + "?", ws = "[" + cs + "]?", Qg = "(?:" + bs + "(?:" + [gs, Bl, Ml].join("|") + ")" + ws + xs + ")*", eb = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", tb = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Cs = ws + xs + Qg, nb = "(?:" + [Yg, Bl, Ml].join("|") + ")" + Cs, rb = "(?:" + [gs + Ji + "?", Ji, Bl, Ml, Zg].join("|") + ")", ib = RegExp(Rl, "g"), ob = RegExp(Ji, "g"), Kl = RegExp(Il + "(?=" + Il + ")|" + rb + Cs, "g"), lb = RegExp([
      Cr + "?" + hs + "+" + $s + "(?=" + [fs, Cr, "$"].join("|") + ")",
      Jg + "+" + ys + "(?=" + [fs, Cr + ms, "$"].join("|") + ")",
      Cr + "?" + ms + "+" + $s,
      Cr + "+" + ys,
      tb,
      eb,
      ps,
      nb
    ].join("|"), "g"), ab = RegExp("[" + bs + Dt + ls + cs + "]"), ub = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, sb = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], cb = -1, je = {};
    je[yr] = je[xr] = je[Jn] = je[Yr] = je[Xr] = je[Jr] = je[Qr] = je[ei] = je[ti] = !0, je[ut] = je[dt] = je[tn] = je[ge] = je[Mn] = je[ft] = je[cn] = je[dn] = je[pt] = je[Ht] = je[At] = je[Me] = je[Ke] = je[$n] = je[Bn] = !1;
    var He = {};
    He[ut] = He[dt] = He[tn] = He[Mn] = He[ge] = He[ft] = He[yr] = He[xr] = He[Jn] = He[Yr] = He[Xr] = He[pt] = He[Ht] = He[At] = He[Me] = He[Ke] = He[$n] = He[$r] = He[Jr] = He[Qr] = He[ei] = He[ti] = !0, He[cn] = He[dn] = He[Bn] = !1;
    var db = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, fb = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, pb = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, hb = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, vb = parseFloat, gb = parseInt, Es = typeof xi == "object" && xi && xi.Object === Object && xi, bb = typeof self == "object" && self && self.Object === Object && self, vt = Es || bb || Function("return this")(), Ol = t && !t.nodeType && t, Qn = Ol && !0 && e && !e.nodeType && e, Ss = Qn && Qn.exports === Ol, kl = Ss && Es.process, Ut = function() {
      try {
        var S = Qn && Qn.require && Qn.require("util").types;
        return S || kl && kl.binding && kl.binding("util");
      } catch {
      }
    }(), Ps = Ut && Ut.isArrayBuffer, Ts = Ut && Ut.isDate, As = Ut && Ut.isMap, _s = Ut && Ut.isRegExp, Ds = Ut && Ut.isSet, Fs = Ut && Ut.isTypedArray;
    function Mt(S, M, L) {
      switch (L.length) {
        case 0:
          return S.call(M);
        case 1:
          return S.call(M, L[0]);
        case 2:
          return S.call(M, L[0], L[1]);
        case 3:
          return S.call(M, L[0], L[1], L[2]);
      }
      return S.apply(M, L);
    }
    function mb(S, M, L, re) {
      for (var fe = -1, Oe = S == null ? 0 : S.length; ++fe < Oe; ) {
        var ot = S[fe];
        M(re, ot, L(ot), S);
      }
      return re;
    }
    function jt(S, M) {
      for (var L = -1, re = S == null ? 0 : S.length; ++L < re && M(S[L], L, S) !== !1; )
        ;
      return S;
    }
    function $b(S, M) {
      for (var L = S == null ? 0 : S.length; L-- && M(S[L], L, S) !== !1; )
        ;
      return S;
    }
    function Ls(S, M) {
      for (var L = -1, re = S == null ? 0 : S.length; ++L < re; )
        if (!M(S[L], L, S))
          return !1;
      return !0;
    }
    function Kn(S, M) {
      for (var L = -1, re = S == null ? 0 : S.length, fe = 0, Oe = []; ++L < re; ) {
        var ot = S[L];
        M(ot, L, S) && (Oe[fe++] = ot);
      }
      return Oe;
    }
    function Qi(S, M) {
      var L = S == null ? 0 : S.length;
      return !!L && Er(S, M, 0) > -1;
    }
    function Nl(S, M, L) {
      for (var re = -1, fe = S == null ? 0 : S.length; ++re < fe; )
        if (L(M, S[re]))
          return !0;
      return !1;
    }
    function Ze(S, M) {
      for (var L = -1, re = S == null ? 0 : S.length, fe = Array(re); ++L < re; )
        fe[L] = M(S[L], L, S);
      return fe;
    }
    function On(S, M) {
      for (var L = -1, re = M.length, fe = S.length; ++L < re; )
        S[fe + L] = M[L];
      return S;
    }
    function zl(S, M, L, re) {
      var fe = -1, Oe = S == null ? 0 : S.length;
      for (re && Oe && (L = S[++fe]); ++fe < Oe; )
        L = M(L, S[fe], fe, S);
      return L;
    }
    function yb(S, M, L, re) {
      var fe = S == null ? 0 : S.length;
      for (re && fe && (L = S[--fe]); fe--; )
        L = M(L, S[fe], fe, S);
      return L;
    }
    function Wl(S, M) {
      for (var L = -1, re = S == null ? 0 : S.length; ++L < re; )
        if (M(S[L], L, S))
          return !0;
      return !1;
    }
    var xb = Vl("length");
    function wb(S) {
      return S.split("");
    }
    function Cb(S) {
      return S.match(Z) || [];
    }
    function Rs(S, M, L) {
      var re;
      return L(S, function(fe, Oe, ot) {
        if (M(fe, Oe, ot))
          return re = Oe, !1;
      }), re;
    }
    function eo(S, M, L, re) {
      for (var fe = S.length, Oe = L + (re ? 1 : -1); re ? Oe-- : ++Oe < fe; )
        if (M(S[Oe], Oe, S))
          return Oe;
      return -1;
    }
    function Er(S, M, L) {
      return M === M ? Bb(S, M, L) : eo(S, Is, L);
    }
    function Eb(S, M, L, re) {
      for (var fe = L - 1, Oe = S.length; ++fe < Oe; )
        if (re(S[fe], M))
          return fe;
      return -1;
    }
    function Is(S) {
      return S !== S;
    }
    function Bs(S, M) {
      var L = S == null ? 0 : S.length;
      return L ? Ul(S, M) / L : ne;
    }
    function Vl(S) {
      return function(M) {
        return M == null ? r : M[S];
      };
    }
    function Hl(S) {
      return function(M) {
        return S == null ? r : S[M];
      };
    }
    function Ms(S, M, L, re, fe) {
      return fe(S, function(Oe, ot, Ve) {
        L = re ? (re = !1, Oe) : M(L, Oe, ot, Ve);
      }), L;
    }
    function Sb(S, M) {
      var L = S.length;
      for (S.sort(M); L--; )
        S[L] = S[L].value;
      return S;
    }
    function Ul(S, M) {
      for (var L, re = -1, fe = S.length; ++re < fe; ) {
        var Oe = M(S[re]);
        Oe !== r && (L = L === r ? Oe : L + Oe);
      }
      return L;
    }
    function jl(S, M) {
      for (var L = -1, re = Array(S); ++L < S; )
        re[L] = M(L);
      return re;
    }
    function Pb(S, M) {
      return Ze(M, function(L) {
        return [L, S[L]];
      });
    }
    function Ks(S) {
      return S && S.slice(0, zs(S) + 1).replace(oi, "");
    }
    function Kt(S) {
      return function(M) {
        return S(M);
      };
    }
    function Gl(S, M) {
      return Ze(M, function(L) {
        return S[L];
      });
    }
    function li(S, M) {
      return S.has(M);
    }
    function Os(S, M) {
      for (var L = -1, re = S.length; ++L < re && Er(M, S[L], 0) > -1; )
        ;
      return L;
    }
    function ks(S, M) {
      for (var L = S.length; L-- && Er(M, S[L], 0) > -1; )
        ;
      return L;
    }
    function Tb(S, M) {
      for (var L = S.length, re = 0; L--; )
        S[L] === M && ++re;
      return re;
    }
    var Ab = Hl(db), _b = Hl(fb);
    function Db(S) {
      return "\\" + hb[S];
    }
    function Fb(S, M) {
      return S == null ? r : S[M];
    }
    function Sr(S) {
      return ab.test(S);
    }
    function Lb(S) {
      return ub.test(S);
    }
    function Rb(S) {
      for (var M, L = []; !(M = S.next()).done; )
        L.push(M.value);
      return L;
    }
    function ql(S) {
      var M = -1, L = Array(S.size);
      return S.forEach(function(re, fe) {
        L[++M] = [fe, re];
      }), L;
    }
    function Ns(S, M) {
      return function(L) {
        return S(M(L));
      };
    }
    function kn(S, M) {
      for (var L = -1, re = S.length, fe = 0, Oe = []; ++L < re; ) {
        var ot = S[L];
        (ot === M || ot === v) && (S[L] = v, Oe[fe++] = L);
      }
      return Oe;
    }
    function to(S) {
      var M = -1, L = Array(S.size);
      return S.forEach(function(re) {
        L[++M] = re;
      }), L;
    }
    function Ib(S) {
      var M = -1, L = Array(S.size);
      return S.forEach(function(re) {
        L[++M] = [re, re];
      }), L;
    }
    function Bb(S, M, L) {
      for (var re = L - 1, fe = S.length; ++re < fe; )
        if (S[re] === M)
          return re;
      return -1;
    }
    function Mb(S, M, L) {
      for (var re = L + 1; re--; )
        if (S[re] === M)
          return re;
      return re;
    }
    function Pr(S) {
      return Sr(S) ? Ob(S) : xb(S);
    }
    function rn(S) {
      return Sr(S) ? kb(S) : wb(S);
    }
    function zs(S) {
      for (var M = S.length; M-- && Dl.test(S.charAt(M)); )
        ;
      return M;
    }
    var Kb = Hl(pb);
    function Ob(S) {
      for (var M = Kl.lastIndex = 0; Kl.test(S); )
        ++M;
      return M;
    }
    function kb(S) {
      return S.match(Kl) || [];
    }
    function Nb(S) {
      return S.match(lb) || [];
    }
    var zb = function S(M) {
      M = M == null ? vt : Tr.defaults(vt.Object(), M, Tr.pick(vt, sb));
      var L = M.Array, re = M.Date, fe = M.Error, Oe = M.Function, ot = M.Math, Ve = M.Object, Zl = M.RegExp, Wb = M.String, Gt = M.TypeError, no = L.prototype, Vb = Oe.prototype, Ar = Ve.prototype, ro = M["__core-js_shared__"], io = Vb.toString, ze = Ar.hasOwnProperty, Hb = 0, Ws = function() {
        var n = /[^.]+$/.exec(ro && ro.keys && ro.keys.IE_PROTO || "");
        return n ? "Symbol(src)_1." + n : "";
      }(), oo = Ar.toString, Ub = io.call(Ve), jb = vt._, Gb = Zl(
        "^" + io.call(ze).replace(ii, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), lo = Ss ? M.Buffer : r, Nn = M.Symbol, ao = M.Uint8Array, Vs = lo ? lo.allocUnsafe : r, uo = Ns(Ve.getPrototypeOf, Ve), Hs = Ve.create, Us = Ar.propertyIsEnumerable, so = no.splice, js = Nn ? Nn.isConcatSpreadable : r, ai = Nn ? Nn.iterator : r, er = Nn ? Nn.toStringTag : r, co = function() {
        try {
          var n = or(Ve, "defineProperty");
          return n({}, "", {}), n;
        } catch {
        }
      }(), qb = M.clearTimeout !== vt.clearTimeout && M.clearTimeout, Zb = re && re.now !== vt.Date.now && re.now, Yb = M.setTimeout !== vt.setTimeout && M.setTimeout, fo = ot.ceil, po = ot.floor, Yl = Ve.getOwnPropertySymbols, Xb = lo ? lo.isBuffer : r, Gs = M.isFinite, Jb = no.join, Qb = Ns(Ve.keys, Ve), lt = ot.max, bt = ot.min, e0 = re.now, t0 = M.parseInt, qs = ot.random, n0 = no.reverse, Xl = or(M, "DataView"), ui = or(M, "Map"), Jl = or(M, "Promise"), _r = or(M, "Set"), si = or(M, "WeakMap"), ci = or(Ve, "create"), ho = si && new si(), Dr = {}, r0 = lr(Xl), i0 = lr(ui), o0 = lr(Jl), l0 = lr(_r), a0 = lr(si), vo = Nn ? Nn.prototype : r, di = vo ? vo.valueOf : r, Zs = vo ? vo.toString : r;
      function g(n) {
        if (Qe(n) && !ve(n) && !(n instanceof _e)) {
          if (n instanceof qt)
            return n;
          if (ze.call(n, "__wrapped__"))
            return Yc(n);
        }
        return new qt(n);
      }
      var Fr = function() {
        function n() {
        }
        return function(i) {
          if (!Xe(i))
            return {};
          if (Hs)
            return Hs(i);
          n.prototype = i;
          var l = new n();
          return n.prototype = r, l;
        };
      }();
      function go() {
      }
      function qt(n, i) {
        this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!i, this.__index__ = 0, this.__values__ = r;
      }
      g.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Al,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: ji,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Gi,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: g
        }
      }, g.prototype = go.prototype, g.prototype.constructor = g, qt.prototype = Fr(go.prototype), qt.prototype.constructor = qt;
      function _e(n) {
        this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = pe, this.__views__ = [];
      }
      function u0() {
        var n = new _e(this.__wrapped__);
        return n.__actions__ = Ft(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = Ft(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = Ft(this.__views__), n;
      }
      function s0() {
        if (this.__filtered__) {
          var n = new _e(this);
          n.__dir__ = -1, n.__filtered__ = !0;
        } else
          n = this.clone(), n.__dir__ *= -1;
        return n;
      }
      function c0() {
        var n = this.__wrapped__.value(), i = this.__dir__, l = ve(n), c = i < 0, p = l ? n.length : 0, b = wm(0, p, this.__views__), x = b.start, E = b.end, P = E - x, N = c ? E : x - 1, z = this.__iteratees__, q = z.length, te = 0, oe = bt(P, this.__takeCount__);
        if (!l || !c && p == P && oe == P)
          return $c(n, this.__actions__);
        var ue = [];
        e:
          for (; P-- && te < oe; ) {
            N += i;
            for (var $e = -1, se = n[N]; ++$e < q; ) {
              var Te = z[$e], Le = Te.iteratee, Nt = Te.type, wt = Le(se);
              if (Nt == X)
                se = wt;
              else if (!wt) {
                if (Nt == D)
                  continue e;
                break e;
              }
            }
            ue[te++] = se;
          }
        return ue;
      }
      _e.prototype = Fr(go.prototype), _e.prototype.constructor = _e;
      function tr(n) {
        var i = -1, l = n == null ? 0 : n.length;
        for (this.clear(); ++i < l; ) {
          var c = n[i];
          this.set(c[0], c[1]);
        }
      }
      function d0() {
        this.__data__ = ci ? ci(null) : {}, this.size = 0;
      }
      function f0(n) {
        var i = this.has(n) && delete this.__data__[n];
        return this.size -= i ? 1 : 0, i;
      }
      function p0(n) {
        var i = this.__data__;
        if (ci) {
          var l = i[n];
          return l === f ? r : l;
        }
        return ze.call(i, n) ? i[n] : r;
      }
      function h0(n) {
        var i = this.__data__;
        return ci ? i[n] !== r : ze.call(i, n);
      }
      function v0(n, i) {
        var l = this.__data__;
        return this.size += this.has(n) ? 0 : 1, l[n] = ci && i === r ? f : i, this;
      }
      tr.prototype.clear = d0, tr.prototype.delete = f0, tr.prototype.get = p0, tr.prototype.has = h0, tr.prototype.set = v0;
      function xn(n) {
        var i = -1, l = n == null ? 0 : n.length;
        for (this.clear(); ++i < l; ) {
          var c = n[i];
          this.set(c[0], c[1]);
        }
      }
      function g0() {
        this.__data__ = [], this.size = 0;
      }
      function b0(n) {
        var i = this.__data__, l = bo(i, n);
        if (l < 0)
          return !1;
        var c = i.length - 1;
        return l == c ? i.pop() : so.call(i, l, 1), --this.size, !0;
      }
      function m0(n) {
        var i = this.__data__, l = bo(i, n);
        return l < 0 ? r : i[l][1];
      }
      function $0(n) {
        return bo(this.__data__, n) > -1;
      }
      function y0(n, i) {
        var l = this.__data__, c = bo(l, n);
        return c < 0 ? (++this.size, l.push([n, i])) : l[c][1] = i, this;
      }
      xn.prototype.clear = g0, xn.prototype.delete = b0, xn.prototype.get = m0, xn.prototype.has = $0, xn.prototype.set = y0;
      function wn(n) {
        var i = -1, l = n == null ? 0 : n.length;
        for (this.clear(); ++i < l; ) {
          var c = n[i];
          this.set(c[0], c[1]);
        }
      }
      function x0() {
        this.size = 0, this.__data__ = {
          hash: new tr(),
          map: new (ui || xn)(),
          string: new tr()
        };
      }
      function w0(n) {
        var i = _o(this, n).delete(n);
        return this.size -= i ? 1 : 0, i;
      }
      function C0(n) {
        return _o(this, n).get(n);
      }
      function E0(n) {
        return _o(this, n).has(n);
      }
      function S0(n, i) {
        var l = _o(this, n), c = l.size;
        return l.set(n, i), this.size += l.size == c ? 0 : 1, this;
      }
      wn.prototype.clear = x0, wn.prototype.delete = w0, wn.prototype.get = C0, wn.prototype.has = E0, wn.prototype.set = S0;
      function nr(n) {
        var i = -1, l = n == null ? 0 : n.length;
        for (this.__data__ = new wn(); ++i < l; )
          this.add(n[i]);
      }
      function P0(n) {
        return this.__data__.set(n, f), this;
      }
      function T0(n) {
        return this.__data__.has(n);
      }
      nr.prototype.add = nr.prototype.push = P0, nr.prototype.has = T0;
      function on(n) {
        var i = this.__data__ = new xn(n);
        this.size = i.size;
      }
      function A0() {
        this.__data__ = new xn(), this.size = 0;
      }
      function _0(n) {
        var i = this.__data__, l = i.delete(n);
        return this.size = i.size, l;
      }
      function D0(n) {
        return this.__data__.get(n);
      }
      function F0(n) {
        return this.__data__.has(n);
      }
      function L0(n, i) {
        var l = this.__data__;
        if (l instanceof xn) {
          var c = l.__data__;
          if (!ui || c.length < a - 1)
            return c.push([n, i]), this.size = ++l.size, this;
          l = this.__data__ = new wn(c);
        }
        return l.set(n, i), this.size = l.size, this;
      }
      on.prototype.clear = A0, on.prototype.delete = _0, on.prototype.get = D0, on.prototype.has = F0, on.prototype.set = L0;
      function Ys(n, i) {
        var l = ve(n), c = !l && ar(n), p = !l && !c && Un(n), b = !l && !c && !p && Br(n), x = l || c || p || b, E = x ? jl(n.length, Wb) : [], P = E.length;
        for (var N in n)
          (i || ze.call(n, N)) && !(x && // Safari 9 has enumerable `arguments.length` in strict mode.
          (N == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          p && (N == "offset" || N == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          b && (N == "buffer" || N == "byteLength" || N == "byteOffset") || // Skip index properties.
          Pn(N, P))) && E.push(N);
        return E;
      }
      function Xs(n) {
        var i = n.length;
        return i ? n[sa(0, i - 1)] : r;
      }
      function R0(n, i) {
        return Do(Ft(n), rr(i, 0, n.length));
      }
      function I0(n) {
        return Do(Ft(n));
      }
      function Ql(n, i, l) {
        (l !== r && !ln(n[i], l) || l === r && !(i in n)) && Cn(n, i, l);
      }
      function fi(n, i, l) {
        var c = n[i];
        (!(ze.call(n, i) && ln(c, l)) || l === r && !(i in n)) && Cn(n, i, l);
      }
      function bo(n, i) {
        for (var l = n.length; l--; )
          if (ln(n[l][0], i))
            return l;
        return -1;
      }
      function B0(n, i, l, c) {
        return zn(n, function(p, b, x) {
          i(c, p, l(p), x);
        }), c;
      }
      function Js(n, i) {
        return n && pn(i, st(i), n);
      }
      function M0(n, i) {
        return n && pn(i, Rt(i), n);
      }
      function Cn(n, i, l) {
        i == "__proto__" && co ? co(n, i, {
          configurable: !0,
          enumerable: !0,
          value: l,
          writable: !0
        }) : n[i] = l;
      }
      function ea(n, i) {
        for (var l = -1, c = i.length, p = L(c), b = n == null; ++l < c; )
          p[l] = b ? r : Ia(n, i[l]);
        return p;
      }
      function rr(n, i, l) {
        return n === n && (l !== r && (n = n <= l ? n : l), i !== r && (n = n >= i ? n : i)), n;
      }
      function Zt(n, i, l, c, p, b) {
        var x, E = i & m, P = i & y, N = i & $;
        if (l && (x = p ? l(n, c, p, b) : l(n)), x !== r)
          return x;
        if (!Xe(n))
          return n;
        var z = ve(n);
        if (z) {
          if (x = Em(n), !E)
            return Ft(n, x);
        } else {
          var q = mt(n), te = q == dn || q == bn;
          if (Un(n))
            return wc(n, E);
          if (q == At || q == ut || te && !p) {
            if (x = P || te ? {} : zc(n), !E)
              return P ? pm(n, M0(x, n)) : fm(n, Js(x, n));
          } else {
            if (!He[q])
              return p ? n : {};
            x = Sm(n, q, E);
          }
        }
        b || (b = new on());
        var oe = b.get(n);
        if (oe)
          return oe;
        b.set(n, x), gd(n) ? n.forEach(function(se) {
          x.add(Zt(se, i, l, se, n, b));
        }) : hd(n) && n.forEach(function(se, Te) {
          x.set(Te, Zt(se, i, l, Te, n, b));
        });
        var ue = N ? P ? ya : $a : P ? Rt : st, $e = z ? r : ue(n);
        return jt($e || n, function(se, Te) {
          $e && (Te = se, se = n[Te]), fi(x, Te, Zt(se, i, l, Te, n, b));
        }), x;
      }
      function K0(n) {
        var i = st(n);
        return function(l) {
          return Qs(l, n, i);
        };
      }
      function Qs(n, i, l) {
        var c = l.length;
        if (n == null)
          return !c;
        for (n = Ve(n); c--; ) {
          var p = l[c], b = i[p], x = n[p];
          if (x === r && !(p in n) || !b(x))
            return !1;
        }
        return !0;
      }
      function ec(n, i, l) {
        if (typeof n != "function")
          throw new Gt(s);
        return $i(function() {
          n.apply(r, l);
        }, i);
      }
      function pi(n, i, l, c) {
        var p = -1, b = Qi, x = !0, E = n.length, P = [], N = i.length;
        if (!E)
          return P;
        l && (i = Ze(i, Kt(l))), c ? (b = Nl, x = !1) : i.length >= a && (b = li, x = !1, i = new nr(i));
        e:
          for (; ++p < E; ) {
            var z = n[p], q = l == null ? z : l(z);
            if (z = c || z !== 0 ? z : 0, x && q === q) {
              for (var te = N; te--; )
                if (i[te] === q)
                  continue e;
              P.push(z);
            } else
              b(i, q, c) || P.push(z);
          }
        return P;
      }
      var zn = Tc(fn), tc = Tc(na, !0);
      function O0(n, i) {
        var l = !0;
        return zn(n, function(c, p, b) {
          return l = !!i(c, p, b), l;
        }), l;
      }
      function mo(n, i, l) {
        for (var c = -1, p = n.length; ++c < p; ) {
          var b = n[c], x = i(b);
          if (x != null && (E === r ? x === x && !kt(x) : l(x, E)))
            var E = x, P = b;
        }
        return P;
      }
      function k0(n, i, l, c) {
        var p = n.length;
        for (l = be(l), l < 0 && (l = -l > p ? 0 : p + l), c = c === r || c > p ? p : be(c), c < 0 && (c += p), c = l > c ? 0 : md(c); l < c; )
          n[l++] = i;
        return n;
      }
      function nc(n, i) {
        var l = [];
        return zn(n, function(c, p, b) {
          i(c, p, b) && l.push(c);
        }), l;
      }
      function gt(n, i, l, c, p) {
        var b = -1, x = n.length;
        for (l || (l = Tm), p || (p = []); ++b < x; ) {
          var E = n[b];
          i > 0 && l(E) ? i > 1 ? gt(E, i - 1, l, c, p) : On(p, E) : c || (p[p.length] = E);
        }
        return p;
      }
      var ta = Ac(), rc = Ac(!0);
      function fn(n, i) {
        return n && ta(n, i, st);
      }
      function na(n, i) {
        return n && rc(n, i, st);
      }
      function $o(n, i) {
        return Kn(i, function(l) {
          return Tn(n[l]);
        });
      }
      function ir(n, i) {
        i = Vn(i, n);
        for (var l = 0, c = i.length; n != null && l < c; )
          n = n[hn(i[l++])];
        return l && l == c ? n : r;
      }
      function ic(n, i, l) {
        var c = i(n);
        return ve(n) ? c : On(c, l(n));
      }
      function yt(n) {
        return n == null ? n === r ? Pl : mn : er && er in Ve(n) ? xm(n) : Im(n);
      }
      function ra(n, i) {
        return n > i;
      }
      function N0(n, i) {
        return n != null && ze.call(n, i);
      }
      function z0(n, i) {
        return n != null && i in Ve(n);
      }
      function W0(n, i, l) {
        return n >= bt(i, l) && n < lt(i, l);
      }
      function ia(n, i, l) {
        for (var c = l ? Nl : Qi, p = n[0].length, b = n.length, x = b, E = L(b), P = 1 / 0, N = []; x--; ) {
          var z = n[x];
          x && i && (z = Ze(z, Kt(i))), P = bt(z.length, P), E[x] = !l && (i || p >= 120 && z.length >= 120) ? new nr(x && z) : r;
        }
        z = n[0];
        var q = -1, te = E[0];
        e:
          for (; ++q < p && N.length < P; ) {
            var oe = z[q], ue = i ? i(oe) : oe;
            if (oe = l || oe !== 0 ? oe : 0, !(te ? li(te, ue) : c(N, ue, l))) {
              for (x = b; --x; ) {
                var $e = E[x];
                if (!($e ? li($e, ue) : c(n[x], ue, l)))
                  continue e;
              }
              te && te.push(ue), N.push(oe);
            }
          }
        return N;
      }
      function V0(n, i, l, c) {
        return fn(n, function(p, b, x) {
          i(c, l(p), b, x);
        }), c;
      }
      function hi(n, i, l) {
        i = Vn(i, n), n = Uc(n, i);
        var c = n == null ? n : n[hn(Xt(i))];
        return c == null ? r : Mt(c, n, l);
      }
      function oc(n) {
        return Qe(n) && yt(n) == ut;
      }
      function H0(n) {
        return Qe(n) && yt(n) == tn;
      }
      function U0(n) {
        return Qe(n) && yt(n) == ft;
      }
      function vi(n, i, l, c, p) {
        return n === i ? !0 : n == null || i == null || !Qe(n) && !Qe(i) ? n !== n && i !== i : j0(n, i, l, c, vi, p);
      }
      function j0(n, i, l, c, p, b) {
        var x = ve(n), E = ve(i), P = x ? dt : mt(n), N = E ? dt : mt(i);
        P = P == ut ? At : P, N = N == ut ? At : N;
        var z = P == At, q = N == At, te = P == N;
        if (te && Un(n)) {
          if (!Un(i))
            return !1;
          x = !0, z = !1;
        }
        if (te && !z)
          return b || (b = new on()), x || Br(n) ? Oc(n, i, l, c, p, b) : $m(n, i, P, l, c, p, b);
        if (!(l & A)) {
          var oe = z && ze.call(n, "__wrapped__"), ue = q && ze.call(i, "__wrapped__");
          if (oe || ue) {
            var $e = oe ? n.value() : n, se = ue ? i.value() : i;
            return b || (b = new on()), p($e, se, l, c, b);
          }
        }
        return te ? (b || (b = new on()), ym(n, i, l, c, p, b)) : !1;
      }
      function G0(n) {
        return Qe(n) && mt(n) == pt;
      }
      function oa(n, i, l, c) {
        var p = l.length, b = p, x = !c;
        if (n == null)
          return !b;
        for (n = Ve(n); p--; ) {
          var E = l[p];
          if (x && E[2] ? E[1] !== n[E[0]] : !(E[0] in n))
            return !1;
        }
        for (; ++p < b; ) {
          E = l[p];
          var P = E[0], N = n[P], z = E[1];
          if (x && E[2]) {
            if (N === r && !(P in n))
              return !1;
          } else {
            var q = new on();
            if (c)
              var te = c(N, z, P, n, i, q);
            if (!(te === r ? vi(z, N, A | _, c, q) : te))
              return !1;
          }
        }
        return !0;
      }
      function lc(n) {
        if (!Xe(n) || _m(n))
          return !1;
        var i = Tn(n) ? Gb : ht;
        return i.test(lr(n));
      }
      function q0(n) {
        return Qe(n) && yt(n) == Me;
      }
      function Z0(n) {
        return Qe(n) && mt(n) == Ke;
      }
      function Y0(n) {
        return Qe(n) && Mo(n.length) && !!je[yt(n)];
      }
      function ac(n) {
        return typeof n == "function" ? n : n == null ? It : typeof n == "object" ? ve(n) ? cc(n[0], n[1]) : sc(n) : _d(n);
      }
      function la(n) {
        if (!mi(n))
          return Qb(n);
        var i = [];
        for (var l in Ve(n))
          ze.call(n, l) && l != "constructor" && i.push(l);
        return i;
      }
      function X0(n) {
        if (!Xe(n))
          return Rm(n);
        var i = mi(n), l = [];
        for (var c in n)
          c == "constructor" && (i || !ze.call(n, c)) || l.push(c);
        return l;
      }
      function aa(n, i) {
        return n < i;
      }
      function uc(n, i) {
        var l = -1, c = Lt(n) ? L(n.length) : [];
        return zn(n, function(p, b, x) {
          c[++l] = i(p, b, x);
        }), c;
      }
      function sc(n) {
        var i = wa(n);
        return i.length == 1 && i[0][2] ? Vc(i[0][0], i[0][1]) : function(l) {
          return l === n || oa(l, n, i);
        };
      }
      function cc(n, i) {
        return Ea(n) && Wc(i) ? Vc(hn(n), i) : function(l) {
          var c = Ia(l, n);
          return c === r && c === i ? Ba(l, n) : vi(i, c, A | _);
        };
      }
      function yo(n, i, l, c, p) {
        n !== i && ta(i, function(b, x) {
          if (p || (p = new on()), Xe(b))
            J0(n, i, x, l, yo, c, p);
          else {
            var E = c ? c(Pa(n, x), b, x + "", n, i, p) : r;
            E === r && (E = b), Ql(n, x, E);
          }
        }, Rt);
      }
      function J0(n, i, l, c, p, b, x) {
        var E = Pa(n, l), P = Pa(i, l), N = x.get(P);
        if (N) {
          Ql(n, l, N);
          return;
        }
        var z = b ? b(E, P, l + "", n, i, x) : r, q = z === r;
        if (q) {
          var te = ve(P), oe = !te && Un(P), ue = !te && !oe && Br(P);
          z = P, te || oe || ue ? ve(E) ? z = E : tt(E) ? z = Ft(E) : oe ? (q = !1, z = wc(P, !0)) : ue ? (q = !1, z = Cc(P, !0)) : z = [] : yi(P) || ar(P) ? (z = E, ar(E) ? z = $d(E) : (!Xe(E) || Tn(E)) && (z = zc(P))) : q = !1;
        }
        q && (x.set(P, z), p(z, P, c, b, x), x.delete(P)), Ql(n, l, z);
      }
      function dc(n, i) {
        var l = n.length;
        if (l)
          return i += i < 0 ? l : 0, Pn(i, l) ? n[i] : r;
      }
      function fc(n, i, l) {
        i.length ? i = Ze(i, function(b) {
          return ve(b) ? function(x) {
            return ir(x, b.length === 1 ? b[0] : b);
          } : b;
        }) : i = [It];
        var c = -1;
        i = Ze(i, Kt(ae()));
        var p = uc(n, function(b, x, E) {
          var P = Ze(i, function(N) {
            return N(b);
          });
          return { criteria: P, index: ++c, value: b };
        });
        return Sb(p, function(b, x) {
          return dm(b, x, l);
        });
      }
      function Q0(n, i) {
        return pc(n, i, function(l, c) {
          return Ba(n, c);
        });
      }
      function pc(n, i, l) {
        for (var c = -1, p = i.length, b = {}; ++c < p; ) {
          var x = i[c], E = ir(n, x);
          l(E, x) && gi(b, Vn(x, n), E);
        }
        return b;
      }
      function em(n) {
        return function(i) {
          return ir(i, n);
        };
      }
      function ua(n, i, l, c) {
        var p = c ? Eb : Er, b = -1, x = i.length, E = n;
        for (n === i && (i = Ft(i)), l && (E = Ze(n, Kt(l))); ++b < x; )
          for (var P = 0, N = i[b], z = l ? l(N) : N; (P = p(E, z, P, c)) > -1; )
            E !== n && so.call(E, P, 1), so.call(n, P, 1);
        return n;
      }
      function hc(n, i) {
        for (var l = n ? i.length : 0, c = l - 1; l--; ) {
          var p = i[l];
          if (l == c || p !== b) {
            var b = p;
            Pn(p) ? so.call(n, p, 1) : fa(n, p);
          }
        }
        return n;
      }
      function sa(n, i) {
        return n + po(qs() * (i - n + 1));
      }
      function tm(n, i, l, c) {
        for (var p = -1, b = lt(fo((i - n) / (l || 1)), 0), x = L(b); b--; )
          x[c ? b : ++p] = n, n += l;
        return x;
      }
      function ca(n, i) {
        var l = "";
        if (!n || i < 1 || i > le)
          return l;
        do
          i % 2 && (l += n), i = po(i / 2), i && (n += n);
        while (i);
        return l;
      }
      function xe(n, i) {
        return Ta(Hc(n, i, It), n + "");
      }
      function nm(n) {
        return Xs(Mr(n));
      }
      function rm(n, i) {
        var l = Mr(n);
        return Do(l, rr(i, 0, l.length));
      }
      function gi(n, i, l, c) {
        if (!Xe(n))
          return n;
        i = Vn(i, n);
        for (var p = -1, b = i.length, x = b - 1, E = n; E != null && ++p < b; ) {
          var P = hn(i[p]), N = l;
          if (P === "__proto__" || P === "constructor" || P === "prototype")
            return n;
          if (p != x) {
            var z = E[P];
            N = c ? c(z, P, E) : r, N === r && (N = Xe(z) ? z : Pn(i[p + 1]) ? [] : {});
          }
          fi(E, P, N), E = E[P];
        }
        return n;
      }
      var vc = ho ? function(n, i) {
        return ho.set(n, i), n;
      } : It, im = co ? function(n, i) {
        return co(n, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Ka(i),
          writable: !0
        });
      } : It;
      function om(n) {
        return Do(Mr(n));
      }
      function Yt(n, i, l) {
        var c = -1, p = n.length;
        i < 0 && (i = -i > p ? 0 : p + i), l = l > p ? p : l, l < 0 && (l += p), p = i > l ? 0 : l - i >>> 0, i >>>= 0;
        for (var b = L(p); ++c < p; )
          b[c] = n[c + i];
        return b;
      }
      function lm(n, i) {
        var l;
        return zn(n, function(c, p, b) {
          return l = i(c, p, b), !l;
        }), !!l;
      }
      function xo(n, i, l) {
        var c = 0, p = n == null ? c : n.length;
        if (typeof i == "number" && i === i && p <= Be) {
          for (; c < p; ) {
            var b = c + p >>> 1, x = n[b];
            x !== null && !kt(x) && (l ? x <= i : x < i) ? c = b + 1 : p = b;
          }
          return p;
        }
        return da(n, i, It, l);
      }
      function da(n, i, l, c) {
        var p = 0, b = n == null ? 0 : n.length;
        if (b === 0)
          return 0;
        i = l(i);
        for (var x = i !== i, E = i === null, P = kt(i), N = i === r; p < b; ) {
          var z = po((p + b) / 2), q = l(n[z]), te = q !== r, oe = q === null, ue = q === q, $e = kt(q);
          if (x)
            var se = c || ue;
          else
            N ? se = ue && (c || te) : E ? se = ue && te && (c || !oe) : P ? se = ue && te && !oe && (c || !$e) : oe || $e ? se = !1 : se = c ? q <= i : q < i;
          se ? p = z + 1 : b = z;
        }
        return bt(b, Ie);
      }
      function gc(n, i) {
        for (var l = -1, c = n.length, p = 0, b = []; ++l < c; ) {
          var x = n[l], E = i ? i(x) : x;
          if (!l || !ln(E, P)) {
            var P = E;
            b[p++] = x === 0 ? 0 : x;
          }
        }
        return b;
      }
      function bc(n) {
        return typeof n == "number" ? n : kt(n) ? ne : +n;
      }
      function Ot(n) {
        if (typeof n == "string")
          return n;
        if (ve(n))
          return Ze(n, Ot) + "";
        if (kt(n))
          return Zs ? Zs.call(n) : "";
        var i = n + "";
        return i == "0" && 1 / n == -H ? "-0" : i;
      }
      function Wn(n, i, l) {
        var c = -1, p = Qi, b = n.length, x = !0, E = [], P = E;
        if (l)
          x = !1, p = Nl;
        else if (b >= a) {
          var N = i ? null : bm(n);
          if (N)
            return to(N);
          x = !1, p = li, P = new nr();
        } else
          P = i ? [] : E;
        e:
          for (; ++c < b; ) {
            var z = n[c], q = i ? i(z) : z;
            if (z = l || z !== 0 ? z : 0, x && q === q) {
              for (var te = P.length; te--; )
                if (P[te] === q)
                  continue e;
              i && P.push(q), E.push(z);
            } else
              p(P, q, l) || (P !== E && P.push(q), E.push(z));
          }
        return E;
      }
      function fa(n, i) {
        return i = Vn(i, n), n = Uc(n, i), n == null || delete n[hn(Xt(i))];
      }
      function mc(n, i, l, c) {
        return gi(n, i, l(ir(n, i)), c);
      }
      function wo(n, i, l, c) {
        for (var p = n.length, b = c ? p : -1; (c ? b-- : ++b < p) && i(n[b], b, n); )
          ;
        return l ? Yt(n, c ? 0 : b, c ? b + 1 : p) : Yt(n, c ? b + 1 : 0, c ? p : b);
      }
      function $c(n, i) {
        var l = n;
        return l instanceof _e && (l = l.value()), zl(i, function(c, p) {
          return p.func.apply(p.thisArg, On([c], p.args));
        }, l);
      }
      function pa(n, i, l) {
        var c = n.length;
        if (c < 2)
          return c ? Wn(n[0]) : [];
        for (var p = -1, b = L(c); ++p < c; )
          for (var x = n[p], E = -1; ++E < c; )
            E != p && (b[p] = pi(b[p] || x, n[E], i, l));
        return Wn(gt(b, 1), i, l);
      }
      function yc(n, i, l) {
        for (var c = -1, p = n.length, b = i.length, x = {}; ++c < p; ) {
          var E = c < b ? i[c] : r;
          l(x, n[c], E);
        }
        return x;
      }
      function ha(n) {
        return tt(n) ? n : [];
      }
      function va(n) {
        return typeof n == "function" ? n : It;
      }
      function Vn(n, i) {
        return ve(n) ? n : Ea(n, i) ? [n] : Zc(Ne(n));
      }
      var am = xe;
      function Hn(n, i, l) {
        var c = n.length;
        return l = l === r ? c : l, !i && l >= c ? n : Yt(n, i, l);
      }
      var xc = qb || function(n) {
        return vt.clearTimeout(n);
      };
      function wc(n, i) {
        if (i)
          return n.slice();
        var l = n.length, c = Vs ? Vs(l) : new n.constructor(l);
        return n.copy(c), c;
      }
      function ga(n) {
        var i = new n.constructor(n.byteLength);
        return new ao(i).set(new ao(n)), i;
      }
      function um(n, i) {
        var l = i ? ga(n.buffer) : n.buffer;
        return new n.constructor(l, n.byteOffset, n.byteLength);
      }
      function sm(n) {
        var i = new n.constructor(n.source, ke.exec(n));
        return i.lastIndex = n.lastIndex, i;
      }
      function cm(n) {
        return di ? Ve(di.call(n)) : {};
      }
      function Cc(n, i) {
        var l = i ? ga(n.buffer) : n.buffer;
        return new n.constructor(l, n.byteOffset, n.length);
      }
      function Ec(n, i) {
        if (n !== i) {
          var l = n !== r, c = n === null, p = n === n, b = kt(n), x = i !== r, E = i === null, P = i === i, N = kt(i);
          if (!E && !N && !b && n > i || b && x && P && !E && !N || c && x && P || !l && P || !p)
            return 1;
          if (!c && !b && !N && n < i || N && l && p && !c && !b || E && l && p || !x && p || !P)
            return -1;
        }
        return 0;
      }
      function dm(n, i, l) {
        for (var c = -1, p = n.criteria, b = i.criteria, x = p.length, E = l.length; ++c < x; ) {
          var P = Ec(p[c], b[c]);
          if (P) {
            if (c >= E)
              return P;
            var N = l[c];
            return P * (N == "desc" ? -1 : 1);
          }
        }
        return n.index - i.index;
      }
      function Sc(n, i, l, c) {
        for (var p = -1, b = n.length, x = l.length, E = -1, P = i.length, N = lt(b - x, 0), z = L(P + N), q = !c; ++E < P; )
          z[E] = i[E];
        for (; ++p < x; )
          (q || p < b) && (z[l[p]] = n[p]);
        for (; N--; )
          z[E++] = n[p++];
        return z;
      }
      function Pc(n, i, l, c) {
        for (var p = -1, b = n.length, x = -1, E = l.length, P = -1, N = i.length, z = lt(b - E, 0), q = L(z + N), te = !c; ++p < z; )
          q[p] = n[p];
        for (var oe = p; ++P < N; )
          q[oe + P] = i[P];
        for (; ++x < E; )
          (te || p < b) && (q[oe + l[x]] = n[p++]);
        return q;
      }
      function Ft(n, i) {
        var l = -1, c = n.length;
        for (i || (i = L(c)); ++l < c; )
          i[l] = n[l];
        return i;
      }
      function pn(n, i, l, c) {
        var p = !l;
        l || (l = {});
        for (var b = -1, x = i.length; ++b < x; ) {
          var E = i[b], P = c ? c(l[E], n[E], E, l, n) : r;
          P === r && (P = n[E]), p ? Cn(l, E, P) : fi(l, E, P);
        }
        return l;
      }
      function fm(n, i) {
        return pn(n, Ca(n), i);
      }
      function pm(n, i) {
        return pn(n, kc(n), i);
      }
      function Co(n, i) {
        return function(l, c) {
          var p = ve(l) ? mb : B0, b = i ? i() : {};
          return p(l, n, ae(c, 2), b);
        };
      }
      function Lr(n) {
        return xe(function(i, l) {
          var c = -1, p = l.length, b = p > 1 ? l[p - 1] : r, x = p > 2 ? l[2] : r;
          for (b = n.length > 3 && typeof b == "function" ? (p--, b) : r, x && xt(l[0], l[1], x) && (b = p < 3 ? r : b, p = 1), i = Ve(i); ++c < p; ) {
            var E = l[c];
            E && n(i, E, c, b);
          }
          return i;
        });
      }
      function Tc(n, i) {
        return function(l, c) {
          if (l == null)
            return l;
          if (!Lt(l))
            return n(l, c);
          for (var p = l.length, b = i ? p : -1, x = Ve(l); (i ? b-- : ++b < p) && c(x[b], b, x) !== !1; )
            ;
          return l;
        };
      }
      function Ac(n) {
        return function(i, l, c) {
          for (var p = -1, b = Ve(i), x = c(i), E = x.length; E--; ) {
            var P = x[n ? E : ++p];
            if (l(b[P], P, b) === !1)
              break;
          }
          return i;
        };
      }
      function hm(n, i, l) {
        var c = i & F, p = bi(n);
        function b() {
          var x = this && this !== vt && this instanceof b ? p : n;
          return x.apply(c ? l : this, arguments);
        }
        return b;
      }
      function _c(n) {
        return function(i) {
          i = Ne(i);
          var l = Sr(i) ? rn(i) : r, c = l ? l[0] : i.charAt(0), p = l ? Hn(l, 1).join("") : i.slice(1);
          return c[n]() + p;
        };
      }
      function Rr(n) {
        return function(i) {
          return zl(Td(Pd(i).replace(ib, "")), n, "");
        };
      }
      function bi(n) {
        return function() {
          var i = arguments;
          switch (i.length) {
            case 0:
              return new n();
            case 1:
              return new n(i[0]);
            case 2:
              return new n(i[0], i[1]);
            case 3:
              return new n(i[0], i[1], i[2]);
            case 4:
              return new n(i[0], i[1], i[2], i[3]);
            case 5:
              return new n(i[0], i[1], i[2], i[3], i[4]);
            case 6:
              return new n(i[0], i[1], i[2], i[3], i[4], i[5]);
            case 7:
              return new n(i[0], i[1], i[2], i[3], i[4], i[5], i[6]);
          }
          var l = Fr(n.prototype), c = n.apply(l, i);
          return Xe(c) ? c : l;
        };
      }
      function vm(n, i, l) {
        var c = bi(n);
        function p() {
          for (var b = arguments.length, x = L(b), E = b, P = Ir(p); E--; )
            x[E] = arguments[E];
          var N = b < 3 && x[0] !== P && x[b - 1] !== P ? [] : kn(x, P);
          if (b -= N.length, b < l)
            return Ic(
              n,
              i,
              Eo,
              p.placeholder,
              r,
              x,
              N,
              r,
              r,
              l - b
            );
          var z = this && this !== vt && this instanceof p ? c : n;
          return Mt(z, this, x);
        }
        return p;
      }
      function Dc(n) {
        return function(i, l, c) {
          var p = Ve(i);
          if (!Lt(i)) {
            var b = ae(l, 3);
            i = st(i), l = function(E) {
              return b(p[E], E, p);
            };
          }
          var x = n(i, l, c);
          return x > -1 ? p[b ? i[x] : x] : r;
        };
      }
      function Fc(n) {
        return Sn(function(i) {
          var l = i.length, c = l, p = qt.prototype.thru;
          for (n && i.reverse(); c--; ) {
            var b = i[c];
            if (typeof b != "function")
              throw new Gt(s);
            if (p && !x && Ao(b) == "wrapper")
              var x = new qt([], !0);
          }
          for (c = x ? c : l; ++c < l; ) {
            b = i[c];
            var E = Ao(b), P = E == "wrapper" ? xa(b) : r;
            P && Sa(P[0]) && P[1] == (J | B | j | w) && !P[4].length && P[9] == 1 ? x = x[Ao(P[0])].apply(x, P[3]) : x = b.length == 1 && Sa(b) ? x[E]() : x.thru(b);
          }
          return function() {
            var N = arguments, z = N[0];
            if (x && N.length == 1 && ve(z))
              return x.plant(z).value();
            for (var q = 0, te = l ? i[q].apply(this, N) : z; ++q < l; )
              te = i[q].call(this, te);
            return te;
          };
        });
      }
      function Eo(n, i, l, c, p, b, x, E, P, N) {
        var z = i & J, q = i & F, te = i & W, oe = i & (B | V), ue = i & Y, $e = te ? r : bi(n);
        function se() {
          for (var Te = arguments.length, Le = L(Te), Nt = Te; Nt--; )
            Le[Nt] = arguments[Nt];
          if (oe)
            var wt = Ir(se), zt = Tb(Le, wt);
          if (c && (Le = Sc(Le, c, p, oe)), b && (Le = Pc(Le, b, x, oe)), Te -= zt, oe && Te < N) {
            var nt = kn(Le, wt);
            return Ic(
              n,
              i,
              Eo,
              se.placeholder,
              l,
              Le,
              nt,
              E,
              P,
              N - Te
            );
          }
          var an = q ? l : this, _n = te ? an[n] : n;
          return Te = Le.length, E ? Le = Bm(Le, E) : ue && Te > 1 && Le.reverse(), z && P < Te && (Le.length = P), this && this !== vt && this instanceof se && (_n = $e || bi(_n)), _n.apply(an, Le);
        }
        return se;
      }
      function Lc(n, i) {
        return function(l, c) {
          return V0(l, n, i(c), {});
        };
      }
      function So(n, i) {
        return function(l, c) {
          var p;
          if (l === r && c === r)
            return i;
          if (l !== r && (p = l), c !== r) {
            if (p === r)
              return c;
            typeof l == "string" || typeof c == "string" ? (l = Ot(l), c = Ot(c)) : (l = bc(l), c = bc(c)), p = n(l, c);
          }
          return p;
        };
      }
      function ba(n) {
        return Sn(function(i) {
          return i = Ze(i, Kt(ae())), xe(function(l) {
            var c = this;
            return n(i, function(p) {
              return Mt(p, c, l);
            });
          });
        });
      }
      function Po(n, i) {
        i = i === r ? " " : Ot(i);
        var l = i.length;
        if (l < 2)
          return l ? ca(i, n) : i;
        var c = ca(i, fo(n / Pr(i)));
        return Sr(i) ? Hn(rn(c), 0, n).join("") : c.slice(0, n);
      }
      function gm(n, i, l, c) {
        var p = i & F, b = bi(n);
        function x() {
          for (var E = -1, P = arguments.length, N = -1, z = c.length, q = L(z + P), te = this && this !== vt && this instanceof x ? b : n; ++N < z; )
            q[N] = c[N];
          for (; P--; )
            q[N++] = arguments[++E];
          return Mt(te, p ? l : this, q);
        }
        return x;
      }
      function Rc(n) {
        return function(i, l, c) {
          return c && typeof c != "number" && xt(i, l, c) && (l = c = r), i = An(i), l === r ? (l = i, i = 0) : l = An(l), c = c === r ? i < l ? 1 : -1 : An(c), tm(i, l, c, n);
        };
      }
      function To(n) {
        return function(i, l) {
          return typeof i == "string" && typeof l == "string" || (i = Jt(i), l = Jt(l)), n(i, l);
        };
      }
      function Ic(n, i, l, c, p, b, x, E, P, N) {
        var z = i & B, q = z ? x : r, te = z ? r : x, oe = z ? b : r, ue = z ? r : b;
        i |= z ? j : G, i &= ~(z ? G : j), i & R || (i &= ~(F | W));
        var $e = [
          n,
          i,
          p,
          oe,
          q,
          ue,
          te,
          E,
          P,
          N
        ], se = l.apply(r, $e);
        return Sa(n) && jc(se, $e), se.placeholder = c, Gc(se, n, i);
      }
      function ma(n) {
        var i = ot[n];
        return function(l, c) {
          if (l = Jt(l), c = c == null ? 0 : bt(be(c), 292), c && Gs(l)) {
            var p = (Ne(l) + "e").split("e"), b = i(p[0] + "e" + (+p[1] + c));
            return p = (Ne(b) + "e").split("e"), +(p[0] + "e" + (+p[1] - c));
          }
          return i(l);
        };
      }
      var bm = _r && 1 / to(new _r([, -0]))[1] == H ? function(n) {
        return new _r(n);
      } : Na;
      function Bc(n) {
        return function(i) {
          var l = mt(i);
          return l == pt ? ql(i) : l == Ke ? Ib(i) : Pb(i, n(i));
        };
      }
      function En(n, i, l, c, p, b, x, E) {
        var P = i & W;
        if (!P && typeof n != "function")
          throw new Gt(s);
        var N = c ? c.length : 0;
        if (N || (i &= ~(j | G), c = p = r), x = x === r ? x : lt(be(x), 0), E = E === r ? E : be(E), N -= p ? p.length : 0, i & G) {
          var z = c, q = p;
          c = p = r;
        }
        var te = P ? r : xa(n), oe = [
          n,
          i,
          l,
          c,
          p,
          z,
          q,
          b,
          x,
          E
        ];
        if (te && Lm(oe, te), n = oe[0], i = oe[1], l = oe[2], c = oe[3], p = oe[4], E = oe[9] = oe[9] === r ? P ? 0 : n.length : lt(oe[9] - N, 0), !E && i & (B | V) && (i &= ~(B | V)), !i || i == F)
          var ue = hm(n, i, l);
        else
          i == B || i == V ? ue = vm(n, i, E) : (i == j || i == (F | j)) && !p.length ? ue = gm(n, i, l, c) : ue = Eo.apply(r, oe);
        var $e = te ? vc : jc;
        return Gc($e(ue, oe), n, i);
      }
      function Mc(n, i, l, c) {
        return n === r || ln(n, Ar[l]) && !ze.call(c, l) ? i : n;
      }
      function Kc(n, i, l, c, p, b) {
        return Xe(n) && Xe(i) && (b.set(i, n), yo(n, i, r, Kc, b), b.delete(i)), n;
      }
      function mm(n) {
        return yi(n) ? r : n;
      }
      function Oc(n, i, l, c, p, b) {
        var x = l & A, E = n.length, P = i.length;
        if (E != P && !(x && P > E))
          return !1;
        var N = b.get(n), z = b.get(i);
        if (N && z)
          return N == i && z == n;
        var q = -1, te = !0, oe = l & _ ? new nr() : r;
        for (b.set(n, i), b.set(i, n); ++q < E; ) {
          var ue = n[q], $e = i[q];
          if (c)
            var se = x ? c($e, ue, q, i, n, b) : c(ue, $e, q, n, i, b);
          if (se !== r) {
            if (se)
              continue;
            te = !1;
            break;
          }
          if (oe) {
            if (!Wl(i, function(Te, Le) {
              if (!li(oe, Le) && (ue === Te || p(ue, Te, l, c, b)))
                return oe.push(Le);
            })) {
              te = !1;
              break;
            }
          } else if (!(ue === $e || p(ue, $e, l, c, b))) {
            te = !1;
            break;
          }
        }
        return b.delete(n), b.delete(i), te;
      }
      function $m(n, i, l, c, p, b, x) {
        switch (l) {
          case Mn:
            if (n.byteLength != i.byteLength || n.byteOffset != i.byteOffset)
              return !1;
            n = n.buffer, i = i.buffer;
          case tn:
            return !(n.byteLength != i.byteLength || !b(new ao(n), new ao(i)));
          case ge:
          case ft:
          case Ht:
            return ln(+n, +i);
          case cn:
            return n.name == i.name && n.message == i.message;
          case Me:
          case $n:
            return n == i + "";
          case pt:
            var E = ql;
          case Ke:
            var P = c & A;
            if (E || (E = to), n.size != i.size && !P)
              return !1;
            var N = x.get(n);
            if (N)
              return N == i;
            c |= _, x.set(n, i);
            var z = Oc(E(n), E(i), c, p, b, x);
            return x.delete(n), z;
          case $r:
            if (di)
              return di.call(n) == di.call(i);
        }
        return !1;
      }
      function ym(n, i, l, c, p, b) {
        var x = l & A, E = $a(n), P = E.length, N = $a(i), z = N.length;
        if (P != z && !x)
          return !1;
        for (var q = P; q--; ) {
          var te = E[q];
          if (!(x ? te in i : ze.call(i, te)))
            return !1;
        }
        var oe = b.get(n), ue = b.get(i);
        if (oe && ue)
          return oe == i && ue == n;
        var $e = !0;
        b.set(n, i), b.set(i, n);
        for (var se = x; ++q < P; ) {
          te = E[q];
          var Te = n[te], Le = i[te];
          if (c)
            var Nt = x ? c(Le, Te, te, i, n, b) : c(Te, Le, te, n, i, b);
          if (!(Nt === r ? Te === Le || p(Te, Le, l, c, b) : Nt)) {
            $e = !1;
            break;
          }
          se || (se = te == "constructor");
        }
        if ($e && !se) {
          var wt = n.constructor, zt = i.constructor;
          wt != zt && "constructor" in n && "constructor" in i && !(typeof wt == "function" && wt instanceof wt && typeof zt == "function" && zt instanceof zt) && ($e = !1);
        }
        return b.delete(n), b.delete(i), $e;
      }
      function Sn(n) {
        return Ta(Hc(n, r, Qc), n + "");
      }
      function $a(n) {
        return ic(n, st, Ca);
      }
      function ya(n) {
        return ic(n, Rt, kc);
      }
      var xa = ho ? function(n) {
        return ho.get(n);
      } : Na;
      function Ao(n) {
        for (var i = n.name + "", l = Dr[i], c = ze.call(Dr, i) ? l.length : 0; c--; ) {
          var p = l[c], b = p.func;
          if (b == null || b == n)
            return p.name;
        }
        return i;
      }
      function Ir(n) {
        var i = ze.call(g, "placeholder") ? g : n;
        return i.placeholder;
      }
      function ae() {
        var n = g.iteratee || Oa;
        return n = n === Oa ? ac : n, arguments.length ? n(arguments[0], arguments[1]) : n;
      }
      function _o(n, i) {
        var l = n.__data__;
        return Am(i) ? l[typeof i == "string" ? "string" : "hash"] : l.map;
      }
      function wa(n) {
        for (var i = st(n), l = i.length; l--; ) {
          var c = i[l], p = n[c];
          i[l] = [c, p, Wc(p)];
        }
        return i;
      }
      function or(n, i) {
        var l = Fb(n, i);
        return lc(l) ? l : r;
      }
      function xm(n) {
        var i = ze.call(n, er), l = n[er];
        try {
          n[er] = r;
          var c = !0;
        } catch {
        }
        var p = oo.call(n);
        return c && (i ? n[er] = l : delete n[er]), p;
      }
      var Ca = Yl ? function(n) {
        return n == null ? [] : (n = Ve(n), Kn(Yl(n), function(i) {
          return Us.call(n, i);
        }));
      } : za, kc = Yl ? function(n) {
        for (var i = []; n; )
          On(i, Ca(n)), n = uo(n);
        return i;
      } : za, mt = yt;
      (Xl && mt(new Xl(new ArrayBuffer(1))) != Mn || ui && mt(new ui()) != pt || Jl && mt(Jl.resolve()) != Xn || _r && mt(new _r()) != Ke || si && mt(new si()) != Bn) && (mt = function(n) {
        var i = yt(n), l = i == At ? n.constructor : r, c = l ? lr(l) : "";
        if (c)
          switch (c) {
            case r0:
              return Mn;
            case i0:
              return pt;
            case o0:
              return Xn;
            case l0:
              return Ke;
            case a0:
              return Bn;
          }
        return i;
      });
      function wm(n, i, l) {
        for (var c = -1, p = l.length; ++c < p; ) {
          var b = l[c], x = b.size;
          switch (b.type) {
            case "drop":
              n += x;
              break;
            case "dropRight":
              i -= x;
              break;
            case "take":
              i = bt(i, n + x);
              break;
            case "takeRight":
              n = lt(n, i - x);
              break;
          }
        }
        return { start: n, end: i };
      }
      function Cm(n) {
        var i = n.match(Ll);
        return i ? i[1].split(C) : [];
      }
      function Nc(n, i, l) {
        i = Vn(i, n);
        for (var c = -1, p = i.length, b = !1; ++c < p; ) {
          var x = hn(i[c]);
          if (!(b = n != null && l(n, x)))
            break;
          n = n[x];
        }
        return b || ++c != p ? b : (p = n == null ? 0 : n.length, !!p && Mo(p) && Pn(x, p) && (ve(n) || ar(n)));
      }
      function Em(n) {
        var i = n.length, l = new n.constructor(i);
        return i && typeof n[0] == "string" && ze.call(n, "index") && (l.index = n.index, l.input = n.input), l;
      }
      function zc(n) {
        return typeof n.constructor == "function" && !mi(n) ? Fr(uo(n)) : {};
      }
      function Sm(n, i, l) {
        var c = n.constructor;
        switch (i) {
          case tn:
            return ga(n);
          case ge:
          case ft:
            return new c(+n);
          case Mn:
            return um(n, l);
          case yr:
          case xr:
          case Jn:
          case Yr:
          case Xr:
          case Jr:
          case Qr:
          case ei:
          case ti:
            return Cc(n, l);
          case pt:
            return new c();
          case Ht:
          case $n:
            return new c(n);
          case Me:
            return sm(n);
          case Ke:
            return new c();
          case $r:
            return cm(n);
        }
      }
      function Pm(n, i) {
        var l = i.length;
        if (!l)
          return n;
        var c = l - 1;
        return i[c] = (l > 1 ? "& " : "") + i[c], i = i.join(l > 2 ? ", " : " "), n.replace(Fl, `{
/* [wrapped with ` + i + `] */
`);
      }
      function Tm(n) {
        return ve(n) || ar(n) || !!(js && n && n[js]);
      }
      function Pn(n, i) {
        var l = typeof n;
        return i = i ?? le, !!i && (l == "number" || l != "symbol" && Je.test(n)) && n > -1 && n % 1 == 0 && n < i;
      }
      function xt(n, i, l) {
        if (!Xe(l))
          return !1;
        var c = typeof i;
        return (c == "number" ? Lt(l) && Pn(i, l.length) : c == "string" && i in l) ? ln(l[i], n) : !1;
      }
      function Ea(n, i) {
        if (ve(n))
          return !1;
        var l = typeof n;
        return l == "number" || l == "symbol" || l == "boolean" || n == null || kt(n) ? !0 : Zi.test(n) || !qi.test(n) || i != null && n in Ve(i);
      }
      function Am(n) {
        var i = typeof n;
        return i == "string" || i == "number" || i == "symbol" || i == "boolean" ? n !== "__proto__" : n === null;
      }
      function Sa(n) {
        var i = Ao(n), l = g[i];
        if (typeof l != "function" || !(i in _e.prototype))
          return !1;
        if (n === l)
          return !0;
        var c = xa(l);
        return !!c && n === c[0];
      }
      function _m(n) {
        return !!Ws && Ws in n;
      }
      var Dm = ro ? Tn : Wa;
      function mi(n) {
        var i = n && n.constructor, l = typeof i == "function" && i.prototype || Ar;
        return n === l;
      }
      function Wc(n) {
        return n === n && !Xe(n);
      }
      function Vc(n, i) {
        return function(l) {
          return l == null ? !1 : l[n] === i && (i !== r || n in Ve(l));
        };
      }
      function Fm(n) {
        var i = Io(n, function(c) {
          return l.size === h && l.clear(), c;
        }), l = i.cache;
        return i;
      }
      function Lm(n, i) {
        var l = n[1], c = i[1], p = l | c, b = p < (F | W | J), x = c == J && l == B || c == J && l == w && n[7].length <= i[8] || c == (J | w) && i[7].length <= i[8] && l == B;
        if (!(b || x))
          return n;
        c & F && (n[2] = i[2], p |= l & F ? 0 : R);
        var E = i[3];
        if (E) {
          var P = n[3];
          n[3] = P ? Sc(P, E, i[4]) : E, n[4] = P ? kn(n[3], v) : i[4];
        }
        return E = i[5], E && (P = n[5], n[5] = P ? Pc(P, E, i[6]) : E, n[6] = P ? kn(n[5], v) : i[6]), E = i[7], E && (n[7] = E), c & J && (n[8] = n[8] == null ? i[8] : bt(n[8], i[8])), n[9] == null && (n[9] = i[9]), n[0] = i[0], n[1] = p, n;
      }
      function Rm(n) {
        var i = [];
        if (n != null)
          for (var l in Ve(n))
            i.push(l);
        return i;
      }
      function Im(n) {
        return oo.call(n);
      }
      function Hc(n, i, l) {
        return i = lt(i === r ? n.length - 1 : i, 0), function() {
          for (var c = arguments, p = -1, b = lt(c.length - i, 0), x = L(b); ++p < b; )
            x[p] = c[i + p];
          p = -1;
          for (var E = L(i + 1); ++p < i; )
            E[p] = c[p];
          return E[i] = l(x), Mt(n, this, E);
        };
      }
      function Uc(n, i) {
        return i.length < 2 ? n : ir(n, Yt(i, 0, -1));
      }
      function Bm(n, i) {
        for (var l = n.length, c = bt(i.length, l), p = Ft(n); c--; ) {
          var b = i[c];
          n[c] = Pn(b, l) ? p[b] : r;
        }
        return n;
      }
      function Pa(n, i) {
        if (!(i === "constructor" && typeof n[i] == "function") && i != "__proto__")
          return n[i];
      }
      var jc = qc(vc), $i = Yb || function(n, i) {
        return vt.setTimeout(n, i);
      }, Ta = qc(im);
      function Gc(n, i, l) {
        var c = i + "";
        return Ta(n, Pm(c, Mm(Cm(c), l)));
      }
      function qc(n) {
        var i = 0, l = 0;
        return function() {
          var c = e0(), p = T - (c - l);
          if (l = c, p > 0) {
            if (++i >= k)
              return arguments[0];
          } else
            i = 0;
          return n.apply(r, arguments);
        };
      }
      function Do(n, i) {
        var l = -1, c = n.length, p = c - 1;
        for (i = i === r ? c : i; ++l < i; ) {
          var b = sa(l, p), x = n[b];
          n[b] = n[l], n[l] = x;
        }
        return n.length = i, n;
      }
      var Zc = Fm(function(n) {
        var i = [];
        return n.charCodeAt(0) === 46 && i.push(""), n.replace(_l, function(l, c, p, b) {
          i.push(p ? b.replace(ce, "$1") : c || l);
        }), i;
      });
      function hn(n) {
        if (typeof n == "string" || kt(n))
          return n;
        var i = n + "";
        return i == "0" && 1 / n == -H ? "-0" : i;
      }
      function lr(n) {
        if (n != null) {
          try {
            return io.call(n);
          } catch {
          }
          try {
            return n + "";
          } catch {
          }
        }
        return "";
      }
      function Mm(n, i) {
        return jt(Tt, function(l) {
          var c = "_." + l[0];
          i & l[1] && !Qi(n, c) && n.push(c);
        }), n.sort();
      }
      function Yc(n) {
        if (n instanceof _e)
          return n.clone();
        var i = new qt(n.__wrapped__, n.__chain__);
        return i.__actions__ = Ft(n.__actions__), i.__index__ = n.__index__, i.__values__ = n.__values__, i;
      }
      function Km(n, i, l) {
        (l ? xt(n, i, l) : i === r) ? i = 1 : i = lt(be(i), 0);
        var c = n == null ? 0 : n.length;
        if (!c || i < 1)
          return [];
        for (var p = 0, b = 0, x = L(fo(c / i)); p < c; )
          x[b++] = Yt(n, p, p += i);
        return x;
      }
      function Om(n) {
        for (var i = -1, l = n == null ? 0 : n.length, c = 0, p = []; ++i < l; ) {
          var b = n[i];
          b && (p[c++] = b);
        }
        return p;
      }
      function km() {
        var n = arguments.length;
        if (!n)
          return [];
        for (var i = L(n - 1), l = arguments[0], c = n; c--; )
          i[c - 1] = arguments[c];
        return On(ve(l) ? Ft(l) : [l], gt(i, 1));
      }
      var Nm = xe(function(n, i) {
        return tt(n) ? pi(n, gt(i, 1, tt, !0)) : [];
      }), zm = xe(function(n, i) {
        var l = Xt(i);
        return tt(l) && (l = r), tt(n) ? pi(n, gt(i, 1, tt, !0), ae(l, 2)) : [];
      }), Wm = xe(function(n, i) {
        var l = Xt(i);
        return tt(l) && (l = r), tt(n) ? pi(n, gt(i, 1, tt, !0), r, l) : [];
      });
      function Vm(n, i, l) {
        var c = n == null ? 0 : n.length;
        return c ? (i = l || i === r ? 1 : be(i), Yt(n, i < 0 ? 0 : i, c)) : [];
      }
      function Hm(n, i, l) {
        var c = n == null ? 0 : n.length;
        return c ? (i = l || i === r ? 1 : be(i), i = c - i, Yt(n, 0, i < 0 ? 0 : i)) : [];
      }
      function Um(n, i) {
        return n && n.length ? wo(n, ae(i, 3), !0, !0) : [];
      }
      function jm(n, i) {
        return n && n.length ? wo(n, ae(i, 3), !0) : [];
      }
      function Gm(n, i, l, c) {
        var p = n == null ? 0 : n.length;
        return p ? (l && typeof l != "number" && xt(n, i, l) && (l = 0, c = p), k0(n, i, l, c)) : [];
      }
      function Xc(n, i, l) {
        var c = n == null ? 0 : n.length;
        if (!c)
          return -1;
        var p = l == null ? 0 : be(l);
        return p < 0 && (p = lt(c + p, 0)), eo(n, ae(i, 3), p);
      }
      function Jc(n, i, l) {
        var c = n == null ? 0 : n.length;
        if (!c)
          return -1;
        var p = c - 1;
        return l !== r && (p = be(l), p = l < 0 ? lt(c + p, 0) : bt(p, c - 1)), eo(n, ae(i, 3), p, !0);
      }
      function Qc(n) {
        var i = n == null ? 0 : n.length;
        return i ? gt(n, 1) : [];
      }
      function qm(n) {
        var i = n == null ? 0 : n.length;
        return i ? gt(n, H) : [];
      }
      function Zm(n, i) {
        var l = n == null ? 0 : n.length;
        return l ? (i = i === r ? 1 : be(i), gt(n, i)) : [];
      }
      function Ym(n) {
        for (var i = -1, l = n == null ? 0 : n.length, c = {}; ++i < l; ) {
          var p = n[i];
          c[p[0]] = p[1];
        }
        return c;
      }
      function ed(n) {
        return n && n.length ? n[0] : r;
      }
      function Xm(n, i, l) {
        var c = n == null ? 0 : n.length;
        if (!c)
          return -1;
        var p = l == null ? 0 : be(l);
        return p < 0 && (p = lt(c + p, 0)), Er(n, i, p);
      }
      function Jm(n) {
        var i = n == null ? 0 : n.length;
        return i ? Yt(n, 0, -1) : [];
      }
      var Qm = xe(function(n) {
        var i = Ze(n, ha);
        return i.length && i[0] === n[0] ? ia(i) : [];
      }), e1 = xe(function(n) {
        var i = Xt(n), l = Ze(n, ha);
        return i === Xt(l) ? i = r : l.pop(), l.length && l[0] === n[0] ? ia(l, ae(i, 2)) : [];
      }), t1 = xe(function(n) {
        var i = Xt(n), l = Ze(n, ha);
        return i = typeof i == "function" ? i : r, i && l.pop(), l.length && l[0] === n[0] ? ia(l, r, i) : [];
      });
      function n1(n, i) {
        return n == null ? "" : Jb.call(n, i);
      }
      function Xt(n) {
        var i = n == null ? 0 : n.length;
        return i ? n[i - 1] : r;
      }
      function r1(n, i, l) {
        var c = n == null ? 0 : n.length;
        if (!c)
          return -1;
        var p = c;
        return l !== r && (p = be(l), p = p < 0 ? lt(c + p, 0) : bt(p, c - 1)), i === i ? Mb(n, i, p) : eo(n, Is, p, !0);
      }
      function i1(n, i) {
        return n && n.length ? dc(n, be(i)) : r;
      }
      var o1 = xe(td);
      function td(n, i) {
        return n && n.length && i && i.length ? ua(n, i) : n;
      }
      function l1(n, i, l) {
        return n && n.length && i && i.length ? ua(n, i, ae(l, 2)) : n;
      }
      function a1(n, i, l) {
        return n && n.length && i && i.length ? ua(n, i, r, l) : n;
      }
      var u1 = Sn(function(n, i) {
        var l = n == null ? 0 : n.length, c = ea(n, i);
        return hc(n, Ze(i, function(p) {
          return Pn(p, l) ? +p : p;
        }).sort(Ec)), c;
      });
      function s1(n, i) {
        var l = [];
        if (!(n && n.length))
          return l;
        var c = -1, p = [], b = n.length;
        for (i = ae(i, 3); ++c < b; ) {
          var x = n[c];
          i(x, c, n) && (l.push(x), p.push(c));
        }
        return hc(n, p), l;
      }
      function Aa(n) {
        return n == null ? n : n0.call(n);
      }
      function c1(n, i, l) {
        var c = n == null ? 0 : n.length;
        return c ? (l && typeof l != "number" && xt(n, i, l) ? (i = 0, l = c) : (i = i == null ? 0 : be(i), l = l === r ? c : be(l)), Yt(n, i, l)) : [];
      }
      function d1(n, i) {
        return xo(n, i);
      }
      function f1(n, i, l) {
        return da(n, i, ae(l, 2));
      }
      function p1(n, i) {
        var l = n == null ? 0 : n.length;
        if (l) {
          var c = xo(n, i);
          if (c < l && ln(n[c], i))
            return c;
        }
        return -1;
      }
      function h1(n, i) {
        return xo(n, i, !0);
      }
      function v1(n, i, l) {
        return da(n, i, ae(l, 2), !0);
      }
      function g1(n, i) {
        var l = n == null ? 0 : n.length;
        if (l) {
          var c = xo(n, i, !0) - 1;
          if (ln(n[c], i))
            return c;
        }
        return -1;
      }
      function b1(n) {
        return n && n.length ? gc(n) : [];
      }
      function m1(n, i) {
        return n && n.length ? gc(n, ae(i, 2)) : [];
      }
      function $1(n) {
        var i = n == null ? 0 : n.length;
        return i ? Yt(n, 1, i) : [];
      }
      function y1(n, i, l) {
        return n && n.length ? (i = l || i === r ? 1 : be(i), Yt(n, 0, i < 0 ? 0 : i)) : [];
      }
      function x1(n, i, l) {
        var c = n == null ? 0 : n.length;
        return c ? (i = l || i === r ? 1 : be(i), i = c - i, Yt(n, i < 0 ? 0 : i, c)) : [];
      }
      function w1(n, i) {
        return n && n.length ? wo(n, ae(i, 3), !1, !0) : [];
      }
      function C1(n, i) {
        return n && n.length ? wo(n, ae(i, 3)) : [];
      }
      var E1 = xe(function(n) {
        return Wn(gt(n, 1, tt, !0));
      }), S1 = xe(function(n) {
        var i = Xt(n);
        return tt(i) && (i = r), Wn(gt(n, 1, tt, !0), ae(i, 2));
      }), P1 = xe(function(n) {
        var i = Xt(n);
        return i = typeof i == "function" ? i : r, Wn(gt(n, 1, tt, !0), r, i);
      });
      function T1(n) {
        return n && n.length ? Wn(n) : [];
      }
      function A1(n, i) {
        return n && n.length ? Wn(n, ae(i, 2)) : [];
      }
      function _1(n, i) {
        return i = typeof i == "function" ? i : r, n && n.length ? Wn(n, r, i) : [];
      }
      function _a(n) {
        if (!(n && n.length))
          return [];
        var i = 0;
        return n = Kn(n, function(l) {
          if (tt(l))
            return i = lt(l.length, i), !0;
        }), jl(i, function(l) {
          return Ze(n, Vl(l));
        });
      }
      function nd(n, i) {
        if (!(n && n.length))
          return [];
        var l = _a(n);
        return i == null ? l : Ze(l, function(c) {
          return Mt(i, r, c);
        });
      }
      var D1 = xe(function(n, i) {
        return tt(n) ? pi(n, i) : [];
      }), F1 = xe(function(n) {
        return pa(Kn(n, tt));
      }), L1 = xe(function(n) {
        var i = Xt(n);
        return tt(i) && (i = r), pa(Kn(n, tt), ae(i, 2));
      }), R1 = xe(function(n) {
        var i = Xt(n);
        return i = typeof i == "function" ? i : r, pa(Kn(n, tt), r, i);
      }), I1 = xe(_a);
      function B1(n, i) {
        return yc(n || [], i || [], fi);
      }
      function M1(n, i) {
        return yc(n || [], i || [], gi);
      }
      var K1 = xe(function(n) {
        var i = n.length, l = i > 1 ? n[i - 1] : r;
        return l = typeof l == "function" ? (n.pop(), l) : r, nd(n, l);
      });
      function rd(n) {
        var i = g(n);
        return i.__chain__ = !0, i;
      }
      function O1(n, i) {
        return i(n), n;
      }
      function Fo(n, i) {
        return i(n);
      }
      var k1 = Sn(function(n) {
        var i = n.length, l = i ? n[0] : 0, c = this.__wrapped__, p = function(b) {
          return ea(b, n);
        };
        return i > 1 || this.__actions__.length || !(c instanceof _e) || !Pn(l) ? this.thru(p) : (c = c.slice(l, +l + (i ? 1 : 0)), c.__actions__.push({
          func: Fo,
          args: [p],
          thisArg: r
        }), new qt(c, this.__chain__).thru(function(b) {
          return i && !b.length && b.push(r), b;
        }));
      });
      function N1() {
        return rd(this);
      }
      function z1() {
        return new qt(this.value(), this.__chain__);
      }
      function W1() {
        this.__values__ === r && (this.__values__ = bd(this.value()));
        var n = this.__index__ >= this.__values__.length, i = n ? r : this.__values__[this.__index__++];
        return { done: n, value: i };
      }
      function V1() {
        return this;
      }
      function H1(n) {
        for (var i, l = this; l instanceof go; ) {
          var c = Yc(l);
          c.__index__ = 0, c.__values__ = r, i ? p.__wrapped__ = c : i = c;
          var p = c;
          l = l.__wrapped__;
        }
        return p.__wrapped__ = n, i;
      }
      function U1() {
        var n = this.__wrapped__;
        if (n instanceof _e) {
          var i = n;
          return this.__actions__.length && (i = new _e(this)), i = i.reverse(), i.__actions__.push({
            func: Fo,
            args: [Aa],
            thisArg: r
          }), new qt(i, this.__chain__);
        }
        return this.thru(Aa);
      }
      function j1() {
        return $c(this.__wrapped__, this.__actions__);
      }
      var G1 = Co(function(n, i, l) {
        ze.call(n, l) ? ++n[l] : Cn(n, l, 1);
      });
      function q1(n, i, l) {
        var c = ve(n) ? Ls : O0;
        return l && xt(n, i, l) && (i = r), c(n, ae(i, 3));
      }
      function Z1(n, i) {
        var l = ve(n) ? Kn : nc;
        return l(n, ae(i, 3));
      }
      var Y1 = Dc(Xc), X1 = Dc(Jc);
      function J1(n, i) {
        return gt(Lo(n, i), 1);
      }
      function Q1(n, i) {
        return gt(Lo(n, i), H);
      }
      function e$(n, i, l) {
        return l = l === r ? 1 : be(l), gt(Lo(n, i), l);
      }
      function id(n, i) {
        var l = ve(n) ? jt : zn;
        return l(n, ae(i, 3));
      }
      function od(n, i) {
        var l = ve(n) ? $b : tc;
        return l(n, ae(i, 3));
      }
      var t$ = Co(function(n, i, l) {
        ze.call(n, l) ? n[l].push(i) : Cn(n, l, [i]);
      });
      function n$(n, i, l, c) {
        n = Lt(n) ? n : Mr(n), l = l && !c ? be(l) : 0;
        var p = n.length;
        return l < 0 && (l = lt(p + l, 0)), Ko(n) ? l <= p && n.indexOf(i, l) > -1 : !!p && Er(n, i, l) > -1;
      }
      var r$ = xe(function(n, i, l) {
        var c = -1, p = typeof i == "function", b = Lt(n) ? L(n.length) : [];
        return zn(n, function(x) {
          b[++c] = p ? Mt(i, x, l) : hi(x, i, l);
        }), b;
      }), i$ = Co(function(n, i, l) {
        Cn(n, l, i);
      });
      function Lo(n, i) {
        var l = ve(n) ? Ze : uc;
        return l(n, ae(i, 3));
      }
      function o$(n, i, l, c) {
        return n == null ? [] : (ve(i) || (i = i == null ? [] : [i]), l = c ? r : l, ve(l) || (l = l == null ? [] : [l]), fc(n, i, l));
      }
      var l$ = Co(function(n, i, l) {
        n[l ? 0 : 1].push(i);
      }, function() {
        return [[], []];
      });
      function a$(n, i, l) {
        var c = ve(n) ? zl : Ms, p = arguments.length < 3;
        return c(n, ae(i, 4), l, p, zn);
      }
      function u$(n, i, l) {
        var c = ve(n) ? yb : Ms, p = arguments.length < 3;
        return c(n, ae(i, 4), l, p, tc);
      }
      function s$(n, i) {
        var l = ve(n) ? Kn : nc;
        return l(n, Bo(ae(i, 3)));
      }
      function c$(n) {
        var i = ve(n) ? Xs : nm;
        return i(n);
      }
      function d$(n, i, l) {
        (l ? xt(n, i, l) : i === r) ? i = 1 : i = be(i);
        var c = ve(n) ? R0 : rm;
        return c(n, i);
      }
      function f$(n) {
        var i = ve(n) ? I0 : om;
        return i(n);
      }
      function p$(n) {
        if (n == null)
          return 0;
        if (Lt(n))
          return Ko(n) ? Pr(n) : n.length;
        var i = mt(n);
        return i == pt || i == Ke ? n.size : la(n).length;
      }
      function h$(n, i, l) {
        var c = ve(n) ? Wl : lm;
        return l && xt(n, i, l) && (i = r), c(n, ae(i, 3));
      }
      var v$ = xe(function(n, i) {
        if (n == null)
          return [];
        var l = i.length;
        return l > 1 && xt(n, i[0], i[1]) ? i = [] : l > 2 && xt(i[0], i[1], i[2]) && (i = [i[0]]), fc(n, gt(i, 1), []);
      }), Ro = Zb || function() {
        return vt.Date.now();
      };
      function g$(n, i) {
        if (typeof i != "function")
          throw new Gt(s);
        return n = be(n), function() {
          if (--n < 1)
            return i.apply(this, arguments);
        };
      }
      function ld(n, i, l) {
        return i = l ? r : i, i = n && i == null ? n.length : i, En(n, J, r, r, r, r, i);
      }
      function ad(n, i) {
        var l;
        if (typeof i != "function")
          throw new Gt(s);
        return n = be(n), function() {
          return --n > 0 && (l = i.apply(this, arguments)), n <= 1 && (i = r), l;
        };
      }
      var Da = xe(function(n, i, l) {
        var c = F;
        if (l.length) {
          var p = kn(l, Ir(Da));
          c |= j;
        }
        return En(n, c, i, l, p);
      }), ud = xe(function(n, i, l) {
        var c = F | W;
        if (l.length) {
          var p = kn(l, Ir(ud));
          c |= j;
        }
        return En(i, c, n, l, p);
      });
      function sd(n, i, l) {
        i = l ? r : i;
        var c = En(n, B, r, r, r, r, r, i);
        return c.placeholder = sd.placeholder, c;
      }
      function cd(n, i, l) {
        i = l ? r : i;
        var c = En(n, V, r, r, r, r, r, i);
        return c.placeholder = cd.placeholder, c;
      }
      function dd(n, i, l) {
        var c, p, b, x, E, P, N = 0, z = !1, q = !1, te = !0;
        if (typeof n != "function")
          throw new Gt(s);
        i = Jt(i) || 0, Xe(l) && (z = !!l.leading, q = "maxWait" in l, b = q ? lt(Jt(l.maxWait) || 0, i) : b, te = "trailing" in l ? !!l.trailing : te);
        function oe(nt) {
          var an = c, _n = p;
          return c = p = r, N = nt, x = n.apply(_n, an), x;
        }
        function ue(nt) {
          return N = nt, E = $i(Te, i), z ? oe(nt) : x;
        }
        function $e(nt) {
          var an = nt - P, _n = nt - N, Dd = i - an;
          return q ? bt(Dd, b - _n) : Dd;
        }
        function se(nt) {
          var an = nt - P, _n = nt - N;
          return P === r || an >= i || an < 0 || q && _n >= b;
        }
        function Te() {
          var nt = Ro();
          if (se(nt))
            return Le(nt);
          E = $i(Te, $e(nt));
        }
        function Le(nt) {
          return E = r, te && c ? oe(nt) : (c = p = r, x);
        }
        function Nt() {
          E !== r && xc(E), N = 0, c = P = p = E = r;
        }
        function wt() {
          return E === r ? x : Le(Ro());
        }
        function zt() {
          var nt = Ro(), an = se(nt);
          if (c = arguments, p = this, P = nt, an) {
            if (E === r)
              return ue(P);
            if (q)
              return xc(E), E = $i(Te, i), oe(P);
          }
          return E === r && (E = $i(Te, i)), x;
        }
        return zt.cancel = Nt, zt.flush = wt, zt;
      }
      var b$ = xe(function(n, i) {
        return ec(n, 1, i);
      }), m$ = xe(function(n, i, l) {
        return ec(n, Jt(i) || 0, l);
      });
      function $$(n) {
        return En(n, Y);
      }
      function Io(n, i) {
        if (typeof n != "function" || i != null && typeof i != "function")
          throw new Gt(s);
        var l = function() {
          var c = arguments, p = i ? i.apply(this, c) : c[0], b = l.cache;
          if (b.has(p))
            return b.get(p);
          var x = n.apply(this, c);
          return l.cache = b.set(p, x) || b, x;
        };
        return l.cache = new (Io.Cache || wn)(), l;
      }
      Io.Cache = wn;
      function Bo(n) {
        if (typeof n != "function")
          throw new Gt(s);
        return function() {
          var i = arguments;
          switch (i.length) {
            case 0:
              return !n.call(this);
            case 1:
              return !n.call(this, i[0]);
            case 2:
              return !n.call(this, i[0], i[1]);
            case 3:
              return !n.call(this, i[0], i[1], i[2]);
          }
          return !n.apply(this, i);
        };
      }
      function y$(n) {
        return ad(2, n);
      }
      var x$ = am(function(n, i) {
        i = i.length == 1 && ve(i[0]) ? Ze(i[0], Kt(ae())) : Ze(gt(i, 1), Kt(ae()));
        var l = i.length;
        return xe(function(c) {
          for (var p = -1, b = bt(c.length, l); ++p < b; )
            c[p] = i[p].call(this, c[p]);
          return Mt(n, this, c);
        });
      }), Fa = xe(function(n, i) {
        var l = kn(i, Ir(Fa));
        return En(n, j, r, i, l);
      }), fd = xe(function(n, i) {
        var l = kn(i, Ir(fd));
        return En(n, G, r, i, l);
      }), w$ = Sn(function(n, i) {
        return En(n, w, r, r, r, i);
      });
      function C$(n, i) {
        if (typeof n != "function")
          throw new Gt(s);
        return i = i === r ? i : be(i), xe(n, i);
      }
      function E$(n, i) {
        if (typeof n != "function")
          throw new Gt(s);
        return i = i == null ? 0 : lt(be(i), 0), xe(function(l) {
          var c = l[i], p = Hn(l, 0, i);
          return c && On(p, c), Mt(n, this, p);
        });
      }
      function S$(n, i, l) {
        var c = !0, p = !0;
        if (typeof n != "function")
          throw new Gt(s);
        return Xe(l) && (c = "leading" in l ? !!l.leading : c, p = "trailing" in l ? !!l.trailing : p), dd(n, i, {
          leading: c,
          maxWait: i,
          trailing: p
        });
      }
      function P$(n) {
        return ld(n, 1);
      }
      function T$(n, i) {
        return Fa(va(i), n);
      }
      function A$() {
        if (!arguments.length)
          return [];
        var n = arguments[0];
        return ve(n) ? n : [n];
      }
      function _$(n) {
        return Zt(n, $);
      }
      function D$(n, i) {
        return i = typeof i == "function" ? i : r, Zt(n, $, i);
      }
      function F$(n) {
        return Zt(n, m | $);
      }
      function L$(n, i) {
        return i = typeof i == "function" ? i : r, Zt(n, m | $, i);
      }
      function R$(n, i) {
        return i == null || Qs(n, i, st(i));
      }
      function ln(n, i) {
        return n === i || n !== n && i !== i;
      }
      var I$ = To(ra), B$ = To(function(n, i) {
        return n >= i;
      }), ar = oc(function() {
        return arguments;
      }()) ? oc : function(n) {
        return Qe(n) && ze.call(n, "callee") && !Us.call(n, "callee");
      }, ve = L.isArray, M$ = Ps ? Kt(Ps) : H0;
      function Lt(n) {
        return n != null && Mo(n.length) && !Tn(n);
      }
      function tt(n) {
        return Qe(n) && Lt(n);
      }
      function K$(n) {
        return n === !0 || n === !1 || Qe(n) && yt(n) == ge;
      }
      var Un = Xb || Wa, O$ = Ts ? Kt(Ts) : U0;
      function k$(n) {
        return Qe(n) && n.nodeType === 1 && !yi(n);
      }
      function N$(n) {
        if (n == null)
          return !0;
        if (Lt(n) && (ve(n) || typeof n == "string" || typeof n.splice == "function" || Un(n) || Br(n) || ar(n)))
          return !n.length;
        var i = mt(n);
        if (i == pt || i == Ke)
          return !n.size;
        if (mi(n))
          return !la(n).length;
        for (var l in n)
          if (ze.call(n, l))
            return !1;
        return !0;
      }
      function z$(n, i) {
        return vi(n, i);
      }
      function W$(n, i, l) {
        l = typeof l == "function" ? l : r;
        var c = l ? l(n, i) : r;
        return c === r ? vi(n, i, r, l) : !!c;
      }
      function La(n) {
        if (!Qe(n))
          return !1;
        var i = yt(n);
        return i == cn || i == Bt || typeof n.message == "string" && typeof n.name == "string" && !yi(n);
      }
      function V$(n) {
        return typeof n == "number" && Gs(n);
      }
      function Tn(n) {
        if (!Xe(n))
          return !1;
        var i = yt(n);
        return i == dn || i == bn || i == he || i == ye;
      }
      function pd(n) {
        return typeof n == "number" && n == be(n);
      }
      function Mo(n) {
        return typeof n == "number" && n > -1 && n % 1 == 0 && n <= le;
      }
      function Xe(n) {
        var i = typeof n;
        return n != null && (i == "object" || i == "function");
      }
      function Qe(n) {
        return n != null && typeof n == "object";
      }
      var hd = As ? Kt(As) : G0;
      function H$(n, i) {
        return n === i || oa(n, i, wa(i));
      }
      function U$(n, i, l) {
        return l = typeof l == "function" ? l : r, oa(n, i, wa(i), l);
      }
      function j$(n) {
        return vd(n) && n != +n;
      }
      function G$(n) {
        if (Dm(n))
          throw new fe(u);
        return lc(n);
      }
      function q$(n) {
        return n === null;
      }
      function Z$(n) {
        return n == null;
      }
      function vd(n) {
        return typeof n == "number" || Qe(n) && yt(n) == Ht;
      }
      function yi(n) {
        if (!Qe(n) || yt(n) != At)
          return !1;
        var i = uo(n);
        if (i === null)
          return !0;
        var l = ze.call(i, "constructor") && i.constructor;
        return typeof l == "function" && l instanceof l && io.call(l) == Ub;
      }
      var Ra = _s ? Kt(_s) : q0;
      function Y$(n) {
        return pd(n) && n >= -le && n <= le;
      }
      var gd = Ds ? Kt(Ds) : Z0;
      function Ko(n) {
        return typeof n == "string" || !ve(n) && Qe(n) && yt(n) == $n;
      }
      function kt(n) {
        return typeof n == "symbol" || Qe(n) && yt(n) == $r;
      }
      var Br = Fs ? Kt(Fs) : Y0;
      function X$(n) {
        return n === r;
      }
      function J$(n) {
        return Qe(n) && mt(n) == Bn;
      }
      function Q$(n) {
        return Qe(n) && yt(n) == Vi;
      }
      var ey = To(aa), ty = To(function(n, i) {
        return n <= i;
      });
      function bd(n) {
        if (!n)
          return [];
        if (Lt(n))
          return Ko(n) ? rn(n) : Ft(n);
        if (ai && n[ai])
          return Rb(n[ai]());
        var i = mt(n), l = i == pt ? ql : i == Ke ? to : Mr;
        return l(n);
      }
      function An(n) {
        if (!n)
          return n === 0 ? n : 0;
        if (n = Jt(n), n === H || n === -H) {
          var i = n < 0 ? -1 : 1;
          return i * de;
        }
        return n === n ? n : 0;
      }
      function be(n) {
        var i = An(n), l = i % 1;
        return i === i ? l ? i - l : i : 0;
      }
      function md(n) {
        return n ? rr(be(n), 0, pe) : 0;
      }
      function Jt(n) {
        if (typeof n == "number")
          return n;
        if (kt(n))
          return ne;
        if (Xe(n)) {
          var i = typeof n.valueOf == "function" ? n.valueOf() : n;
          n = Xe(i) ? i + "" : i;
        }
        if (typeof n != "string")
          return n === 0 ? n : +n;
        n = Ks(n);
        var l = we.test(n);
        return l || Ye.test(n) ? gb(n.slice(2), l ? 2 : 8) : Ae.test(n) ? ne : +n;
      }
      function $d(n) {
        return pn(n, Rt(n));
      }
      function ny(n) {
        return n ? rr(be(n), -le, le) : n === 0 ? n : 0;
      }
      function Ne(n) {
        return n == null ? "" : Ot(n);
      }
      var ry = Lr(function(n, i) {
        if (mi(i) || Lt(i)) {
          pn(i, st(i), n);
          return;
        }
        for (var l in i)
          ze.call(i, l) && fi(n, l, i[l]);
      }), yd = Lr(function(n, i) {
        pn(i, Rt(i), n);
      }), Oo = Lr(function(n, i, l, c) {
        pn(i, Rt(i), n, c);
      }), iy = Lr(function(n, i, l, c) {
        pn(i, st(i), n, c);
      }), oy = Sn(ea);
      function ly(n, i) {
        var l = Fr(n);
        return i == null ? l : Js(l, i);
      }
      var ay = xe(function(n, i) {
        n = Ve(n);
        var l = -1, c = i.length, p = c > 2 ? i[2] : r;
        for (p && xt(i[0], i[1], p) && (c = 1); ++l < c; )
          for (var b = i[l], x = Rt(b), E = -1, P = x.length; ++E < P; ) {
            var N = x[E], z = n[N];
            (z === r || ln(z, Ar[N]) && !ze.call(n, N)) && (n[N] = b[N]);
          }
        return n;
      }), uy = xe(function(n) {
        return n.push(r, Kc), Mt(xd, r, n);
      });
      function sy(n, i) {
        return Rs(n, ae(i, 3), fn);
      }
      function cy(n, i) {
        return Rs(n, ae(i, 3), na);
      }
      function dy(n, i) {
        return n == null ? n : ta(n, ae(i, 3), Rt);
      }
      function fy(n, i) {
        return n == null ? n : rc(n, ae(i, 3), Rt);
      }
      function py(n, i) {
        return n && fn(n, ae(i, 3));
      }
      function hy(n, i) {
        return n && na(n, ae(i, 3));
      }
      function vy(n) {
        return n == null ? [] : $o(n, st(n));
      }
      function gy(n) {
        return n == null ? [] : $o(n, Rt(n));
      }
      function Ia(n, i, l) {
        var c = n == null ? r : ir(n, i);
        return c === r ? l : c;
      }
      function by(n, i) {
        return n != null && Nc(n, i, N0);
      }
      function Ba(n, i) {
        return n != null && Nc(n, i, z0);
      }
      var my = Lc(function(n, i, l) {
        i != null && typeof i.toString != "function" && (i = oo.call(i)), n[i] = l;
      }, Ka(It)), $y = Lc(function(n, i, l) {
        i != null && typeof i.toString != "function" && (i = oo.call(i)), ze.call(n, i) ? n[i].push(l) : n[i] = [l];
      }, ae), yy = xe(hi);
      function st(n) {
        return Lt(n) ? Ys(n) : la(n);
      }
      function Rt(n) {
        return Lt(n) ? Ys(n, !0) : X0(n);
      }
      function xy(n, i) {
        var l = {};
        return i = ae(i, 3), fn(n, function(c, p, b) {
          Cn(l, i(c, p, b), c);
        }), l;
      }
      function wy(n, i) {
        var l = {};
        return i = ae(i, 3), fn(n, function(c, p, b) {
          Cn(l, p, i(c, p, b));
        }), l;
      }
      var Cy = Lr(function(n, i, l) {
        yo(n, i, l);
      }), xd = Lr(function(n, i, l, c) {
        yo(n, i, l, c);
      }), Ey = Sn(function(n, i) {
        var l = {};
        if (n == null)
          return l;
        var c = !1;
        i = Ze(i, function(b) {
          return b = Vn(b, n), c || (c = b.length > 1), b;
        }), pn(n, ya(n), l), c && (l = Zt(l, m | y | $, mm));
        for (var p = i.length; p--; )
          fa(l, i[p]);
        return l;
      });
      function Sy(n, i) {
        return wd(n, Bo(ae(i)));
      }
      var Py = Sn(function(n, i) {
        return n == null ? {} : Q0(n, i);
      });
      function wd(n, i) {
        if (n == null)
          return {};
        var l = Ze(ya(n), function(c) {
          return [c];
        });
        return i = ae(i), pc(n, l, function(c, p) {
          return i(c, p[0]);
        });
      }
      function Ty(n, i, l) {
        i = Vn(i, n);
        var c = -1, p = i.length;
        for (p || (p = 1, n = r); ++c < p; ) {
          var b = n == null ? r : n[hn(i[c])];
          b === r && (c = p, b = l), n = Tn(b) ? b.call(n) : b;
        }
        return n;
      }
      function Ay(n, i, l) {
        return n == null ? n : gi(n, i, l);
      }
      function _y(n, i, l, c) {
        return c = typeof c == "function" ? c : r, n == null ? n : gi(n, i, l, c);
      }
      var Cd = Bc(st), Ed = Bc(Rt);
      function Dy(n, i, l) {
        var c = ve(n), p = c || Un(n) || Br(n);
        if (i = ae(i, 4), l == null) {
          var b = n && n.constructor;
          p ? l = c ? new b() : [] : Xe(n) ? l = Tn(b) ? Fr(uo(n)) : {} : l = {};
        }
        return (p ? jt : fn)(n, function(x, E, P) {
          return i(l, x, E, P);
        }), l;
      }
      function Fy(n, i) {
        return n == null ? !0 : fa(n, i);
      }
      function Ly(n, i, l) {
        return n == null ? n : mc(n, i, va(l));
      }
      function Ry(n, i, l, c) {
        return c = typeof c == "function" ? c : r, n == null ? n : mc(n, i, va(l), c);
      }
      function Mr(n) {
        return n == null ? [] : Gl(n, st(n));
      }
      function Iy(n) {
        return n == null ? [] : Gl(n, Rt(n));
      }
      function By(n, i, l) {
        return l === r && (l = i, i = r), l !== r && (l = Jt(l), l = l === l ? l : 0), i !== r && (i = Jt(i), i = i === i ? i : 0), rr(Jt(n), i, l);
      }
      function My(n, i, l) {
        return i = An(i), l === r ? (l = i, i = 0) : l = An(l), n = Jt(n), W0(n, i, l);
      }
      function Ky(n, i, l) {
        if (l && typeof l != "boolean" && xt(n, i, l) && (i = l = r), l === r && (typeof i == "boolean" ? (l = i, i = r) : typeof n == "boolean" && (l = n, n = r)), n === r && i === r ? (n = 0, i = 1) : (n = An(n), i === r ? (i = n, n = 0) : i = An(i)), n > i) {
          var c = n;
          n = i, i = c;
        }
        if (l || n % 1 || i % 1) {
          var p = qs();
          return bt(n + p * (i - n + vb("1e-" + ((p + "").length - 1))), i);
        }
        return sa(n, i);
      }
      var Oy = Rr(function(n, i, l) {
        return i = i.toLowerCase(), n + (l ? Sd(i) : i);
      });
      function Sd(n) {
        return Ma(Ne(n).toLowerCase());
      }
      function Pd(n) {
        return n = Ne(n), n && n.replace(_t, Ab).replace(ob, "");
      }
      function ky(n, i, l) {
        n = Ne(n), i = Ot(i);
        var c = n.length;
        l = l === r ? c : rr(be(l), 0, c);
        var p = l;
        return l -= i.length, l >= 0 && n.slice(l, p) == i;
      }
      function Ny(n) {
        return n = Ne(n), n && Ui.test(n) ? n.replace(wr, _b) : n;
      }
      function zy(n) {
        return n = Ne(n), n && Yi.test(n) ? n.replace(ii, "\\$&") : n;
      }
      var Wy = Rr(function(n, i, l) {
        return n + (l ? "-" : "") + i.toLowerCase();
      }), Vy = Rr(function(n, i, l) {
        return n + (l ? " " : "") + i.toLowerCase();
      }), Hy = _c("toLowerCase");
      function Uy(n, i, l) {
        n = Ne(n), i = be(i);
        var c = i ? Pr(n) : 0;
        if (!i || c >= i)
          return n;
        var p = (i - c) / 2;
        return Po(po(p), l) + n + Po(fo(p), l);
      }
      function jy(n, i, l) {
        n = Ne(n), i = be(i);
        var c = i ? Pr(n) : 0;
        return i && c < i ? n + Po(i - c, l) : n;
      }
      function Gy(n, i, l) {
        n = Ne(n), i = be(i);
        var c = i ? Pr(n) : 0;
        return i && c < i ? Po(i - c, l) + n : n;
      }
      function qy(n, i, l) {
        return l || i == null ? i = 0 : i && (i = +i), t0(Ne(n).replace(oi, ""), i || 0);
      }
      function Zy(n, i, l) {
        return (l ? xt(n, i, l) : i === r) ? i = 1 : i = be(i), ca(Ne(n), i);
      }
      function Yy() {
        var n = arguments, i = Ne(n[0]);
        return n.length < 3 ? i : i.replace(n[1], n[2]);
      }
      var Xy = Rr(function(n, i, l) {
        return n + (l ? "_" : "") + i.toLowerCase();
      });
      function Jy(n, i, l) {
        return l && typeof l != "number" && xt(n, i, l) && (i = l = r), l = l === r ? pe : l >>> 0, l ? (n = Ne(n), n && (typeof i == "string" || i != null && !Ra(i)) && (i = Ot(i), !i && Sr(n)) ? Hn(rn(n), 0, l) : n.split(i, l)) : [];
      }
      var Qy = Rr(function(n, i, l) {
        return n + (l ? " " : "") + Ma(i);
      });
      function e4(n, i, l) {
        return n = Ne(n), l = l == null ? 0 : rr(be(l), 0, n.length), i = Ot(i), n.slice(l, l + i.length) == i;
      }
      function t4(n, i, l) {
        var c = g.templateSettings;
        l && xt(n, i, l) && (i = r), n = Ne(n), i = Oo({}, i, c, Mc);
        var p = Oo({}, i.imports, c.imports, Mc), b = st(p), x = Gl(p, b), E, P, N = 0, z = i.interpolate || nn, q = "__p += '", te = Zl(
          (i.escape || nn).source + "|" + z.source + "|" + (z === Gi ? Re : nn).source + "|" + (i.evaluate || nn).source + "|$",
          "g"
        ), oe = "//# sourceURL=" + (ze.call(i, "sourceURL") ? (i.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++cb + "]") + `
`;
        n.replace(te, function(se, Te, Le, Nt, wt, zt) {
          return Le || (Le = Nt), q += n.slice(N, zt).replace(Xi, Db), Te && (E = !0, q += `' +
__e(` + Te + `) +
'`), wt && (P = !0, q += `';
` + wt + `;
__p += '`), Le && (q += `' +
((__t = (` + Le + `)) == null ? '' : __t) +
'`), N = zt + se.length, se;
        }), q += `';
`;
        var ue = ze.call(i, "variable") && i.variable;
        if (!ue)
          q = `with (obj) {
` + q + `
}
`;
        else if (ee.test(ue))
          throw new fe(d);
        q = (P ? q.replace(Tl, "") : q).replace(ni, "$1").replace(Hi, "$1;"), q = "function(" + (ue || "obj") + `) {
` + (ue ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (E ? ", __e = _.escape" : "") + (P ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + q + `return __p
}`;
        var $e = Ad(function() {
          return Oe(b, oe + "return " + q).apply(r, x);
        });
        if ($e.source = q, La($e))
          throw $e;
        return $e;
      }
      function n4(n) {
        return Ne(n).toLowerCase();
      }
      function r4(n) {
        return Ne(n).toUpperCase();
      }
      function i4(n, i, l) {
        if (n = Ne(n), n && (l || i === r))
          return Ks(n);
        if (!n || !(i = Ot(i)))
          return n;
        var c = rn(n), p = rn(i), b = Os(c, p), x = ks(c, p) + 1;
        return Hn(c, b, x).join("");
      }
      function o4(n, i, l) {
        if (n = Ne(n), n && (l || i === r))
          return n.slice(0, zs(n) + 1);
        if (!n || !(i = Ot(i)))
          return n;
        var c = rn(n), p = ks(c, rn(i)) + 1;
        return Hn(c, 0, p).join("");
      }
      function l4(n, i, l) {
        if (n = Ne(n), n && (l || i === r))
          return n.replace(oi, "");
        if (!n || !(i = Ot(i)))
          return n;
        var c = rn(n), p = Os(c, rn(i));
        return Hn(c, p).join("");
      }
      function a4(n, i) {
        var l = O, c = K;
        if (Xe(i)) {
          var p = "separator" in i ? i.separator : p;
          l = "length" in i ? be(i.length) : l, c = "omission" in i ? Ot(i.omission) : c;
        }
        n = Ne(n);
        var b = n.length;
        if (Sr(n)) {
          var x = rn(n);
          b = x.length;
        }
        if (l >= b)
          return n;
        var E = l - Pr(c);
        if (E < 1)
          return c;
        var P = x ? Hn(x, 0, E).join("") : n.slice(0, E);
        if (p === r)
          return P + c;
        if (x && (E += P.length - E), Ra(p)) {
          if (n.slice(E).search(p)) {
            var N, z = P;
            for (p.global || (p = Zl(p.source, Ne(ke.exec(p)) + "g")), p.lastIndex = 0; N = p.exec(z); )
              var q = N.index;
            P = P.slice(0, q === r ? E : q);
          }
        } else if (n.indexOf(Ot(p), E) != E) {
          var te = P.lastIndexOf(p);
          te > -1 && (P = P.slice(0, te));
        }
        return P + c;
      }
      function u4(n) {
        return n = Ne(n), n && ri.test(n) ? n.replace(yn, Kb) : n;
      }
      var s4 = Rr(function(n, i, l) {
        return n + (l ? " " : "") + i.toUpperCase();
      }), Ma = _c("toUpperCase");
      function Td(n, i, l) {
        return n = Ne(n), i = l ? r : i, i === r ? Lb(n) ? Nb(n) : Cb(n) : n.match(i) || [];
      }
      var Ad = xe(function(n, i) {
        try {
          return Mt(n, r, i);
        } catch (l) {
          return La(l) ? l : new fe(l);
        }
      }), c4 = Sn(function(n, i) {
        return jt(i, function(l) {
          l = hn(l), Cn(n, l, Da(n[l], n));
        }), n;
      });
      function d4(n) {
        var i = n == null ? 0 : n.length, l = ae();
        return n = i ? Ze(n, function(c) {
          if (typeof c[1] != "function")
            throw new Gt(s);
          return [l(c[0]), c[1]];
        }) : [], xe(function(c) {
          for (var p = -1; ++p < i; ) {
            var b = n[p];
            if (Mt(b[0], this, c))
              return Mt(b[1], this, c);
          }
        });
      }
      function f4(n) {
        return K0(Zt(n, m));
      }
      function Ka(n) {
        return function() {
          return n;
        };
      }
      function p4(n, i) {
        return n == null || n !== n ? i : n;
      }
      var h4 = Fc(), v4 = Fc(!0);
      function It(n) {
        return n;
      }
      function Oa(n) {
        return ac(typeof n == "function" ? n : Zt(n, m));
      }
      function g4(n) {
        return sc(Zt(n, m));
      }
      function b4(n, i) {
        return cc(n, Zt(i, m));
      }
      var m4 = xe(function(n, i) {
        return function(l) {
          return hi(l, n, i);
        };
      }), $4 = xe(function(n, i) {
        return function(l) {
          return hi(n, l, i);
        };
      });
      function ka(n, i, l) {
        var c = st(i), p = $o(i, c);
        l == null && !(Xe(i) && (p.length || !c.length)) && (l = i, i = n, n = this, p = $o(i, st(i)));
        var b = !(Xe(l) && "chain" in l) || !!l.chain, x = Tn(n);
        return jt(p, function(E) {
          var P = i[E];
          n[E] = P, x && (n.prototype[E] = function() {
            var N = this.__chain__;
            if (b || N) {
              var z = n(this.__wrapped__), q = z.__actions__ = Ft(this.__actions__);
              return q.push({ func: P, args: arguments, thisArg: n }), z.__chain__ = N, z;
            }
            return P.apply(n, On([this.value()], arguments));
          });
        }), n;
      }
      function y4() {
        return vt._ === this && (vt._ = jb), this;
      }
      function Na() {
      }
      function x4(n) {
        return n = be(n), xe(function(i) {
          return dc(i, n);
        });
      }
      var w4 = ba(Ze), C4 = ba(Ls), E4 = ba(Wl);
      function _d(n) {
        return Ea(n) ? Vl(hn(n)) : em(n);
      }
      function S4(n) {
        return function(i) {
          return n == null ? r : ir(n, i);
        };
      }
      var P4 = Rc(), T4 = Rc(!0);
      function za() {
        return [];
      }
      function Wa() {
        return !1;
      }
      function A4() {
        return {};
      }
      function _4() {
        return "";
      }
      function D4() {
        return !0;
      }
      function F4(n, i) {
        if (n = be(n), n < 1 || n > le)
          return [];
        var l = pe, c = bt(n, pe);
        i = ae(i), n -= pe;
        for (var p = jl(c, i); ++l < n; )
          i(l);
        return p;
      }
      function L4(n) {
        return ve(n) ? Ze(n, hn) : kt(n) ? [n] : Ft(Zc(Ne(n)));
      }
      function R4(n) {
        var i = ++Hb;
        return Ne(n) + i;
      }
      var I4 = So(function(n, i) {
        return n + i;
      }, 0), B4 = ma("ceil"), M4 = So(function(n, i) {
        return n / i;
      }, 1), K4 = ma("floor");
      function O4(n) {
        return n && n.length ? mo(n, It, ra) : r;
      }
      function k4(n, i) {
        return n && n.length ? mo(n, ae(i, 2), ra) : r;
      }
      function N4(n) {
        return Bs(n, It);
      }
      function z4(n, i) {
        return Bs(n, ae(i, 2));
      }
      function W4(n) {
        return n && n.length ? mo(n, It, aa) : r;
      }
      function V4(n, i) {
        return n && n.length ? mo(n, ae(i, 2), aa) : r;
      }
      var H4 = So(function(n, i) {
        return n * i;
      }, 1), U4 = ma("round"), j4 = So(function(n, i) {
        return n - i;
      }, 0);
      function G4(n) {
        return n && n.length ? Ul(n, It) : 0;
      }
      function q4(n, i) {
        return n && n.length ? Ul(n, ae(i, 2)) : 0;
      }
      return g.after = g$, g.ary = ld, g.assign = ry, g.assignIn = yd, g.assignInWith = Oo, g.assignWith = iy, g.at = oy, g.before = ad, g.bind = Da, g.bindAll = c4, g.bindKey = ud, g.castArray = A$, g.chain = rd, g.chunk = Km, g.compact = Om, g.concat = km, g.cond = d4, g.conforms = f4, g.constant = Ka, g.countBy = G1, g.create = ly, g.curry = sd, g.curryRight = cd, g.debounce = dd, g.defaults = ay, g.defaultsDeep = uy, g.defer = b$, g.delay = m$, g.difference = Nm, g.differenceBy = zm, g.differenceWith = Wm, g.drop = Vm, g.dropRight = Hm, g.dropRightWhile = Um, g.dropWhile = jm, g.fill = Gm, g.filter = Z1, g.flatMap = J1, g.flatMapDeep = Q1, g.flatMapDepth = e$, g.flatten = Qc, g.flattenDeep = qm, g.flattenDepth = Zm, g.flip = $$, g.flow = h4, g.flowRight = v4, g.fromPairs = Ym, g.functions = vy, g.functionsIn = gy, g.groupBy = t$, g.initial = Jm, g.intersection = Qm, g.intersectionBy = e1, g.intersectionWith = t1, g.invert = my, g.invertBy = $y, g.invokeMap = r$, g.iteratee = Oa, g.keyBy = i$, g.keys = st, g.keysIn = Rt, g.map = Lo, g.mapKeys = xy, g.mapValues = wy, g.matches = g4, g.matchesProperty = b4, g.memoize = Io, g.merge = Cy, g.mergeWith = xd, g.method = m4, g.methodOf = $4, g.mixin = ka, g.negate = Bo, g.nthArg = x4, g.omit = Ey, g.omitBy = Sy, g.once = y$, g.orderBy = o$, g.over = w4, g.overArgs = x$, g.overEvery = C4, g.overSome = E4, g.partial = Fa, g.partialRight = fd, g.partition = l$, g.pick = Py, g.pickBy = wd, g.property = _d, g.propertyOf = S4, g.pull = o1, g.pullAll = td, g.pullAllBy = l1, g.pullAllWith = a1, g.pullAt = u1, g.range = P4, g.rangeRight = T4, g.rearg = w$, g.reject = s$, g.remove = s1, g.rest = C$, g.reverse = Aa, g.sampleSize = d$, g.set = Ay, g.setWith = _y, g.shuffle = f$, g.slice = c1, g.sortBy = v$, g.sortedUniq = b1, g.sortedUniqBy = m1, g.split = Jy, g.spread = E$, g.tail = $1, g.take = y1, g.takeRight = x1, g.takeRightWhile = w1, g.takeWhile = C1, g.tap = O1, g.throttle = S$, g.thru = Fo, g.toArray = bd, g.toPairs = Cd, g.toPairsIn = Ed, g.toPath = L4, g.toPlainObject = $d, g.transform = Dy, g.unary = P$, g.union = E1, g.unionBy = S1, g.unionWith = P1, g.uniq = T1, g.uniqBy = A1, g.uniqWith = _1, g.unset = Fy, g.unzip = _a, g.unzipWith = nd, g.update = Ly, g.updateWith = Ry, g.values = Mr, g.valuesIn = Iy, g.without = D1, g.words = Td, g.wrap = T$, g.xor = F1, g.xorBy = L1, g.xorWith = R1, g.zip = I1, g.zipObject = B1, g.zipObjectDeep = M1, g.zipWith = K1, g.entries = Cd, g.entriesIn = Ed, g.extend = yd, g.extendWith = Oo, ka(g, g), g.add = I4, g.attempt = Ad, g.camelCase = Oy, g.capitalize = Sd, g.ceil = B4, g.clamp = By, g.clone = _$, g.cloneDeep = F$, g.cloneDeepWith = L$, g.cloneWith = D$, g.conformsTo = R$, g.deburr = Pd, g.defaultTo = p4, g.divide = M4, g.endsWith = ky, g.eq = ln, g.escape = Ny, g.escapeRegExp = zy, g.every = q1, g.find = Y1, g.findIndex = Xc, g.findKey = sy, g.findLast = X1, g.findLastIndex = Jc, g.findLastKey = cy, g.floor = K4, g.forEach = id, g.forEachRight = od, g.forIn = dy, g.forInRight = fy, g.forOwn = py, g.forOwnRight = hy, g.get = Ia, g.gt = I$, g.gte = B$, g.has = by, g.hasIn = Ba, g.head = ed, g.identity = It, g.includes = n$, g.indexOf = Xm, g.inRange = My, g.invoke = yy, g.isArguments = ar, g.isArray = ve, g.isArrayBuffer = M$, g.isArrayLike = Lt, g.isArrayLikeObject = tt, g.isBoolean = K$, g.isBuffer = Un, g.isDate = O$, g.isElement = k$, g.isEmpty = N$, g.isEqual = z$, g.isEqualWith = W$, g.isError = La, g.isFinite = V$, g.isFunction = Tn, g.isInteger = pd, g.isLength = Mo, g.isMap = hd, g.isMatch = H$, g.isMatchWith = U$, g.isNaN = j$, g.isNative = G$, g.isNil = Z$, g.isNull = q$, g.isNumber = vd, g.isObject = Xe, g.isObjectLike = Qe, g.isPlainObject = yi, g.isRegExp = Ra, g.isSafeInteger = Y$, g.isSet = gd, g.isString = Ko, g.isSymbol = kt, g.isTypedArray = Br, g.isUndefined = X$, g.isWeakMap = J$, g.isWeakSet = Q$, g.join = n1, g.kebabCase = Wy, g.last = Xt, g.lastIndexOf = r1, g.lowerCase = Vy, g.lowerFirst = Hy, g.lt = ey, g.lte = ty, g.max = O4, g.maxBy = k4, g.mean = N4, g.meanBy = z4, g.min = W4, g.minBy = V4, g.stubArray = za, g.stubFalse = Wa, g.stubObject = A4, g.stubString = _4, g.stubTrue = D4, g.multiply = H4, g.nth = i1, g.noConflict = y4, g.noop = Na, g.now = Ro, g.pad = Uy, g.padEnd = jy, g.padStart = Gy, g.parseInt = qy, g.random = Ky, g.reduce = a$, g.reduceRight = u$, g.repeat = Zy, g.replace = Yy, g.result = Ty, g.round = U4, g.runInContext = S, g.sample = c$, g.size = p$, g.snakeCase = Xy, g.some = h$, g.sortedIndex = d1, g.sortedIndexBy = f1, g.sortedIndexOf = p1, g.sortedLastIndex = h1, g.sortedLastIndexBy = v1, g.sortedLastIndexOf = g1, g.startCase = Qy, g.startsWith = e4, g.subtract = j4, g.sum = G4, g.sumBy = q4, g.template = t4, g.times = F4, g.toFinite = An, g.toInteger = be, g.toLength = md, g.toLower = n4, g.toNumber = Jt, g.toSafeInteger = ny, g.toString = Ne, g.toUpper = r4, g.trim = i4, g.trimEnd = o4, g.trimStart = l4, g.truncate = a4, g.unescape = u4, g.uniqueId = R4, g.upperCase = s4, g.upperFirst = Ma, g.each = id, g.eachRight = od, g.first = ed, ka(g, function() {
        var n = {};
        return fn(g, function(i, l) {
          ze.call(g.prototype, l) || (n[l] = i);
        }), n;
      }(), { chain: !1 }), g.VERSION = o, jt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(n) {
        g[n].placeholder = g;
      }), jt(["drop", "take"], function(n, i) {
        _e.prototype[n] = function(l) {
          l = l === r ? 1 : lt(be(l), 0);
          var c = this.__filtered__ && !i ? new _e(this) : this.clone();
          return c.__filtered__ ? c.__takeCount__ = bt(l, c.__takeCount__) : c.__views__.push({
            size: bt(l, pe),
            type: n + (c.__dir__ < 0 ? "Right" : "")
          }), c;
        }, _e.prototype[n + "Right"] = function(l) {
          return this.reverse()[n](l).reverse();
        };
      }), jt(["filter", "map", "takeWhile"], function(n, i) {
        var l = i + 1, c = l == D || l == Q;
        _e.prototype[n] = function(p) {
          var b = this.clone();
          return b.__iteratees__.push({
            iteratee: ae(p, 3),
            type: l
          }), b.__filtered__ = b.__filtered__ || c, b;
        };
      }), jt(["head", "last"], function(n, i) {
        var l = "take" + (i ? "Right" : "");
        _e.prototype[n] = function() {
          return this[l](1).value()[0];
        };
      }), jt(["initial", "tail"], function(n, i) {
        var l = "drop" + (i ? "" : "Right");
        _e.prototype[n] = function() {
          return this.__filtered__ ? new _e(this) : this[l](1);
        };
      }), _e.prototype.compact = function() {
        return this.filter(It);
      }, _e.prototype.find = function(n) {
        return this.filter(n).head();
      }, _e.prototype.findLast = function(n) {
        return this.reverse().find(n);
      }, _e.prototype.invokeMap = xe(function(n, i) {
        return typeof n == "function" ? new _e(this) : this.map(function(l) {
          return hi(l, n, i);
        });
      }), _e.prototype.reject = function(n) {
        return this.filter(Bo(ae(n)));
      }, _e.prototype.slice = function(n, i) {
        n = be(n);
        var l = this;
        return l.__filtered__ && (n > 0 || i < 0) ? new _e(l) : (n < 0 ? l = l.takeRight(-n) : n && (l = l.drop(n)), i !== r && (i = be(i), l = i < 0 ? l.dropRight(-i) : l.take(i - n)), l);
      }, _e.prototype.takeRightWhile = function(n) {
        return this.reverse().takeWhile(n).reverse();
      }, _e.prototype.toArray = function() {
        return this.take(pe);
      }, fn(_e.prototype, function(n, i) {
        var l = /^(?:filter|find|map|reject)|While$/.test(i), c = /^(?:head|last)$/.test(i), p = g[c ? "take" + (i == "last" ? "Right" : "") : i], b = c || /^find/.test(i);
        p && (g.prototype[i] = function() {
          var x = this.__wrapped__, E = c ? [1] : arguments, P = x instanceof _e, N = E[0], z = P || ve(x), q = function(Te) {
            var Le = p.apply(g, On([Te], E));
            return c && te ? Le[0] : Le;
          };
          z && l && typeof N == "function" && N.length != 1 && (P = z = !1);
          var te = this.__chain__, oe = !!this.__actions__.length, ue = b && !te, $e = P && !oe;
          if (!b && z) {
            x = $e ? x : new _e(this);
            var se = n.apply(x, E);
            return se.__actions__.push({ func: Fo, args: [q], thisArg: r }), new qt(se, te);
          }
          return ue && $e ? n.apply(this, E) : (se = this.thru(q), ue ? c ? se.value()[0] : se.value() : se);
        });
      }), jt(["pop", "push", "shift", "sort", "splice", "unshift"], function(n) {
        var i = no[n], l = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", c = /^(?:pop|shift)$/.test(n);
        g.prototype[n] = function() {
          var p = arguments;
          if (c && !this.__chain__) {
            var b = this.value();
            return i.apply(ve(b) ? b : [], p);
          }
          return this[l](function(x) {
            return i.apply(ve(x) ? x : [], p);
          });
        };
      }), fn(_e.prototype, function(n, i) {
        var l = g[i];
        if (l) {
          var c = l.name + "";
          ze.call(Dr, c) || (Dr[c] = []), Dr[c].push({ name: i, func: l });
        }
      }), Dr[Eo(r, W).name] = [{
        name: "wrapper",
        func: r
      }], _e.prototype.clone = u0, _e.prototype.reverse = s0, _e.prototype.value = c0, g.prototype.at = k1, g.prototype.chain = N1, g.prototype.commit = z1, g.prototype.next = W1, g.prototype.plant = H1, g.prototype.reverse = U1, g.prototype.toJSON = g.prototype.valueOf = g.prototype.value = j1, g.prototype.first = g.prototype.head, ai && (g.prototype[ai] = V1), g;
    }, Tr = zb();
    Qn ? ((Qn.exports = Tr)._ = Tr, Ol._ = Tr) : vt._ = Tr;
  }).call(xi);
})(fl, fl.exports);
var L2 = fl.exports;
const R2 = Vt({
  base: "box-border	block cursor-pointer whitespace-nowrap rounded text-black no-underline hover:bg-white hover:shadow",
  variants: {
    isSelected: {
      true: "border border-gray-200 bg-white shadow",
      false: ""
    }
  }
}), Q2 = ({ items: e, scrollableContainerId: t }) => {
  const [r, o] = Ce(""), a = ie(r), u = (d) => {
    a.current = d, o(d);
  };
  Ee(() => {
    if (window.location.hash !== a.current) {
      u(window.location.hash);
      const d = document.getElementById(
        window.location.hash.replace("#", "")
      );
      d && d.scrollIntoView();
    }
  }, []);
  const s = () => {
    const d = t ? document.getElementById(t) : null;
    if (!d)
      return;
    const f = d.scrollTop, h = d.offsetHeight;
    for (let v = 0; v < e.length; v++) {
      const m = e[v], y = document.getElementById(m.href.replace("#", ""));
      if (!y)
        continue;
      const $ = y.offsetTop;
      if ($ >= f && $ <= f + h / 2) {
        a.current !== m.href && (u(m.href), window.history.pushState(null, "", m.href));
        break;
      }
    }
  };
  return Ee(() => {
    const d = t ? document.getElementById(t) : null;
    if (!d)
      return;
    const f = L2.throttle(s, 500);
    return d.addEventListener(
      "scroll",
      f
    ), () => d.removeEventListener(
      "scroll",
      f
    );
  }, []), /* @__PURE__ */ U.jsx("div", { children: e.map((d, f) => /* @__PURE__ */ U.jsx(
    "a",
    {
      href: d.href,
      onClick: () => u(d.href),
      target: "_self",
      className: R2({
        isSelected: r === d.href
      }),
      children: /* @__PURE__ */ U.jsxs("div", { className: "flex items-center gap-1 p-1", children: [
        d.icon ? /* @__PURE__ */ U.jsx(Zn, { ...d.icon }) : /* @__PURE__ */ U.jsx(U.Fragment, {}),
        /* @__PURE__ */ U.jsx("div", { children: d.label })
      ] })
    },
    f
  )) });
}, e7 = ({ children: e, height: t, id: r }) => /* @__PURE__ */ U.jsx(
  "div",
  {
    id: r,
    className: "relative overflow-auto scroll-smooth",
    style: t ? { height: t } : {},
    children: e
  }
), I2 = Vt({
  base: "rounded border border-gray-200 bg-white shadow-xl",
  variants: {
    isEntering: {
      true: "animate-in fade-in placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 placement-left:slide-in-from-right-1 placement-right:slide-in-from-left-1 duration-300 ease-out"
    },
    isExiting: {
      true: "animate-out fade-out placement-bottom:slide-out-to-top-1 placement-top:slide-out-to-bottom-1 placement-left:slide-out-to-right-1 placement-right:slide-out-to-left-1 duration-150 ease-in"
    }
  }
}), Og = ({ children: e, className: t, ...r }) => /* @__PURE__ */ U.jsx(
  Kw,
  {
    ...r,
    className: rg(
      t,
      (o, a) => I2({ ...a, className: o })
    ),
    children: e
  }
), B2 = Vt({
  base: "box-border flex h-4 items-center justify-between gap-1",
  variants: {
    variant: {
      outlined: "rounded border border-gray-200",
      ghost: "border-0"
    }
  }
}), t7 = ({
  children: e,
  variant: t = "outlined",
  label: r,
  description: o,
  errorMessage: a,
  placeholder: u = "Start typing to narrow down options",
  ...s
}) => /* @__PURE__ */ U.jsxs(Vw, { className: "w-full", menuTrigger: "focus", ...s, children: [
  /* @__PURE__ */ U.jsxs("div", { className: "flex flex-col gap-0.5", children: [
    r && /* @__PURE__ */ U.jsx(Lg, { children: r }),
    /* @__PURE__ */ U.jsxs(vw, { className: B2({ variant: t }), children: [
      /* @__PURE__ */ U.jsx(
        mw,
        {
          className: "w-full overflow-hidden text-ellipsis whitespace-nowrap px-0.5 outline-0",
          placeholder: u
        }
      ),
      /* @__PURE__ */ U.jsx(
        os,
        {
          variant: "ghost",
          p: 0.5,
          h: "full",
          icon: { Icon: Bg, side: "right", color: "gray-700" }
        }
      )
    ] })
  ] }),
  !a && o && /* @__PURE__ */ U.jsx(zi, { slot: "description", children: o }),
  a && /* @__PURE__ */ U.jsx(zi, { slot: "errorMessage", children: a }),
  /* @__PURE__ */ U.jsx(Og, { className: "w-[--trigger-width]", offset: 16, children: /* @__PURE__ */ U.jsx(Ig, { children: e }) })
] });
var kg = {}, Ng = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  function t(o, a) {
    return {
      handler: o,
      config: a
    };
  }
  t.withOptions = function(o, a = () => ({})) {
    const u = function(s) {
      return {
        __options: s,
        handler: o(s),
        config: a(s)
      };
    };
    return u.__isOptionsFunction = !0, u.__pluginFunction = o, u.__configFunction = a, u;
  };
  const r = t;
})(Ng);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return o;
    }
  });
  const t = /* @__PURE__ */ r(Ng);
  function r(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  const o = t.default;
})(kg);
let au = kg;
var zg = (au.__esModule ? au : { default: au }).default;
const M2 = zg;
function Ff(e) {
  return Object.fromEntries(
    Object.entries(e).filter(([t]) => t !== "DEFAULT")
  );
}
var K2 = M2(
  ({ addUtilities: e, matchUtilities: t, theme: r }) => {
    e({
      "@keyframes enter": r("keyframes.enter"),
      "@keyframes exit": r("keyframes.exit"),
      ".animate-in": {
        animationName: "enter",
        animationDuration: r("animationDuration.DEFAULT"),
        "--tw-enter-opacity": "initial",
        "--tw-enter-scale": "initial",
        "--tw-enter-rotate": "initial",
        "--tw-enter-translate-x": "initial",
        "--tw-enter-translate-y": "initial"
      },
      ".animate-out": {
        animationName: "exit",
        animationDuration: r("animationDuration.DEFAULT"),
        "--tw-exit-opacity": "initial",
        "--tw-exit-scale": "initial",
        "--tw-exit-rotate": "initial",
        "--tw-exit-translate-x": "initial",
        "--tw-exit-translate-y": "initial"
      }
    }), t(
      {
        "fade-in": (o) => ({ "--tw-enter-opacity": o }),
        "fade-out": (o) => ({ "--tw-exit-opacity": o })
      },
      { values: r("animationOpacity") }
    ), t(
      {
        "zoom-in": (o) => ({ "--tw-enter-scale": o }),
        "zoom-out": (o) => ({ "--tw-exit-scale": o })
      },
      { values: r("animationScale") }
    ), t(
      {
        "spin-in": (o) => ({ "--tw-enter-rotate": o }),
        "spin-out": (o) => ({ "--tw-exit-rotate": o })
      },
      { values: r("animationRotate") }
    ), t(
      {
        "slide-in-from-top": (o) => ({
          "--tw-enter-translate-y": `-${o}`
        }),
        "slide-in-from-bottom": (o) => ({
          "--tw-enter-translate-y": o
        }),
        "slide-in-from-left": (o) => ({
          "--tw-enter-translate-x": `-${o}`
        }),
        "slide-in-from-right": (o) => ({
          "--tw-enter-translate-x": o
        }),
        "slide-out-to-top": (o) => ({
          "--tw-exit-translate-y": `-${o}`
        }),
        "slide-out-to-bottom": (o) => ({
          "--tw-exit-translate-y": o
        }),
        "slide-out-to-left": (o) => ({
          "--tw-exit-translate-x": `-${o}`
        }),
        "slide-out-to-right": (o) => ({
          "--tw-exit-translate-x": o
        })
      },
      { values: r("animationTranslate") }
    ), t(
      { duration: (o) => ({ animationDuration: o }) },
      { values: Ff(r("animationDuration")) }
    ), t(
      { delay: (o) => ({ animationDelay: o }) },
      { values: r("animationDelay") }
    ), t(
      { ease: (o) => ({ animationTimingFunction: o }) },
      { values: Ff(r("animationTimingFunction")) }
    ), e({
      ".running": { animationPlayState: "running" },
      ".paused": { animationPlayState: "paused" }
    }), t(
      { "fill-mode": (o) => ({ animationFillMode: o }) },
      { values: r("animationFillMode") }
    ), t(
      { direction: (o) => ({ animationDirection: o }) },
      { values: r("animationDirection") }
    ), t(
      { repeat: (o) => ({ animationIterationCount: o }) },
      { values: r("animationRepeat") }
    );
  },
  {
    theme: {
      extend: {
        animationDelay: ({ theme: e }) => ({
          ...e("transitionDelay")
        }),
        animationDuration: ({ theme: e }) => ({
          0: "0ms",
          ...e("transitionDuration")
        }),
        animationTimingFunction: ({ theme: e }) => ({
          ...e("transitionTimingFunction")
        }),
        animationFillMode: {
          none: "none",
          forwards: "forwards",
          backwards: "backwards",
          both: "both"
        },
        animationDirection: {
          normal: "normal",
          reverse: "reverse",
          alternate: "alternate",
          "alternate-reverse": "alternate-reverse"
        },
        animationOpacity: ({ theme: e }) => ({
          DEFAULT: 0,
          ...e("opacity")
        }),
        animationTranslate: ({ theme: e }) => ({
          DEFAULT: "100%",
          ...e("translate")
        }),
        animationScale: ({ theme: e }) => ({
          DEFAULT: 0,
          ...e("scale")
        }),
        animationRotate: ({ theme: e }) => ({
          DEFAULT: "30deg",
          ...e("rotate")
        }),
        animationRepeat: {
          0: "0",
          1: "1",
          infinite: "infinite"
        },
        keyframes: {
          enter: {
            from: {
              opacity: "var(--tw-enter-opacity, 1)",
              transform: "translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))"
            }
          },
          exit: {
            to: {
              opacity: "var(--tw-exit-opacity, 1)",
              transform: "translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))"
            }
          }
        }
      }
    }
  }
);
const O2 = /* @__PURE__ */ Bf(K2), k2 = zg, uu = {
  boolean: [
    // Conditions
    "allows-removing",
    "allows-sorting",
    "allows-dragging",
    // States
    "open",
    "entering",
    "exiting",
    "indeterminate",
    ["placeholder-shown", "placeholder"],
    "current",
    "required",
    "unavailable",
    "invalid",
    ["read-only", "readonly"],
    "outside-month",
    "outside-visible-range",
    // Content
    "empty",
    // Interactive states
    "focus-within",
    ["hover", "hovered"],
    ["focus", "focused"],
    "focus-visible",
    "pressed",
    "selected",
    "selection-start",
    "selection-end",
    "dragging",
    "drop-target",
    "resizing",
    "disabled"
  ],
  enum: {
    placement: ["left", "right", "top", "bottom"],
    type: ["literal", "year", "month", "day"],
    layout: ["grid", "stack"],
    orientation: ["horizontal", "vertical"],
    "selection-mode": ["single", "multiple"],
    "resizable-direction": ["right", "left", "both"],
    "sort-direction": ["ascending", "descending"]
  }
}, N2 = {
  "selection-mode": "selection",
  "resizable-direction": "resizable",
  "sort-direction": "sort"
}, z2 = ["indeterminate", "required", "invalid", "empty", "focus-visible", "focus-within", "disabled"], W2 = new Map([
  ...z2.map((e) => [e, `:${e}`]),
  ["hovered", ":hover"],
  ["focused", ":focus"],
  ["readonly", ":read-only"],
  ["open", "[open]"]
]), Lf = /* @__PURE__ */ new Map([
  ["placeholder", ":placeholder-shown"]
]);
let Rf = (e, t, r, o) => {
  let a = r ? `[data-${t}="${r}"]` : `[data-${t}]`, u = W2.get(t);
  if (e === "" && u) {
    let s = `&:where(:not([data-rac]))${u}`, d = s;
    return u === ":hover" && o && (d = (f) => `@media (hover: hover) and (pointer: fine) { ${f(s)} }`), [`&:where([data-rac])${a}`, d];
  } else
    return e === "" && Lf.has(t) ? [`&${a}`, `&${Lf.get(t)}`] : `&${a}`;
}, Di = (e, t) => Array.isArray(e) ? e.map(t) : t(e), Fi = (e, t) => typeof e == "function" ? e(t) : t(e), If = (e, t, r, o) => {
  r(e, Di(t, (a) => Fi(a, (u) => u))), o(
    "group",
    (a, { modifier: u }) => u ? Di(t, (s) => Fi(s, (d) => `:merge(.group\\/${u})${d.slice(1)} &`)) : Di(t, (s) => Fi(s, (d) => `:merge(.group)${d.slice(1)} &`)),
    { values: { [e]: e } }
  ), o(
    "peer",
    (a, { modifier: u }) => u ? Di(t, (s) => Fi(s, (d) => `:merge(.peer\\/${u})${d.slice(1)} ~ &`)) : Di(t, (s) => Fi(s, (d) => `:merge(.peer)${d.slice(1)} ~ &`)),
    { values: { [e]: e } }
  );
};
var V2 = k2.withOptions((e) => ({ addVariant: t, matchVariant: r, config: o }) => {
  let a = e != null && e.prefix ? `${e.prefix}-` : "", u = o().future, s = u === "all" || (u == null ? void 0 : u.hoverOnlyWhenSupported);
  Object.keys(uu.enum).forEach((d) => {
    uu.enum[d].forEach(
      (f) => {
        let h = N2[d] || d, v = `${a}${h}-${f}`, m = Rf(a, d, f, s);
        If(v, m, t, r);
      }
    );
  }), uu.boolean.forEach((d) => {
    let f = Array.isArray(d) ? d[0] : d;
    f = `${a}${f}`;
    let h = Array.isArray(d) ? d[1] : d, v = Rf(a, h, null, s);
    If(f, v, t, r);
  });
});
const H2 = /* @__PURE__ */ Bf(V2), n7 = {
  important: !0,
  // TODO: temporary, until we can remove the conflicting stylesheets from main app
  darkMode: ["class", '[data-mode="dark"]'],
  theme: {
    extend: {},
    spacing: {
      px: "1px",
      0: "0",
      0.5: "0.25rem",
      // 4px
      1: "0.5rem",
      // 8px
      1.5: "0.75rem",
      // 12px
      2: "1rem",
      // 16px
      2.5: "1.25rem",
      // 20px
      3: "1.5rem",
      // 24px
      4: "2rem",
      // 32px
      5: "2.5rem",
      // 40px
      6: "3rem",
      // 48px
      7: "3.5rem",
      // 56px
      8: "4rem",
      // 64px
      9: "4.5rem"
      // 72px
    },
    colors: {
      transparent: "transparent",
      current: "currentColor",
      primary: {
        light: "#E7FCF5",
        base: "#3BA384",
        dark: "#23604D",
        hover: "#278367"
      },
      secondary: {
        light: "#A0CDDD",
        base: "#16333D"
      },
      brand: "#6ACCAF",
      link: "#2670BF",
      linkLight: "#327DCD",
      subTitle: "#909da3",
      success: {
        light: "#67C8AB",
        base: "#3BA384",
        dark: "#23604D"
      },
      warning: {
        light: "#FDF7EC",
        base: "#FBB83F",
        dark: "#DA9417"
      },
      critical: {
        light: "#FFECEC",
        base: "#E06363",
        dark: "#AE2323",
        hover: "#CA4848"
      },
      informational: {
        light: "#EBF5FF",
        base: "#39849E",
        dark: "#2D687C",
        hover: "#105EB0"
      },
      black: "#171B1F",
      white: "#FFFFFF",
      gray: {
        700: "#101828",
        600: "#465361",
        500: "#667085",
        400: "#98A2B3",
        300: "#CFD7E0",
        200: "#E1E7EC",
        100: "#F4F6F8",
        50: "#F1F1F1"
      },
      decorative: {
        mintGreen: "#DAF5ED",
        highlightBlue: "#93ADF5"
      },
      channel: {
        inbound: "#FFA600",
        outbound: "#003F5C",
        referrals: "#BC5090"
      }
    },
    fontFamily: {
      inter: ["Inter"]
    },
    fontSize: {
      "title-large": [
        "1.5rem",
        {
          lineHeight: "2rem",
          fontWeight: "600"
        }
      ],
      "page-title": [
        "1.25rem",
        {
          lineHeight: "1.75rem",
          fontWeight: "700"
        }
      ],
      heading: ["1.125rem", { lineHeight: "1.5rem", fontWeight: "600" }],
      "subtitle-1": ["1rem", { lineHeight: "1.5rem", fontWeight: "600" }],
      "subtitle-2": ["0.875rem", { lineHeight: "1.25rem", fontWeight: "600" }],
      body: ["1rem", { lineHeight: "1.5rem", fontWeight: "400" }],
      "body-small": ["0.875rem", { lineHeight: "1.25rem", fontWeight: "400" }],
      "body-xs": ["0.75rem", { lineHeight: "0.875rem", fontWeight: "400" }],
      button: ["0.875rem", { lineHeight: "1.25rem", fontWeight: "500" }],
      caption: ["0.75rem", { lineHeight: "1rem", fontWeight: "400" }],
      overline: [
        "0.625rem",
        { lineHeight: "1rem", fontWeight: "700", letterSpacing: "1px" }
      ]
    },
    borderRadius: {
      none: "0",
      DEFAULT: "6px",
      full: "9999px"
    },
    boxShadow: {
      none: "0 0 #0000",
      DEFAULT: "0px 1px 4px 0px rgba(0 0 0 / 0.05)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      xl: "0px 4px 10px 0px rgba(0, 0, 0, 0.05)"
    }
  },
  corePlugins: {
    preflight: !1
  },
  plugins: [O2, H2]
};
export {
  Q2 as AnchorTagNav,
  os as Button,
  Z2 as Chat,
  iw as Collection,
  t7 as ComboBox,
  j6 as Header,
  Zn as Icon,
  Rg as Item,
  Lg as Label,
  Ig as ListBox,
  U6 as ListSection,
  Og as Popover,
  Z6 as Progress,
  Y2 as RadioButton,
  X2 as RadioButtonGroup,
  e7 as Scrollable,
  G2 as Section,
  q2 as Select,
  zi as Text,
  J2 as ToggleButton,
  n7 as twConfigPreset
};
